webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.patch = exports.put = exports.post = exports.remove = exports.get = undefined;

var _index = __webpack_require__(67);

var _index2 = _interopRequireDefault(_index);

var _axios = __webpack_require__(71);

var _axios2 = _interopRequireDefault(_axios);

var _index3 = __webpack_require__(32);

var _index4 = _interopRequireDefault(_index3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestsTotal = 0;
var requestCompleted = 0;
var postTotal = 0;
var postCompleted = 0;

var get = function get(path, data, cb, errorCb) {
    requestsTotal++;
    _index2.default.state.loading = true;
    _index2.default.state.errors = [];

    _index4.default.get(path, {
        params: data,
        cancelToken: _index3.axiosConfig.cancelTokenSource.token
    }).then(function (response) {
        requestCompleted++;
        loading();
        cb(response);
    }).catch(function (error) {
        requestCompleted++;
        loading();

        if (_axios2.default.isCancel(error)) {
            return;
        }
        if (errorCb) errorCb(error);
    });
};

var remove = function remove(path, cb, errorCb) {
    requestsTotal++;
    _index2.default.state.loading = true;
    _index2.default.state.errors = [];
    _index4.default.delete(path, {
        cancelToken: _index3.axiosConfig.cancelTokenSource.token
    }).then(function (response) {
        requestCompleted++;
        loading();
        cb(response);
    }).catch(function (error) {
        requestCompleted++;
        loading();
        if (_axios2.default.isCancel(error)) return;
        if (errorCb) errorCb(error);
    });
};

var post = function post(path, data, cb, errorCb) {
    postTotal++;
    _index2.default.state.inputLoading = true;
    _index4.default.post(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (errorCb !== undefined) {
            errorCb(error.response);
        }
    });
};

var put = function put(path, data, cb, errorCb) {
    postTotal++;
    _index2.default.state.inputLoading = true;
    _index2.default.state.errors = [];
    data['_method'] = 'PUT';
    _index4.default.post(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (error.response !== undefined) {
            if (error.response.status === 422) {
                _index2.default.state.errors = error.response.data;
            }
        }
    });
};

var patch = function patch(path, data, cb, errorCb) {
    postTotal++;
    _index2.default.state.inputLoading = true;
    _index2.default.state.errors = [];
    data['_method'] = 'PATCH';
    _index4.default.post(path, data).then(function (response) {
        postCompleted++;
        PostLoading();
        cb(response);
    }).catch(function (error) {
        postCompleted++;
        PostLoading();
        if (error.response !== undefined) {
            if (error.response.status === 422) {
                _index2.default.state.errors = error.response.data;
            }
        }
    });
};

function loading() {
    if (requestsTotal <= requestCompleted) {
        requestsTotal = 0;
        requestCompleted = 0;
        _index2.default.state.loading = false;
    }
}

function PostLoading() {
    if (postTotal <= postCompleted) {
        postTotal = 0;
        postCompleted = 0;
        _index2.default.state.inputLoading = false;
    }
}

exports.get = get;
exports.remove = remove;
exports.post = post;
exports.put = put;
exports.patch = patch;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBudget = exports.claims = exports.update = exports.between = exports.find = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var namespace = 'projects';

var find = function find(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var between = function between(dateFrom, dateTo, department, params, cb, errorCb) {
    params = (0, _extends3.default)({}, params, { 'filter[between]': dateFrom + ',' + dateTo }, { 'per_page': 50 });
    if (department.uuid) {
        params = (0, _extends3.default)({}, params, { 'filter[department]': department.name });
    }
    HttpService.get(namespace, params, cb, errorCb);
};

var update = function update(params, cb, errorCb) {
    HttpService.post(namespace + '/update', params, cb, errorCb);
};

var claims = function claims(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var getBudget = function getBudget(uuid, params, cb, errorCb) {
    HttpService.get('project-budget/' + uuid, params, cb, errorCb);
};

exports.find = find;
exports.between = between;
exports.update = update;
exports.claims = claims;
exports.getBudget = getBudget;

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(28);

var _promise2 = _interopRequireDefault(_promise);

var _projectService = __webpack_require__(4);

var projectService = _interopRequireWildcard(_projectService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getData: function getData() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'dateInterval': true };

        return new _promise2.default(function (resolve, reject) {
            if (!_this.$store.state.config.loaded) return;
            _this.rows = [];
            _this.loading = true;
            if (options.dateInterval === true) {
                projectService.between(_this.$store.getters.getStartDate, _this.$store.getters.getEndDate, _this.$store.getters.getCurrentDepartment, _this.params, function (response) {
                    _this.rows = response.data;
                    _this.loading = false;
                    _this.$emit('finishedLoading', _this.rows.length);
                    resolve(response.data);
                }, function (err) {
                    reject(err);
                });
            } else {
                projectService.find(_this.params, function (response) {
                    _this.rows = response.data;
                    _this.loading = false;
                    _this.$emit('finishedLoading', _this.rows.length);
                    resolve(response.data);
                }, function (err) {
                    reject(err);
                });
            }
        });
    },
    searchOptions: {
        enabled: true,
        trigger: 'enter',
        placeholder: 'Søg og tryk enter ...',
        skipDiacritics: true
    },
    paginationOptions: {
        enabled: true,
        perPage: 30,
        rowsPerPageLabel: 'Rækker pr. side',
        allLabel: 'Alle',
        nextLabel: 'Næste',
        prevLabel: 'Forrige',
        ofLabel: 'af',
        pageLabel: 'side'
    },
    sortOptions: {
        enabled: true
    }
};

/***/ }),
/* 7 */,
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.compareCustomerHours = exports.compareCoveragePerHour = exports.compareCoverage = exports.compareCoveragePercent = exports.compareRevenue = exports.compareKeyfigures = exports.accountingYearsCheck = exports.keyFigures = exports.costsDivision = exports.costpricePerHour = exports.suppliers = exports.materialUsage = exports.revenueAndCosts = exports.accountCategories = exports.accountEntries = exports.accountPlan = exports.updateAccount = exports.accounts = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = '';

var accounts = function accounts(params, cb, errorCb) {
    HttpService.get(namespace + 'accounts', params, cb, errorCb);
};

var accountPlan = function accountPlan(params, cb, errorCb) {
    HttpService.get(namespace + 'accounts/plan', params, cb, errorCb);
};

var accountCategories = function accountCategories(params, cb, errorCb) {
    HttpService.get(namespace + 'account-categories', params, cb, errorCb);
};

var updateAccount = function updateAccount(uuid, body, params, cb, errorCb) {
    HttpService.put(namespace + 'accounts/' + uuid, body, params, cb, errorCb);
};

var revenueAndCosts = function revenueAndCosts(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/economy/revenueandcosts', params, cb, errorCb);
};

var materialUsage = function materialUsage(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/economy/material-usage', params, cb, errorCb);
};

var suppliers = function suppliers(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/economy/suppliers', params, cb, errorCb);
};

var costpricePerHour = function costpricePerHour(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/economy/costprice-per-hour', params, cb, errorCb);
};

var costsDivision = function costsDivision(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/economy/costs-division', params, cb, errorCb);
};

var keyFigures = function keyFigures(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/economy', params, cb, errorCb);
};
var accountEntries = function accountEntries(uuid, params, cb, errorCb) {
    HttpService.get(namespace + 'accounts/' + uuid + '/entries', params, cb, errorCb);
};

var accountingYearsCheck = function accountingYearsCheck(params, cb, errorCb) {
    HttpService.get(namespace + 'accounting-years-check', params, cb, errorCb);
};

var compareKeyfigures = function compareKeyfigures(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/compare-keyfigures', params, cb, errorCb);
};

var compareRevenue = function compareRevenue(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/compare-revenue', params, cb, errorCb);
};

var compareCoveragePercent = function compareCoveragePercent(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/compare-coverage-percent', params, cb, errorCb);
};

var compareCoverage = function compareCoverage(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/compare-coverage', params, cb, errorCb);
};

var compareCoveragePerHour = function compareCoveragePerHour(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/compare-coverage-per-hour', params, cb, errorCb);
};

var compareCustomerHours = function compareCustomerHours(params, cb, errorCb) {
    HttpService.get(namespace + 'calculations/compare-customer-hours', params, cb, errorCb);
};

exports.accounts = accounts;
exports.updateAccount = updateAccount;
exports.accountPlan = accountPlan;
exports.accountEntries = accountEntries;
exports.accountCategories = accountCategories;
exports.revenueAndCosts = revenueAndCosts;
exports.materialUsage = materialUsage;
exports.suppliers = suppliers;
exports.costpricePerHour = costpricePerHour;
exports.costsDivision = costsDivision;
exports.keyFigures = keyFigures;
exports.accountingYearsCheck = accountingYearsCheck;
exports.compareKeyfigures = compareKeyfigures;
exports.compareRevenue = compareRevenue;
exports.compareCoveragePercent = compareCoveragePercent;
exports.compareCoverage = compareCoverage;
exports.compareCoveragePerHour = compareCoveragePerHour;
exports.compareCustomerHours = compareCustomerHours;

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.responsibleValuechain = exports.compareResponsibleEmployeesProjectTypes = exports.compareResponsibleEmployees = exports.revenue = exports.skills = exports.update = exports.findAll = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'employees';

var findAll = function findAll(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var update = function update(uuid, body, cb, errorCb) {
    HttpService.put(namespace + '/update-employee/' + uuid, body, cb, errorCb);
};

var skills = function skills(uuid, params, cb, errorCb) {
    HttpService.get(namespace + '/' + uuid + '/skill', params, cb, errorCb);
};

var revenue = function revenue(params, cb, errorCb) {
    HttpService.get(namespace + '/revenue', params, cb, errorCb);
};

var compareResponsibleEmployees = function compareResponsibleEmployees(params, cb, errorCb) {
    HttpService.get(namespace + '/compare/responsible', params, cb, errorCb);
};

var compareResponsibleEmployeesProjectTypes = function compareResponsibleEmployeesProjectTypes(params, cb, errorCb) {
    HttpService.get(namespace + '/compare/responsible-project-types', params, cb, errorCb);
};

var responsibleValuechain = function responsibleValuechain(params, cb, errorCb) {
    HttpService.get('/project-responsible-valuechain', params, cb, errorCb);
};

exports.findAll = findAll;
exports.update = update;
exports.skills = skills;
exports.revenue = revenue;
exports.compareResponsibleEmployees = compareResponsibleEmployees;
exports.compareResponsibleEmployeesProjectTypes = compareResponsibleEmployeesProjectTypes;
exports.responsibleValuechain = responsibleValuechain;

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.between = exports.overdue = exports.unpaid = exports.all = exports.find = undefined;

var _extends2 = __webpack_require__(2);

var _extends3 = _interopRequireDefault(_extends2);

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var namespace = '/invoices';

var find = function find(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var all = function all(params, cb, errorCb) {
    HttpService.get('all-invoices', params, cb, errorCb);
};

var unpaid = function unpaid(params, cb, errorCb) {
    HttpService.get('unpaid-invoices', params, cb, errorCb);
};

var overdue = function overdue(params, cb, errorCb) {
    HttpService.get('overdue-invoices', params, cb, errorCb);
};

var between = function between(dateFrom, dateTo, department, params, cb, errorCb) {
    params = (0, _extends3.default)({}, params, { 'filter[between]': dateFrom + ',' + dateTo }, { 'per_page': 50 });
    if (department.uuid) {
        params = (0, _extends3.default)({}, params, { 'filter[department]': department.name });
    }
    HttpService.get(namespace, params, cb, errorCb);
};

exports.find = find;
exports.all = all;
exports.unpaid = unpaid;
exports.overdue = overdue;
exports.between = between;

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.projectTypesPotential = exports.valueChain = exports.update = exports.remove = exports.create = exports.ebitda = exports.findAll = exports.find = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'calculations';

var find = function find(id, options, cb, errorCb) {
    HttpService.get(namespace + '/' + id, options, cb, errorCb);
};

var findAll = function findAll(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var ebitda = function ebitda(companyId, params, cb, errorCb) {
    HttpService.get(namespace + '/' + companyId + '/ebitda', params, cb, errorCb);
};

var create = function create(body, cb, errorCb) {
    HttpService.post(namespace, body, cb, errorCb);
};

var remove = function remove(id, cb, errorCb) {
    HttpService.remove(namespace + '/' + id, cb, errorCb);
};

var update = function update(id, body, cb, errorCb) {
    HttpService.put(namespace + '/' + id, body, cb, errorCb);
};

var valueChain = function valueChain(params, cb, errorCb) {
    HttpService.get(namespace + '/value-chain', params, cb, errorCb);
};

var projectTypesPotential = function projectTypesPotential(params, cb, errorCb) {
    HttpService.get(namespace + '/potential/project-types', params, cb, errorCb);
};

exports.find = find;
exports.findAll = findAll;
exports.ebitda = ebitda;
exports.create = create;
exports.remove = remove;
exports.update = update;
exports.valueChain = valueChain;
exports.projectTypesPotential = projectTypesPotential;

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.create = exports.ebitda = exports.cph = exports.hours = exports.overview = exports.data = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'budget';

var data = function data(params, cb, errorCb) {
    HttpService.get(namespace + '/data', params, cb, errorCb);
};

var overview = function overview(params, cb, errorCb) {
    HttpService.get(namespace + '/overview', params, cb, errorCb);
};

var hours = function hours(params, cb, errorCb) {
    HttpService.get(namespace + '/hours', params, cb, errorCb);
};

var cph = function cph(params, cb, errorCb) {
    HttpService.get(namespace + '/cph', params, cb, errorCb);
};

var ebitda = function ebitda(params, cb, errorCb) {
    HttpService.get(namespace + '/ebitda', params, cb, errorCb);
};

var create = function create(body, cb, errorCb) {
    HttpService.post(namespace + '/create', body, cb, errorCb);
};

exports.data = data;
exports.overview = overview;
exports.hours = hours;
exports.cph = cph;
exports.ebitda = ebitda;
exports.create = create;

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cancelPendingRequests = exports.axiosConfig = undefined;

var _axios = __webpack_require__(71);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var axiosConfig = exports.axiosConfig = {
    cancelTokenSource: _axios2.default.CancelToken.source()
};

var cancelPendingRequests = exports.cancelPendingRequests = function cancelPendingRequests() {
    axiosConfig.cancelTokenSource.cancel('Operation canceled by router');
    axiosConfig.cancelTokenSource = _axios2.default.CancelToken.source();
};

var instance = _axios2.default.create({
    baseURL: "https://api.proebitda.dk/v1",
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    }
});

exports.default = instance;

/***/ }),
/* 33 */,
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.updateEmployeeCalc = exports.employeeCalc = exports.updateBudgetCalc = exports.budgetCalc = exports.change = exports.findAll = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'companies';

var findAll = function findAll(options, cb, errorCb) {
    HttpService.get(namespace, options, cb, errorCb);
};

var budgetCalc = function budgetCalc(options, cb, errorCb) {
    HttpService.get('company/budget', options, cb, errorCb);
};

var updateBudgetCalc = function updateBudgetCalc(body, cb, errorCb) {
    HttpService.post('company/budget', body, cb, errorCb);
};

var employeeCalc = function employeeCalc(options, cb, errorCb) {
    HttpService.get('company/employee-calc', options, cb, errorCb);
};

var updateEmployeeCalc = function updateEmployeeCalc(body, cb, errorCb) {
    HttpService.post('company/employee-calc', body, cb, errorCb);
};

var change = function change(body, cb, errorCb) {
    HttpService.post('change-company', body, cb, errorCb);
};

exports.findAll = findAll;
exports.change = change;
exports.budgetCalc = budgetCalc;
exports.updateBudgetCalc = updateBudgetCalc;
exports.employeeCalc = employeeCalc;
exports.updateEmployeeCalc = updateEmployeeCalc;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.subProjectTypes = exports.employees = exports.main = exports.projectTypes = exports.all = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'enterprise/main-projects';

var all = function all(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var projectTypes = function projectTypes(params, cb, errorCb) {
    HttpService.get(namespace + '/types', params, cb, errorCb);
};

var main = function main(params, cb, errorCb) {
    HttpService.get(namespace + '/list', params, cb, errorCb);
};

var employees = function employees(params, cb, errorCb) {
    HttpService.get('enterprise/employees', params, cb, errorCb);
};

var subProjectTypes = function subProjectTypes(params, cb, errorCb) {
    HttpService.get('enterprise/sub-project-types', params, cb, errorCb);
};

exports.all = all;
exports.projectTypes = projectTypes;
exports.main = main;
exports.employees = employees;
exports.subProjectTypes = subProjectTypes;

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.graphs = exports.coveragePerHour = exports.projectTypeSkills = exports.skills = exports.findAll = exports.development = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'project-types';

var development = function development(params, cb, errorCb) {
    HttpService.get(namespace + '/development', params, cb, errorCb);
};

var findAll = function findAll(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var skills = function skills(uuid, params, cb, errorCb) {
    HttpService.get(namespace + '/' + uuid + '/main-employees', params, cb, errorCb);
};

var projectTypeSkills = function projectTypeSkills(params, cb, errorCb) {
    HttpService.get('project-types-skills', params, cb, errorCb);
};

var coveragePerHour = function coveragePerHour(params, cb, errorCb) {
    HttpService.get(namespace + '/coverage-per-hour', params, cb, errorCb);
};

var graphs = function graphs(params, cb, errorCb) {
    HttpService.get(namespace + '/graphs', params, cb, errorCb);
};

exports.development = development;
exports.findAll = findAll;
exports.skills = skills;
exports.projectTypeSkills = projectTypeSkills;
exports.coveragePerHour = coveragePerHour;
exports.graphs = graphs;

/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(28);

var _promise2 = _interopRequireDefault(_promise);

var _invoiceService = __webpack_require__(19);

var invoiceService = _interopRequireWildcard(_invoiceService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    getData: function getData() {
        var _this = this;

        var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : { 'dateInterval': true };

        return new _promise2.default(function (resolve, reject) {
            if (!_this.$store.state.config.loaded) return;
            _this.rows = [];
            _this.loading = true;
            if (options.dateInterval === true) {
                invoiceService.between(_this.$store.getters.getStartDate, _this.$store.getters.getEndDate, _this.$store.getters.getCurrentDepartment, _this.params, function (response) {
                    _this.rows = response.data;
                    _this.loading = false;
                    _this.$emit('finishedLoading', _this.rows.length);
                    resolve(response.data);
                }, function (err) {
                    reject(err);
                });
            } else {
                invoiceService.find(_this.params, function (response) {
                    _this.rows = response.data;
                    _this.loading = false;
                    _this.$emit('finishedLoading', _this.rows.length);
                    resolve(response.data);
                }, function (err) {
                    reject(err);
                });
            }
        });
    },
    searchOptions: {
        enabled: true,
        trigger: 'enter',
        placeholder: 'Søg og tryk enter ...',
        skipDiacritics: true
    },
    paginationOptions: {
        enabled: true,
        perPage: 30,
        rowsPerPageLabel: 'Rækker pr. side',
        allLabel: 'Alle',
        nextLabel: 'Næste',
        prevLabel: 'Forrige',
        ofLabel: 'af',
        pageLabel: 'side'
    },
    sortOptions: {
        enabled: true
    }
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.employees = exports.skills = exports.all = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'calculations/time-usage';

var all = function all(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var skills = function skills(params, cb, errorCb) {
    HttpService.get(namespace + '/skills', params, cb, errorCb);
};

var employees = function employees(params, cb, errorCb) {
    HttpService.get('time-usage/employees', params, cb, errorCb);
};

exports.all = all;
exports.skills = skills;
exports.employees = employees;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.forgotPassword = exports.remove = exports.update = exports.create = exports.all = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'users';

var all = function all(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var create = function create(body, cb, errorCb) {
    HttpService.post(namespace, body, cb, errorCb);
};

var update = function update(uuid, body, cb, errorCb) {
    HttpService.patch(namespace + '/' + uuid, body, cb, errorCb);
};

var remove = function remove(uuid, cb, errorCb) {
    HttpService.remove(namespace + '/' + uuid, cb, errorCb);
};

var forgotPassword = function forgotPassword(params, cb, errorCb) {
    HttpService.get('forgot-password', params, cb, errorCb);
};

exports.all = all;
exports.create = create;
exports.update = update;
exports.remove = remove;
exports.forgotPassword = forgotPassword;

/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _toConsumableArray2 = __webpack_require__(83);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(951);

var _vuex2 = _interopRequireDefault(_vuex);

var _moment = __webpack_require__(1);

var _moment2 = _interopRequireDefault(_moment);

var _configService = __webpack_require__(480);

var configService = _interopRequireWildcard(_configService);

var _lodash = __webpack_require__(62);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var allDepartments = {
    uuid: 0,
    name: 'Virksomheden'
};

exports.default = new _vuex2.default.Store({
    state: {
        config: {
            companyMeta: {},
            availableAccountingYears: [],
            availableDepartments: [allDepartments],
            currentDepartment: allDepartments,
            startDate: 'Jan 1, 2019 00:00:00',
            endDate: new Date(),
            loaded: false
        },
        view: 'drift',
        efficiencyData: {},
        closedRows: [],
        customerRevenueRows: [],

        graphColors: ['#1e807c', '#7aa8d4', '#c53e4a', '#e8c531', '#91c891', '#246ab2', '#7a215c', '#e75645', '#c8a146', '#cccccc', '#000000'],
        showDailyTip: false
    },
    getters: {
        groupedProjects: function groupedProjects(state) {
            if (state.closedRows.length) {
                return _lodash2.default.groupBy(state.closedRows, function (project) {
                    return project.type ? project.type.name : 'Ingen type';
                });
            }
            return null;
        },
        getStartDate: function getStartDate(state) {
            return (0, _moment2.default)(state.config.startDate).format('YYYY-MM-DD');
        },
        getEndDate: function getEndDate(state) {
            return (0, _moment2.default)(state.config.endDate).format('YYYY-MM-DD');
        },
        getAvailableDepartments: function getAvailableDepartments(state) {
            return state.config.availableDepartments;
        },
        getCurrentDepartment: function getCurrentDepartment(state) {
            return state.config.currentDepartment;
        },
        getCurrentAccountingYear: function getCurrentAccountingYear(state) {
            return state.config.availableAccountingYears[0];
        }
    },
    actions: {
        getConfig: function getConfig(context) {
            configService.get({}, function (response) {
                context.commit('setConfig', response.data);
                context.dispatch('setDatesPreset', 'currentAccountingYear');
            });
        },

        setDatesPreset: function setDatesPreset(context, preset) {
            var date = new Date();
            var startDate = null;var endDate = null;
            switch (preset) {
                case 'currentAccountingYear':
                    startDate = context.state.config.availableAccountingYears[0].from_date;
                    endDate = context.state.config.availableAccountingYears[0].to_date;
                    break;
                case 'currentWeek':
                    var first = date.getDate() - date.getDay() + 1;
                    var last = first + 6;
                    startDate = new Date(date.setDate(first));
                    endDate = new Date(date.setDate(last));
                    break;
                case 'currentMonth':
                    startDate = new Date(date.getFullYear(), date.getMonth(), 1);
                    endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
                    break;
                default:
                    console.log('fejl i setDatesPreset: ' + preset + ' eksisterer ikke');
            }
            context.commit('setDates', { startDate: startDate, endDate: endDate });
        }
    },
    mutations: {
        setCurrentDepartment: function setCurrentDepartment(state, department) {
            state.config.currentDepartment = department;
        },
        resetCurrentDepartment: function resetCurrentDepartment(state) {
            state.config.currentDepartment = allDepartments;
        },
        setConfig: function setConfig(state, config) {
            state.config.lastSynced = config.last_sync;
            state.config.availableAccountingYears = config.accounting_years.reverse();
            state.config.availableDepartments = [allDepartments].concat((0, _toConsumableArray3.default)(config.departments));
            state.config.companyMeta = config.company;
            state.config.loaded = true;
        },
        setDates: function setDates(state, dates) {
            state.config.startDate = dates.startDate;
            state.config.endDate = dates.endDate;
        },
        setClosedRows: function setClosedRows(state, rows) {
            state.closedRows = rows;
        },
        setCustomerRevenueRows: function setCustomerRevenueRows(state, rows) {
            state.customerRevenueRows = rows;
        }
    }
});

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(635)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(329),
  /* template */
  __webpack_require__(929),
  /* scopeId */
  "data-v-c979e24c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(638)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(427),
  /* template */
  __webpack_require__(934),
  /* scopeId */
  "data-v-d8e10d84",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.customerRevenueSingle = exports.typeRevenue = exports.customerCategoryActivity = exports.customerActivity = exports.customerRevenue = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'customers';

var customerRevenue = function customerRevenue(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var customerActivity = function customerActivity(params, cb, errorCb) {
    HttpService.get('customer-activity', params, cb, errorCb);
};

var customerCategoryActivity = function customerCategoryActivity(params, cb, errorCb) {
    HttpService.get('customer-category-activity', params, cb, errorCb);
};

var typeRevenue = function typeRevenue(params, cb, errorCb) {
    HttpService.get('customer-categories', params, cb, errorCb);
};

var customerRevenueSingle = function customerRevenueSingle(uuid, params, cb, errorCb) {
    HttpService.get(namespace + '/' + uuid, params, cb, errorCb);
};

exports.customerRevenue = customerRevenue;
exports.customerActivity = customerActivity;
exports.customerCategoryActivity = customerCategoryActivity;
exports.typeRevenue = typeRevenue;
exports.customerRevenueSingle = customerRevenueSingle;

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.update = exports.cleanup = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'settings';

var cleanup = function cleanup(params, cb, errorCb) {
    HttpService.get(namespace + '/cleanup', params, cb, errorCb);
};

var update = function update(body, cb, errorCb) {
    HttpService.post('company/settings', body, cb, errorCb);
};

exports.cleanup = cleanup;
exports.update = update;

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.singleRandom = exports.list = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'tips';

var list = function list(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var singleRandom = function singleRandom(params, cb, errorCb) {
    HttpService.get(namespace + '/single-random', params, cb, errorCb);
};

exports.list = list;
exports.singleRandom = singleRandom;

/***/ }),
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(372),
  /* template */
  __webpack_require__(894),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(595)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(403),
  /* template */
  __webpack_require__(836),
  /* scopeId */
  "data-v-2f6d19d5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(413),
  /* template */
  __webpack_require__(804),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(436),
  /* template */
  __webpack_require__(814),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {

    request: function request(req, token) {
        var API_URL = "https://api.proebitda.dk/v1";
        var authLoginUrl = API_URL + '/login';
        var resetLoginUrl = API_URL + '/password/reset';

        if (req.url === authLoginUrl || req.url === resetLoginUrl) {
            localStorage.removeItem('user-token');
            this.options.http._setHeaders.call(this, req, { Authorization: '' });
        } else {
            this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token });
        }
    },

    response: function response(res) {
        var token = res.data.access_token;

        if (token) {
            token = token.split(/Bearer\:?\s?/i);

            return token[token.length > 1 ? 1 : 0].trim();
        }
    }
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(949);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _index = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var routes = [{
  path: '/404',
  name: '404',
  redirect: '/',
  component: __webpack_require__(673)
}, {
  path: '*',
  redirect: '/'
}, {
  path: '/',
  name: 'Index',
  component: __webpack_require__(735),
  meta: {
    auth: true
  }
}, {
  path: '/mulige-indsatser',
  name: 'PossibleEfforts',
  component: __webpack_require__(736),
  meta: {
    auth: true
  }
}, {
  path: '/oekonomi',
  name: 'Economy',
  component: __webpack_require__(695),
  meta: {
    auth: true
  },
  children: [{
    path: 'drift',
    name: 'EconomyOperations',
    component: __webpack_require__(707)
  }, {
    path: 'oekonomi',
    name: 'EconomyLearning',
    component: __webpack_require__(696)
  }]
}, {
  path: '/kunder',
  name: 'Customers',
  component: __webpack_require__(676),
  meta: {
    auth: true
  },
  children: [{
    path: 'drift',
    name: 'CustomersOperations',
    component: __webpack_require__(678)
  }, {
    path: 'udvikling-og-laering',
    name: 'CustomersLearning',
    component: __webpack_require__(677)
  }]
}, {
  path: '/opgaver',
  name: 'Projects',
  component: __webpack_require__(752),
  meta: {
    auth: true
  },
  children: [{
    path: 'drift',
    name: 'ProjectsOperations',
    component: __webpack_require__(751)
  }, {
    path: 'udvikling-og-laering',
    name: 'ProjectsLearning',
    component: __webpack_require__(750)
  }]
}, {
  path: '/medarbejdere',
  name: 'Employees',
  component: __webpack_require__(709),
  meta: {
    auth: true
  },
  children: [{
    path: 'drift',
    name: 'EmployeesOperations',
    component: __webpack_require__(722)
  }, {
    path: 'udvikling-og-laering',
    name: 'EmployeesLearning',
    component: __webpack_require__(710)
  }]
}, {
  path: '/ansvarlige',
  name: 'Responsibles',
  component: __webpack_require__(754),
  meta: {
    auth: true
  }
}, {
  path: '/potentiale',
  name: 'Potential',
  component: __webpack_require__(738),
  meta: {
    auth: true
  }
}, {
  path: '/budget-laegning',
  name: 'BudgetPlanning',
  component: __webpack_require__(672),
  meta: {
    auth: true
  }
}, {
  path: '/register',
  name: 'Register',
  component: __webpack_require__(753),
  meta: {
    auth: false
  }
}, {
  path: '/login',
  name: 'Login',
  component: __webpack_require__(69),
  meta: {
    auth: false
  }
}, {
  path: '/indstillinger',
  name: 'Settings',
  component: __webpack_require__(785),
  meta: {
    auth: true
  }
}, {
  path: '/entreprise',
  name: 'Enterprise',
  component: __webpack_require__(731),
  meta: {
    auth: true
  }
}, {
  path: 'skift-virksomhed',
  name: 'ChangeCompany',
  component: __webpack_require__(774),
  meta: {
    auth: true
  }
}, {
  path: '/super-admin',
  name: 'SuperAdmin',
  component: __webpack_require__(786),
  meta: {
    auth: true
  }
}, {
  path: '/kommer-snart',
  name: 'ComingSoon',
  component: __webpack_require__(674),
  meta: {
    auth: true
  }
}, {
  path: '/tips',
  name: 'Tips',
  component: __webpack_require__(675),
  meta: {
    auth: true
  }
}];

var router = new _vueRouter2.default({
  mode: 'history',
  routes: routes
});

router.beforeEach(function (to, from, next) {
  var isInitialNavigation = from.matched.length === 0;
  var isFromLogin = from.path === '/login';

  if (to.path !== from.path && !isInitialNavigation && !isFromLogin) {
    (0, _index.cancelPendingRequests)();
  }
  next();
});

exports.default = router;

/***/ }),
/* 256 */,
/* 257 */,
/* 258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 259 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 260 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 261 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 262 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(604)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(327),
  /* template */
  __webpack_require__(853),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(629)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(911),
  /* scopeId */
  "data-v-87b029dc",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(633)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(328),
  /* template */
  __webpack_require__(923),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(628)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(330),
  /* template */
  __webpack_require__(910),
  /* scopeId */
  "data-v-804e69b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(607)
__webpack_require__(606)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(334),
  /* template */
  __webpack_require__(856),
  /* scopeId */
  "data-v-46c39325",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(608)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(335),
  /* template */
  __webpack_require__(861),
  /* scopeId */
  "data-v-4d680023",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(590)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(823),
  /* scopeId */
  "data-v-23bfba74",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(643)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(336),
  /* template */
  __webpack_require__(942),
  /* scopeId */
  "data-v-ee45503c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(587)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(341),
  /* template */
  __webpack_require__(821),
  /* scopeId */
  "data-v-22a330da",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(574)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(343),
  /* template */
  __webpack_require__(792),
  /* scopeId */
  "data-v-06a459bd",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(598)
__webpack_require__(597)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(344),
  /* template */
  __webpack_require__(838),
  /* scopeId */
  "data-v-30dee4b6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(586)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(819),
  /* scopeId */
  "data-v-20fa3fe5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(345),
  /* template */
  __webpack_require__(826),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(615)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(346),
  /* template */
  __webpack_require__(878),
  /* scopeId */
  "data-v-5e3ac208",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(636)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(347),
  /* template */
  __webpack_require__(930),
  /* scopeId */
  "data-v-cd5cc2c2",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(624)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(348),
  /* template */
  __webpack_require__(904),
  /* scopeId */
  "data-v-77c8f022",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(580)
__webpack_require__(579)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(815),
  /* scopeId */
  "data-v-1bc34b89",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(351),
  /* template */
  __webpack_require__(943),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(352),
  /* template */
  __webpack_require__(846),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(353),
  /* template */
  __webpack_require__(915),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(354),
  /* template */
  __webpack_require__(926),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(355),
  /* template */
  __webpack_require__(863),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(356),
  /* template */
  __webpack_require__(848),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(357),
  /* template */
  __webpack_require__(850),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(358),
  /* template */
  __webpack_require__(839),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(359),
  /* template */
  __webpack_require__(908),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(360),
  /* template */
  __webpack_require__(852),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(361),
  /* template */
  __webpack_require__(928),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(362),
  /* template */
  __webpack_require__(820),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony default export */ __webpack_exports__["default"] = ({
    close: 'Close',
    dataIterator: {
      pageText: 'Viser {0} - {1} af {2} resultater',
      noResultsText: 'Ingen resultater fundet',
      loadingText: 'Indlæser data...',
    },
    dataTable: {
      itemsPerPageText: 'Rækker per side:',
      ariaLabel: {
        sortDescending: ': Sorteret faldende. Aktivér for at fjerne sortering.',
        sortAscending: ': Sorteret stigende. Aktivér for at sortere faldende.',
        sortNone: ': Ikke sorteret. Aktivér for at sortere stigende.',
      },
      sortBy: 'Sorter efter',
    },
    dataFooter: {
      itemsPerPageText: 'Resultater pr side:',
      itemsPerPageAll: 'Alle',
      nextPage: 'Næste side',
      prevPage: 'Forrige side',
      firstPage: 'Første side',
      lastPage: 'Sidste side',
    },
    datePicker: {
      itemsSelected: '{0} valgt',
    },
    noDataText: 'Ingen data fundet',
    carousel: {
      prev: 'Forrige',
      next: 'Næste',
    },
    calendar: {
      moreEvents: '{0} flere',
    },
    fileInput: {
      counter: '{0} filer',
      counterSize: '{0} filer ({1} total)',
    },
});

/***/ }),
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedOption: {
                name: ''
            },
            showMenu: false,
            placeholderText: 'Please select an item'
        };
    },

    props: {
        options: {
            type: [Array, Object]
        },
        selected: {},
        placeholder: [String],
        closeOnOutsideClick: {
            type: [Boolean],
            default: true
        }
    },

    mounted: function mounted() {
        this.selectedOption = this.selected;
        if (this.placeholder) {
            this.placeholderText = this.placeholder;
        }

        if (this.closeOnOutsideClick) {
            document.addEventListener('click', this.clickHandler);
        }
    },
    beforeDestroy: function beforeDestroy() {
        document.removeEventListener('click', this.clickHandler);
    },


    methods: {
        updateOption: function updateOption(option) {
            this.selectedOption = option;
            this.showMenu = false;
            this.$emit('updateOption', this.selectedOption);
        },
        toggleMenu: function toggleMenu() {
            this.showMenu = !this.showMenu;
        },
        clickHandler: function clickHandler(event) {
            var target = event.target;
            var $el = this.$el;


            if (!$el.contains(target)) {
                this.showMenu = false;
            }
        }
    }
});

/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  components: {
    'layout': __webpack_require__(671)
  }
});

/***/ }),
/* 328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['headline', 'identifier'],
    data: function data() {
        return {
            show: false,
            content: null
        };
    },
    created: function created() {
        if (this.identifier !== null) {
            this.getDataFromContentful();
        }
    },

    methods: {
        showHelper: function showHelper() {
            this.show = true;
        },
        hideHelper: function hideHelper() {
            this.show = false;
        },
        getDataFromContentful: function getDataFromContentful() {
            var _this = this;

            var contentful = __webpack_require__(29);
            var client = contentful.createClient({
                space: '3h0kg5qa88is',

                accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            });

            client.getEntries({
                content_type: 'hjaelpebokse',

                'fields.relation[in]': this.identifier
            }).then(function (entries) {
                if (entries.items[0].fields.htmlIndhold.content.length > 0) {
                    _this.content = '<h1>' + _this.headline + '</h1>';
                    entries.items[0].fields.htmlIndhold.content.forEach(function (block) {
                        if (block.nodeType === 'heading-3') {
                            _this.content += '<h3>';
                            if (block.content.length > 0) {
                                block.content.forEach(function (childBlock) {
                                    if (childBlock.marks.length > 0) {
                                        childBlock.marks.forEach(function (mark) {
                                            if (mark.type === 'bold') {
                                                _this.content += '<b>';
                                            }
                                            if (mark.type === 'underline') {
                                                _this.content += '<u>';
                                            }
                                            _this.content += childBlock.value;
                                            if (mark.type === 'bold') {
                                                _this.content += '</b>';
                                            }
                                            if (mark.type === 'underline') {
                                                _this.content += '</u>';
                                            }
                                        });
                                    } else {
                                        _this.content += childBlock.value;
                                    }
                                });
                            } else {
                                _this.content += block.content[0].value;
                            }
                            _this.content += '</h3>';
                        }
                        if (block.nodeType === 'paragraph') {
                            _this.content += '<p>';
                            if (block.content.length > 0) {
                                block.content.forEach(function (childBlock) {
                                    if (childBlock.marks.length > 0) {
                                        childBlock.marks.forEach(function (mark) {
                                            if (mark.type === 'bold') {
                                                _this.content += '<b>';
                                            }
                                            if (mark.type === 'underline') {
                                                _this.content += '<u>';
                                            }
                                            _this.content += childBlock.value;
                                            if (mark.type === 'bold') {
                                                _this.content += '</b>';
                                            }
                                            if (mark.type === 'underline') {
                                                _this.content += '</u>';
                                            }
                                        });
                                    } else {
                                        _this.content += childBlock.value;
                                    }
                                });
                            } else {
                                _this.content += block.content[0].value;
                            }
                            _this.content += '</p>';
                        }
                        if (block.nodeType === 'unordered-list') {
                            _this.content += '<ul style="padding-left:40px;margin-bottom:15px;">';
                            block.content.forEach(function (listItem) {
                                _this.content += '<li>';
                                if (listItem.content[0].content.length > 0) {
                                    listItem.content[0].content.forEach(function (childListItem) {
                                        if (childListItem.marks.length > 0) {
                                            listItem.content[0].content[0].marks.forEach(function (mark) {
                                                if (mark.type === 'bold') {
                                                    _this.content += '<b>';
                                                }
                                                if (mark.type === 'underline') {
                                                    _this.content += '<u>';
                                                }
                                                _this.content += listItem.content[0].content[0].value;
                                                if (mark.type === 'bold') {
                                                    _this.content += '</b>';
                                                }
                                                if (mark.type === 'underline') {
                                                    _this.content += '</u>';
                                                }
                                            });
                                        } else {
                                            _this.content += childListItem.value;
                                        }
                                        _this.content += '<br>';
                                    });
                                } else {}
                                _this.content += '</li>';
                            });
                            _this.content += '</ul>';
                        }
                        if (block.nodeType === 'ordered-list') {
                            _this.content += '<ol style="padding-left:40px;margin-bottom:15px;">';
                            block.content.forEach(function (listItem) {
                                _this.content += '<li>';
                                if (listItem.content[0].content.length > 0) {
                                    listItem.content[0].content.forEach(function (childListItem) {
                                        if (childListItem.marks.length > 0) {
                                            listItem.content[0].content[0].marks.forEach(function (mark) {
                                                if (mark.type === 'bold') {
                                                    _this.content += '<b>';
                                                }
                                                if (mark.type === 'underline') {
                                                    _this.content += '<u>';
                                                }
                                                _this.content += listItem.content[0].content[0].value;
                                                if (mark.type === 'bold') {
                                                    _this.content += '</b>';
                                                }
                                                if (mark.type === 'underline') {
                                                    _this.content += '</u>';
                                                }
                                            });
                                        } else {
                                            _this.content += childListItem.value;
                                        }
                                        _this.content += '<br>';
                                    });
                                } else {}
                                _this.content += '</li>';
                            });
                            _this.content += '</ol>';
                        }
                    });
                }
            }).catch(function (err) {
                return console.log(err);
            });
        }
    }
});

/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['height']
});

/***/ }),
/* 330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['project'],
    data: function data() {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        };
    }
});

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dropdowns__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_dropdowns___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_dropdowns__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            departments: [],
            selectedDepartment: null,
            selectedTimePeriod: 'Vælg tidsinterval',
            datepickerLocale: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["da"]
        };
    },
    mounted: function mounted() {
        this.getDepartments();
    },

    methods: {
        selectAccountingYear: function selectAccountingYear(accountingYear) {
            var dates = {
                startDate: accountingYear.from_date,
                endDate: accountingYear.to_date
            };
            this.$store.commit('setDates', dates);
            this.selectedTimePeriod = 'Vælg tidsinterval';
        },
        goToCleanUp: function goToCleanUp() {
            this.$router.push({ name: 'Settings', params: { selected: 'cleanup' } });
        },
        getDepartments: function getDepartments() {
            this.departments = this.$store.getters.getAvailableDepartments;
            this.selectedDepartment = this.$store.getters.getCurrentDepartment;
            this.departments.push({ name: 'Ingen afdeling tilknyttet' });
            if (this.$auth.user().roles[0].name === 'department-responsible') {
                if (!this.$auth.user().department || !this.$auth.user().relation_department_id) {
                    alert('Din profil er oprettet som afdelingsansvarlig, men du er ikke tilknyttet en afdeling. Du logges nu ud af proEBITDA. Kontakt din administrator for at opdatere din brugerprofil.');
                    this.$auth.logout();
                }
                console.log('Du er afdelingsansvarlig! Nice...');
                this.selectDepartment(this.$auth.user().department);
                this.selectedDepartment = this.$auth.user().department;
            }
        },
        selectDepartment: function selectDepartment(department) {
            this.selectedTimePeriod = 'Vælg tidsinterval';
            if (department.name === 'Ingen afdeling tilknyttet') {
                this.$router.push({ name: 'Settings', params: { selected: 'cleanup' } });
            } else {
                this.$store.commit('setCurrentDepartment', department);
            }
        },
        selectTimePeriod: function selectTimePeriod(event) {
            var _this = this;

            this.customTimeIntervals.forEach(function (interval) {
                if (interval.name === event.target.value) {
                    _this.$store.state.config.startDate = interval.start;
                    _this.$store.state.config.endDate = interval.end;
                }
            });
        }
    },
    components: {
        Datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
        dropdown: __WEBPACK_IMPORTED_MODULE_2_vue_dropdowns___default.a
    },
    computed: {
        startDate: function startDate() {
            return this.$store.state.getters.getStartDate;
        },
        customTimeIntervals: function customTimeIntervals() {
            var timeIntervals = [{
                name: 'Denne uge',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('week').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('week').format('YYYY-MM-DD')
            }, {
                name: 'Sidste uge',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'week').startOf('week').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(1, 'week').endOf('week').format('YYYY-MM-DD')
            }, {
                name: 'Denne måned',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().startOf('month').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().endOf('month').format('YYYY-MM-DD')
            }, {
                name: 'Sidste 3 måneder',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(3, 'months').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
            }, {
                name: 'Sidste 6 måneder',
                start: __WEBPACK_IMPORTED_MODULE_3_moment___default()().subtract(6, 'months').format('YYYY-MM-DD'),
                end: __WEBPACK_IMPORTED_MODULE_3_moment___default()().format('YYYY-MM-DD')
            }];
            return timeIntervals;
        }
    }
});

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['identifier', 'type'],
    data: function data() {
        return {
            content: null
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            var contentful = __webpack_require__(29);
            var client = contentful.createClient({
                space: '3h0kg5qa88is',

                accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            });

            client.getEntries({
                content_type: 'budgetmodul',

                'fields.identifier[in]': this.identifier
            }).then(function (entries) {
                if (entries.items[0].fields.content.content.length > 0) {
                    _this.content = '';
                    _this.content += '<div style="margin-bottom:-15px;">';
                    entries.items[0].fields.content.content.forEach(function (content) {
                        if (content.nodeType === 'paragraph') {
                            _this.content += '<p style="margin-bottom:15px;">' + content.content[0].value + '</p>';
                        } else if (content.nodeType === 'unordered-list') {
                            _this.content += '<ul style="padding-left:20px;margin-bottom:15px;">';
                            content.content.forEach(function (listItem) {
                                _this.content += '<li>' + listItem.content[0].content[0].value + '</li>';
                            });
                            _this.content += '</ul>';
                        }
                    });
                    _this.content += '</div>';
                    _this.content = _this.content.replace(/(?:\r\n|\r|\n)/g, '<br>');
                }
            }).catch(function (err) {
                return console.log(err);
            });
        }
    }
});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);




var DASH = '4 3';

/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        months: Array,
        wip: Object
    },
    data: function data() {
        return {
            colors: {
                budget: '#172b43',
                positive: '#4CAF50',
                negative: '#FF5252',
                positiveFaded: 'rgba(76, 175, 80, 0.35)',
                negativeFaded: 'rgba(255, 82, 82, 0.35)'
            }
        };
    },

    computed: {
        current: function current() {
            return this.months.findIndex(function (month) {
                return month.forecast !== null;
            });
        },
        remaining: function remaining() {
            return this.months.slice(this.current);
        },
        labels: function labels() {
            var _this = this;

            return this.remaining.map(function (month) {
                return _this.$options.filters.moment(month.month, 'MMM');
            });
        },
        realizedToDate: function realizedToDate() {
            return this.months.slice(0, this.current + 1).reduce(function (sum, month) {
                return sum + (month.realized || 0);
            }, 0);
        },
        wipPerMonth: function wipPerMonth() {
            var ongoing = (this.wip && this.wip.ongoing || 0) / this.remaining.length;
            var unbilled = this.wip && this.wip.unbilled || 0;
            return this.remaining.map(function (month, index) {
                return ongoing + (index === 0 ? unbilled : 0);
            });
        },
        forecastAccumulated: function forecastAccumulated() {
            return this.accumulate(function (month) {
                return month.forecast;
            });
        },
        budgetAccumulated: function budgetAccumulated() {
            return this.accumulate(function (month) {
                return month.budget_rest;
            });
        },
        series: function series() {
            var _this2 = this;

            return [{
                name: 'Budget',
                data: this.remaining.map(function (month, index) {
                    return { x: _this2.labels[index], y: Math.round(_this2.budgetAccumulated[index]) };
                })
            }, {
                name: 'Forventet',
                data: this.remaining.map(function (month, index) {
                    var value = _this2.forecastAccumulated[index];
                    var positive = value >= 0;
                    return {
                        x: _this2.labels[index],
                        y: Math.round(value),
                        fillColor: positive ? _this2.colors.positiveFaded : _this2.colors.negativeFaded,
                        strokeColor: positive ? _this2.colors.positive : _this2.colors.negative
                    };
                })
            }];
        },
        options: function options() {
            var _this3 = this;

            return {
                colors: [this.colors.budget, this.colors.positive],
                plotOptions: {
                    bar: {
                        columnWidth: '70%'
                    }
                },
                fill: {
                    opacity: 1
                },
                stroke: {
                    show: true,
                    width: 2,
                    colors: ['transparent']
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    show: false
                },
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return _this3.$options.filters.currency(value);
                        }
                    },
                    forceNiceScale: true
                },
                chart: {
                    toolbar: {
                        show: false
                    },
                    zoom: {
                        enabled: false
                    },
                    events: {
                        mounted: function mounted(chart) {
                            return _this3.dashForecast(chart);
                        },
                        updated: function updated(chart) {
                            return _this3.dashForecast(chart);
                        }
                    }
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    y: {
                        formatter: function formatter(value) {
                            return value === null || value === undefined ? '-' : _this3.$options.filters.currency(value);
                        },
                        title: {
                            formatter: function formatter(name) {
                                return name + ': ';
                            }
                        }
                    }
                }
            };
        }
    },
    methods: {
        accumulate: function accumulate(amount) {
            var _this4 = this;

            var sum = this.realizedToDate;
            return this.remaining.map(function (month, index) {
                sum += (amount(month) || 0) + _this4.wipPerMonth[index];
                return sum;
            });
        },
        dashForecast: function dashForecast(chart) {
            chart.el.querySelectorAll('path.apexcharts-bar-area[index="1"]').forEach(function (path) {
                path.setAttribute('stroke-dasharray', DASH);
            });
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    }
});

/***/ }),
/* 334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_calculationService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_calculationService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__services_calculationService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale__);











/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        Datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__["a" /* default */],
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_4_vue_apexcharts___default.a
    },
    props: {
        heading: String,
        unit: String,
        ylabel: String,
        height: String,
        trend: Boolean,
        endpoint: String,
        paramsInEndpoint: Boolean,
        dynamicInterval: Boolean,
        series: Array
    },
    data: function data() {
        var _this = this;

        return {
            datepickerLocale: __WEBPACK_IMPORTED_MODULE_7_vuejs_datepicker_dist_locale__["da"],
            loading: true,
            startDate: this.$store.state.config.startDate,
            endDate: this.$store.state.config.endDate,
            values: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.series)),
            options: {
                colors: ['#172b43', '#F44336', '#9C27B0', '#3F51B5', '#4CAF50', '#FF9800'],
                labels: [],
                plotOptions: {
                    bar: {
                        columnWidth: '50%'
                    }
                },
                stroke: {
                    width: [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(function () {
                        return _this.series.map(function (series) {
                            return series.width;
                        });
                    }()), [3]),
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return Math.round(value) + ' ' + _this.unit;
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    min: 0,
                    max: 100
                },
                tooltip: {
                    shared: true,
                    intersect: false,
                    followCursor: true,
                    y: {
                        formatter: function formatter(y) {
                            if (typeof y !== 'undefined') {
                                return y.toFixed(0) + ' ' + _this.unit;
                            }
                            return y;
                        }
                    }
                },
                chart: {
                    toolbar: {
                        show: false
                    }
                }
            }
        };
    },

    computed: {
        companyId: function companyId() {
            return this.$store.state.companyId || this.$auth.user().company_id;
        },
        dataUrl: function dataUrl() {
            return this.endpoint + (this.paramsInEndpoint ? '&' : '?') + 'date_from=' + this.formatDate(this.startDate) + '&date_to=' + this.formatDate(this.endDate);
        },
        storeStartDate: function storeStartDate() {
            return this.$store.state.config.startDate;
        },
        storeEndDate: function storeEndDate() {
            return this.$store.state.config.endDate;
        },
        getSeries: function getSeries() {
            if (this.trend) {
                return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.values), [this.average]);
            } else {
                return [].concat(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(this.values));
            }
        },
        average: function average() {
            var averages = [];
            if (this.values[0].data) {
                var sum = 0;
                var n = 1;
                this.values[0].data.forEach(function (value) {
                    sum += value;
                    averages.push(sum / n);
                    n++;
                });
            }
            return {
                name: 'Trend',
                type: 'line',
                data: averages
            };
        }
    },
    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_5__services_calculationService__["find"](this.dataUrl, {}, function (response) {
                _this2.options = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.options, {
                    labels: response.data.labels
                });

                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(response.data.values).forEach(function (seriesKey, index) {
                    _this2.values = [__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, _this2.values[index], {
                        data: response.data.values[seriesKey]
                    })];
                    var maxValue = Math.max.apply(Math, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_toConsumableArray___default()(_this2.values[index].data));
                    if (_this2.dynamicInterval && maxValue > _this2.options.yaxis.max) {
                        _this2.options.yaxis.max = maxValue * 1.2;
                    }
                });
                _this2.loading = false;
            }, function (err) {
                _this2.loading = false;
                return err;
            });
        },
        formatDate: function formatDate(date) {
            return __WEBPACK_IMPORTED_MODULE_6_moment___default()(date).format('YYYY-MM-DD');
        }
    },
    created: function created() {
        this.getData();
    },

    watch: {
        storeStartDate: function storeStartDate(date) {
            this.startDate = date;
        },
        storeEndDate: function storeEndDate(date) {
            this.endDate = date;
        },
        dataUrl: function dataUrl() {
            this.getData();
        }
    }
});

/***/ }),
/* 335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        project: { type: Object },
        closed: {
            type: Boolean,
            default: false
        }
    },
    data: function data() {
        return {
            loading: false,
            show: false,
            options: {
                popover: {
                    defaultClass: 'mb-tooltip',
                    defaultBaseClass: 'mb-tooltip',
                    trigger: 'hover'
                }
            },
            minubaBudget: null
        };
    },
    mounted: function mounted() {},

    methods: {
        getData: function getData() {
            var _this = this;

            this.minubaBudget = null;
            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["getBudget"](this.project.uuid, {}, function (response) {
                _this.minubaBudget = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        sum: function sum(arr, key) {
            return arr.reduce(function (a, b) {
                return a + (Number(b[key]) || 0);
            }, 0);
        },
        ccp: function ccp(revenue, expenses) {
            if (revenue > 0 && expenses > 0) {
                return Math.round(expenses / revenue * 100);
            }
            return 0;
        },
        notBudgetted: function notBudgetted() {
            var value = this.project.total_expenses - this.sum(this.minubaBudget.budget_lines, 'expended_cost');
            return value > 0 ? value : 0;
        }
    },
    computed: {
        filteredBudgetLines: function filteredBudgetLines() {
            if (this.minubaBudget && this.minubaBudget.budget_lines) {
                return this.minubaBudget.budget_lines.filter(function (x) {
                    return x.proposal_cost || x.order_cost || x.expended_cost;
                });
            }
            return [];
        }
    },
    watch: {
        show: function show(newVal, oldVal) {
            if (!this.minubaBudget) {
                if (oldVal === false && newVal === true) {
                    this.getData();
                }
            }
        }
    }
});

/***/ }),
/* 336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            paused: true
        };
    },

    methods: {
        startCounter: function startCounter() {
            this.$refs.counter.start();
        },
        goTo: function goTo() {
            if (this.doEmit) {
                this.$emit('clicked');
            } else {
                if (this.linkParent) {
                    this.$router.push({
                        name: this.linkParent,
                        params: {
                            selectedItem: this.linkChild
                        },
                        query: {
                            tab: this.linkChild
                        }
                    });
                }
            }
        }
    },
    props: ['heading', 'description', 'number', 'icon', 'state', 'totalValue', 'linkParent', 'linkChild', 'tooltipIdentifier', 'doEmit', 'selected']
});

/***/ }),
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['selectedBox', 'data', 'customersMakingMoneyRange', 'smallAndBigRange', 'texts'],
    data: function data() {
        return {
            selectedItem: 'makingMoney',
            customersColumns: [{ label: 'Kunde', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours_total', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            smallAndBigColumns: [{ label: 'Omsætning pr. kunde', field: 'name', type: 'string', sortable: false }, { label: 'Kunder', field: 'customers_count', type: 'number' }, { label: 'Omsætning i alt', field: 'invoices_total', width: '10%', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        goToRoute: function goToRoute(parent, child) {
            this.$router.push({
                name: parent,
                params: {
                    selectedItem: child
                },
                query: {
                    tab: child
                }
            });
        }
    },
    watch: {
        selectedBox: function selectedBox() {
            if (this.selectedBox) {
                this.selectedItem = this.selectedBox;
            } else {
                this.selectedItem = 'makingMoney';
            }
        }
    }
});

/***/ }),
/* 338 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['selectedBox', 'data', 'totalOpenValue', 'totalAcontoValue', 'totalRemindersValue', 'texts'],
    data: function data() {
        return {
            selectedItem: 'projects',
            openColumns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Forv. DB', field: 'expected_coverage', type: 'number' }, { label: 'Status', field: 'status.name', type: 'string' }],
            acontoColumns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Aconto', field: 'invoices_total', type: 'number' }, { label: 'Timer/materialer, kostpris', field: 'total_expenses', type: 'number' }, { label: 'Værdi, salgspris', field: 'value_with_avg_cp', type: 'number' }, { label: 'Status', field: 'status.name', type: 'string' }],
            unpaidInvoicesColumns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true }, { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            openSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'expected_coverage',
                    type: 'desc'
                }
            },
            acontoSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'value_with_avg_cp',
                    type: 'desc'
                }
            },
            unpaidInvoicesSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'amount',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.openColumns.push({ label: 'Åbn', field: 'minuba_external_id' });
            this.acontoColumns.push({ label: 'Åbn', field: 'minuba_external_id' });
            this.unpaidInvoicesColumns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    },

    methods: {
        goToRoute: function goToRoute(parent, child) {
            this.$router.push({
                name: parent,
                params: {
                    selectedItem: child
                },
                query: {
                    tab: child
                }
            });
        }
    },
    watch: {
        selectedBox: function selectedBox() {
            if (this.selectedBox) {
                this.selectedItem = this.selectedBox;
            } else {
                this.selectedItem = 'projects';
            }
        }
    }
});

/***/ }),
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['selectedBox', 'data', 'employeesRightPeoplePossibleRevenue', 'projects', 'texts'],
    data: function data() {
        return {
            selectedItem: 'moreTime',
            moreTimeColumns: [{ label: 'Type', field: 'type', type: 'string' }, { label: 'Tid (%)', field: 'percentage', type: 'number' }, { label: 'Antal timer', field: 'hours', type: 'number' }],
            employeesSicknessRateColumns: [{ label: 'Medarbejder', field: 'name', type: 'string' }, { label: 'Sygefravær (%)', field: 'sickness_percentage', type: 'number' }, { label: 'Antal timer', field: 'sickness_hours', type: 'number' }],
            rightPeopleColumns: [{ label: 'Initialer', field: 'initials', type: 'string' }, { label: 'Medarbejder', field: 'full_name', type: 'string' }, { label: 'Antal opgaver', field: 'total_projects', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'percentage',
                    type: 'desc'
                }
            },
            employeesSicknessRateSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'sickness_percentage',
                    type: 'desc'
                }
            },
            rightPeopleSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_per_hour',
                    type: 'desc'
                }
            },
            mostImportantSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_total',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        goToRoute: function goToRoute(parent, child) {
            this.$router.push({
                name: parent,
                params: {
                    selectedItem: child
                },
                query: {
                    tab: child
                }
            });
        }
    },
    watch: {
        selectedBox: function selectedBox() {
            if (this.selectedBox) {
                this.selectedItem = this.selectedBox;
            } else {
                this.selectedItem = 'moreTime';
            }
        }
    }
});

/***/ }),
/* 340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['selectedBox', 'data', 'projectsRightProjectsRange', 'projectsMostImportantRange', 'texts'],
    data: function data() {
        return {
            selectedItem: 'rightProjects',
            rightProjectsColumns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours_total', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            mostImportantColumns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'projects_count', type: 'number' }, { label: 'DB (sum)', field: 'coverage_total', type: 'number' }, { label: 'DB udv.', field: 'coverage.progress_percent', type: 'number' }, { label: 'DB/time (sum)', field: 'coverage_per_hour_total', type: 'number' }, { label: 'DB/time udv.', field: 'coverage_per_hour.progress_percent', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            mostImportantSortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_total',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        goToRoute: function goToRoute(parent, child) {
            this.$router.push({
                name: parent,
                params: {
                    selectedItem: child
                },
                query: {
                    tab: child
                }
            });
        }
    },
    watch: {
        selectedBox: function selectedBox() {
            if (this.selectedBox) {
                this.selectedItem = this.selectedBox;
            } else {
                this.selectedItem = 'rightProjects';
            }
        }
    }
});

/***/ }),
/* 341 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        project: { type: Object },
        valueBased: { type: Boolean, default: false },
        valueBasedWithCP: { type: Boolean, default: false }
    },
    data: function data() {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        };
    }
});

/***/ }),
/* 342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            routes: [{
                name: 'Startside',
                icon: 'home',
                route: 'Index',
                onlySuperAdmin: false
            }, {
                name: 'Økonomi',
                icon: 'wallet',
                route: 'Economy',
                onlySuperAdmin: true
            }, {
                name: 'Kunder',
                icon: 'briefcase',
                route: 'Customers',
                onlySuperAdmin: true
            }, {
                name: 'Opgaver',
                icon: 'clipboard-list-check',
                route: 'ProjectsOperations',
                onlySuperAdmin: false
            }, {
                name: 'Medarbejdere',
                icon: 'users',
                route: 'Employees',
                onlySuperAdmin: true
            }, {
                name: 'Indstillinger',
                icon: 'cog',
                route: 'Settings',
                onlySuperAdmin: true
            }, {
                name: 'Super Admin',
                icon: 'user-cog',
                route: 'SuperAdmin',
                onlySuperAdmin: true
            }]
        };
    },

    computed: {
        initials: function initials() {
            if (this.$auth.user().name) {
                var initials = this.$auth.user().name.split(' ').map(function (n) {
                    return n[0];
                }).join('');
                var splittedString = initials.match(/.{1,2}/g);
                return splittedString[0];
            }
        },
        lastSync: function lastSync() {
            if (this.$store.state.config && this.$store.state.config.lastSynced) {
                var date = this.$store.state.config.lastSynced;
                var formatted = __WEBPACK_IMPORTED_MODULE_0_moment___default()(date).format('D. MMMM YYYY [kl.] HH:mm');

                return formatted;
            }
            return null;
        }
    },
    methods: {
        goToRoute: function goToRoute(item) {
            if (this.$auth.user().userrole_id === 1) {
                this.$router.push({ name: item.route });
            } else {
                this.$router.push({ name: 'ComingSoon' });
            }
        },
        subIsActive: function subIsActive(input) {
            var _this = this;

            var paths = Array.isArray(input) ? input : [input];
            return paths.some(function (path) {
                return _this.$route.path.indexOf(path) === 0;
            });
        },
        logout: function logout() {
            this.$auth.logout({
                makeRequest: true
            });
        }
    }
});

/***/ }),
/* 343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['heading', 'number'],
    components: {}
});

/***/ }),
/* 344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__);








/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            datepickerLocale: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__["da"],
            loading: true,
            search: '',
            startDate: this.$store.state.config.startDate,
            endDate: this.$store.state.config.endDate,
            data: []
        };
    },

    props: ['heading', 'endpoint', 'headers', 'customClass', 'icon', 'group', 'filters', 'includes'],
    computed: {
        companyId: function companyId() {
            return this.$store.state.companyId || this.$auth.user().company_id;
        },
        dataUrl: function dataUrl() {
            return this.endpoint + '/' + this.companyId + '/' + this.formatDate(this.startDate) + '/' + this.formatDate(this.endDate) + this.filterString + this.includeString;
        },
        storeStartDate: function storeStartDate() {
            return this.$store.state.config.startDate;
        },
        storeEndDate: function storeEndDate() {
            return this.$store.state.endDate;
        },
        items: function items() {
            return this.data.map(function (project) {
                return {
                    name: project.description,
                    customer: project.customer.name,
                    project: project.description,
                    projectType: project.type.name,
                    revenue: '-',
                    date: project.start_date,
                    db: project.coverage,
                    dbPerHour: project.coverage_per_hour,
                    dg: project.coverage_percent,
                    projectmanager: project.projectmanager
                };
            });
        },
        filterString: function filterString() {
            var _this = this;

            var filters = '';
            if (this.filters) {
                __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.filters).forEach(function (filter, filterCounter) {
                    if (filterCounter === 0) {
                        filters += '?filter[' + filter + ']=';
                    } else {
                        filters += '&filter[' + filter + ']=';
                    }
                    _this.filters[filter].forEach(function (value, valueCounter) {
                        if (valueCounter === 0) {
                            filters += value;
                        } else {
                            filters += ', ' + value;
                        }
                    });
                });
            }
            return filters;
        },
        includeString: function includeString() {
            var includes = '';
            if (this.includes) {
                if (this.filters) includes += '&';
                this.includes.forEach(function (include, includeCounter) {
                    if (includeCounter === 0) {
                        includes += 'include=' + include;
                    } else {
                        includes += ',' + include;
                    }
                });
            }
            return includes;
        }
    },
    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](this.dataUrl, {}, function (response) {
                _this2.data = response.data.data;
                setTimeout(function () {
                    _this2.loading = false;
                }, 2000);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        formatDate: function formatDate(date) {
            return __WEBPACK_IMPORTED_MODULE_3_moment___default()(date).format('YYYY-MM-DD');
        }
    },
    created: function created() {},

    watch: {
        storeStartDate: function storeStartDate(date) {
            this.startDate = date;
        },
        storeEndDate: function storeEndDate(date) {
            this.endDate = date;
        },
        dataUrl: function dataUrl() {
            this.getData();
        }
    },
    components: {
        Datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */]
    }
});

/***/ }),
/* 345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        selectedItem: String,
        items: Array,
        counts: Object
    },
    methods: {
        handleClick: function handleClick(item) {
            this.$emit('selectItem', item);
        }
    }
});

/***/ }),
/* 346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);



/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        identifier: String,
        placement: String,
        icon: String,
        space: Boolean
    },
    data: function data() {
        return {
            options: {
                content: null,
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip'
                }
            }
        };
    },
    created: function created() {
        if (this.identifier !== null) {
            this.getDataFromContentful();
        }
    },

    methods: {
        getDataFromContentful: function getDataFromContentful() {
            var _this = this;

            var contentful = __webpack_require__(29);
            var client = contentful.createClient({
                space: '3h0kg5qa88is',

                accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            });

            client.getEntries({
                content_type: 'informationsbokse',

                'fields.relation[in]': this.identifier
            }).then(function (entries) {
                if (entries.items[0].fields.htmlForklaring.content.length > 0) {
                    _this.options.content = '';
                    _this.options.content += '<div style="margin-bottom:-15px;">';
                    entries.items[0].fields.htmlForklaring.content.forEach(function (content) {
                        if (content.nodeType === 'paragraph') {
                            _this.options.content += '<p style="margin-bottom:15px;">' + content.content[0].value + '</p>';
                        } else if (content.nodeType === 'unordered-list') {
                            _this.options.content += '<ul style="padding-left:20px;margin-bottom:15px;">';
                            content.content.forEach(function (listItem) {
                                _this.options.content += '<li>' + listItem.content[0].content[0].value + '</li>';
                            });
                            _this.options.content += '</ul>';
                        }
                    });
                    _this.options.content += '</div>';
                    _this.options.content = _this.options.content.replace(/(?:\r\n|\r|\n)/g, '<br>');
                }
            }).catch(function (err) {
                return console.log(err);
            });
        },
        click: function click() {
            this.$emit('clicked');
        }
    },
    computed: {
        styleOptions: function styleOptions() {
            var cases = {
                left: 'float: left',
                right: 'float: right',
                inline: 'display: inline-block'
            };
            if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cases).includes(this.placement)) {
                console.log('fejl i placement prop');
                return '';
            }
            return cases[this.placement];
        }
    }
});

/***/ }),
/* 347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['headline', 'position', 'customClass']
});

/***/ }),
/* 348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        operationsName: {
            required: true,
            type: String
        },
        operationsLink: {
            required: true,
            type: String
        },
        learningName: {
            required: true,
            type: String
        },
        learningLink: {
            required: true,
            type: String
        }

    },
    methods: {
        doToggle: function doToggle(state, routeName) {
            this.$store.state.view = state;
            this.$router.push({ name: routeName });
        }
    }
});

/***/ }),
/* 349 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            show: false,
            abbreviations: [{
                abb: 'EBITDA',
                exp: 'Resultatet før renter, skat, afskrivninger og nedbringelse af gæld',
                comment: 'EBITDA er virksomhedens driftsoverskud. Med andre ord viser EBTIDA, hvor stærk en “motor” virksomheden har til at kunne betale renter, afbetale på gæld og mindst lige så vigtig at skabe overskud til virksomhedens ejer. EBITDA er også en væsentligt indikator for, hvor meget virksomheden er værd. Hvor meget vil du betale for en virksomhed, der har et driftsoverskud på 300.000 kr.? Hvis virksomheden sælges for f.eks. 1.500.000 kr., vil det tage 5 år, inden investeringen er kommet hjem. For hver krone EBTIDA øges, vil virksomheden stige i værdi.'
            }, {
                abb: 'DB',
                exp: 'Dækningsbidrag',
                comment: 'Dækningsbidraget er et udtryk for, hvor stort et beløb der er tilbage på en opgave, når de direkte omkostninger er afholdt (lønninger, materialer). Dækningsbidrag er dermed lig overskud pr. opgave.'
            }, {
                abb: 'DG',
                exp: 'Dækningsgrad',
                comment: 'Dækningsgraden er et udtryk for hvor meget dit overskud pr. opgave udgør i % af den samlede omsætning på en opgave. Hvis du eksempelvis har opnået et overskud på 2.000 kr på en opgave til 4.000 kr vil din DG være 50 (50%).'
            }, {
                abb: 'DB pr. time',
                exp: 'Dækningsbidrag pr. time',
                comment: 'Dækningsbidraget pr. time er et udtryk for dækningsbidraget divideret med antal timer brugt. Dvs. hvor "effektive" svendene har været. DB. pr time er dermed lig overskud pr. time.'
            }]
        };
    },

    methods: {
        toggle: function toggle() {
            this.show = !this.show;
        }
    }
});

/***/ }),
/* 350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_Sidebar__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_elements_Sidebar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_elements_Sidebar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_ConfigBar__ = __webpack_require__(662);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_elements_ConfigBar___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_elements_ConfigBar__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_footer__ = __webpack_require__(670);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_layout_footer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_layout_footer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_tipService__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_tipService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_tipService__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            dailyTip: null
        };
    },

    components: {
        Sidebar: __WEBPACK_IMPORTED_MODULE_0__components_elements_Sidebar___default.a,
        ConfigBar: __WEBPACK_IMPORTED_MODULE_1__components_elements_ConfigBar___default.a,
        'foo': __WEBPACK_IMPORTED_MODULE_2__components_layout_footer___default.a
    },
    created: function created() {
        this.$store.dispatch('getConfig');
        this.checkUser();
        this.getDailyTip();
    },

    methods: {
        checkUser: function checkUser() {
            if (this.$auth.user() && this.$auth.user().relation_employee_id) {
                this.$router.push({ name: 'Responsibles' });
            }
        },
        getDailyTip: function getDailyTip() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_3__services_tipService__["singleRandom"]({}, function (response) {
                _this.dailyTip = response.data;
            }, function (err) {
                alert('Der skete en fejl...');
                console.log(err);
            });
        }
    },
    watch: {
        $route: function $route(to, from) {
            this.checkUser();
        }
    }
});

/***/ }),
/* 351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_invoiceService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Type', field: 'type', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true }, { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions, {
                initialSortBy: {
                    field: 'customer_name',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table',
            params: {}
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["all"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_invoiceService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left' }, { label: 'Ordre', field: 'project.case_number', type: 'string', width: '10%', align: 'left' }, { label: 'Kunde', field: 'customer.name', type: 'string', width: '15%' }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%' }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%' }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions),
            styleClass: 'vgt-table',
            params: {
                'filter[unpaid]': true,
                'filter[overdue]': true,
                'filter[type]': '1,3',
                'include': 'customer'
            }
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'project.minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[unpaid]': 'true',
                'filter[overdue]': true,
                'filter[type]': '1,3',
                include: 'customer,project',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_invoiceService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true }, { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions, {
                initialSortBy: {
                    field: 'customer_name',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["unpaid"](params, function (response) {
                console.log(response.data);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    }
});

/***/ }),
/* 354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[complaint]': true,
                'filter[status]': 'pending,ongoing',
                'filter[visible]': true,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            testData: [],
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Installationsadresse', field: 'installation_address.full_text', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions, {
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            }),
            styleClass: 'vgt-table',
            params: {
                'filter[status]': 'billed,posted',
                'include': 'customer,type,installationAddress'
            }
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            if (this.$store.state.closedRows.length) {
                this.$store.commit('setClosedRows', null);
            }
            this.loading = true;
            this.$emit('finishedLoading', null);
            var dateFrom = this.$store.getters.getStartDate;
            var dateTo = this.$store.getters.getEndDate;
            var params = {
                'filter[status]': 'billed,posted',
                include: 'customer,type,installationAddress',
                'filter[between]': dateFrom + ',' + dateTo
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
                _this.$store.commit('setClosedRows', _this.rows);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 356 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            explanation: 'Denne tabel viser alle opgaver med en status, der angiver at den er afsluttet, men hvor der endnu ikke ligger en eller flere fakturaer tilknyttet opgaven. Hvis opgaven <b>er</b> blevet faktureret, bør du undersøge om fakturaen er tilknyttet opgaven i dit ordrestyrings-program.',
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions, {
                initialSortBy: {
                    field: 'start_date',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.columns = [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Aconto', field: 'invoices_total', type: 'number' }, { label: 'Timer/materialer, kostpris', field: 'total_expenses', type: 'number' }, { label: 'Værdi, salgspris', field: 'value_with_avg_cp', type: 'number' }, { label: 'Status', field: 'status.name', type: 'string' }];
        this.sortOptions.initialSortBy = {
            field: 'value_with_avg_cp',
            type: 'desc'
        };

        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'unbilled',

                'filter[visible]': true,
                include: 'type,customer,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        totalValue: function totalValue() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value;
                });
                return total;
            }
            return 0;
        },
        totalValueWithCP: function totalValueWithCP() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value_with_avg_cp;
                });
                return total;
            }
            return 0;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'offer',
                'filter[visible]': true,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.columns = [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Aconto', field: 'invoices_total', type: 'number' }, { label: 'Timer/materialer, kostpris', field: 'total_expenses', type: 'number' }, { label: 'Værdi, salgspris', field: 'value_with_avg_cp', type: 'number' }, { label: 'Status', field: 'status.name', type: 'string' }];
        this.sortOptions.initialSortBy = {
            field: 'value_with_avg_cp',
            type: 'desc'
        };

        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'ongoing',
                'filter[visible]': true,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        totalValue: function totalValue() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value;
                });
                return total;
            }
            return 0;
        },
        totalValueWithCP: function totalValueWithCP() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value_with_avg_cp;
                });
                return total;
            }
            return 0;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'pending',
                'filter[visible]': true,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 360 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rows'],
    data: function data() {
        return {
            testData: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions, {
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },

    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;

            return startDate + endDate + department;
        }
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        openExternalLink: function openExternalLink(id) {
            alert('Åbn sagsnummer ' + id + ' i Ordrestyring nu');
        }
    }
});

/***/ }),
/* 361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.columns = [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Aconto', field: 'invoices_total', type: 'number' }, { label: 'Timer/materialer, kostpris', field: 'total_expenses', type: 'number' }, { label: 'Værdi, salgspris', field: 'value_with_avg_cp', type: 'number' }, { label: 'Status', field: 'status.name', type: 'string' }];
        this.sortOptions.initialSortBy = {
            field: 'value_with_avg_cp',
            type: 'desc'
        };

        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[snoozed]': true,
                'filter[status]': 'ongoing',
                'filter[visible]': true,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                console.log(response);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        totalValue: function totalValue() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value;
                });
                return total;
            }
            return 0;
        },
        totalValueWithCP: function totalValueWithCP() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value_with_avg_cp;
                });
                return total;
            }
            return 0;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title'],
    data: function data() {
        return {
            selectedProjectType: null,
            columns: [{ label: 'Opgavetype', field: 'type', type: 'string' }, { label: 'Antal', field: 'count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    computed: {
        closedRows: function closedRows() {
            return this.$store.state.closedRows;
        }
    },
    watch: {
        closedRows: function closedRows() {
            var _this = this;

            this.rows = [];
            this.$emit('finishedLoading', null);
            this.$nextTick(function () {
                if (_this.closedRows && _this.closedRows.length) {
                    _this.calculateData();
                } else if (Array.isArray(_this.closedRows)) {
                    _this.$emit('finishedLoading', 0);
                }
            });
        }
    },
    methods: {
        selectedRowClass: function selectedRowClass(row) {
            if (row.type === this.selectedProjectType) {
                return 'selected';
            }
        },
        selectProjectType: function selectProjectType(params) {
            this.selectedProjectType = params.row.type;
            this.$emit('selectProjectType', params.row.type);
        },
        openExternalLink: function openExternalLink(id) {
            alert('Åbn sagsnummer ' + id + ' i Ordrestyring nu');
        },
        calculateData: function calculateData() {
            var _this2 = this;

            this.rows = [];
            var groupedProjects = this.$store.getters.groupedProjects;

            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(groupedProjects).forEach(function (projectType) {
                var invoicesTotalArray = groupedProjects[projectType].map(function (project) {
                    return Math.round(project.invoices_total);
                });

                var summedInvoicesTotal = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(invoicesTotalArray, function (sum, invoicesTotal) {
                    return sum + invoicesTotal;
                });

                var coverageArray = groupedProjects[projectType].map(function (project) {
                    return Math.round(project.coverage);
                });

                var summedCoverage = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(coverageArray, function (sum, coverage) {
                    return sum + coverage;
                });

                var timelogArray = groupedProjects[projectType].map(function (project) {
                    return Number(project.timelog_hours);
                });

                var summedTimelogTotal = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(timelogArray, function (sum, timelogHours) {
                    return sum + timelogHours;
                });

                var coveragePercentArray = [];
                var coveragePerHourArray = [];
                groupedProjects[projectType].forEach(function (project) {
                    if (project.coverage_percent) {
                        coveragePercentArray.push(Math.round(project.coverage_percent));
                    }
                    if (project.coverage_per_hour) {
                        coveragePerHourArray.push(project.coverage_per_hour);
                    }
                });

                var averageCoveragePercent = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mean(coveragePercentArray);
                var averageCoveragePerHour = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.mean(coveragePerHourArray);

                var item = {
                    type: projectType,
                    count: groupedProjects[projectType].length,
                    invoices_total: summedInvoicesTotal,
                    coverage: summedCoverage,
                    coverage_percent_avg: Math.round(averageCoveragePercent),
                    coverage_percent: summedInvoicesTotal !== 0 ? Math.round(summedCoverage / summedInvoicesTotal * 100) : 0,
                    coverage_per_hour_avg: Math.round(averageCoveragePerHour),
                    coverage_per_hour: summedTimelogTotal > 0 ? Math.round(summedCoverage / summedTimelogTotal) : 0,
                    timelog_hours: summedTimelogTotal
                };
                _this2.rows.push(item);
            });
            this.$emit('finishedLoading', this.rows.length);
        }
    }
});

/***/ }),
/* 363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_budgetService__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_budgetService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_budgetService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_apexcharts__);







var VueAutonumeric = __webpack_require__(661);


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            comment: null,
            commentExpenses: null,
            commentEbitda: null,
            commentHours: null,
            commentCPH: null,
            multiplyFactor: 1,
            step: 0,
            stepsInitiated: {
                expenses: false,
                ebitdagoal: false,
                hours: false,
                coverageperhour: false,
                result: false
            },
            stepsCompleted: {
                expenses: false,
                ebitdagoal: false,
                hours: false,
                coverageperhour: false,
                result: false
            },
            data: null,
            loading: true,
            hoursCalcType: 'employees',
            showExpensesModal: null,
            options: {
                labels: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'Maj.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dec.'],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.currency(value);
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#172b43', '#03a9f4']
            },
            series: [{ name: 'Budget', data: [3564253, 1978675, 6542345, 6782498, 9834872, 3726837, 8318913, 5892478, 2354634, 6233235, 2512597, 3135512] }],
            hoursGraphOptions: {
                labels: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'Maj.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dec.'],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.number(value) + ' timer';
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#172b43', '#03a9f4']
            },
            expensesGraphOptions: {
                labels: ['Jan.', 'Feb.', 'Mar.', 'Apr.', 'Maj.', 'Jun.', 'Jul.', 'Aug.', 'Sep.', 'Okt.', 'Nov.', 'Dec.'],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.currency(value);
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#172b43', '#03a9f4'],
                chart: {
                    toolbar: {
                        show: false
                    }
                }
            },
            oldResultList: null
        };
    },
    mounted: function mounted() {
        if (window.location.href.includes('accountingYear')) {
            this.getData('accountingYear');
        } else {
            this.getData();
        }
    },

    methods: {
        getData: function getData(period) {
            var _this2 = this;

            this.data = null;
            var params = {
                period: period
            };

            if (this.updatingBudget) {
                params.update = 1;
            }
            __WEBPACK_IMPORTED_MODULE_3__services_budgetService__["data"](params, function (response) {
                if (params.period === 'accountingYear') {
                    response.data.created_budget = null;
                }
                if (_this2.updatingBudget) {
                    var savedBudget = response.data.created_budget;
                    _this2.data = response.data;

                    _this2.data.created_budget = null;
                    _this2.data.expenses.account_categories.forEach(function (accountCategory) {
                        accountCategory.old_budget = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(accountCategory.budget));
                    });
                    _this2.data.ebitda.old_goal = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this2.data.ebitda.goal));
                    _this2.data.hours.employees.forEach(function (employee) {
                        employee.old_hours_with_project_percent = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(employee.hours_with_project_percent));
                        employee.old_budget = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(employee.budget));
                    });
                    _this2.data.coverage_per_hour.project_types.forEach(function (projectType) {
                        projectType.old_budget_coverage_per_hour = JSON.parse(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(projectType.budget_coverage_per_hour));
                    });

                    _this2.comment = savedBudget.comment;
                    _this2.commentExpenses = savedBudget.comment_expenses;
                    _this2.commentEbitda = savedBudget.comment_ebitda;
                    _this2.commentHours = savedBudget.comment_hours;
                    _this2.commentCPH = savedBudget.comment_cph;
                    var oldResultList = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.resultList);
                    _this2.oldResultList = oldResultList;
                } else {
                    _this2.data = response.data;
                }
                _this2.calculateMultiplyFactor();
            }, function (err) {
                console.log(err);
            });
        },
        sum: function sum(arr, key) {
            return arr.reduce(function (a, b) {
                return a + (Number(b[key]) || 0);
            }, 0);
        },
        sumTwice: function sumTwice(arr, key, secondKey) {
            return arr.reduce(function (a, b) {
                return a + (Number(b[key][secondKey]) || 0);
            }, 0);
        },
        finishStep: function finishStep(step, divId) {
            this.stepsCompleted[step] = true;
            var el = document.getElementById(divId);
            var pageElement = document.getElementsByClassName('page')[0];
            setTimeout(function () {
                pageElement.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: el.offsetTop - 25
                });
            }, 100);
        },
        saveBudget: function saveBudget() {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at lægge et budget i demo-versionen.');
                return;
            }
            if (this.data) {
                var body = {
                    from: __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.data.periods.budget.from).format('YYYY-MM-DD'),
                    to: __WEBPACK_IMPORTED_MODULE_4_moment___default()(this.data.periods.budget.to).format('YYYY-MM-DD'),

                    ebitda_goal: this.data.ebitda.goal,
                    ebitda_calculated: this.resultList[this.resultList.length - 1].budget,
                    total_expenses: this.totalExpenses,
                    total_hours: this.totalHours,
                    cph_zero_revenue: this.demandForZeroRevenue,
                    cph_goal_ebitda: this.demandForGoal,
                    cph_calculated: this.calculatedCoveragePerHour,

                    hours_january: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[0].hours,
                    hours_february: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[1].hours,
                    hours_march: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[2].hours,
                    hours_april: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[3].hours,
                    hours_may: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[4].hours,
                    hours_june: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[5].hours,
                    hours_july: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[6].hours,
                    hours_august: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[7].hours,
                    hours_september: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[8].hours,
                    hours_october: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[9].hours,
                    hours_november: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[10].hours,
                    hours_december: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(this.totalHoursPeriodised)[11].hours,
                    project_types: this.data.coverage_per_hour.project_types,
                    expenses: this.totalExpensesPeriodised,
                    data: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.data),
                    comment: this.comment,
                    comment_expenses: this.commentExpenses,
                    comment_ebitda: this.commentExpenses,
                    comment_hours: this.commentHours,
                    comment_cph: this.commentCPH
                };
                __WEBPACK_IMPORTED_MODULE_3__services_budgetService__["create"](body, function (response) {
                    console.log(response.data);
                    alert('Budgettet er nu gemt. Siden opdateres...');
                    window.location.replace(location.pathname);
                }, function (err) {
                    console.log(err);
                });
            }
        },
        openExpensesModal: function openExpensesModal(actc) {
            var accountCategory = this.data.expenses.account_categories.filter(function (x) {
                return x.slug === actc.slug;
            })[0];
            var untouched = true;
            accountCategory.accounts.forEach(function (account) {
                if (account.entries_total !== account.budget) {
                    untouched = false;
                }
            });
            if (untouched) {
                var multiplyFactor = accountCategory.budget / accountCategory.entries_total;
                accountCategory.accounts.forEach(function (account) {
                    account.budget = account.entries_total * multiplyFactor;
                });
            }
            this.showExpensesModal = actc;
        },
        closeExpensesModal: function closeExpensesModal(accountCategorySlug) {
            this.showExpensesModal = null;
        },
        calculateMultiplyFactor: function calculateMultiplyFactor() {
            var expenses = Math.abs(this.sum(this.expensesAccountCategories, 'entries_total'));
            var hours = this.totalHistoricHours;
            var coveragePerHour = this.coveragePerHourHistoric;
            var ebitda = this.resultList[this.resultList.length - 1].total;
            var expensesPlusEbitda = expenses + ebitda;
            var hoursTimesCoveragePerHour = hours * coveragePerHour;
            var multiplyFactor = expensesPlusEbitda / hoursTimesCoveragePerHour;
            this.multiplyFactor = multiplyFactor;
        }
    },
    computed: {
        updatingBudget: function updatingBudget() {
            var queryString = window.location.search;
            var urlParams = new URLSearchParams(queryString);
            var update = urlParams.get('update');
            if (update && update === '1') {
                return true;
            }
            return false;
        },
        projectTypeHours: function projectTypeHours() {
            if (!this.data) {
                return 0;
            }
            var employeeHours = this.sum(this.data.hours.employees, 'hours');
            var projectTypeHours = this.sum(this.data.hours.project_types, 'hours');
            var multiplyFactor = employeeHours / projectTypeHours;
            this.data.hours.project_types.forEach(function (projectType) {
                var newValue = Math.round(projectType.hours * multiplyFactor);
                projectType.hours = newValue;
                projectType.budget = newValue;
            });
            return this.data.hours.project_types;
        },
        expensesAccountCategories: function expensesAccountCategories() {
            if (this.data) {
                return this.data.expenses.account_categories.filter(function (x) {
                    return !['omsaetning'].includes(x.slug);
                });
            }
            return null;
        },
        totalHistoricExpenses: function totalHistoricExpenses() {
            if (!this.data) {
                return 0;
            }
            if (this.updatingBudget) {
                return this.sum(this.expensesAccountCategories, 'old_budget');
            }
            return this.sum(this.expensesAccountCategories, 'entries_total');
        },
        totalExpenses: function totalExpenses() {
            if (!this.data) {
                return 0;
            }
            return Math.abs(this.sum(this.expensesAccountCategories, 'budget'));
        },
        totalHours: function totalHours() {
            if (!this.data) {
                return 0;
            }
            if (this.hoursCalcType === 'projectTypes') {
                return this.sum(this.data.hours.project_types, 'budget');
            }
            if (this.hoursCalcType === 'employees') {
                return this.sum(this.data.hours.employees, 'budget');
            }
        },
        totalHistoricHours: function totalHistoricHours() {
            if (!this.data) {
                return 0;
            }
            if (this.hoursCalcType === 'projectTypes') {
                return this.sum(this.data.hours.project_types, 'hours');
            }
            if (this.hoursCalcType === 'employees') {
                return this.sum(this.data.hours.employees, 'hours');
            }
        },
        demandForZeroRevenue: function demandForZeroRevenue() {
            if (!this.data) {
                return 0;
            }
            var historicCoveragePerHour = this.coveragePerHourHistoric;
            var calculatedRevenue = this.totalHours * this.historicRevenuePerHour;
            var expenses = this.totalExpenses;
            if (expenses < Math.abs(this.totalHistoricExpenses)) {
                expenses = Math.abs(this.totalHistoricExpenses) - (Math.abs(this.totalHistoricExpenses) - expenses) * 0.1;
            }
            var extraExpenses = this.additionalMaterialExpenses + this.additionalSubContractorsExpenses;
            var expensesTotal = expenses - extraExpenses;
            var diff = expensesTotal - calculatedRevenue;
            var hours = this.totalHours;
            var change = diff / hours;
            var result = historicCoveragePerHour + change;
            if (result < 0) {
                return 0;
            }
            return result;
        },
        demandForGoal: function demandForGoal() {
            if (!this.data) {
                return 0;
            }
            var historicCoveragePerHour = this.coveragePerHourHistoric;
            var calculatedRevenue = this.totalHours * this.historicRevenuePerHour;
            var extraExpenses = this.additionalMaterialExpenses + this.additionalSubContractorsExpenses;
            var expenses = this.totalExpenses;
            if (expenses < Math.abs(this.totalHistoricExpenses)) {
                expenses = Math.abs(this.totalHistoricExpenses) - (Math.abs(this.totalHistoricExpenses) - expenses) * 0.1;
            }
            var expensesTotal = expenses - extraExpenses;
            var goalEbitda = this.data.ebitda.goal;
            var diff = expensesTotal + goalEbitda - calculatedRevenue;
            var hours = this.totalHours;
            var change = diff / hours;
            var result = historicCoveragePerHour + change;
            if (result < 0) {
                return 0;
            }
            return result;
        },
        displayedCoveragePerHour: function displayedCoveragePerHour() {
            return Math.floor(this.calculatedCoveragePerHour);
        },
        calculatedCoveragePerHour: function calculatedCoveragePerHour() {
            if (!this.data) {
                return 0;
            }

            var coverage = this.totalCoverageForCPH;
            var hours = this.sum(this.data.coverage_per_hour.project_types, 'hours');
            return coverage / hours;
        },
        additionalCoverage: function additionalCoverage() {
            if (!this.data) {
                return 0;
            }
            var multiplyFactor = this.sum(this.data.coverage_per_hour.project_types, 'hours') / this.sum(this.data.hours.employees, 'hours');
            var total = 0;
            this.data.coverage_per_hour.project_types.forEach(function (projectType) {
                if (projectType.coverage_per_hour !== projectType.budget_coverage_per_hour) {
                    var diff = projectType.budget_coverage_per_hour - projectType.coverage_per_hour;
                    total += diff * projectType.hours * multiplyFactor;
                }
            });
            return total;
        },
        totalCoverageForCPH: function totalCoverageForCPH() {
            if (!this.data) {
                return 0;
            }
            var total = 0;
            this.data.coverage_per_hour.project_types.forEach(function (projectType) {
                total += Number(projectType.hours) * Number(projectType.budget_coverage_per_hour);
            });
            return total;
        },
        historicRevenuePerHour: function historicRevenuePerHour() {
            if (!this.data) {
                return 0;
            }
            var revenue = this.data.expenses.account_categories.filter(function (x) {
                return x.slug === 'omsaetning';
            })[0].entries_total;
            var hours = this.sum(this.data.hours.project_types, 'hours');
            if (this.hoursCalcType === 'employees') {
                hours = this.sum(this.data.hours.employees, 'hours');
            }
            return revenue / hours;
        },
        historicMaterialExpensesPerHour: function historicMaterialExpensesPerHour() {
            if (!this.data) {
                return 0;
            }
            var materialExpenses = this.data.expenses.account_categories.filter(function (x) {
                return x.slug === 'vareforbrug';
            })[0].entries_total;
            var hours = this.sum(this.data.hours.project_types, 'hours');
            if (this.hoursCalcType === 'employees') {
                hours = this.sum(this.data.hours.employees, 'hours');
            }
            return materialExpenses / hours;
        },
        additionalMaterialExpenses: function additionalMaterialExpenses() {
            if (!this.data) {
                return 0;
            }
            var materialExpensesPerHour = this.historicMaterialExpensesPerHour;
            var extraHours = this.totalHours - this.totalHistoricHours;
            return materialExpensesPerHour * extraHours;
        },
        historicSubContractorsPerHour: function historicSubContractorsPerHour() {
            if (!this.data) {
                return 0;
            }
            var subContractorsExpenses = this.data.expenses.account_categories.filter(function (x) {
                return x.slug === 'underleverandorer';
            })[0].entries_total;
            var hours = this.sum(this.data.hours.project_types, 'hours');
            if (this.hoursCalcType === 'employees') {
                hours = this.sum(this.data.hours.employees, 'hours');
            }
            return subContractorsExpenses / hours;
        },
        additionalSubContractorsExpenses: function additionalSubContractorsExpenses() {
            if (!this.data) {
                return 0;
            }
            var subContractorsPerHour = this.historicSubContractorsPerHour;
            var extraHours = this.totalHours - this.totalHistoricHours;
            return subContractorsPerHour * extraHours;
        },
        calculatedRevenue: function calculatedRevenue() {
            if (!this.data) {
                return 0;
            }
            var budgetHours = this.totalHours;
            var revenuePerHour = this.historicRevenuePerHour;
            var coveragePerHour = this.calculatedCoveragePerHour;
            var historicCoveragePerHour = this.coveragePerHourHistoric;
            return budgetHours * revenuePerHour + (coveragePerHour - historicCoveragePerHour) * budgetHours;
        },
        resultList: function resultList() {
            if (!this.data) {
                return 0;
            }
            var arr = [];
            arr.push({
                name: 'Omsætning',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'omsaetning';
                })[0].entries_total,
                budget: this.calculatedRevenue,
                oldBudget: this.oldResultList ? this.oldResultList[0].budget : 0
            });
            arr.push({
                name: 'Vareforbrug',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'vareforbrug';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'vareforbrug';
                })[0].budget + this.additionalMaterialExpenses,
                oldBudget: this.oldResultList ? this.oldResultList[1].budget : 0
            });
            arr.push({
                name: 'Underleverandører',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'underleverandorer';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'underleverandorer';
                })[0].budget + this.additionalSubContractorsExpenses,
                oldBudget: this.oldResultList ? this.oldResultList[2].budget : 0
            });

            arr.push({
                name: 'Dækningsbidrag 1',
                total: this.sum(arr, 'total'),
                budget: this.sum(arr, 'budget'),
                oldBudget: this.oldResultList ? this.oldResultList[3].budget : 0
            });
            arr.push({
                name: 'Lønninger, svende',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'lonninger-svende';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'lonninger-svende';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[4].budget : 0
            });
            arr.push({
                name: 'Lønninger, administration',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'lonninger-administration';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'lonninger-administration';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[5].budget : 0
            });

            arr.push({
                name: 'Dækningsbidrag 2',
                total: this.sum(arr.filter(function (x) {
                    return !['Dækningsbidrag 1'].includes(x.name);
                }), 'total'),
                budget: this.sum(arr.filter(function (x) {
                    return !['Dækningsbidrag 1'].includes(x.name);
                }), 'budget'),
                oldBudget: this.oldResultList ? this.oldResultList[6].budget : 0
            });
            arr.push({
                name: 'Arbejdstøj',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'arbejdstoj';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'arbejdstoj';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[7].budget : 0
            });
            arr.push({
                name: 'Biler, svende',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'biler-svende';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'biler-svende';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[8].budget : 0
            });
            arr.push({
                name: 'Biler, andre',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'biler-andre';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'biler-andre';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[9].budget : 0
            });
            arr.push({
                name: 'Telefoner, svende',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'telefoner-svende';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'telefoner-svende';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[10].budget : 0
            });
            arr.push({
                name: 'Telefoner, andre',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'telefoner-andre';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'telefoner-andre';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[11].budget : 0
            });
            arr.push({
                name: 'Husleje',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'husleje';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'husleje';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[12].budget : 0
            });
            arr.push({
                name: 'Rådgivning og konsulenter',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'radgivning-og-konsulenter';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'radgivning-og-konsulenter';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[13].budget : 0
            });
            arr.push({
                name: 'Abonnementer og kontingenter',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'abonnementer-og-kontingenter';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'abonnementer-og-kontingenter';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[14].budget : 0
            });
            arr.push({
                name: 'Forsikringer',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'forsikringer';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'forsikringer';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[15].budget : 0
            });
            arr.push({
                name: 'Markedsføring',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'markedsforing';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'markedsforing';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[16].budget : 0
            });
            arr.push({
                name: 'IT',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'it';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'it';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[17].budget : 0
            });
            arr.push({
                name: 'Øvrige omkostninger',
                total: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'ovrige-omkostninger';
                })[0].entries_total,
                budget: this.data.expenses.account_categories.filter(function (x) {
                    return x.slug === 'ovrige-omkostninger';
                })[0].budget,
                oldBudget: this.oldResultList ? this.oldResultList[18].budget : 0
            });
            arr.push({
                name: 'EBITDA',
                total: this.sum(arr.filter(function (x) {
                    return !['Dækningsbidrag 1', 'Dækningsbidrag 2'].includes(x.name);
                }), 'total'),
                budget: this.sum(arr.filter(function (x) {
                    return !['Dækningsbidrag 1', 'Dækningsbidrag 2'].includes(x.name);
                }), 'budget'),
                oldBudget: this.oldResultList ? this.oldResultList[19].budget : 0
            });
            return arr;
        },
        allStepsCompleted: function allStepsCompleted() {
            if (!this.stepsCompleted.expenses) {
                return false;
            }
            if (!this.stepsCompleted.ebitdagoal) {
                return false;
            }
            if (!this.stepsCompleted.hours) {
                return false;
            }
            if (!this.stepsCompleted.coverageperhour) {
                return false;
            }
            return true;
        },
        totalHoursPeriodised: function totalHoursPeriodised() {
            if (this.data) {
                var months = {
                    1: { name: 'Januar', hours: 0, historicalHours: 0 },
                    2: { name: 'Februar', hours: 0, historicalHours: 0 },
                    3: { name: 'Marts', hours: 0, historicalHours: 0 },
                    4: { name: 'April', hours: 0, historicalHours: 0 },
                    5: { name: 'Maj', hours: 0, historicalHours: 0 },
                    6: { name: 'Juni', hours: 0, historicalHours: 0 },
                    7: { name: 'Juli', hours: 0, historicalHours: 0 },
                    8: { name: 'August', hours: 0, historicalHours: 0 },
                    9: { name: 'September', hours: 0, historicalHours: 0 },
                    10: { name: 'Oktober', hours: 0, historicalHours: 0 },
                    11: { name: 'November', hours: 0, historicalHours: 0 },
                    12: { name: 'December', hours: 0, historicalHours: 0 }
                };
                this.data.hours.employees.forEach(function (employee) {
                    var multiplyFactor = 1;
                    if (employee.hours !== employee.budget) {
                        multiplyFactor = employee.budget / (employee.hours > 0 ? employee.hours : 1);
                    }
                    for (var i = 1; i < 13; i++) {
                        months[i].hours += Number(employee.hours_division[i] > 0 ? employee.hours_division[i] : 1 / 12) * multiplyFactor;
                        months[i].historicalHours += Number(employee.hours_division[i]);
                    }
                });
                if (this.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'hours') !== this.totalHours) {
                    var diff = this.totalHours - this.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'hours');
                    if (diff !== 0) {
                        for (var i = 1; i < 13; i++) {
                            months[i].hours = months[i].hours + diff / 12;
                        }
                    }
                }
                return months;
            }
            return [];
        },
        totalHoursPeriodisedSeries: function totalHoursPeriodisedSeries() {
            var budgetArray = [];
            var historicArray = [];
            if (this.data) {
                var months = this.totalHoursPeriodised;
                for (var i = 1; i < 13; i++) {
                    budgetArray.push(months[i].hours);
                    historicArray.push(months[i].historicalHours);
                }
                return [{ name: 'Budget', data: budgetArray }];
            }
            return [{ name: 'Budget', data: budgetArray }];
        },
        totalExpensesPeriodised: function totalExpensesPeriodised() {
            var _this3 = this;

            if (this.data) {
                this.data.expenses.account_categories.forEach(function (accountCategory) {
                    accountCategory.accounts.forEach(function (account) {
                        var multiplyFactor = 1;

                        var revenueMultiplyFactor = 1;
                        var historicRevenue = _this3.data.expenses.account_categories.filter(function (x) {
                            return x.slug === 'omsaetning';
                        })[0].entries_total;
                        revenueMultiplyFactor = _this3.calculatedRevenue / historicRevenue;

                        var materialMultiplyFactor = 1;
                        var additionalMaterialExpenses = _this3.additionalMaterialExpenses;
                        materialMultiplyFactor = (accountCategory.budget + additionalMaterialExpenses) / accountCategory.budget;

                        var subcontractorsMultiplyFactor = 1;
                        var additionalSubContractorsExpenses = _this3.additionalSubContractorsExpenses;
                        subcontractorsMultiplyFactor = (accountCategory.budget + additionalSubContractorsExpenses) / accountCategory.budget;
                        var months = {
                            1: { name: 'Januar', expenses: 0, historicalExpenses: 0 },
                            2: { name: 'Februar', expenses: 0, historicalExpenses: 0 },
                            3: { name: 'Marts', expenses: 0, historicalExpenses: 0 },
                            4: { name: 'April', expenses: 0, historicalExpenses: 0 },
                            5: { name: 'Maj', expenses: 0, historicalExpenses: 0 },
                            6: { name: 'Juni', expenses: 0, historicalExpenses: 0 },
                            7: { name: 'Juli', expenses: 0, historicalExpenses: 0 },
                            8: { name: 'August', expenses: 0, historicalExpenses: 0 },
                            9: { name: 'September', expenses: 0, historicalExpenses: 0 },
                            10: { name: 'Oktober', expenses: 0, historicalExpenses: 0 },
                            11: { name: 'November', expenses: 0, historicalExpenses: 0 },
                            12: { name: 'December', expenses: 0, historicalExpenses: 0 },
                            13: { name: 'Total', expenses: 0, historicalExpenses: 0 }
                        };
                        if (account.entries_total !== account.budget) {
                            multiplyFactor = account.budget / (account.entries_total !== 0 ? account.entries_total : 1);
                        }
                        for (var i = 1; i < 13; i++) {
                            months[i].expenses += Number(account.entries_division[i] !== 0 ? account.entries_division[i] * multiplyFactor : 0);
                            months[i].historicalExpenses += Number(account.entries_division[i]);

                            if (accountCategory.slug === 'omsaetning') {
                                if (months[i].expenses !== 0) {
                                    months[i].expenses = months[i].expenses * revenueMultiplyFactor;
                                }
                            }
                            if (accountCategory.slug === 'vareforbrug') {
                                if (months[i].expenses !== 0) {
                                    months[i].expenses = months[i].expenses * materialMultiplyFactor;
                                }
                            }
                            if (accountCategory.slug === 'underleverandorer') {
                                if (months[i].expenses !== 0) {
                                    months[i].expenses = months[i].expenses * subcontractorsMultiplyFactor;
                                }
                            }

                            months[i].expenses = Math.round(months[i].expenses);
                        }

                        if (accountCategory.slug === 'omsaetning') {
                            if (account.budget * revenueMultiplyFactor !== _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses')) {
                                var revenueDiff = account.budget * revenueMultiplyFactor - _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses');
                                if (revenueDiff !== 0) {
                                    for (var _i = 1; _i < 13; _i++) {
                                        if (Math.abs(months[_i].expenses) > Math.abs(revenueDiff)) {
                                            months[_i].expenses = months[_i].expenses + revenueDiff;
                                            break;
                                        }
                                    }
                                }
                            }
                        } else if (accountCategory.slug === 'vareforbrug') {
                            if (account.budget * materialMultiplyFactor !== _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses')) {
                                var _revenueDiff = account.budget * materialMultiplyFactor - _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses');
                                if (_revenueDiff !== 0) {
                                    for (var _i2 = 1; _i2 < 13; _i2++) {
                                        if (Math.abs(months[_i2].expenses) > Math.abs(_revenueDiff)) {
                                            months[_i2].expenses = months[_i2].expenses + _revenueDiff;
                                            break;
                                        }
                                    }
                                }
                            }
                        } else if (accountCategory.slug === 'underleverandorer') {
                            if (account.budget * subcontractorsMultiplyFactor !== _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses')) {
                                var _revenueDiff2 = account.budget * subcontractorsMultiplyFactor - _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses');
                                if (_revenueDiff2 !== 0) {
                                    for (var _i3 = 1; _i3 < 13; _i3++) {
                                        if (Math.abs(months[_i3].expenses) > Math.abs(_revenueDiff2)) {
                                            months[_i3].expenses = months[_i3].expenses + _revenueDiff2;
                                            break;
                                        }
                                    }
                                }
                            }
                        } else {
                            if (account.budget !== _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses')) {
                                var diff = Math.round(account.budget) - _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses');
                                if (diff !== 0) {
                                    for (var _i4 = 1; _i4 < 13; _i4++) {
                                        if (Math.abs(months[_i4].expenses) > Math.abs(diff)) {
                                            months[_i4].expenses = months[_i4].expenses + diff;
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                        account.months = months;
                        account.monthsTotal = _this3.sum(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(months), 'expenses');
                        return account;
                    });
                });
                return this.data.expenses.account_categories;
            }
            return [];
        },
        totalExpensesPeriodisedSeries: function totalExpensesPeriodisedSeries() {
            var budgetArray = [];
            var historicArray = [];
            if (this.data) {
                var months = {
                    1: { name: 'Januar', expenses: 0, historicalExpenses: 0 },
                    2: { name: 'Februar', expenses: 0, historicalExpenses: 0 },
                    3: { name: 'Marts', expenses: 0, historicalExpenses: 0 },
                    4: { name: 'April', expenses: 0, historicalExpenses: 0 },
                    5: { name: 'Maj', expenses: 0, historicalExpenses: 0 },
                    6: { name: 'Juni', expenses: 0, historicalExpenses: 0 },
                    7: { name: 'Juli', expenses: 0, historicalExpenses: 0 },
                    8: { name: 'August', expenses: 0, historicalExpenses: 0 },
                    9: { name: 'September', expenses: 0, historicalExpenses: 0 },
                    10: { name: 'Oktober', expenses: 0, historicalExpenses: 0 },
                    11: { name: 'November', expenses: 0, historicalExpenses: 0 },
                    12: { name: 'December', expenses: 0, historicalExpenses: 0 }
                };
                this.totalExpensesPeriodised.filter(function (x) {
                    return x.slug !== 'omsaetning';
                }).forEach(function (accountCategory) {
                    accountCategory.accounts.forEach(function (account) {
                        for (var i = 1; i < 13; i++) {
                            months[i].expenses += account.months[i].expenses * -1;
                            months[i].historicalExpenses += account.months[i].historicalExpenses * -1;
                        }
                    });
                });
                for (var i = 1; i < 13; i++) {
                    budgetArray.push(months[i].expenses);
                    historicArray.push(months[i].historicalExpenses);
                }
                return [{ name: 'Budget', data: budgetArray }];
            }
            return [{ name: 'Budget', data: budgetArray }];
        },
        employeesInPeriod: function employeesInPeriod() {
            if (!this.data) {
                return [];
            }
            return this.data.hours.employees.filter(function (x) {
                return Number(x.hours) > 0 || Number(x.budget) > 0;
            });
        },
        percentageHoursWithCustomers: function percentageHoursWithCustomers() {
            if (!this.data) {
                return null;
            }
            var employees = this.employeesInPeriod.filter(function (x) {
                return x.name !== 'Planlagt ansættelse af nye svende';
            });
            var availableHours = this.sum(employees, 'available_hours');
            var budgetHours = this.sum(employees, 'budget');
            return budgetHours / availableHours * 100;
        },
        coveragePerHourHistoric: function coveragePerHourHistoric() {
            if (!this.data) {
                return null;
            }
            var hours = this.sum(this.data.coverage_per_hour.project_types, 'hours');
            var total = 0;
            this.data.coverage_per_hour.project_types.forEach(function (projectType) {
                total += Number(projectType.hours) * Number(projectType.coverage_per_hour);
            });
            return total / hours;
        },
        testEbitda: function testEbitda() {
            if (!this.data) {
                return null;
            }
            var total = 0;
            this.totalExpensesPeriodised.forEach(function (accountCategory) {
                accountCategory.accounts.forEach(function (account) {
                    total += account.monthsTotal;
                });
            });
            return total;
        },
        employeeHours: function employeeHours() {
            if (!this.data) {
                return null;
            }
            return this.sum(this.data.hours.employees, 'budget');
        }
    },
    components: {
        VueAutonumeric: VueAutonumeric,
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_5_vue_apexcharts___default.a,
        'contentful-guide': __webpack_require__(663)
    },
    watch: {
        expensesAccountCategories: {
            deep: true,
            handler: function handler(newValue, oldValue) {
                if (newValue !== null && newValue.length > 0) {
                    newValue.forEach(function (accountCategory) {
                        if (accountCategory.input_type === 'accounts') {
                            var total = 0;
                            accountCategory.accounts.forEach(function (account) {
                                total += account.budget;
                            });
                            accountCategory.budget = total;
                        }
                        if (accountCategory.input_type === 'total') {
                            if (accountCategory.budget !== accountCategory.entries_total && accountCategory.entries_total !== 0) {
                                var multiplyFactor = 1;
                                multiplyFactor = accountCategory.budget / accountCategory.entries_total;
                                accountCategory.accounts.forEach(function (account) {
                                    account.budget = account.entries_total * multiplyFactor;
                                });
                            }
                        }
                    });
                }
            }
        },
        employeeHours: {
            handler: function handler() {
                this.data.hours.employees.forEach(function (employee) {
                    if (employee.budget_type === 'input') {
                        employee.hours_with_project_percent = employee.budget / employee.available_hours * 100;
                    }
                });
            }
        }
    }
});

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tipService__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_tipService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_tipService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            tips: [],
            show: null
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_tipService__["list"]({}, function (response) {
                _this.tips = response.data;
            }, function (err) {
                alert('Der skete en fejl...');
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedTable: 'customerTypeRevenue',
            sidebarMenuItems: [{
                name: 'Hvilke kundetyper tjener vi penge på?',
                tableName: 'customerTypeRevenue'
            }]
        };
    },

    computed: {},
    methods: {
        updateCount: function updateCount(tableName, event) {
            this.counts[tableName] = event;
        }
    }
});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'customerTypeRevenue',
            counts: {
                customerRevenue: null,
                customerTypeRevenue: null
            },
            switchItems: [{
                name: 'Hvilke kundetyper tjener vi penge på?',
                slug: 'customerTypeRevenue'
            }, {
                name: 'Hvilke konkrete kunder tjener vi penge på?',
                slug: 'customerRevenue'
            }, {
                name: 'Hvordan er kunderne fordelt på omsætning?',
                slug: 'customerRevenueGrouped'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
        this.$store.state.view = 'learning';
    },

    components: {
        'customer-revenue': __webpack_require__(680),
        'customer-type-revenue': __webpack_require__(683),
        'customer-revenue-grouped': __webpack_require__(681)
    }
});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'openProjects',
            counts: {
                openProjects: null,
                snoozedProjects: null,
                noInvoiceProjects: null,
                ongoingProjects: null,
                openClaims: null,
                projectsCloseToBudget: '-'
            },
            switchItems: [{
                name: 'Ikke igangsatte opgaver',
                slug: 'openProjects'
            }, {
                name: 'Opgaver uden bevægelse i ' + this.$store.state.config.companyMeta.settings.snoozed_days + ' dage',
                slug: 'snoozedProjects'
            }, {
                name: 'Afsluttede opgaver, der ikke er fakturerede',
                slug: 'noInvoiceProjects'
            }, {
                name: 'Igangværende opgaver',
                slug: 'ongoingProjects'
            }, {
                name: 'Igangværende reklamationer',
                slug: 'openClaims'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
        this.$store.state.view = 'operations';
    }
});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        customers: {
            type: Array,
            default: function _default() {
                return [];
            }
        },
        name: {
            type: String
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Kunde', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_customerService__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_customerService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__services_customerService__);







/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: false,
            rows: [],
            columns: [{ label: 'Kunde', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours_total', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return _this.getData();

                        case 2:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this);
        }))();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                _this2.loading = true;
                _this2.$emit('finishedLoading', null);
                _this2.$store.commit('setCustomerRevenueRows', []);
                _this2.selectedRow = null;
                var params = {
                    date_from: _this2.$store.getters.getStartDate,
                    date_to: _this2.$store.getters.getEndDate
                };
                if (_this2.$store.getters.getCurrentDepartment.uuid !== 0) {
                    params.department = _this2.$store.getters.getCurrentDepartment.uuid;
                }
                __WEBPACK_IMPORTED_MODULE_3__services_customerService__["customerActivity"](params, function (response) {
                    _this2.rows = response.data;
                    _this2.$emit('finishedLoading', _this2.rows.length);
                    _this2.loading = false;
                    _this2.$store.commit('setCustomerRevenueRows', _this2.rows);
                    resolve(response.data);
                }, function (err) {
                    console.log(err);
                    _this2.loading = false;
                    reject(err);
                });
            });
        },
        selectCustomer: function selectCustomer(customer) {
            this.selectedRow = customer.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        'customer-revenue-single': __webpack_require__(244),
        'customer-revenue-project-types': __webpack_require__(682)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 370 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title'],
    data: function data() {
        return {
            groupBy: 'invoices_total',
            selectedBracket: '',
            selectedProjectType: null,
            selectedRow: null,
            loading: false,
            columns: [{ label: 'Omsætning pr. kunde', field: 'bracket', type: 'string', sortable: false }, { label: 'Kunder', field: 'count', type: 'number' }, { label: 'Omsætning i alt', field: 'invoices_total', width: '10%', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },

    computed: {
        customerRevenueRows: function customerRevenueRows() {
            return this.$store.state.customerRevenueRows;
        },
        groupedCustomers: function groupedCustomers() {
            return __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.groupBy(this.customerRevenueRows, function (customer) {
                if (customer.invoices_total <= 2000) {
                    return '0 - 2.000';
                } else if (customer.invoices_total <= 5000) {
                    return '2.001 - 5.000';
                } else if (customer.invoices_total <= 10000) {
                    return '5.001 - 10.000';
                } else if (customer.invoices_total <= 20000) {
                    return '10.001 - 20.000';
                } else if (customer.invoices_total <= 50000) {
                    return '20.001 - 50.000';
                } else if (customer.invoices_total <= 100000) {
                    return '50.001 - 100.000';
                } else {
                    return 'over 100.000';
                }
            });
        }
    },
    watch: {
        customerRevenueRows: function customerRevenueRows() {
            if (this.customerRevenueRows.length) {
                this.calculateData();
            }
        }
    },
    methods: {
        selectedRowClass: function selectedRowClass(row) {
            if (row.bracket === this.selectedBracket) {
                return 'selected';
            }
        },
        handleRowClick: function handleRowClick(params) {
            this.selectedBracket = params.row.bracket;
        },
        openExternalLink: function openExternalLink(id) {
            alert('Åbn sagsnummer ' + id + ' i Ordrestyring nu');
        },
        calculateData: function calculateData() {
            var _this = this;

            this.rows = [];
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.groupedCustomers).forEach(function (customerBracket) {
                var invoicesTotalArray = _this.groupedCustomers[customerBracket].map(function (customer) {
                    return Math.round(customer.invoices_total);
                });

                var summedInvoicesTotal = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(invoicesTotalArray, function (sum, invoicesTotal) {
                    return sum + invoicesTotal;
                });

                var coverageArray = _this.groupedCustomers[customerBracket].map(function (customer) {
                    return Math.round(customer.coverage);
                });

                var summedCoverage = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(coverageArray, function (sum, coverage) {
                    return sum + coverage;
                });

                var timelogHoursArray = _this.groupedCustomers[customerBracket].map(function (customer) {
                    return customer.timelog_hours_total;
                });
                var summedTimelogHours = __WEBPACK_IMPORTED_MODULE_1_lodash___default.a.reduce(timelogHoursArray, function (sum, timelogHoursTotal) {
                    return sum + timelogHoursTotal;
                });

                var item = {
                    bracket: customerBracket,
                    count: _this.groupedCustomers[customerBracket].length,
                    invoices_total: summedInvoicesTotal,
                    coverage: summedCoverage,

                    coverage_percent: summedInvoicesTotal > 0 ? summedCoverage / summedInvoicesTotal * 100 : 0,
                    coverage_per_hour: summedTimelogHours > 0 ? summedCoverage / summedTimelogHours : 0,
                    timelog_hours_total: summedTimelogHours
                };
                _this.rows.push(item);
            });
            this.rows.sort(function (a, b) {
                var aSubstring = parseInt(a.bracket.substring(a.bracket.lastIndexOf(' ') + 1, a.bracket.lastIndexOf('.')));
                var bSubstring = parseInt(b.bracket.substring(b.bracket.lastIndexOf(' ') + 1, b.bracket.lastIndexOf('.')));
                return aSubstring > bSubstring ? 1 : -1;
            });
            this.$emit('finishedLoading', this.rows.length);
        }
    },
    components: {
        'customer-grouped-single': __webpack_require__(679)
    }
});

/***/ }),
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            customer: null,
            rows: [],
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal opgaver', field: 'projects_count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        },
        clearSelectedProjectType: function clearSelectedProjectType() {
            this.selectedRow = null;
        }
    },
    watch: {
        'data': 'clearSelectedProjectType'
    },
    components: {
        'customer-revenue-single': __webpack_require__(244)
    }
});

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    },
    data: function data() {
        return {
            customer: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_customerService__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_customerService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_customerService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Kundetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'customers_count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours_total', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_customerService__["customerCategoryActivity"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectCustomerType: function selectCustomerType(customerType) {
            this.selectedRow = customerType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'customer-type-revenue-single': __webpack_require__(684)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            loading: false,
            customer: null,
            rows: [],
            columns: [{ label: 'Kunde', field: 'name', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_economyService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            height: '400',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return _this.$options.filters.currency(value);
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["compareCoverage"](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.series = response.data.series;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 376 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_economyService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            height: '400',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return _this.$options.filters.currency(value);
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["compareCoveragePerHour"](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.series = response.data.series;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_economyService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            height: '400',
            unit: ' %',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return value + ' %';
                            } else {
                                return '- %';
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: false,
                    min: 0,
                    max: 100
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_2__services_economyService__["compareCoveragePercent"](params, function (response) {
                _this.options.labels = response.data.labels;
                _this.series = response.data.series.map(function (serie) {
                    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, serie, {
                        data: serie.data.map(function (value) {
                            return value === null ? null : Math.max(0, value);
                        })
                    });
                });

                _this.loading = false;
                _this.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_economyService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            height: '400',
            unit: ' %',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return value + ' %';
                            } else {
                                return '- %';
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: false,
                    min: 0,
                    max: 100
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["compareCustomerHours"](params, function (response) {
                _this.options.labels = response.data.labels;
                _this.series = response.data.series;

                _this.loading = false;
                _this.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_economyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Afdeling', field: 'name', type: 'string' }, { label: 'Opgaver', field: 'projects_count', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'Dækningsbidrag', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }, { label: 'Tid hos kunder', field: 'hours_with_customers', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["compareKeyfigures"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_economyService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            height: '400',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return _this.$options.filters.currency(value);
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["compareRevenue"](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.series = response.data.series;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.series.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;

            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_economyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            showCalculations: true,
            data: null
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.data = null;

            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["costpricePerHour"](params, function (response) {
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_economyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            data: null
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.data = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["costsDivision"](params, function (response) {
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_economyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Navn', field: 'name', type: 'string' }, { label: 'Antal brugt', field: 'total_quantity', type: 'number' }, { label: 'Total kostpris', field: 'total_cost', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_cost',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["materialUsage"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 384 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_economyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Navn', field: 'name', type: 'string' }, { label: 'Antal købt', field: 'total_quantity', type: 'number' }, { label: 'Total købspris', field: 'total_cost', type: 'number' }, { label: 'Kostpris pr. enhed (gns)', field: 'avg_price_per_material', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_cost',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["suppliers"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedTable: 'KeyFigures',
            sidebarMenuItems: [{
                name: 'Nøgletal',
                tableName: 'KeyFigures'
            }]
        };
    },

    computed: {},
    methods: {
        onRowClick: function onRowClick(params) {
            console.log(params);
        },
        rowStyleClassFn: function rowStyleClassFn(row) {
            return row.age > 18 ? 'green' : 'red';
        },
        updateCount: function updateCount(tableName, event) {
            this.counts[tableName] = event;
        }
    }
});

/***/ }),
/* 386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__learning_revenueAndCosts_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__learning_revenueAndCosts_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__learning_revenueAndCosts_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__learning_ebitda_vue__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__learning_ebitda_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__learning_ebitda_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__learning_compare_vue__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__learning_compare_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__learning_compare_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__learning_potential_vue__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__learning_potential_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__learning_potential_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__learning_keyFigures_vue__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__learning_keyFigures_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__learning_keyFigures_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__learning_materials_vue__ = __webpack_require__(704);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__learning_materials_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__learning_materials_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__learning_budgetFollowup_vue__ = __webpack_require__(697);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__learning_budgetFollowup_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__learning_budgetFollowup_vue__);










/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        revenueAndCosts: __WEBPACK_IMPORTED_MODULE_0__learning_revenueAndCosts_vue___default.a,
        ebitda: __WEBPACK_IMPORTED_MODULE_1__learning_ebitda_vue___default.a,
        budgetFollowup: __WEBPACK_IMPORTED_MODULE_6__learning_budgetFollowup_vue___default.a,
        compare: __WEBPACK_IMPORTED_MODULE_2__learning_compare_vue___default.a,
        potential: __WEBPACK_IMPORTED_MODULE_3__learning_potential_vue___default.a,
        keyFigures: __WEBPACK_IMPORTED_MODULE_4__learning_keyFigures_vue___default.a,
        materials: __WEBPACK_IMPORTED_MODULE_5__learning_materials_vue___default.a
    },
    data: function data() {
        return {
            selectedItem: 'ebitda',
            counts: {
                EconomyOperationsUnbilledProjects: null,
                EconomyOperationsExceededPayments: null,
                allInvoices: null
            },
            switchItems: [{
                name: 'EBITDA',
                slug: 'ebitda',
                dTooltip: 'economy.ebitda'
            }, {
                name: 'Værdikæde',
                slug: 'revenueAndCosts'
            }, {
                name: 'Nøgletal',
                slug: 'keyFigures'
            }, {
                name: 'Vareforbrug',
                slug: 'materials'
            }, {
                name: 'Alle fakturaer og kreditnotaer',
                slug: 'allInvoices'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
        this.$store.state.view = 'learning';
        if (this.$store.state.config.availableDepartments.length > 3) {
            this.switchItems.splice(4, 0, { name: 'Sammenlign afdelinger', slug: 'compare' });
        }

        this.switchItems.splice(1, 0, { name: 'Budgetopfølgning', slug: 'budgetFollowup' });
    }
});

/***/ }),
/* 387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_budgetService__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_budgetService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_budgetService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_budgetHours_vue__ = __webpack_require__(701);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_budgetHours_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_budgetHours_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_budgetCph_vue__ = __webpack_require__(699);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_budgetCph_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_budgetCph_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_budgetEbitda_vue__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_budgetEbitda_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_budgetEbitda_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_BoxLoading_vue__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_elements_BoxLoading_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_elements_BoxLoading_vue__);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedSubMenuItem: 'hours',
            data: null,
            loading: true
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_budgetService__["overview"]({}, function (response) {
                console.log(response);
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a,
        budgetHours: __WEBPACK_IMPORTED_MODULE_2__components_budgetHours_vue___default.a,
        budgetCph: __WEBPACK_IMPORTED_MODULE_3__components_budgetCph_vue___default.a,
        budgetEbitda: __WEBPACK_IMPORTED_MODULE_4__components_budgetEbitda_vue___default.a,
        BoxLoading: __WEBPACK_IMPORTED_MODULE_5__components_elements_BoxLoading_vue___default.a
    }
});

/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'compare-keyfigures': __webpack_require__(689),
        'compare-revenue': __webpack_require__(690),
        'compare-coverage-percent': __webpack_require__(687),
        'compare-coverage': __webpack_require__(685),
        'compare-coverage-per-hour': __webpack_require__(686),
        'compare-customer-hours': __webpack_require__(688)
    }
});

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_budgetService__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_budgetService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_budgetService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            data: null,
            graphModal: null,
            graphOptions: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            return _this.$options.filters.currency(value);
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#FFA000', '#4CAF50', '#03A9F4', '#172b43'],
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                tooltip: {
                    enabled: true,
                    shared: true,
                    followCursor: true
                }
            }
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_budgetService__["cph"]({}, function (response) {
                if (response.data.project_types.length > 0) {
                    _this2.graphOptions.labels = response.data.project_types[0].labels;
                }
                _this2.data = response.data;
                console.log(response);
            }, function (err) {
                console.log(err);
            });
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
    }
});

/***/ }),
/* 390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_budgetService__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_budgetService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_budgetService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            period: 'budgetyear',
            data: null,
            accountsModal: null
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.data = null;
            this.accountsModal = null;
            var params = {
                period: this.period
            };
            __WEBPACK_IMPORTED_MODULE_0__services_budgetService__["ebitda"](params, function (response) {
                _this.data = response.data;
            }, function (err) {
                console.log(err);
            });
        }
    },
    watch: {
        period: function period() {
            this.getData();
        }
    }
});

/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_budgetService__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_budgetService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_budgetService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            data: null,
            hoursGraphSeries: [],
            hoursGraphOptions: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.number(value) + ' timer';
                            } else {
                                return '0 timer';
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                dataLabels: {
                    enabled: false
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: ['#172b43', '#4CAF50'],
                chart: {
                    toolbar: {
                        show: false
                    }
                }
            }
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_budgetService__["hours"]({}, function (response) {
                _this2.hoursGraphOptions.labels = response.data.hours.graph.labels;
                _this2.hoursGraphSeries.push({ name: 'Budget', data: response.data.hours.graph.budget_series });
                _this2.hoursGraphSeries.push({ name: 'Faktisk', data: response.data.hours.graph.actual_series });
                _this2.data = response.data;
                console.log(response.data);
            }, function (err) {
                console.log(err);
            });
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
    }
});

/***/ }),
/* 392 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(492);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__services_economyService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axios_index__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__axios_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__axios_index__);









/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            accountingYearsCheck: null,
            accounts: null,
            selectedAccountCategory: null,
            selectedAccount: null,
            accountEntries: null,
            loading: true,
            includeJournal: true
        };
    },
    created: function created() {
        this.getData();
        this.getContentfulData();
    },

    methods: {
        getContentfulData: function getContentfulData() {
            var contentful = __webpack_require__(29);
            var client = contentful.createClient({
                space: '3h0kg5qa88is',

                accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            });

            client.getEntry('4SzlILGMZwweEFr9myvbxT').then(function (entry) {}).catch(function (err) {
                return console.log(err);
            });
        },
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.accounts = null;
            this.selectedAccountCategory = null;
            var baseParams = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            var entriesPromise = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__services_economyService__["accountPlan"](__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, baseParams, { source: 'entries' }), function (r) {
                    return resolve(r.data);
                }, reject);
            });
            var journalPromise = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__services_economyService__["accountPlan"](__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, baseParams, { source: 'journal' }), function (r) {
                    return resolve(r.data);
                }, reject);
            });
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([entriesPromise, journalPromise]).then(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    entries = _ref2[0],
                    journal = _ref2[1];

                _this.accounts = _this.mergeAccountPlans(entries, journal);

                _this.includeJournal = _this.hasJournalData(_this.accounts);
                _this.loading = false;
            }).catch(function (err) {
                _this.loading = false;
                console.log(err);
            });
        },
        hasJournalData: function hasJournalData(nodes) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(nodes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var node = _step.value;

                    if (Array.isArray(node)) {
                        if (this.hasJournalData(node)) return true;
                        continue;
                    }
                    if (Number(node.journal_total) !== 0) return true;
                    if (Array.isArray(node.accounts)) {
                        var _iteratorNormalCompletion2 = true;
                        var _didIteratorError2 = false;
                        var _iteratorError2 = undefined;

                        try {
                            for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(node.accounts), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                                var acc = _step2.value;

                                if (Number(acc.journal_total) !== 0) return true;
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally {
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                                    _iterator2.return();
                                }
                            } finally {
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return false;
        },
        mergeAccountPlans: function mergeAccountPlans(entries, journal) {
            var journalByUuid = {};
            var collectByUuid = function collectByUuid(groups, target) {
                groups.forEach(function (node) {
                    if (Array.isArray(node)) {
                        collectByUuid(node, target);
                    } else {
                        target[node.uuid] = node;
                    }
                });
            };
            collectByUuid(journal, journalByUuid);

            var mergeNode = function mergeNode(node) {
                if (Array.isArray(node)) return node.map(mergeNode);
                var journalNode = journalByUuid[node.uuid];
                var entriesTotal = Number(node.total) || 0;
                var journalTotal = journalNode ? Number(journalNode.total) || 0 : 0;
                var merged = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, node, {
                    entries_total: entriesTotal,
                    journal_total: journalTotal,
                    total: entriesTotal + journalTotal
                });
                if (Array.isArray(node.accounts)) {
                    var journalAccountsByUuid = {};
                    if (journalNode && Array.isArray(journalNode.accounts)) {
                        journalNode.accounts.forEach(function (a) {
                            journalAccountsByUuid[a.uuid] = a;
                        });
                    }
                    merged.accounts = node.accounts.map(function (acc) {
                        var jAcc = journalAccountsByUuid[acc.uuid];
                        var eTot = Number(acc.total) || 0;
                        var jTot = jAcc ? Number(jAcc.total) || 0 : 0;
                        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, acc, {
                            entries_total: eTot,
                            journal_total: jTot,
                            total: eTot + jTot
                        });
                    });
                }
                return merged;
            };
            return entries.map(mergeNode);
        },
        selectAccountCategory: function selectAccountCategory(accountCategory) {
            this.selectedAccountCategory = accountCategory;
            this.selectedAccount = null;
            this.accountEntries = null;
        },
        checkAttachments: function checkAttachments() {
            var _this2 = this;

            if (!this.accountEntries || this.accountEntries.length === 0) return;
            var voucherNumbers = this.accountEntries.filter(function (e) {
                return e.voucher_number;
            }).map(function (e) {
                return e.voucher_number;
            });
            if (voucherNumbers.length === 0) return;
            __WEBPACK_IMPORTED_MODULE_5__axios_index___default.a.post('voucher/check-attachments', {
                voucher_numbers: voucherNumbers
            }).then(function (response) {
                var withAttachments = response.data;
                _this2.accountEntries.forEach(function (entry) {
                    _this2.$set(entry, 'hasAttachment', withAttachments.includes(entry.voucher_number));
                });
            }).catch(function () {});
        },
        openAttachment: function openAttachment(entry) {
            var _this3 = this;

            if (entry.loadingAttachment) return;
            this.$set(entry, 'loadingAttachment', true);
            var newWindow = window.open('about:blank', '_blank');
            __WEBPACK_IMPORTED_MODULE_5__axios_index___default.a.get('voucher/' + entry.voucher_number + '/attachment', {
                responseType: 'blob'
            }).then(function (response) {
                var blob = new Blob([response.data], { type: 'application/pdf' });
                var url = window.URL.createObjectURL(blob);
                newWindow.location.href = url;
                entry.loadingAttachment = false;
            }).catch(function (err) {
                entry.loadingAttachment = false;
                if (newWindow) newWindow.close();
                if (err.response && err.response.status === 404) {
                    _this3.$toastr('info', 'Intet bilag fundet for denne postering', 'Info');
                } else {
                    _this3.$toastr('error', 'Kunne ikke hente bilag', 'Fejl');
                }
            });
        },
        selectAccount: function selectAccount(account) {
            var _this4 = this;

            this.selectedAccount = account;
            this.accountEntries = null;
            var baseParams = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };

            var entriesPromise = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__services_economyService__["accountEntries"](account.uuid, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, baseParams, { source: 'entries' }), function (r) {
                    return resolve(r.data.data);
                }, reject);
            });
            var journalPromise = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
                __WEBPACK_IMPORTED_MODULE_4__services_economyService__["accountEntries"](account.uuid, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, baseParams, { source: 'journal' }), function (r) {
                    return resolve(r.data.data);
                }, reject);
            });
            __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a.all([entriesPromise, journalPromise]).then(function (_ref3) {
                var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                    entries = _ref4[0],
                    journal = _ref4[1];

                var combined = [];(entries || []).forEach(function (e) {
                    return combined.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, e, { _source: 'entries' }));
                });(journal || []).forEach(function (e) {
                    return combined.push(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, e, { _source: 'journal' }));
                });
                combined.sort(function (a, b) {
                    return (b.date || '').localeCompare(a.date || '');
                });
                _this4.accountEntries = combined;
                _this4.checkAttachments();
            }).catch(function (err) {
                console.log(err);
            });
        },
        checkAccountingYears: function checkAccountingYears() {
            var _this5 = this;

            __WEBPACK_IMPORTED_MODULE_4__services_economyService__["accountingYearsCheck"]({}, function (response) {
                _this5.accountingYearsCheck = response.data;
            }, function (err) {
                console.log(err);
            });
        }
    },
    computed: {
        filteredAccountEntries: function filteredAccountEntries() {
            if (!this.accountEntries) return null;
            if (this.includeJournal) return this.accountEntries;
            return this.accountEntries.filter(function (e) {
                return e._source !== 'journal';
            });
        },
        categoryHasJournalAccounts: function categoryHasJournalAccounts() {
            if (!this.selectedAccountCategory || !this.selectedAccountCategory.accounts) return false;
            return this.selectedAccountCategory.accounts.some(function (a) {
                return Number(a.journal_total) !== 0;
            });
        },
        entriesHaveJournal: function entriesHaveJournal() {
            if (!this.filteredAccountEntries) return false;
            return this.filteredAccountEntries.some(function (e) {
                return e._source === 'journal';
            });
        },
        sortedAccounts: function sortedAccounts() {
            if (this.accounts) {
                var arr = [];
                this.accounts.forEach(function (account) {
                    if (!Array.isArray(account)) {
                        arr.push(account);
                    } else {
                        account.forEach(function (child) {
                            arr.push(child);
                        });
                    }
                });

                return arr;
            }
        },
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            revenueSeries: [{ 'name': 'Omsætning', 'type': 'line', 'width': 3 }, { 'name': 'Dækningsbidrag', 'type': 'area', 'width': 3 }]
        };
    },

    components: {
        'costprice-per-hour': __webpack_require__(691),
        'costs-division': __webpack_require__(692)
    }
});

/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        'material-usage': __webpack_require__(693),
        'suppliers': __webpack_require__(694)
    }
});

/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_economyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            data: null,
            ebitda: null,
            customerHours: {
                now: 46,
                min: 0,
                max: 54,
                value: 0,
                label: '%'
            },
            projectRevenue: {
                now: 12300,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            },
            materialsUsage: {
                now: 2400,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            },
            coveragePercent: {
                now: 45,
                min: 0,
                max: 100,
                value: 0,
                label: '%'
            }
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["keyFigures"](params, function (response) {
                _this.data = response.data;
                _this.ebitda = _this.data.economy.ebitda;
                _this.customerHours.now = response.data.timeloggings.avg_percent;
                _this.customerHours.max = 100 - response.data.timeloggings.avg_percent;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        customerHoursTotal: function customerHoursTotal() {
            if (this.data) {
                return this.data.coverage.total * (this.customerHours.value / this.customerHours.now);
            }
            return 0;
        },
        projectRevenueTotal: function projectRevenueTotal() {
            if (this.data) {
                return this.data.revenue.invoices_total * (this.projectRevenue.value / 100);
            }
            return 0;
        },
        materialsUsageTotal: function materialsUsageTotal() {
            if (this.data) {
                return this.data.materials.total * (this.materialsUsage.value / 100);
            }
            return 0;
        },
        projects: function projects() {
            var _this2 = this;

            if (this.data && this.coveragePercent.value !== 0) {
                var projects = this.data.coverage.projects;
                var responseProjects = [];
                projects.forEach(function (project) {
                    if (project.coverage_percent && project.coverage_percent < _this2.coveragePercent.value && project.coverage_percent > 0 && project.invoices_total > 0) {
                        responseProjects.push(project);
                    }
                });
                return responseProjects;
            }
        },
        coveragePercentTotal: function coveragePercentTotal() {
            var _this3 = this;

            if (this.data && this.coveragePercent.value !== 0) {
                var projects = this.projects;
                var count = 0;
                projects.forEach(function (project) {
                    if (project.coverage_percent && project.coverage_percent < _this3.coveragePercent.value && project.coverage_percent > 0 && project.invoices_total > 0) {
                        count += (_this3.coveragePercent.value - project.coverage_percent) / 100 * project.invoices_total;
                    }
                });
                return count;
            }
            return 0;
        },
        totalPotential: function totalPotential() {
            return this.ebitda + this.customerHoursTotal + this.projectRevenueTotal + this.materialsUsageTotal + this.coveragePercentTotal;
        },
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_calculationService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            showChildren: true,
            figures: null
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {};
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["valueChain"](params, function (response) {
                _this.figures = response.data;
                if (_this.$auth.user().name.includes('Demo')) {
                    _this.figures.unbilled.count = 2;
                    _this.figures.unbilled.revenue = 80577;
                    _this.figures.unbilled.coverage = 35454;
                    _this.figures.unpaid_invoices.count = 8;
                    _this.figures.unpaid_invoices.revenue = 322311;
                    _this.figures.unpaid_invoices.coverage = 141816;
                }
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        total: function total() {
            var revenue = this.figures.expected_revenue + this.figures.revenue_in_pipeline;
            var costs = this.figures.expected_costs;
            return revenue - costs;
        },
        globalParams: function globalParams() {
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return department;
        },
        revenueTotal: function revenueTotal() {
            if (this.figures) {
                var total = this.figures.offer.expected_revenue + this.figures.open.expected_revenue + this.figures.ongoing.value_with_avg_cp + this.figures.unbilled.value_with_avg_cp + this.figures.unpaid_invoices.expected_revenue + this.figures.overdue_invoices.expected_revenue;
                return total;
            }
        },
        coverageTotal: function coverageTotal() {
            if (this.figures) {
                var total = this.figures.offer.expected_coverage + this.figures.open.expected_coverage + (this.figures.ongoing.value_with_avg_cp - this.figures.ongoing.value) + (this.figures.unbilled.value_with_avg_cp - this.figures.unbilled.value) + this.figures.unpaid_invoices.expected_coverage + this.figures.overdue_invoices.expected_coverage;
                return total;
            }
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operations_exceededPayments_vue__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__operations_exceededPayments_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__operations_exceededPayments_vue__);




/* harmony default export */ __webpack_exports__["default"] = ({
    components: {
        exceededPayments: __WEBPACK_IMPORTED_MODULE_0__operations_exceededPayments_vue___default.a
    },
    data: function data() {
        return {
            selectedItem: 'noInvoiceProjects',
            counts: {
                noInvoiceProjects: null,
                exceededPayments: null,
                allInvoices: null
            },
            switchItems: [{
                name: 'Afsluttede opgaver, der ikke er fakturerede',
                slug: 'noInvoiceProjects'
            }, {
                name: 'Fakturaer, der ikke er betalt',
                slug: 'unpaidInvoices'
            }, {
                name: 'Fakturaer, hvor betalingsfristen er overskredet med ' + this.$store.state.config.companyMeta.settings.overdue_days + ' dage',
                slug: 'exceededPayments'
            }, {
                name: 'Alle fakturaer og kreditnotaer',
                slug: 'allInvoices'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
        this.$store.state.view = 'operations';
        if (this.$route.params.selectedItem) {
            this.selectedItem = this.$route.params.selectedItem;
        }
    }
});

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false
        };
    }
});

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'timeUsageSkills',
            counts: {},
            switchItems: [{
                name: 'Hvor gode er vi til at registrere tid?',
                slug: 'timeUsageSkills'
            }, {
                name: 'Hvad bruger vi tiden på?',
                slug: 'timeUsage'
            }, {
                name: 'Hvordan er medarbejdernes indtjening?',
                slug: 'employeeRevenue'
            }, {
                name: 'Hvor meget tid bruger svendene hos kunderne?',
                slug: 'efficiencyGraph'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
        this.$store.state.view = 'learning';
    },

    components: {
        'employee-skills': __webpack_require__(718),
        'time-usage': __webpack_require__(720),
        'time-usage-skills': __webpack_require__(721),
        'employee-revenue': __webpack_require__(715),
        'efficiency-graph': __webpack_require__(714)
    }
});

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['employeeWorkingFieldName'],
    data: function data() {
        return {
            loading: true,
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Navn', field: 'name', type: 'string' }, { label: 'Tid hos kunder', field: 'hoursWithCustomers', type: 'number' }, { label: 'Sygefravær', field: 'sicknessPercent', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'hoursWithCustomers',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.rows = [];
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            if (this.employeeWorkingFieldName !== '') {
                params.working_field_name = this.employeeWorkingFieldName;
            }
            __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__["employees"](params, function (response) {
                console.log(response.data);
                response.data.forEach(function (item) {
                    var hoursWithCustomers = item.hours_division.series[0];
                    var totalDivision = item.hours_division.series.reduce(function (a, b) {
                        return a + b;
                    }, 0);
                    item.hoursWithCustomers = totalDivision > 0 ? Math.round(hoursWithCustomers / totalDivision * 100) : 0;
                    var hours = 0;
                    var totalHours = 0;
                    item.hours_without_customers.series.forEach(function (series) {
                        totalHours = totalHours + series;
                    });
                    item.hours_without_customers.labels.forEach(function (label, index) {
                        if (label.toString(16).toLowerCase().includes('syg')) {
                            hours = hours + item.hours_without_customers.series[index];
                        }
                    });
                    item.sicknessPercent = hours > 0 && totalHours > 0 ? Math.round(hours / item.available_hours * 100) : 0;
                });
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectCustomer: function selectCustomer(employee) {
            var _this2 = this;

            this.selectedRow = null;
            setTimeout(function () {
                _this2.selectedRow = employee.row;
            }, 250);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a,
        'hours-with-customers': __webpack_require__(713),
        'pie': __webpack_require__(245)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        },
        employeeWorkingFieldName: function employeeWorkingFieldName() {
            this.getData();
        }
    }
});

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        var _this = this;

        return {
            chartOptions: {
                series: [],
                labels: [],
                colors: ['#4CAF50', '#FF5252'],
                chart: {
                    type: 'pie',
                    height: '300px'
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function formatter(value) {
                            var percent = Math.round(value / _this.data.hours_total * 100);
                            return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function formatter(val) {
                        return _this.$options.filters.rounded(val) + ' %';
                    }
                },
                legend: {
                    position: 'bottom',
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: false
                            }
                        }
                    }
                }
            }
        };
    },
    created: function created() {
        this.setData();
    },

    methods: {
        setData: function setData() {
            this.chartOptions.labels = this.data.efficiency_series.labels;
            this.chartOptions.series = this.data.efficiency_series.series;
        }
    },
    watch: {
        componentData: function componentData() {
            this.setData();
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    computed: {
        componentData: function componentData() {
            return this.data;
        }
    }
});

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        headline: { type: String, default: '' },
        series: { type: Array, default: function _default() {
                return [];
            } },
        labels: { type: Array, default: function _default() {
                return [];
            } },
        division: { type: Boolean, default: false },
        height: { type: String, default: '300px' }
    },
    data: function data() {
        var _this = this;

        return {
            chartOptions: {
                series: [],
                labels: this.labels ? this.labels : null,
                colors: this.division === true ? ['#4CAF50', '#FFC107', '#E57373', '#9E9E9E'] : this.$store.state.graphColors,
                chart: {
                    type: 'pie',
                    height: this.height
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function formatter(value) {
                            var percent = Math.round(value / _this.total * 100);
                            return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function formatter(val) {
                        return _this.$options.filters.rounded(val) + ' %';
                    }
                },
                legend: {
                    show: false,
                    position: 'bottom',
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    }
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: false,
                                value: {
                                    formatter: function formatter(value) {
                                        var percent = Math.round(value / _this.total * 100);
                                        return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    },

    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a
    },
    computed: {
        total: function total() {
            var count = 0;
            this.series.forEach(function (item) {
                count += item;
            });
            return count;
        }
    }
});

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            efficiencyGraph: 'efficiency',
            efficiencyGraphParams: false,
            efficiencyGraphSeries: [{ 'name': 'Arbejde hos kunderne', 'type': 'bar', 'width': 0 }]
        };
    },

    methods: {
        toggleEfficiency: function toggleEfficiency() {
            if (this.efficiencyGraph === 'efficiency') {
                this.efficiencyGraph = 'efficiency?weekdays=1';
                this.efficiencyGraphParams = true;
            } else {
                this.efficiencyGraph = 'efficiency';
                this.efficiencyGraphParams = false;
            }
        }
    }
});

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_employeeService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            selectedRow: null,
            selectedProjectType: null,
            columns: [{ label: 'Initialer', field: 'initials', type: 'string' }, { label: 'Medarbejder', field: 'full_name', type: 'string' }, { label: 'Antal opgaver', field: 'total_projects', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.selectedRow = null;
            this.selectedProjectType = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["revenue"](params, function (response) {
                _this.rows = response.data ? response.data : [];
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.full_name === this.selectedRow.full_name) {
                return 'selected';
            }
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        data: function data() {
            this.getData();
        },
        globalParams: function globalParams() {
            this.getData();
        }
    },
    components: {
        'employee-revenue-project-types': __webpack_require__(716)
    }
});

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            selectedRow: null,
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal opgaver', field: 'projects_count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    watch: {
        data: function data() {
            this.selectedRow = null;
        }
    },
    components: {
        'employee-revenue-projects': __webpack_require__(717)
    }
});

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            selectedRow: null,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_employeeService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Initialer', field: 'initials', type: 'string' }, { label: 'Medarbejder', field: 'full_name', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["findAll"]({}, function (response) {
                var employees = [];
                response.data.forEach(function (employee) {
                    if (employee.working_field) {
                        employees.push(employee);
                    }
                });
                _this.rows = employees;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        'employee-skills-single': __webpack_require__(719)
    }
});

/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_employeeService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            loading: true,
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal i perioden', field: 'projects_count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["skills"](this.data.uuid, params, function (response) {
                _this.rows = response.data ? response.data.project_types : [];
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
            console.log(projectType);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        data: function data() {
            this.getData();
        },
        globalParams: function globalParams() {
            this.getData();
        }
    },
    components: {
        'employee-skills-single-projects': __webpack_require__(711)
    }
});

/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_apexcharts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            employeeWorkingFieldName: '',
            loading: true,
            hoursDivision: {
                series: null,
                labels: null
            },
            hoursWithCustomers: {
                series: null,
                labels: null
            },
            hoursWithoutCustomers: {
                series: null,
                labels: null
            },
            hoursExcluded: {
                series: null,
                labels: null
            },
            chartOptions: {
                series: [],
                labels: [],
                colors: this.$store.state.graphColors,
                chart: {
                    type: 'pie',
                    height: '600px'
                },
                tooltip: {
                    enabled: true,
                    y: {
                        formatter: function formatter(value) {
                            var percent = Math.round(value / _this.total * 100);
                            return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                        }
                    }
                },
                dataLabels: {
                    enabled: true,
                    formatter: function formatter(val) {
                        return _this.$options.filters.rounded(val) + ' %';
                    }
                },
                legend: {
                    position: 'left'
                },
                plotOptions: {
                    pie: {
                        donut: {
                            labels: {
                                show: true,
                                value: {
                                    formatter: function formatter(value) {
                                        var percent = Math.round(value / _this.total * 100);
                                        return _this.$options.filters.rounded(value) + ' timer (' + percent + '%)';
                                    }
                                }
                            }
                        }
                    }
                }
            }
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.data = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            if (this.employeeWorkingFieldName !== '') {
                params.working_field_name = this.employeeWorkingFieldName;
            }
            __WEBPACK_IMPORTED_MODULE_1__services_timeUsageService__["all"](params, function (response) {
                _this2.hoursDivision.series = response.data.hours_division.series;
                _this2.hoursDivision.labels = response.data.hours_division.labels;
                _this2.hoursWithCustomers.series = response.data.hours_with_customers.series;
                _this2.hoursWithCustomers.labels = response.data.hours_with_customers.labels;
                _this2.hoursWithoutCustomers.series = response.data.hours_without_customers.series;
                _this2.hoursWithoutCustomers.labels = response.data.hours_without_customers.labels;
                _this2.hoursExcluded.series = response.data.hours_excluded ? response.data.hours_excluded.series : [];
                _this2.hoursExcluded.labels = response.data.hours_excluded ? response.data.hours_excluded.labels : [];
                _this2.loading = false;
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_0_vue_apexcharts___default.a,
        'employee-time-usage': __webpack_require__(712),
        'pie': __webpack_require__(245)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        total: function total() {
            if (this.chartOptions.series.length > 0) {
                return this.chartOptions.series.reduce(function (a, b) {
                    return a + b;
                }, 0);
            }
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        },
        employeeWorkingFieldName: function employeeWorkingFieldName() {
            this.getData();
        }
    }
});

/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_timeUsageService__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_timeUsageService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_timeUsageService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            employeeWorkingFieldName: '',
            loading: true,
            data: null,
            columns: [{ label: 'Initialer', field: 'initials', type: 'string' }, { label: 'Medarbejder', field: 'full_name', type: 'string' }, { label: 'Timer til rådighed', field: 'available_hours', type: 'number' }, { label: 'Timer registreret', field: 'logged_hours', type: 'number' }, { label: 'Registreret tid', field: 'efficiency', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 15,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'efficiency',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.data = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            if (this.employeeWorkingFieldName !== '') {
                params.working_field_name = this.employeeWorkingFieldName;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_timeUsageService__["skills"](params, function (response) {
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        },
        employeeWorkingFieldName: function employeeWorkingFieldName() {
            this.getData();
        }
    }
});

/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'claims',
            counts: {
                claims: null
            },
            switchItems: [{
                name: 'Afsluttede reklamationer',
                slug: 'claims'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
        this.$store.state.view = 'operations';
    },

    components: {
        'claims-table': __webpack_require__(246)
    }
});

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Ansvarlig', field: 'responsible_employee.full_name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '30%' }, { label: 'Kunde', field: 'customer.name', type: 'string', width: '30%' }, { label: 'Startdato', field: 'start_date', type: 'string', width: '10%' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'responsible_employee.full_name',
                    type: 'asc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var dateFrom = this.$store.getters.getStartDate;
            var dateTo = this.$store.getters.getEndDate;
            var params = {
                'filter[complaint]': true,
                'filter[status]': 'billed,posted',
                'filter[between]': dateFrom + ',' + dateTo,
                include: 'customer,type,responsibleEmployee,installationAddress'
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["claims"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Navn', field: 'name' }, { label: 'Antal', field: 'sub_projects_count', type: 'number' }, { label: 'Budget omk.', field: 'budget' }, { label: 'Realiseret', field: 'sub_projects_total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__["employees"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        'employee-sub-projects-single': __webpack_require__(724)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Budget omk.', field: 'budget', type: 'string' }, { label: 'Realiseret', field: 'total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name' }, { label: 'Startdato', field: 'external_created_at' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
            this.$emit('showSubProjects', this.selectedRow);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    }
});

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedSubProjectType: null,
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Entreprisetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'count', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__["projectTypes"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectMainProjectType: function selectMainProjectType(mainProjectType) {
            this.selectedRow = mainProjectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        },
        setSubProjects: function setSubProjects(subProjectType) {
            this.selectedSubProjectType = subProjectType;
        }
    },
    components: {
        'main-project-type-single': __webpack_require__(725),
        'sub-projects': __webpack_require__(730)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Entreprisetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'external_created_at', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__["main"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Navn', field: 'name' }, { label: 'Antal', field: 'sub_projects_count', type: 'number' }, { label: 'Budget omk.', field: 'budget' }, { label: 'Realiseret', field: 'total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_mainProjectService__["subProjectTypes"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
                _this.$emit('finishedLoading', _this.rows.length);
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectSubProjectType: function selectSubProjectType(subProjectType) {
            this.selectedRow = subProjectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'sub-project-types-single': __webpack_require__(729)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Budget omk.', field: 'budget', type: 'string' }, { label: 'Realiseret', field: 'total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        data: {
            required: true
        }
    },
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Budget omk.', field: 'budget_expenses', type: 'string' }, { label: 'Realiseret', field: 'total_expenses', type: 'number' }, { label: 'Eff. grad', field: 'efficiency_percent', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    }
});

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedItem: 'mainProjectTypes',
            counts: {
                mainProjectTypes: null,
                mainProjects: null,
                employeesSubProjects: null,
                subProjectTypes: null
            },
            switchItems: [{
                name: 'Hvilke entreprisetyper tjenes der penge på?',
                slug: 'mainProjectTypes'
            }, {
                name: 'Hvilke konkrete entrepriseopgaver tjenes der penge på?',
                slug: 'mainProjects'
            }, {
                name: 'Hvordan er effektiviteten på underentrepriserne?',
                slug: 'subProjectTypes'
            }, {
                name: 'Hvordan er medarbejdernes effektivitet?',
                slug: 'employeesSubProjects'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
    },

    components: {
        'main-project-types': __webpack_require__(726),
        'main-projects': __webpack_require__(727),
        'employees-sub-projects': __webpack_require__(723),
        'sub-project-types': __webpack_require__(728)
    }
});

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: {
        title: String,
        lines: Array
    },
    data: function data() {
        return {
            show: false,
            options: {
                popover: {
                    defaultClass: 'd-tooltip',
                    defaultBaseClass: 'd-tooltip',
                    trigger: 'hover'
                }
            }
        };
    },

    filters: {
        lineAmount: function lineAmount(line) {
            if (line.unit === 't') {
                return line.amount.toLocaleString('da-DK') + ' t';
            }
            return line.amount.toLocaleString('da-DK', { minimumFractionDigits: 0, maximumFractionDigits: 2 }) + ' kr.';
        }
    }
});

/***/ }),
/* 424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_calculationService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calcTooltip_vue__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__calcTooltip_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__calcTooltip_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_EbitdaDevelopment_vue__ = __webpack_require__(664);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_elements_EbitdaDevelopment_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_elements_EbitdaDevelopment_vue__);






/* harmony default export */ __webpack_exports__["default"] = ({
    components: { calcTooltip: __WEBPACK_IMPORTED_MODULE_1__calcTooltip_vue___default.a, EbitdaDevelopment: __WEBPACK_IMPORTED_MODULE_2__components_elements_EbitdaDevelopment_vue___default.a },
    data: function data() {
        return {
            data: null,
            error: false
        };
    },

    computed: {
        realizedLines: function realizedLines() {
            var from = this.$options.filters.moment(this.data.accounting_year.from, 'D. MMM YYYY');
            var today = this.$options.filters.moment(new Date(), 'D. MMM YYYY');
            return [{ label: 'Bogført', formula: from + ' - ' + today, amount: this.data.realized.booked }, { label: 'Kassekladder', formula: 'Endnu ikke bogført', amount: this.data.realized.journal }, { label: 'Realiseret EBITDA', formula: '', amount: this.data.realized_ebitda, total: true }];
        },
        wipLines: function wipLines() {
            return [{ label: 'Igangværende opgaver', formula: this.data.wip.ongoing_count + ' opgaver', amount: this.data.wip.ongoing }, { label: 'Afsluttede, ikke fakturerede', formula: this.data.wip.unbilled_count + ' opgaver', amount: this.data.wip.unbilled }, { label: 'Værdi i alt', formula: '', amount: this.data.wip.total, total: true }];
        },
        forecastLines: function forecastLines() {
            return this.data.forecast.lines;
        },
        comparisonLines: function comparisonLines() {
            return this.data.forecast.comparison;
        },
        cphDeviation: function cphDeviation() {
            return this.data.forecast.coverage_per_hour - this.data.forecast.budget.cph_calculated;
        },
        cphDeviationPercent: function cphDeviationPercent() {
            var budgeted = this.data.forecast.budget.cph_calculated;
            if (!(budgeted > 0)) {
                return null;
            }
            return (Math.abs(this.cphDeviation) / budgeted * 100).toFixed(1).replace('.', ',');
        },
        aboveBudget: function aboveBudget() {
            return this.data.forecast.budget_deviation >= 0;
        }
    },
    methods: {
        getData: function getData() {
            var _this = this;

            this.data = null;
            this.error = false;
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["find"]('expected-ebitda', {}, function (response) {
                _this.data = response.data;
            }, function (err) {
                _this.error = true;
                console.log(err);
            });
        }
    },
    created: function created() {
        this.getData();
    }
});

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_calculationService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            data: null
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.data = null;
            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["valueChain"](params, function (response) {
                _this.data = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_calculationService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            keyfigures: null,
            calculations: {
                offer: null,
                claims: null,
                close_to_budget: null,
                ongoing: null,
                open: null,
                payment_pending: null,
                payment_exceeded: null,
                payment_exceeded_total: null,
                snoozed: null,
                unbilled: null
            }
        };
    },

    methods: {
        getCalculations: function getCalculations() {
            var _this = this;

            this.calculations = {
                offer: null,
                claims: null,
                close_to_budget: null,
                ongoing: null,
                open: null,
                payment_pending: null,
                payment_exceeded: null,
                payment_exceeded_total: null,
                snoozed: null,
                unbilled: null
            };
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["find"]('index/counts', params, function (response) {
                _this.calculations = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        getEconomyData: function getEconomyData() {
            var _this2 = this;

            this.keyfigures = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["find"]('index-economy', params, function (response) {
                _this2.keyfigures = response.data;
                console.log(response.data);
            }, function (err) {
                console.log(err);
            });
        }
    },
    created: function created() {
        this.getCalculations();
        this.getEconomyData();
    },

    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getCalculations();
            this.getEconomyData();
        }
    },
    components: {
        'value-chain': __webpack_require__(734),
        'expected-ebitda': __webpack_require__(733)
    }
});

/***/ }),
/* 427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_userService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            username: '',
            password: '',
            rememberMe: false,
            showResetPasswordForm: false,
            passwordResetted: false
        };
    },
    created: function created() {
        this.checkIfDemoEnvironment();
    },

    methods: {
        checkIfDemoEnvironment: function checkIfDemoEnvironment() {
            if (false) {
                this.username = 'demo@proebitda.dk';
                this.password = 'demo';
            }
        },
        login: function login() {
            var _this = this;

            var body = {
                username: this.username,
                password: this.password
            };
            this.$auth.login({
                data: body,
                rememberMe: this.rememberMe,
                fetchUser: true,
                redirect: { name: 'Index' },
                success: function success(response) {
                    _this.$emit('loggedIn');
                    _this.$store.dispatch('getConfig');
                    var username = _this.$auth.user().name.split(' ')[0];
                    _this.$toastr('success', 'Velkommen, ' + username + '!', 'Logget ind');
                    setTimeout(function () {
                        _this.$store.state.showDailyTip = true;
                    }, 2000);
                },
                error: function error(_error) {
                    console.log(_error);
                }
            });
        },
        toggleResetPasswordForm: function toggleResetPasswordForm() {
            this.showResetPasswordForm = true;
        },
        doReset: function doReset() {
            var _this2 = this;

            var params = {
                email: this.username
            };
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["forgotPassword"](params, function (response) {
                _this2.passwordResetted = true;
            }, function (err) {
                alert('Der skete desværre en fejl ved nulstilling af din adgangskode. Tjek, at du har skrevet en gyldig e-mail adresse og prøv venligst igen.');
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_possibleEffortsService__ = __webpack_require__(483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_possibleEffortsService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_possibleEffortsService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_dailyInsightService__ = __webpack_require__(481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_dailyInsightService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_dailyInsightService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedMenuItem: null,
            selectedBox: null,
            loading: true,
            data: null,
            insight: null,
            insightLoading: false,
            insightHistory: [],
            showHistory: false,
            identifiers: ['economy.projects', 'economy.aconto', 'economy.reminders', 'customers.makingMoney', 'customers.smallAndBig', 'projects.rightProjects', 'projects.mostImportantFirst', 'projects.mostImportantSecond', 'employees.moreTime', 'employees.lessSickness', 'employees.rightPeople', 'potential'],
            textsLoaded: 0,
            texts: {
                economy: {
                    projects: {
                        tekstPOverblik: 'Her er de muligvis 10 største opgaver, der ikke er sat i gang, med et muligt dækningsbidrag på',
                        boksTekst: 'Sæt opgaver i gang',
                        tykTekst1: 'Den mulige indtjening på opgaver, der ikke er sat i gang, er ca.',
                        tykTekst2: null,
                        tyndTekst1: 'Her ser du værdien af de 10 største opgaver, der ikke er sat i gang endnu:'
                    },
                    aconto: {
                        tekstPOverblik: 'Aconto fakturering minimerer risikoen for at tabe penge og forbedrer likviditeten. Salgsværdien af igangværende arbejder er ca.',
                        boksTekst: 'Aconto betalinger',
                        tykTekst1: 'Salgsværdien af igangværende arbejder er ca.',
                        tykTekst2: null,
                        tyndTekst1: 'Du sikrer dine tilgodehavender og likviditet ved at aconto fakturere mest muligt.<br>Her ser du værdien af de 10 største igangværende arbejder. Vurder om der er kunder, som bør acontofaktureres:'
                    },
                    reminders: {
                        tekstPOverblik: 'Der er fakturaer med overskreden betaling for i alt',
                        boksTekst: 'Start rykkerprocessen',
                        tykTekst1: 'Der er fakturaer med overskreden betaling for i alt',
                        tykTekst2: null,
                        tyndTekst1: 'Tag tyren ved hornene og tal med kunden om den manglende betaling mens I begge kan huske, hvad der skal betales for. Sandsynligheden for at få pengene øges betydeligt ved at sætte ind hurtigt. Her ser du de 10 største ubetalte fakturaer:'
                    }
                },
                customers: {
                    makingMoney: {
                        tekstPOverblik: 'Indtjeningen pr. time på de 10 største kunder spænder fra',
                        boksTekst: 'Er de største kunder lønsomme?',
                        tykTekst1: 'Indtjeningen på de 10 største kunder spænder fra',
                        tykTekst2: null,
                        tyndTekst1: 'Vurder om priserne skal hæves for bestemte kunder, eller I måske skal stoppe med at arbejde for dem. Er det muligt at finde nye kunder, der ligner de lønsomme? Her er de 10 største kunder målt på indtjeningen pr. time:'
                    },
                    smallAndBig: {
                        tekstPOverblik: 'På de 2 grupper af kunder med størst omsætning tjenes der pr. time',
                        boksTekst: 'Kan vi tjene penge på både små og store kunder?',
                        tykTekst1: 'På de 2 grupper af kunder med den største indtjening tjenes der henholdsvis',
                        tykTekst2: null,
                        tyndTekst1: 'Se forskellene på indtjeningen i de forskellige grupper og vurder om det er karakteren af opgaven, der gør indtjeningen forskellig, eller om priserne kan justeres. Måske er der opgaver, som kræver mere forberedelse Vurder også, hvad skal der til for at øge indtjeningen på de grupper af kunder, hvor indtjeningen er lavere.'
                    }
                },
                projects: {
                    rightProjects: {
                        tekstPOverblik: 'Indtjeningen på de 10 største opgavetyper spænder fra',
                        boksTekst: 'Arbejdes der med de rigtige opgaver?',
                        tykTekst1: 'Indtjeningen på de 10 største opgavetyper spænder fra',
                        tykTekst2: null,
                        tyndTekst1: 'Se hvor I bruger jeres tid og om indtjeningen pr. time er tilfredsstillende. Indtjeningen kan ofte øges væsentligt med små justeringer af priserne. Måske er der også opgavetyper, I skal træne mere i eller stoppe med at tilbyde. Vurder også, om I har de rigtige opgavetyper i ordrestyringssystemet, så oversigten bliver bedst mulig at handle efter.'
                    },
                    mostImportantFirst: {
                        tekstPOverblik: 'Udviklingen i dækningsbidraget pr. time på de 2 største opgavetyper er',
                        boksTekst: 'Går indtjeningen frem eller tilbage på de vigtigste opgavetyper?',
                        tykTekst1: 'Udviklingen i dækningsbidraget pr. time OG i det samlede dækningsbidrag på de 2 største opgavetyper de seneste 12 måneder er:',
                        tykTekst2: null,
                        tyndTekst1: 'Her ser du, om dækningsbidraget og indtjeningen pr. time på de vigtigste opgavetyper er gået frem eller tilbage de sidste 6 måneder. Vurder hvad det betyder for virksomheden på sigt, hvis f.eks. det samlede dækningsbidrag stiger, men dækningsbidraget pr. time falder. Er det øget konkurrence, som gør, at virksomheden bør overveje at fokusere på andre opgavetyper?'
                    },
                    mostImportantSecond: {
                        tekstPOverblik: 'Udviklingen i det SAMLEDE dækningsbidrag på de 2 største opgavetyper er',
                        boksTekst: 'Går indtjeningen frem eller tilbage på de vigtigste opgavetyper?',
                        tykTekst1: 'Udviklingen i dækningsbidraget pr. time OG i det samlede dækningsbidrag på de 2 største opgavetyper de seneste 12 måneder er:',
                        tykTekst2: null,
                        tyndTekst1: 'Her ser du, om dækningsbidraget og indtjeningen pr. time på de vigtigste opgavetyper er gået frem eller tilbage de sidste 6 måneder. Vurder hvad det betyder for virksomheden på sigt, hvis f.eks. det samlede dækningsbidrag stiger, men dækningsbidraget pr. time falder. Er det øget konkurrence, som gør, at virksomheden bør overveje at fokusere på andre opgavetyper?'
                    }
                },
                employees: {
                    moreTime: {
                        tekstPOverblik: 'Hvis den tid svendene er hos kunderne kan øges med 5%, kan indtjeningen stige med',
                        boksTekst: 'Øg svendenes tid hos kunderne',
                        tykTekst1: 'Tid svendene er hos kunderne af den tid, der registreres:',
                        tykTekst2: 'Hvis kundetiden kan øges med 5%, vil indtjeningen stige med',
                        tyndTekst1: 'Det er kun tiden hos kunderne, der kan faktureres. Derfor er det vigtigt, at tiden brugt på administration og andre aktiviteter er mindst mulig. Her kan du se, hvad svendene bruger den disponible tid til og hvor der eventuelt kan hentes mere kundetid.'
                    },
                    lessSickness: {
                        tekstPOverblik: 'Hvis sygefraværet kan sættes ned til 2%, vil indtjeningen stige med',
                        boksTekst: 'Gør sygefraværet mindre',
                        tykTekst1: 'Sygefraværet de seneste 12 måneder er:',
                        tykTekst2: 'Hvis sygefraværet kan sættes ned til 2%, vil indtjeningen stige med',
                        tyndTekst1: 'En svend kan selvfølgelig godt være syg af medicinske grunde, men der kan også være andre faktorer, som f.eks. arbejdsmiljø og usikkerhed over vor bestemte opgavetyper, der giver sygefravær. Her ser du svende med det største sygefravær og hvem der eventuelt skal tales med.'
                    },
                    rightPeople: {
                        tekstPOverblik: 'Hvis dækningsbidraget pr. time på de svende, der indtjener mindre end gennemsnittet af svendene, hæves til gennemsnittet af svendene i dag, vil indtjeningen kunne øges med',
                        boksTekst: 'Sæt de rigtige svende på opgaverne',
                        tykTekst1: 'Hvis dækningsbidraget pr. time på de svende, der indtjener mindre end gennemsnittet, hæves til gennemsnittet i dag, vil indtjeningen øges med',
                        tykTekst2: null,
                        tyndTekst1: 'Svendene er ikke lige gode til alle opgaver. Der kan øge indtjeningen betydeligt, at sætte svendene på de opgavetyper, de er bedst til, når det er praktisk muligt. Her ser du, hvilke svende, der indtjener mest pr. time på den opgavetype, I bruger mest tid på:'
                    }
                },
                potential: {
                    tekstPOverblik: 'Her kan I hurtigt og let beregne, hvad der er af mulig øget indtjening, ved at skrue på blandt andet<ul><li>&bull;&nbsp;antal timer hos kunden</li><li>&bull;&nbsp;prisen på hver enkelt opgavetype justeres</li></ul>',
                    boksTekst: null,
                    tykTekst1: null,
                    tykTekst2: null,
                    tyndTekst1: null
                }
            }
        };
    },
    mounted: function mounted() {
        var _this = this;

        this.identifiers.forEach(function (identifier) {
            _this.getContentfulData(identifier);
        });
        this.getData();
        this.getInsight();
    },

    methods: {
        selectMenuItem: function selectMenuItem(menuItem) {
            this.selectedBox = null;
            if (menuItem === 'potential') {
                this.$router.push({ name: 'Potential' });
                return;
            }
            this.selectedMenuItem = menuItem;
        },
        selectBox: function selectBox(menuItem, box) {
            this.selectedBox = box;
            this.selectedMenuItem = menuItem;
        },
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_possibleEffortsService__["all"](params, function (response) {
                _this2.data = response.data;
                _this2.loading = false;
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        getInsight: function getInsight() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_1__services_dailyInsightService__["get"](function (response) {
                _this3.insight = response.data;
            }, function () {});
        },
        regenerateInsight: function regenerateInsight() {
            var _this4 = this;

            this.insightLoading = true;
            __WEBPACK_IMPORTED_MODULE_1__services_dailyInsightService__["regenerate"](function (response) {
                _this4.insight = response.data;
                _this4.insightLoading = false;
                _this4.showHistory = false;
                _this4.insightHistory = [];
            }, function () {
                _this4.insightLoading = false;
            });
        },
        loadHistory: function loadHistory() {
            var _this5 = this;

            if (this.insightHistory.length > 0) {
                this.showHistory = true;
                return;
            }
            __WEBPACK_IMPORTED_MODULE_1__services_dailyInsightService__["history"](function (response) {
                _this5.insightHistory = response.data;
                _this5.showHistory = true;
            }, function () {});
        },
        getContentfulData: function getContentfulData(identifier, model) {
            var _this6 = this;

            var contentful = __webpack_require__(29);
            var client = contentful.createClient({
                space: '3h0kg5qa88is',

                accessToken: 'KL17Lh_FTD4ZN6iksXFClsWCVJ_OEVVUbIt7RUGofwc'
            });

            client.getEntries({
                content_type: 'muligeIndsatser',
                'fields.identifier[in]': identifier
            }).then(function (entries) {
                console.log('entries', entries);

                if (identifier === 'economy.projects') {
                    _this6.texts.economy.projects = entries.items[0].fields;
                }
                if (identifier === 'economy.aconto') {
                    _this6.texts.economy.aconto = entries.items[0].fields;
                }
                if (identifier === 'economy.reminders') {
                    _this6.texts.economy.reminders = entries.items[0].fields;
                }

                if (identifier === 'customers.makingMoney') {
                    _this6.texts.customers.makingMoney = entries.items[0].fields;
                }
                if (identifier === 'customers.smallAndBig') {
                    _this6.texts.customers.smallAndBig = entries.items[0].fields;
                }

                if (identifier === 'projects.rightProjects') {
                    _this6.texts.projects.rightProjects = entries.items[0].fields;
                }
                if (identifier === 'projects.mostImportantFirst') {
                    _this6.texts.projects.mostImportantFirst = entries.items[0].fields;
                }
                if (identifier === 'projects.mostImportantSecond') {
                    _this6.texts.projects.mostImportantSecond = entries.items[0].fields;
                }

                if (identifier === 'employees.moreTime') {
                    _this6.texts.employees.moreTime = entries.items[0].fields;
                }
                if (identifier === 'employees.lessSickness') {
                    _this6.texts.employees.lessSickness = entries.items[0].fields;
                }
                if (identifier === 'employees.rightPeople') {
                    _this6.texts.employees.rightPeople = entries.items[0].fields;
                }

                if (identifier === 'potential') {
                    _this6.texts.potential = entries.items[0].fields;
                }

                _this6.textsLoaded++;
            }).catch(function (err) {
                return console.log(err);
            });
        }
    },
    computed: {
        isSuperAdmin: function isSuperAdmin() {
            try {
                return this.$auth.user().roles[0].name === 'super-admin';
            } catch (e) {
                return false;
            }
        },
        localEnv: function localEnv() {
            if (false) {
                return true;
            }
            return false;
        },
        totalOpenValue: function totalOpenValue() {
            var total = 0;
            if (this.data) {
                this.data.economy.projects.table.forEach(function (project) {
                    total += Number(project.expected_coverage);
                });
            }
            return total;
        },
        totalAcontoValue: function totalAcontoValue() {
            var total = 0;
            if (this.data) {
                this.data.economy.aconto.table.forEach(function (project) {
                    total += Number(project.value_with_avg_cp);
                });
            }
            return total;
        },
        totalRemindersValue: function totalRemindersValue() {
            var total = 0;
            if (this.data) {
                this.data.economy.reminders.table.forEach(function (invoice) {
                    total += Number(invoice.amount);
                });
            }
            return total;
        },
        customersMakingMoneyRange: function customersMakingMoneyRange() {
            var arr = [];
            if (this.data) {
                this.data.customers.making_money.table.forEach(function (customer, index) {
                    arr.push(Number(customer.coverage_per_hour));
                });
            }
            arr.sort(function (a, b) {
                return a - b;
            });
            return [arr[0], arr[arr.length - 1]];
        },
        smallAndBigRange: function smallAndBigRange() {
            if (this.data) {
                var ranges = this.data.customers.small_and_big.table;
                return [ranges[0], ranges[1]];
            }
            return [0, 0];
        },
        projectsRightProjectsRange: function projectsRightProjectsRange() {
            var arr = [];
            if (this.data) {
                this.data.projects.right_projects.table.forEach(function (project, index) {
                    arr.push(Number(project.coverage_per_hour));
                });
            }
            arr.sort(function (a, b) {
                return a - b;
            });
            return [arr[0], arr[arr.length - 1]];
        },
        projectsMostImportantRange: function projectsMostImportantRange() {
            var arr = [];
            if (this.data) {
                var first = this.data.projects.most_important.table.values[0];
                var second = this.data.projects.most_important.table.values[1];
                if (first) {
                    arr.push({
                        name: first.name ? first.name : '-',
                        coverage_first: first.coverage.first,
                        coverage_last: first.coverage.last,
                        coverage_change: first.coverage.last - first.coverage.first,
                        coverage_per_hour_first: first.coverage_per_hour.first,
                        coverage_per_hour_last: first.coverage_per_hour.last,
                        coverage_per_hour_change: first.coverage_per_hour.last - first.coverage_per_hour.first
                    });
                }
                if (second) {
                    arr.push({
                        name: second.name ? second.name : '-',
                        coverage_first: second.coverage.first,
                        coverage_last: second.coverage.last,
                        coverage_change: second.coverage.last - second.coverage.first,
                        coverage_per_hour_first: second.coverage_per_hour.first,
                        coverage_per_hour_last: second.coverage_per_hour.last,
                        coverage_per_hour_change: second.coverage_per_hour.last - second.coverage_per_hour.first
                    });
                }
            }
            return arr;
        },
        employeesRightPeoplePossibleRevenue: function employeesRightPeoplePossibleRevenue() {
            var total = 0;
            if (this.data) {
                var avg = this.data.employees.right_people.avg_coverage_per_hour;
                this.data.employees.right_people.table.forEach(function (employee) {
                    if (employee.coverage_per_hour < avg) {
                        total += (avg - employee.coverage_per_hour) * employee.total_hours;
                    }
                });
                return total;
            }
            return total;
        }
    },
    components: {
        'possible-efforts-economy': __webpack_require__(666),
        'possible-efforts-customers': __webpack_require__(665),
        'possible-efforts-projects': __webpack_require__(668),
        'possible-efforts-employees': __webpack_require__(667)
    }
});

/***/ }),
/* 429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_calculationService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_calculationService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            projectTypes: []
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_calculationService__["projectTypesPotential"](params, function (response) {
                if (_this.projectTypes.length > 0) {
                    response.data.forEach(function (responseType) {
                        _this.projectTypes.forEach(function (projectType) {
                            if (projectType.name === responseType.name) {
                                responseType.value = projectType.value;
                            }
                        });
                    });
                }
                _this.projectTypes = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        total: function total() {
            if (this.projectTypes.length > 0) {
                var total = 0;
                this.projectTypes.forEach(function (projectType) {
                    var value = projectType.total_revenue / 100 * projectType.value;
                    total += value;
                });
                return total * this.convertToYear;
            }
        },
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        convertToYear: function convertToYear() {
            var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters.getStartDate);
            var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters.getEndDate);
            if (endDate > __WEBPACK_IMPORTED_MODULE_1_moment___default()()) {
                endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            }
            var duration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(endDate.diff(startDate));
            var days = duration.asDays() + 1;
            return 365 / days;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_economyService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            data: null,
            ebitda: null,
            customerHours: {
                now: 46,
                min: 0,
                max: 54,
                value: 0,
                label: '%'
            },
            projectRevenue: {
                now: 12300,
                min: 0,
                max: 50,
                value: 0,
                label: '%'
            },
            materialsUsage: {
                now: 2400,
                min: 0,
                max: 50,
                value: 0,
                label: '%'
            },
            coveragePercent: {
                now: 45,
                min: 0,
                max: 75,
                value: 0,
                label: '%'
            },
            hourPrice: {
                min: 0,
                max: 100,
                value: 0,
                label: 'kr.'
            }
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["keyFigures"](params, function (response) {
                _this.data = response.data;
                _this.ebitda = _this.data.economy.ebitda;
                _this.customerHours.now = response.data.timeloggings.avg_percent;
                _this.customerHours.max = 100 - response.data.timeloggings.avg_percent;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        customerHoursTotal: function customerHoursTotal() {
            if (this.data && this.data.coverage.total && this.customerHours.value) {
                return this.data.coverage.total * (this.customerHours.value / this.customerHours.now) * this.convertToYear;
            }
            return 0;
        },
        projectRevenueTotal: function projectRevenueTotal() {
            if (this.data && this.data.revenue.invoices_total && this.projectRevenue.value) {
                return this.data.revenue.invoices_total * (this.projectRevenue.value / 100);
            }
            return 0;
        },
        materialsUsageTotal: function materialsUsageTotal() {
            if (this.data) {
                return this.data.materials.total * (this.materialsUsage.value / 100);
            }
            return 0;
        },
        projects: function projects() {
            var _this2 = this;

            if (this.data && this.coveragePercent.value !== 0) {
                var projects = this.data.coverage.projects;
                var responseProjects = [];
                projects.forEach(function (project) {
                    if (Number(project.coverage_percent) && Number(project.coverage_percent) < Number(_this2.coveragePercent.value) && Number(project.coverage_percent) > 0 && Number(project.invoices_total) > 0) {
                        responseProjects.push(project);
                    }
                });
                return responseProjects;
            }
        },
        coveragePercentTotal: function coveragePercentTotal() {
            var _this3 = this;

            if (this.data && this.coveragePercent.value !== 0) {
                var projects = this.projects;
                var count = 0;
                projects.forEach(function (project) {
                    if (Number(project.coverage_percent) && Number(project.coverage_percent) < Number(_this3.coveragePercent.value) && Number(project.coverage_percent) > 0 && Number(project.invoices_total > 0)) {
                        count += (Number(_this3.coveragePercent.value) - Number(project.coverage_percent)) / 100 * Number(project.invoices_total);
                    }
                });
                return count * this.convertToYear;
            }
            return 0;
        },
        hourPriceTotal: function hourPriceTotal() {
            if (this.data && this.hourPrice.value !== 0) {
                return this.hourPrice.value * Math.round(this.data.timeloggings.total_with_project);
            }
            return 0;
        },
        totalPotential: function totalPotential() {
            return this.customerHoursTotal + this.projectRevenueTotal + this.materialsUsageTotal + this.coveragePercentTotal + this.hourPriceTotal;
        },
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        convertToYear: function convertToYear() {
            var startDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters.getStartDate);
            var endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()(this.$store.getters.getEndDate);
            if (endDate > __WEBPACK_IMPORTED_MODULE_1_moment___default()()) {
                endDate = __WEBPACK_IMPORTED_MODULE_1_moment___default()();
            }
            var duration = __WEBPACK_IMPORTED_MODULE_1_moment___default.a.duration(endDate.diff(startDate));
            var days = duration.asDays() + 1;
            return 365 / days;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    },
    components: {
        'project-types-potential': __webpack_require__(737)
    }
});

/***/ }),
/* 431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['rows', 'loading'],
    data: function data() {
        return {
            tableKey: 0,
            selectedType: null,
            columns: [{ label: 'Type', field: 'name', type: 'string', width: '30%', align: 'left', sortable: true }, { label: 'Budgetteret', field: 'proposal_cost', type: 'number', width: '20%', align: 'left', sortable: true }, { label: 'Realiseret', field: 'expended_cost', type: 'number', width: '20%', align: 'left', sortable: true }, { label: 'Difference', field: 'difference', type: 'number', width: '20%', align: 'left', sortable: true }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'difference',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {}
        };
    },

    methods: {
        selectType: function selectType(params) {
            this.selectedType = params.row;
            this.tableKey++;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedType && this.selectedType.name === row.name) {
                return 'selected';
            }
            return '';
        }
    },
    components: {
        'minuba-budget-report-linetypes-projecttypes': __webpack_require__(740)
    },
    computed: {
        filteredRows: function filteredRows() {
            if (this.rows.length) {
                return this.rows;
            }
            return [];
        }
    }
});

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['type', 'rows'],
    data: function data() {
        return {
            tableKey: 0,
            selectedProjectType: null,
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string', width: '30%', align: 'left', sortable: true }, { label: 'Antal opgaver', field: 'projects_count', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Budgetteret', field: 'proposal_cost', type: 'number', width: '20%', align: 'left', sortable: true }, { label: 'Realiseret', field: 'expended_cost', type: 'number', width: '20%', align: 'left', sortable: true }, { label: 'Difference', field: 'difference', type: 'number', width: '20%', align: 'left', sortable: true }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'difference',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {}
        };
    },

    methods: {
        selectProjectType: function selectProjectType(params) {
            this.selectedProjectType = params.row;
            this.tableKey++;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedProjectType && this.selectedProjectType.name === row.name) {
                return 'selected';
            }
            return '';
        }
    },
    watch: {
        rows: function rows() {
            this.selectedProjectType = null;
            this.tableKey++;
        }
    },
    components: {
        'minuba-budget-single-projects': __webpack_require__(247)
    }
});

/***/ }),
/* 433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['rows', 'loading'],
    data: function data() {
        return {
            tableKey: 0,
            selectedProjectType: null,
            columns: [{ label: 'Type', field: 'name', type: 'string', width: '30%', align: 'left', sortable: true }, { label: 'Budgetteret', field: 'proposal_cost', type: 'number', width: '20%', align: 'left', sortable: true }, { label: 'Realiseret', field: 'expended_cost', type: 'number', width: '20%', align: 'left', sortable: true }, { label: 'Difference', field: 'difference', type: 'number', width: '20%', align: 'left', sortable: true }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'difference',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {}
        };
    },

    methods: {
        selectProjectType: function selectProjectType(params) {
            this.selectedProjectType = params.row;
            this.tableKey++;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedProjectType && this.selectedProjectType.name === row.name) {
                return 'selected';
            }
            return '';
        }
    },
    watch: {
        rows: function rows() {
            this.selectedProjectType = null;
        }
    },
    components: {
        'minuba-budget-report-projecttypes-linetypes': __webpack_require__(742)
    },
    computed: {
        filteredRows: function filteredRows() {
            if (this.rows.length) {
                return this.rows;
            }
            return [];
        }
    }
});

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['type', 'rows'],
    data: function data() {
        return {
            tableKey: 0,
            selectedProjectType: null,
            columns: [{ label: 'Budgetlinje', field: 'name', type: 'string', width: '30%', align: 'left', sortable: true }, { label: 'Antal opgaver', field: 'projects_count', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Budgetteret', field: 'proposal_cost', type: 'number', width: '20%', align: 'left', sortable: true }, { label: 'Realiseret', field: 'expended_cost', type: 'number', width: '20%', align: 'left', sortable: true }, { label: 'Difference', field: 'difference', type: 'number', width: '20%', align: 'left', sortable: true }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'difference',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {}
        };
    },

    methods: {
        selectProjectType: function selectProjectType(params) {
            this.selectedProjectType = params.row;
            this.tableKey++;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedProjectType && this.selectedProjectType.name === row.name) {
                return 'selected';
            }
            return '';
        }
    },
    watch: {
        rows: function rows() {
            this.selectedProjectType = null;
            this.tableKey++;
        }
    },
    components: {
        'minuba-budget-single-projects': __webpack_require__(247)
    }
});

/***/ }),
/* 435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_minubaBudgetService__ = __webpack_require__(482);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_minubaBudgetService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_minubaBudgetService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            divisionOption: 1,
            loading: true,
            lineTypes: [],
            projectTypes: []
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;

            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_minubaBudgetService__["report"](params, function (response) {
                _this.lineTypes = response.data.line_types;
                _this.projectTypes = response.data.project_types;

                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        totals: function totals() {
            if (this.lineTypes.length) {
                var proposal = 0;
                var expended = 0;
                this.lineTypes.forEach(function (row) {
                    proposal += row.proposal_cost;
                    expended += row.expended_cost;
                });
                var difference = proposal - expended;
                return [proposal, expended, difference];
            }
            return [null, null, null];
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    },
    components: {
        'minuba-budget-report-linetypes': __webpack_require__(739),
        'minuba-budget-report-projecttypes': __webpack_require__(741)
    }
});

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['rows', 'type'],
    data: function data() {
        return {
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Installationsadresse', field: 'installation_address.full_text', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {
                'filter[status]': 'billed,posted',
                'include': 'customer,type,installationAddress'
            }
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'projects_count', type: 'number' }, { label: 'DB pr. time (gns)', field: 'coverage_per_hour_avg', type: 'number' }, { label: 'Udvikling', field: 'progress_percent', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_per_hour_avg',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {
                'filter[status]': 'billed,posted',
                'include': 'customer,type'
            },
            height: '450',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.currency(value);
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__["coveragePerHour"](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.rows = response.data.values;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.values.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        selectProjectType: function selectProjectType(params) {
            this.series = [];
            this.series.push(params.row);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.series.length > 0 && row.name === this.series[0].name) {
                return 'selected';
            }
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: true,
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'projects_count', type: 'number' }, { label: 'DB (sum)', field: 'coverage_avg', type: 'number' }, { label: 'Udvikling', field: 'progress_percent', type: 'number' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_avg',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            params: {
                'filter[status]': 'billed,posted',
                'include': 'customer,type'
            },
            height: '450',
            unit: ' kr.',
            options: {
                labels: [],
                yaxis: {
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.currency(value);
                            }
                        }
                    },
                    title: {
                        text: this.ylabel
                    },
                    forceNiceScale: true,
                    min: 0
                },
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'bottom'
                },
                colors: this.$store.state.graphColors
            },
            series: []
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__["development"](params, function (response) {
                _this2.options.labels = response.data.labels;
                _this2.rows = response.data.values;

                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.values.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        selectProjectType: function selectProjectType(params) {
            this.series = [];
            this.series.push(params.row);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.series.length > 0 && row.name === this.series[0].name) {
                return 'selected';
            }
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_apexcharts__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        var _this = this;

        return {
            loading: false,
            series: [],
            rows: [],
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Antal', field: 'projects_count', type: 'number' }, { label: 'DB (sum)', field: 'coverage_total', type: 'number' }, { label: 'DB udv.', field: 'coverage.progress_percent', type: 'number' }, { label: 'DB/time (sum)', field: 'coverage_per_hour_total', type: 'number' }, { label: 'DB/time udv.', field: 'coverage_per_hour.progress_percent', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_total',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table',
            height: '450',
            unit: ' kr.',
            options: {
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                labels: [],
                yaxis: [{
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.currency(value);
                            }
                        }
                    },
                    title: {
                        text: 'DB'
                    },
                    forceNiceScale: true,
                    min: 0
                }, {
                    opposite: true,
                    labels: {
                        formatter: function formatter(value) {
                            if (value > 0) {
                                return _this.$options.filters.currency(value);
                            }
                        }
                    },
                    title: {
                        text: 'DB pr. time'
                    },
                    forceNiceScale: true,
                    min: 0
                }],
                stroke: {
                    width: 3,
                    curve: 'smooth'
                },
                legend: {
                    offsetY: 10,
                    itemMargin: {
                        horizontal: 5,
                        vertical: 10
                    },
                    position: 'top'
                },
                colors: this.$store.state.graphColors
            }
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this2 = this;

            this.loading = true;
            this.series = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }

            __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__["graphs"](params, function (response) {
                _this2.rows = response.data.values;
                _this2.options.labels = response.data.labels;
                _this2.loading = false;
                _this2.$emit('finishedLoading', response.data.values.length);
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        selectProjectType: function selectProjectType(projectType) {
            this.series = [];
            this.series.push(projectType.row);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.series.length > 0 && row.name === this.series[0].name) {
                return 'selected';
            }
        },
        generateSeries: function generateSeries() {
            if (this.series.length) {
                var arr = [];
                arr.push({
                    name: 'DB',
                    data: this.series[0].coverage.data
                });
                arr.push({
                    name: 'DB pr. time',
                    data: this.series[0].coverage_per_hour.data
                });
                return arr;
            }
            return [];
        }
    },
    components: {
        VueApexCharts: __WEBPACK_IMPORTED_MODULE_1_vue_apexcharts___default.a
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 440 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Opgavetype', field: 'name', type: 'string' }, { label: 'Medarbejdere', field: 'total_employees', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_projectTypeService__["projectTypeSkills"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(projectType) {
            this.selectedRow = projectType.row;
            console.log(projectType.row);
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'project-type-skills-single': __webpack_require__(748)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            selectedRow: null,
            rows: [],
            columns: [{ label: 'Medarbejder', field: 'name', type: 'string' }, { label: 'Opgaver', field: 'total_projects', type: 'number' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'Antal timer', field: 'timelog_hours', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage_per_hour',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'project-type-skills-single-projects': __webpack_require__(749)
    },
    watch: {
        data: function data() {
            this.selectedRow = null;
        }
    }
});

/***/ }),
/* 442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            selectedRow: null,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Omsætning', field: 'invoices_total', type: 'number' }, { label: 'DB', field: 'coverage', type: 'number' }, { label: 'DG', field: 'coverage_percent', type: 'number' }, { label: 'DB pr. time', field: 'coverage_per_hour', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedProjectType: null,
            selectedItem: 'projectTypeRevenue',
            counts: {
                projectTypeRevenue: null,
                closedProjectsRevenue: null,
                claims: null
            },
            switchItems: [{
                name: 'Hvilke opgavetyper tjenes der penge på?',
                slug: 'projectTypeRevenue'
            }, {
                name: 'Hvilke konkrete opgaver tjenes der penge på?',
                slug: 'closedProjectsRevenue'
            }, {
                name: 'Afsluttede reklamationer',
                slug: 'claims'
            }, {
                name: 'Hvilke svende er gode til hvilke opgaver?',
                slug: 'projectTypeSkills'
            }, {
                name: 'Udviklingen i DB / DB pr. time',
                slug: 'projectTypeGraphs'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        setSelectedProjectType: function setSelectedProjectType(projectType) {
            this.selectedProjectType = projectType;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
        this.$store.state.view = 'learning';

        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.switchItems.push({
                name: 'Opgavebudgetter',
                slug: 'minubaBudgetReport'
            });
        }
    },

    components: {
        'project-type-development': __webpack_require__(745),
        'project-type-skills': __webpack_require__(747),
        'project-type-coverage-per-hour-development': __webpack_require__(744),
        'project-type-graphs': __webpack_require__(746),
        'claims-table': __webpack_require__(246),
        'minuba-budget-report': __webpack_require__(743)
    }
});

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedItem: 'offerProjects',
            counts: {
                offerProjects: null,
                openProjects: null,
                snoozedProjects: null,
                noInvoiceProjects: null,
                ongoingProjects: null,
                openClaims: null,
                projectsCloseToBudget: '-'
            },
            switchItems: [{
                name: 'Tilbud',
                slug: 'offerProjects'
            }, {
                name: 'Ikke igangsatte opgaver',
                slug: 'openProjects'
            }, {
                name: 'Opgaver uden bevægelse i ' + this.$store.state.config.companyMeta.settings.snoozed_days + ' dage',
                slug: 'snoozedProjects'
            }, {
                name: 'Afsluttede opgaver, der ikke er fakturerede',
                slug: 'noInvoiceProjects'
            }, {
                name: 'Igangværende opgaver',
                slug: 'ongoingProjects'
            }, {
                name: 'Igangværende reklamationer',
                slug: 'openClaims'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }
        this.$store.state.view = 'operations';
        if (this.$route.params.selectedItem) {
            this.selectedItem = this.$route.params.selectedItem;
        }
    }
});

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedTable: 'closedProjectsRevenue',
            counts: {
                closedProjectsRevenue: null,
                ongoingProjects: null,
                snoozedProjects: null,
                openClaims: null,
                openProjects: null
            },
            sidebarMenuItems: [{
                name: 'Hvilke opgavetyper tjenes der penge på?',
                tableName: 'projectTypeRevenue'
            }, {
                name: 'Hvilke konkrete opgaver tjenes der penge på?',
                tableName: 'closedProjectsRevenue'
            }, {
                name: 'Igangværende opgaver',
                tableName: 'ongoingProjects'
            }, {
                name: 'Opgaver uden bevægelse de sidste ' + this.$store.state.config.companyMeta.settings.snoozed_days + ' dage',
                tableName: 'snoozedProjects'
            }, {
                name: 'Igangværende reklamationer',
                tableName: 'openClaims'
            }, {
                name: 'Ikke igangsatte opgaver',
                tableName: 'openProjects'
            }],
            goodTable: {
                columns: [{
                    label: 'Opgavetype',
                    field: 'type.name',
                    type: 'string'
                }, {
                    label: 'Opgave',
                    field: 'description',
                    type: 'string',
                    width: '20%'
                }, {
                    label: 'Kunde',
                    field: 'customer.name',
                    type: 'string'
                }, {
                    label: 'Omsætning',
                    field: 'revenue',
                    type: 'number'
                }, {
                    label: 'DB',
                    field: 'coverage',
                    width: '10%',
                    type: 'number'
                }, {
                    label: 'DG',
                    field: 'coverage_percent',
                    width: '8%',
                    type: 'number'
                }, {
                    label: 'DB/time',
                    field: 'coverage_per_hour',
                    width: '8%',
                    type: 'number'
                }],
                rows: []
            }
        };
    },

    computed: {},
    methods: {
        onRowClick: function onRowClick(params) {
            console.log(params);
        },
        rowStyleClassFn: function rowStyleClassFn(row) {
            return row.age > 18 ? 'green' : 'red';
        },
        updateCount: function updateCount(tableName, event) {
            this.counts[tableName] = event;
        }
    }
});

/***/ }),
/* 446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            username: '',
            password: '',
            rememberMe: false
        };
    },

    methods: {
        register: function register() {
            var body = {
                name: this.username,
                password: this.password
            };
            this.$auth.login({
                url: "https://api.proebitda.dk/v1" + '/auth/register',
                data: body,
                rememberMe: this.rememberMe,
                fetchUser: true,
                redirect: { name: 'Login' },
                success: function success(response) {
                    console.log(response);
                },
                error: function error(_error) {
                    console.log(_error);
                }
            });
        }
    },
    components: {}
});

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showHelper: false,
            selectedItem: 'compareResponsibleEmployees',
            counts: {},
            switchItems: [{
                name: 'Hvilke ansvarlige er gode til hvilke opgaver?',
                slug: 'compareResponsibleEmployees'
            }, {
                name: 'Hvilke opgavetyper er den enkelte ansvarlige god til?',
                slug: 'compareProjectTypesForResponsibles'
            }]
        };
    },

    methods: {
        updateCount: function updateCount(slug, event) {
            this.counts[slug] = event;
        },
        handleSelectItem: function handleSelectItem(item) {
            this.selectedItem = item;
            this.$router.push({
                path: this.$route.path,
                query: {
                    tab: item
                }
            });
        }
    },
    mounted: function mounted() {
        if (this.$auth.user().roles[0].name === 'project-responsible') {
            this.selectedItem = 'responsibleValuechain';
        }
        if (this.$route.query.tab) {
            this.selectedItem = this.$route.query.tab;
        }

        this.switchItems.push({
            name: 'Hvordan er de ansvarliges værdikæder?',
            slug: 'responsibleValuechain'
        });
    },

    components: {
        'compare-responsible-employees': __webpack_require__(756),
        'compare-project-types-for-responsibles': __webpack_require__(755),
        'responsible-valuechain': __webpack_require__(771)
    }
});

/***/ }),
/* 448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_employeeService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Opgavetype', field: 'name' }, { label: 'Ansvarlige', field: 'responsibles_count', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.selectedRow = null;
            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["compareResponsibleEmployeesProjectTypes"](params, function (response) {
                console.log(response.data);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        }
    },
    components: {
        'project-types-responsibles': __webpack_require__(758)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 449 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_employeeService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedRow: null,
            loading: true,
            rows: [],
            columns: [{ label: 'Ansvarlig', field: 'name' }, { label: 'Antal opgaver', field: 'total_projects', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.selectedRow = null;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["compareResponsibleEmployees"](params, function (response) {
                console.log(response.data);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.uuid === this.selectedRow.uuid) {
                return 'selected';
            }
        }
    },
    components: {
        'responsible-project-types': __webpack_require__(759)
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgave', field: 'name' }, { label: 'Kunde', field: 'customer_name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            selectedRow: null,
            columns: [{ label: 'Ansvarlig', field: 'name' }, { label: 'Antal opgaver', field: 'sub_projects_count', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectResponsible: function selectResponsible(responsible) {
            this.selectedRow = responsible.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        },
        clearSelectedProjectType: function clearSelectedProjectType() {
            this.selectedRow = null;
        }
    },
    watch: {
        'data': 'clearSelectedProjectType'
    },
    components: {
        'project-types-projects': __webpack_require__(757)
    }
});

/***/ }),
/* 452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            selectedRow: null,
            columns: [{ label: 'Opgavetype', field: 'name' }, { label: 'Antal opgaver', field: 'total_projects', type: 'number' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },

    methods: {
        selectProjectType: function selectProjectType(projectType) {
            this.selectedRow = projectType.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.name === this.selectedRow.name) {
                return 'selected';
            }
        },
        clearSelectedProjectType: function clearSelectedProjectType() {
            this.selectedRow = null;
        }
    },
    watch: {
        'data': 'clearSelectedProjectType'
    },
    components: {
        'responsible-projects': __webpack_require__(760)
    }
});

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['data'],
    data: function data() {
        return {
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgave', field: 'name' }, { label: 'Kunde', field: 'customer_name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Omsætning', field: 'total_revenue', type: 'number' }, { label: 'DB', field: 'total_coverage', width: '10%', type: 'number' }, { label: 'DG', field: 'coverage_percent', width: '8%', type: 'number' }, { label: 'DB/time', field: 'coverage_per_hour', width: '8%', type: 'number' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 10,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'total_coverage',
                    type: 'desc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
    }
});

/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedTable: null
        };
    },

    props: ['data'],
    methods: {
        scrollNow: function scrollNow() {
            var el = document.getElementById('tables');
            var pageElement = document.getElementsByClassName('page')[0];
            setTimeout(function () {
                pageElement.scroll({
                    behavior: 'smooth',
                    left: 0,
                    top: el.offsetTop - 125
                });
            }, 500);
        },
        showTable: function showTable(identifier) {
            this.selectedTable = null;
            this.selectedTable = identifier;

            console.log('scroll to table div');
        },
        reset: function reset() {
            this.selectedTable = null;
        }
    },
    components: {
        'table-offer': __webpack_require__(765),
        'table-open': __webpack_require__(767),
        'table-ongoing': __webpack_require__(766),
        'table-snoozed': __webpack_require__(769),
        'table-claims': __webpack_require__(762),
        'table-noinvoice': __webpack_require__(764),
        'table-unpaid': __webpack_require__(770),
        'table-overdue': __webpack_require__(768),
        'table-exceeded-payments': __webpack_require__(763)
    },
    watch: {
        'data': 'reset'
    }
});

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp', 'employeeId', 'employeeName'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[complaint]': true,
                'filter[status]': 'pending,ongoing',
                'filter[visible]': true,
                'filter[responsible]': this.employeeId,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_invoiceService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['employeeId', 'employeeName'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left' }, { label: 'Ordre', field: 'project.case_number', type: 'string', width: '10%', align: 'left' }, { label: 'Kunde', field: 'customer.name', type: 'string', width: '15%' }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%' }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%' }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions),
            styleClass: 'vgt-table',
            params: {
                'filter[unpaid]': true,
                'filter[overdue]': true,
                'filter[type]': '1,3',
                'include': 'customer'
            }
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'project.minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[unpaid]': 'true',
                'filter[overdue]': true,
                'filter[type]': '1,3',
                'filter[responsible]': this.employeeId,
                include: 'customer,project',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['employeeId', 'employeeName'],
    data: function data() {
        return {
            explanation: 'Denne tabel viser alle opgaver med en status, der angiver at den er afsluttet, men hvor der endnu ikke ligger en eller flere fakturaer tilknyttet opgaven. Hvis opgaven <b>er</b> blevet faktureret, bør du undersøge om fakturaen er tilknyttet opgaven i dit ordrestyrings-program.',
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions, {
                initialSortBy: {
                    field: 'start_date',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.columns = [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Aconto', field: 'invoices_total', type: 'number' }, { label: 'Timer/materialer, kostpris', field: 'total_expenses', type: 'number' }, { label: 'Værdi, salgspris', field: 'value_with_avg_cp', type: 'number' }, { label: 'Status', field: 'status.name', type: 'string' }];
        this.sortOptions.initialSortBy = {
            field: 'value_with_avg_cp',
            type: 'desc'
        };

        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'unbilled',

                'filter[visible]': true,
                'filter[responsible]': this.employeeId,
                include: 'type,customer,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        totalValue: function totalValue() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value;
                });
                return total;
            }
            return 0;
        },
        totalValueWithCP: function totalValueWithCP() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value_with_avg_cp;
                });
                return total;
            }
            return 0;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp', 'employeeId', 'employeeName'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'offer',
                'filter[visible]': true,
                'filter[responsible]': this.employeeId,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            console.log('params', params);
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp', 'employeeId', 'employeeName'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        this.columns = [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Aconto', field: 'invoices_total', type: 'number' }, { label: 'Timer/materialer, kostpris', field: 'total_expenses', type: 'number' }, { label: 'Værdi, salgspris', field: 'value_with_avg_cp', type: 'number' }, { label: 'Status', field: 'status.name', type: 'string' }];
        this.sortOptions.initialSortBy = {
            field: 'value_with_avg_cp',
            type: 'desc'
        };

        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'ongoing',
                'filter[visible]': true,
                'filter[responsible]': this.employeeId,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        },
        totalValue: function totalValue() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value;
                });
                return total;
            }
            return 0;
        },
        totalValueWithCP: function totalValueWithCP() {
            if (this.rows) {
                var total = 0;
                this.rows.forEach(function (project) {
                    total += project.value_with_avg_cp;
                });
                return total;
            }
            return 0;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp', 'employeeId', 'employeeName'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[status]': 'pending',
                'filter[visible]': true,
                'filter[responsible]': this.employeeId,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_invoiceService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['employeeId', 'employeeName'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true }, { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions, {
                initialSortBy: {
                    field: 'customer_name',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate,
                'responsible': this.employeeId
            };
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["overdue"](params, function (response) {
                console.log(response.data);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    }
});

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_projectService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['title', 'rpp', 'employeeId', 'employeeName'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }, { label: 'Status', field: 'status.name', type: 'string' }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                'filter[snoozed]': true,
                'filter[status]': 'ongoing',
                'filter[visible]': true,
                'filter[responsible]': this.employeeId,
                include: 'customer,type,status,installationAddress',
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_2__services_projectService__["find"](params, function (response) {
                console.log(response);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    },
    computed: {
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            var department = this.$store.getters.getCurrentDepartment.uuid;
            return startDate + endDate + department;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getData();
        }
    }
});

/***/ }),
/* 463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_invoiceService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_invoiceService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    props: ['employeeId', 'employeeName'],
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Faktura', field: 'invoice_number', type: 'number', width: '10%', align: 'left', sortable: true }, { label: 'Ordre', field: 'external_project_id', type: 'string', width: '10%', align: 'left', sortable: true }, { label: 'Kunde', field: 'customer_name', type: 'string', width: '15%', sortable: true }, { label: 'Beløb', field: 'amount', type: 'number', width: '15%', sortable: true }, { label: 'Beskrivelse', field: 'description', type: 'string', width: '20%', sortable: true }, { label: 'Forfaldsdato', field: 'due_at', type: 'string', width: '10%', sortable: true }, { label: 'Status', field: 'paid', type: 'boolean', width: '10%', sortable: true }],
            rows: [],
            searchOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.searchOptions),
            paginationOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.paginationOptions),
            sortOptions: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, __WEBPACK_IMPORTED_MODULE_1__components_tables_projects_shared_js___default.a.sortOptions, {
                initialSortBy: {
                    field: 'customer_name',
                    type: 'asc'
                }
            }),
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            this.$emit('finishedLoading', null);
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate,
                'responsible': this.employeeId
            };
            __WEBPACK_IMPORTED_MODULE_2__services_invoiceService__["unpaid"](params, function (response) {
                console.log(response.data);
                _this.rows = response.data;
                _this.$emit('finishedLoading', _this.rows.length);
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    }
});

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_employeeService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selectedEmployee: null,
            loading: true,
            employees: []
        };
    },
    created: function created() {
        this.getData();
        console.log('user', this.$auth.user());
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.selectedRow = null;
            this.loading = true;
            var params = {
                date_from: '2021-10-01',
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params['filter[by_department_uuid]'] = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["responsibleValuechain"](params, function (response) {
                console.log(response.data);
                _this.employees = response.data;
                _this.$emit('finishedLoading', _this.employees.length);
                _this.loading = false;
                if (_this.$auth.user().roles[0].name === 'project-responsible') {
                    _this.employees.forEach(function (employee) {
                        console.log(employee);
                        if (employee.relation_id === _this.$auth.user().relation_employee_id) {
                            _this.selectedEmployee = employee;
                        }
                    });
                    if (!_this.selectedEmployee) {
                        alert('Vi kunne ikke finde din værdikæde. Kontakt venligst din administrator.');
                    }
                }
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        selectEmployee: function selectEmployee(employee) {
            this.selectedRow = employee.row;
        },
        selectedRowClass: function selectedRowClass(row) {
            if (this.selectedRow && row.relation_id === this.selectedRow.relation_id) {
                return 'selected';
            }
        }
    },
    components: {
        'responsible-valuechain-single': __webpack_require__(761)
    }
});

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_economyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            showEmptyAccounts: false,
            loading: true,
            accounts: [],
            accountCategories: null
        };
    },
    created: function created() {
        this.getAccountCategories();
        this.getAccounts();
    },

    methods: {
        getAccountCategories: function getAccountCategories() {
            var _this = this;

            var params = {};
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["accountCategories"](params, function (response) {
                _this.accountCategories = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        getAccounts: function getAccounts() {
            var _this2 = this;

            this.loading = true;
            this.accounts = [];
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["accounts"](params, function (response) {
                _this2.accounts = response.data;
                _this2.loading = false;
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        updateAccount: function updateAccount(account, event) {
            var _this3 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var body = {
                budget: account.budget,
                account_category_uuid: event
            };
            if (event.target) {
                body.account_category_uuid = event.target.value;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["updateAccount"](account.uuid, body, function (response) {
                _this3.$toastr('success', 'Kontoen blev opdateret', 'Sådan!');
            });
        },
        toggleAccount: function toggleAccount(account) {
            var _this4 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var body = {
                show: account.show
            };
            __WEBPACK_IMPORTED_MODULE_0__services_economyService__["updateAccount"](account.uuid, body, function (response) {
                _this4.$toastr('success', 'Kontoen blev opdateret', 'Sådan!');
            });
        }
    },
    computed: {
        filteredAccounts: function filteredAccounts() {
            var _this5 = this;

            if (this.accounts) {
                var accounts = [];
                this.accounts.forEach(function (account) {
                    if (_this5.showEmptyAccounts) {
                        accounts.push(account);
                    } else {
                        if (account.entries_total && account.entries_total !== 0 && account.entries_total !== '0' && account.entries_total !== '0.00') {
                            accounts.push(account);
                        }
                    }
                });
                return accounts;
            }
        },
        globalParams: function globalParams() {
            var startDate = this.$store.getters.getStartDate;
            var endDate = this.$store.getters.getEndDate;
            return startDate + endDate;
        }
    },
    watch: {
        globalParams: function globalParams() {
            this.getAccounts();
        }
    }
});

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_economyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_economyService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            accountCategories: null,
            budgetCalc: null
        };
    },
    mounted: function mounted() {
        this.getAccountCategories();
    },

    methods: {
        getAccountCategories: function getAccountCategories() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["accountCategories"]({}, function (response) {
                _this.accountCategories = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
            });
        },
        updateValue: function updateValue(uuid, month, value) {
            var _this2 = this;

            var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, 'budget_' + month, value);
            __WEBPACK_IMPORTED_MODULE_1__services_economyService__["updateAccount"](uuid, body, function (response) {}, function (err) {
                console.log(err);
                _this2.$toastr('error', 'Der skete en fejl ved opdatering af budgettet', 'Hovsa!');
            });
        }
    }
});

/***/ }),
/* 467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_companyService__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_companyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_companyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            companies: null,
            providerFilter: 'all',
            svendeFilter: 'all',
            sortBy: 'name'
        };
    },

    computed: {
        invalidApiKeyCount: function invalidApiKeyCount() {
            if (!this.companies) return 0;
            return this.companies.filter(function (c) {
                return c.api_key_status === 'invalid';
            }).length;
        },
        filteredCompanies: function filteredCompanies() {
            var _this = this;

            if (!this.companies) return [];
            var list = this.companies.filter(function (company) {
                if (_this.providerFilter !== 'all' && company.api_provider.name !== _this.providerFilter) {
                    return false;
                }
                var count = company.active_field_employees_90d || 0;
                if (_this.svendeFilter === 'with' && count === 0) return false;
                if (_this.svendeFilter === 'without' && count > 0) return false;
                return true;
            });
            var sorted = list.slice();
            if (this.sortBy === 'svende_desc') {
                sorted.sort(function (a, b) {
                    return (b.active_field_employees_90d || 0) - (a.active_field_employees_90d || 0) || a.name.localeCompare(b.name, 'en');
                });
            } else if (this.sortBy === 'newest') {
                sorted.sort(function (a, b) {
                    return new Date(b.created_at || 0) - new Date(a.created_at || 0) || a.name.localeCompare(b.name, 'en');
                });
            } else {
                sorted.sort(function (a, b) {
                    return a.name.localeCompare(b.name, 'en');
                });
            }
            return sorted;
        }
    },
    created: function created() {
        this.getCompanies();
    },

    methods: {
        getCompanies: function getCompanies() {
            var _this2 = this;

            this.loading = true;
            var params = {
                include: 'api_provider'
            };
            __WEBPACK_IMPORTED_MODULE_0__services_companyService__["findAll"](params, function (response) {
                _this2.companies = response.data;
                _this2.loading = false;
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        changeCompany: function changeCompany(company) {
            var _this3 = this;

            var body = {
                company_uuid: company.uuid
            };
            __WEBPACK_IMPORTED_MODULE_0__services_companyService__["change"](body, function (response) {
                _this3.$toastr('success', 'Virksomhed opdateret. Opdaterer siden.', 'Sådan!');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_settingsService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_settingsService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_settingsService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            rows: [],
            columns: [{ label: 'Ordre', field: 'case_number', type: 'number' }, { label: 'Opgavetype', field: 'type.name', type: 'string' }, { label: 'Opgave', field: 'description', type: 'string', width: '20%' }, { label: 'Kunde', field: 'customer.name', type: 'string' }, { label: 'Startdato', field: 'start_date', type: 'string' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            },
            styleClass: 'vgt-table'
        };
    },
    created: function created() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                date_from: this.$store.getters.getStartDate,
                date_to: this.$store.getters.getEndDate
            };
            if (this.$store.getters.getCurrentDepartment.uuid !== 0) {
                params.department = this.$store.getters.getCurrentDepartment.uuid;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_settingsService__["cleanup"](params, function (response) {
                _this.rows = response.data.projects.rows;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    }
});

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_employeeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_employeeService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_companyService__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_companyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_companyService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            employeeTypes: ['Svend, funktionær', 'Svend, timelønnet', 'Lærling'],
            showActive: true,
            showUpdateButton: null,
            employees: null,
            employeeCalc: ''
        };
    },

    computed: {
        activeEmployees: function activeEmployees() {
            if (!this.employees) return [];
            return this.employees.filter(function (e) {
                return e.status;
            });
        },
        inactiveEmployees: function inactiveEmployees() {
            if (!this.employees) return [];
            return this.employees.filter(function (e) {
                return !e.status;
            });
        },
        filteredEmployees: function filteredEmployees() {
            return this.showActive ? this.activeEmployees : this.inactiveEmployees;
        },
        providerName: function providerName() {
            var slug = this.$auth.user().company.api_provider.slug;
            return slug === 'minuba' ? 'Minuba' : 'Ordrestyring';
        }
    },
    created: function created() {
        this.getEmployees();
    },

    methods: {
        getEmployeeCalc: function getEmployeeCalc() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__services_companyService__["employeeCalc"]({}, function (response) {
                _this.employeeCalc = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        selectEmployeeCalc: function selectEmployeeCalc(type) {
            var _this2 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var body = {
                employeeCalc: type
            };
            __WEBPACK_IMPORTED_MODULE_1__services_companyService__["updateEmployeeCalc"](body, function (response) {
                console.log(response);
                _this2.getEmployeeCalc();
                _this2.$toastr('success', 'Medarbejder indtjening indstillingen blev opdateret', 'Sådan!');
            }, function (err) {
                console.log(err);
            });
        },
        getEmployees: function getEmployees() {
            var _this3 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["findAll"]({}, function (response) {
                _this3.employees = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        updateEmployee: function updateEmployee(employee) {
            var _this4 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            this.showUpdateButton = null;
            var body = {
                employed_field: employee.employed_field,
                working_field: employee.working_field,
                responsible_field: employee.responsible_field,
                weekly_hours_working: employee.weekly_hours_working,
                working_field_name: employee.working_field_name ? employee.working_field_name : ''
            };
            __WEBPACK_IMPORTED_MODULE_0__services_employeeService__["update"](employee.id, body, function (response) {
                _this4.$toastr('success', 'Medarbejderen blev opdateret', 'Sådan!');
            }, function (err) {
                _this4.$toastr('error', 'Der skete en fejl ved opdatering af medarbejderen', 'Hov!');
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 470 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_moment__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number' }, { label: 'Opgave', field: 'description' }, { label: 'Kunde', field: 'customer.name' }, { label: 'Startdato', field: 'start_date' }, { label: 'Synlighed', field: 'show', type: 'number' }, { label: 'Vis/skjul', field: 'action' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            }
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
            this.generateFakeData();
        } else {
            this.getData();
        }
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {
                'include': 'type,customer,status',
                'filter[status]': 'pending,ongoing,unbilled'
            };
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        generateFakeData: function generateFakeData() {
            var projects = [];
            var i = void 0;
            for (i = 0; i < 10; i++) {
                var obj = {
                    case_number: 11092 + i * 77,
                    description: i < 5 ? 'Varelager bil ' + (i + 1) : 'Private køb svend ' + (i - 4),
                    customer: {
                        name: 'Name'
                    },
                    start_date: __WEBPACK_IMPORTED_MODULE_1_moment___default()().subtract(Math.floor(Math.random() * 365) + 1, 'days'),
                    show: false
                };
                projects.push(obj);
            }
            this.rows = projects;
            this.loading = false;
        },
        updateProject: function updateProject(project, show) {
            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var params = {
                'uuid': project.uuid,
                'show': show ? 1 : 0
            };
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["update"](params, function (response) {
                console.log(response);
                project.show = response.data.show;
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_settingsService__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_settingsService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_settingsService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_companyService__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__services_companyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__services_companyService__);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            settings: null,
            employeeCalc: null
        };
    },
    mounted: function mounted() {
        this.setSettings();
        this.getEmployeeCalc();
    },

    methods: {
        getEmployeeCalc: function getEmployeeCalc() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_2__services_companyService__["employeeCalc"]({}, function (response) {
                _this.employeeCalc = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        selectEmployeeCalc: function selectEmployeeCalc(type) {
            var _this2 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var body = {
                employeeCalc: type
            };
            __WEBPACK_IMPORTED_MODULE_2__services_companyService__["updateEmployeeCalc"](body, function (response) {
                console.log(response);
                _this2.getEmployeeCalc();
            }, function (err) {
                console.log(err);
            });
        },
        setSettings: function setSettings() {
            this.settings = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.$store.state.config.companyMeta.settings));
        },
        doSave: function doSave() {
            var _this3 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            if (this.settings.main_employee_percent < 50) {
                alert('Værdien i feltet "Hvornår kan en opgave betragtes som værende udført af 1 svend?" er for lav. Angiv venligst minimum 50%.');
                return;
            }
            var body = {
                coverage_percent: {
                    medium: { value: this.settings.coverage_percent.medium.value },
                    high: { value: this.settings.coverage_percent.high.value }
                },
                coverage_per_hour: {
                    medium: { value: this.settings.coverage_per_hour.medium.value },
                    high: { value: this.settings.coverage_per_hour.high.value }
                },
                timelogging: {
                    medium: { value: this.settings.timelogging.medium.value },
                    high: { value: this.settings.timelogging.high.value }
                },
                main_employee_percent: this.settings.main_employee_percent,
                overdue_days: this.settings.overdue_days,
                snoozed_days: this.settings.snoozed_days
            };
            __WEBPACK_IMPORTED_MODULE_1__services_settingsService__["update"](body, function (response) {
                _this3.$toastr('success', 'Indstillingerne blev opdateret', 'Sådan!');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }, function (err) {
                console.log(err);
            });
        },
        doReset: function doReset() {
            var _this4 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            __WEBPACK_IMPORTED_MODULE_1__services_settingsService__["update"]({}, function (response) {
                _this4.$toastr('success', 'Indstillingerne blev gendannet', 'Sådan!');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__ = __webpack_require__(484);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            statuses: null,
            statusTypes: null
        };
    },
    created: function created() {
        this.getData();
        this.getStatusTypes();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__["findAll"]({}, function (response) {
                _this.statuses = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        getStatusTypes: function getStatusTypes() {
            var _this2 = this;

            __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__["statusTypes"]({}, function (response) {
                _this2.statusTypes = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        update: function update(status, event) {
            var _this3 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var body = {
                status_uuid: event.target.value
            };
            __WEBPACK_IMPORTED_MODULE_0__services_projectStatusService__["update"](status.uuid, body, function (response) {
                _this3.$toastr('success', 'Opgavestatusen blev opdateret', 'Sådan!');
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_projectService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_projectService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: true,
            columns: [{ label: 'Ordre', field: 'case_number' }, { label: 'Opgave', field: 'description' }, { label: 'Kunde', field: 'customer.name' }, { label: 'Startdato', field: 'start_date' }, { label: 'Status', field: 'status.name' }],
            rows: [],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 30,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'case_number',
                    type: 'asc'
                }
            }
        };
    },
    mounted: function mounted() {
        if (this.$auth.user().company.api_provider.slug === 'minuba') {
            this.columns.push({ label: 'Åbn', field: 'minuba_external_id' });
        }
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            var params = {
                'include': 'type,customer,status',
                'filter[status]': 'offer,pending,ongoing,unbilled',
                'filter[missingBudget]': 1
            };
            __WEBPACK_IMPORTED_MODULE_0__services_projectService__["find"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        }
    }
});

/***/ }),
/* 474 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_timeloggingTypesService__ = __webpack_require__(485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_timeloggingTypesService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_timeloggingTypesService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            columns: [{ label: 'Navn', field: 'title', type: 'string' }, { label: 'Antal timer det sidste år', field: 'hours_last_year', type: 'number' }, { label: 'Vis/skjul', field: 'action' }],
            searchOptions: {
                enabled: true,
                trigger: 'enter',
                placeholder: 'Søg og tryk enter ...',
                skipDiacritics: true
            },
            paginationOptions: {
                enabled: true,
                perPage: 100,
                rowsPerPageLabel: 'Rækker pr. side',
                allLabel: 'Alle',
                nextLabel: 'Næste',
                prevLabel: 'Forrige',
                ofLabel: 'af',
                pageLabel: 'side'
            },
            sortOptions: {
                enabled: true,
                initialSortBy: {
                    field: 'title',
                    type: 'asc'
                }
            },
            rows: [],
            loading: false
        };
    },
    mounted: function mounted() {
        this.getData();
    },

    methods: {
        getData: function getData() {
            var _this = this;

            this.loading = true;
            var params = {};
            __WEBPACK_IMPORTED_MODULE_0__services_timeloggingTypesService__["list"](params, function (response) {
                _this.rows = response.data;
                _this.loading = false;
            }, function (err) {
                console.log(err);
                _this.loading = false;
            });
        },
        update: function update(row) {
            var _this2 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var params = {
                used_for_calculation: row.used_for_calculation ? 1 : 0
            };
            __WEBPACK_IMPORTED_MODULE_0__services_timeloggingTypesService__["update"](row.id, params, function (response) {
                console.log(response);
                row.used_for_calculation = Number(response.data.used_for_calculation);
                _this2.$toastr('success', 'Indstillingen blev opdateret', 'Sådan!');
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_userService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            user: {
                new_password: ''
            }
        };
    },

    methods: {
        updateUser: function updateUser(user) {
            var _this = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var body = {
                name: this.$auth.user().name,
                email: this.$auth.user().email
            };
            if (this.user.new_password !== '') {
                body.password = this.user.new_password;
                body.password_confirmation = this.user.new_password;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["update"](this.$auth.user().uuid, body, function (response) {
                _this.$toastr('success', 'Profil opdateret. Opdaterer siden.', 'Sådan!');
                setTimeout(function () {
                    window.location.href = '/';
                }, 1000);
            }, function (err) {
                console.log(err);
                _this.$toastr('error', 'Der skete en fejl ved opdatering af brugeren', 'Hovsa!');
            });
        }
    }
});

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_userService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_userService__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_employeeService__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_employeeService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__services_employeeService__);





/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            loading: false,
            availableDepartments: [],
            newUser: {
                name: '',
                email: '',
                role_id: 3,
                password: '',
                relation_department_id: null,
                relation_employee_id: null
            },
            users: null,
            employees: null
        };
    },
    created: function created() {
        this.getEmployees();
        this.getUsers();
        this.availableDepartments = this.$store.getters.getAvailableDepartments;
    },

    methods: {
        getEmployees: function getEmployees() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_1__services_employeeService__["findAll"]({}, function (response) {
                _this.employees = response.data;
                console.log('employees', _this.employees);
                console.log('Torben Larsen', _this.employees.filter(function (x) {
                    return x.full_name === 'Torben Larsen ';
                }));
            }, function (err) {
                console.log(err);
            });
        },
        getUsers: function getUsers() {
            var _this2 = this;

            this.loading = true;
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["all"]({}, function (response) {
                _this2.users = response.data;
                console.log(_this2.users);
                _this2.loading = false;
            }, function (err) {
                console.log(err);
                _this2.loading = false;
            });
        },
        resetFields: function resetFields() {
            this.newUser = {
                name: '',
                email: '',
                role_id: 3,
                password: ''
            };
        },
        createUser: function createUser() {
            var _this3 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            if (this.newUser.role_id === 4 && !this.newUser.relation_department_id) {
                alert('Du skal angive en afdeling til den afdelingsansvarlige for at oprette brugeren.');
                return;
            }
            if (this.newUser.role_id === 4 && !this.newUser.relation_employee_id) {
                alert('Du skal angive en medarbejder til den opgaveansvarlige for at oprette brugeren.');
                return;
            }
            var body = {
                name: this.newUser.name,
                email: this.newUser.email,
                role_id: this.newUser.role_id,
                relation_department_id: this.newUser.relation_department_id,
                relation_employee_id: this.newUser.relation_employee_id,
                password: this.newUser.password,
                password_confirmation: this.newUser.password
            };
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["create"](body, function (response) {
                _this3.$toastr('success', 'Brugeren blev oprettet', 'Sådan!');
                _this3.getUsers();
                _this3.resetFields();
            }, function (err) {
                _this3.$toastr('error', 'Der skete en fejl ved oprettelse af brugeren', 'Hovsa!');
                console.log(err);
            });
        },
        updateUser: function updateUser(user) {
            var _this4 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            if (user.role_id === 4 && !user.relation_department_id) {
                alert('Vælg en afdeling til den afdelingsansvarlige for at opdatere brugeren.');
                return;
            }
            if (user.role_id === 4 && !user.relation_employee_id) {
                alert('Vælg en medarbejder til den opgaveansvarlige for at opdatere brugeren.');
                return;
            }
            var body = {
                name: user.name,
                email: user.email,
                role_id: user.role_id,
                relation_department_id: user.relation_department_id,
                relation_employee_id: user.relation_employee_id
            };
            if (user.new_password) {
                body.password = user.new_password;
                body.password_confirmation = user.new_password;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["update"](user.uuid, body, function (response) {
                _this4.$toastr('success', 'Brugeren blev opdateret', 'Sådan!');
                _this4.getUsers();
            }, function (err) {
                console.log(err);
                _this4.$toastr('error', 'Der skete en fejl ved opdatering af brugeren', 'Hovsa!');
            });
        },
        deleteUser: function deleteUser(user) {
            var _this5 = this;

            if (this.$auth.user().name.includes('Demo')) {
                alert('Det er ikke muligt at ændre indstillinger i demo-versionen.');
                return;
            }
            __WEBPACK_IMPORTED_MODULE_0__services_userService__["remove"](user.uuid, function (response) {
                _this5.$toastr('success', 'Brugeren blev slettet', 'Sådan!');
                _this5.getUsers();
            }, function (err) {
                console.log(err);
                _this5.$toastr('error', 'Der skete en fejl ved sletning af brugeren', 'Hovsa!');
            });
        }
    },
    computed: {
        sortedUsers: function sortedUsers() {
            if (this.users) {
                var users = [];
                this.users.forEach(function (user) {
                    if (user.roles[0].name !== 'super-admin') {
                        user.role_id = user.roles[0].id;
                        user.new_password = null;
                        users.push(user);
                    }
                });
                return users;
            }
        }
    }
});

/***/ }),
/* 477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_companyService__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_companyService___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__services_companyService__);




/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            budgetCalc: null
        };
    },
    mounted: function mounted() {
        this.getBudgetSetting();
    },

    methods: {
        getBudgetSetting: function getBudgetSetting() {
            var _this = this;

            __WEBPACK_IMPORTED_MODULE_0__services_companyService__["budgetCalc"]({}, function (response) {
                _this.budgetCalc = response.data;
            }, function (err) {
                console.log(err);
            });
        },
        selectBudgetCalc: function selectBudgetCalc(type) {
            var _this2 = this;

            if (this.$auth.user().company.demo_company && this.$auth.user().roles[0].name !== 'super-admin') {
                alert('Det er ikke muligt at ændre denne indstilling i demo-versionen.');
                return;
            }
            var body = {
                budgetCalc: type
            };
            __WEBPACK_IMPORTED_MODULE_0__services_companyService__["updateBudgetCalc"](body, function (response) {
                console.log(response);
                _this2.getBudgetSetting();
                _this2.$toastr('success', 'Budget indstillingen blev opdateret', 'Sådan!');
            }, function (err) {
                console.log(err);
            });
        }
    }
});

/***/ }),
/* 478 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            selected: 'general',
            menuitems: [{ name: 'Generelt', slug: 'general', icon: 'cogs' }, { name: 'Kontoplan', slug: 'accountPlan', icon: 'list' }, { name: 'Budget', slug: 'budget', icon: 'calculator' }, { name: 'Medarbejdere', slug: 'employees', icon: 'users' }, { name: 'Opgavestatus', slug: 'projectStatuses', icon: 'briefcase' }, { name: 'Skjul opgaver', slug: 'excludeProjects', icon: 'times' }, { name: 'Tidsregistreringstyper', slug: 'timeloggingTypes', icon: 'clock' }, { name: 'Systembrugere', slug: 'users', icon: 'users' }, { name: 'Din profil', slug: 'user', icon: 'user' }, { name: 'Opgaver uden budget', slug: 'projectsMissingBudget', icon: 'divide' }]
        };
    },

    components: {
        'accountPlan': __webpack_require__(772),
        'budget': __webpack_require__(773),
        'valuechain-calculation': __webpack_require__(784),
        'employees': __webpack_require__(776),
        'general': __webpack_require__(778),
        'cleanup': __webpack_require__(775),
        'projectStatuses': __webpack_require__(779),
        'users': __webpack_require__(783),
        'user': __webpack_require__(782),
        'exclude-projects': __webpack_require__(777),
        'projects-missing-budget': __webpack_require__(780),
        'timelogging-types-settings': __webpack_require__(781)
    },
    mounted: function mounted() {
        if (this.$route.params.selected) {
            this.selected = this.$route.params.selected;
        }
        if (this.$store.state.config.availableDepartments.length > 2) {
            this.menuitems.push({
                name: 'Uden afdeling (oprydning)',
                slug: 'cleanup',
                icon: 'broom'
            });
        }
    }
});

/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _isInteger = __webpack_require__(256);

var _isInteger2 = _interopRequireDefault(_isInteger);

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(270);

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__(255);

var _router2 = _interopRequireDefault(_router);

var _axios = __webpack_require__(32);

var _axios2 = _interopRequireDefault(_axios);

var _vueAxios = __webpack_require__(266);

var _vueAxios2 = _interopRequireDefault(_vueAxios);

var _store = __webpack_require__(67);

var _store2 = _interopRequireDefault(_store);

var _vueMoment = __webpack_require__(299);

var _vueMoment2 = _interopRequireDefault(_vueMoment);

__webpack_require__(257);

var _ravenJs = __webpack_require__(264);

var _ravenJs2 = _interopRequireDefault(_ravenJs);

var _vue3 = __webpack_require__(263);

var _vue4 = _interopRequireDefault(_vue3);

var _vuetify = __webpack_require__(301);

var _vuetify2 = _interopRequireDefault(_vuetify);

__webpack_require__(262);

__webpack_require__(259);

var _vueCountTo = __webpack_require__(267);

var _vueCountTo2 = _interopRequireDefault(_vueCountTo);

var _vTooltip = __webpack_require__(265);

var _vTooltip2 = _interopRequireDefault(_vTooltip);

var _en = __webpack_require__(302);

var _en2 = _interopRequireDefault(_en);

var _dk = __webpack_require__(303);

var _dk2 = _interopRequireDefault(_dk);

var _vueSeo = __webpack_require__(249);

var _vueSeo2 = _interopRequireDefault(_vueSeo);

var _vueToastr = __webpack_require__(250);

var _vueToastr2 = _interopRequireDefault(_vueToastr);

__webpack_require__(258);

var _vueGoodTable = __webpack_require__(268);

var _vueGoodTable2 = _interopRequireDefault(_vueGoodTable);

__webpack_require__(261);

var _vueSweetalert = __webpack_require__(300);

var _vueSweetalert2 = _interopRequireDefault(_vueSweetalert);

__webpack_require__(260);

var _vueJsModal = __webpack_require__(269);

var _vueJsModal2 = _interopRequireDefault(_vueJsModal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vTooltip2.default);

_vue2.default.use(_vuetify2.default);


_vue2.default.component('count-to', _vueCountTo2.default);

_ravenJs2.default.config('https://e19fb0949740b65105e98a6b497e4e1f@o81729.ingest.sentry.io/4506218544693248').addPlugin(_vue4.default, _vue2.default).install();
_vue2.default.prototype.$raven = _ravenJs2.default;

_vue2.default.use(_vueSeo2.default);

_vue2.default.use(_vueAxios2.default, _axios2.default);

_vue2.default.use(_vueToastr2.default, {
    defaultPosition: 'toast-bottom-right',
    defaultType: 'info',
    defaultTimeout: 5000
});

_vue2.default.use(_vueGoodTable2.default);

_vue2.default.use(_vueSweetalert2.default);

_vue2.default.use(_vueJsModal2.default);

_vue2.default.component('box-helper', __webpack_require__(272));
_vue2.default.component('no-data', __webpack_require__(276));
_vue2.default.component('box-loading', __webpack_require__(68));
_vue2.default.component('offline', __webpack_require__(271));
_vue2.default.component('loader', __webpack_require__(286));
_vue2.default.component('title-block', __webpack_require__(284));
_vue2.default.component('summary-card', __webpack_require__(279));
_vue2.default.component('number-card', __webpack_require__(277));
_vue2.default.component('login', __webpack_require__(69));
_vue2.default.component('table-card', __webpack_require__(280));
_vue2.default.component('graph-card', __webpack_require__(274));
_vue2.default.component('projectTypeRevenue-table', __webpack_require__(298));
_vue2.default.component('showTypeRevenue-table', __webpack_require__(296));
_vue2.default.component('closedProjects-table', __webpack_require__(291));
_vue2.default.component('offerProjects-table', __webpack_require__(293));
_vue2.default.component('ongoingProjects-table', __webpack_require__(294));
_vue2.default.component('snoozedProjects-table', __webpack_require__(297));
_vue2.default.component('claimsProjects-table', __webpack_require__(290));
_vue2.default.component('openProjects-table', __webpack_require__(295));
_vue2.default.component('noInvoiceProjects-table', __webpack_require__(292));
_vue2.default.component('unpaidInvoices-table', __webpack_require__(289));
_vue2.default.component('view-toggle', __webpack_require__(285));
_vue2.default.component('coming-soon', __webpack_require__(281));
_vue2.default.component('content-switch', __webpack_require__(282));
_vue2.default.component('exceededPayments-table', __webpack_require__(288));
_vue2.default.component('d-tooltip', __webpack_require__(283));
_vue2.default.component('budget-tooltip', __webpack_require__(273));
_vue2.default.component('project-tooltip', __webpack_require__(278));
_vue2.default.component('minuba-budget-tooltip', __webpack_require__(275));
_vue2.default.component('all-invoices', __webpack_require__(287));

_vue2.default.use(_vueMoment2.default);
__webpack_require__(45);

_vue2.default.filter('truncate', function (input) {
    if (input.length > 50) {
        return input.slice(0, 50) + ' ...';
    } else {
        return input.slice(0, 50);
    }
});

_vue2.default.filter('currency', function (input) {
    if (!input) {
        return '0 kr.';
    }
    input = Math.round(input);
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
});

_vue2.default.filter('realCurrency', function (input) {
    if (!input) {
        return 0 + ' kr.';
    }
    input = Math.round(input);
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ' kr.';
});

_vue2.default.filter('number', function (input) {
    if (!input) {
        return '-';
    }
    input = Math.round(input);
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
});

_vue2.default.filter('realNumber', function (input) {
    if (!input) {
        return 0;
    }
    input = Number(input);
    if (!(0, _isInteger2.default)(input)) {
        input = input.toFixed(2);
    }

    return input;
});

_vue2.default.filter('numberWithDecimals', function (input) {
    if (!input) {
        return '-';
    }

    input = Number(input).toFixed(2);
    return input.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
});

_vue2.default.filter('coveragePercent', function (input) {
    return Math.max(0, Math.round(Number(input) || 0));
});

_vue2.default.filter('rounded', function (input) {
    if (!input) {
        return 0;
    }
    return Math.round(input);
});

_vue2.default.config.productionTip = false;

_vue2.default.router = _router2.default;

_vue2.default.use(__webpack_require__(253), {
    auth: __webpack_require__(254),
    http: __webpack_require__(251),
    router: __webpack_require__(252),
    parseUserData: function parseUserData(data) {
        return data;
    },
    authRedirect: { path: '/login' },
    refreshData: { enabled: false },
    loginData: { url: '/login' },
    logoutData: { url: '/logout', method: 'GET' },
    fetchData: { url: "https://api.proebitda.dk/v1" + '/me' }
});

new _vue2.default({
    el: '#app',
    vuetify: new _vuetify2.default({
        icons: {
            iconfont: 'md'
        },
        lang: {
            locales: { en: _en2.default, dk: _dk2.default },
            current: 'dk'
        }
    }),
    store: _store2.default,
    router: _router2.default,
    template: '<App/>',
    components: { App: _App2.default }
});

/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.get = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'company';

var get = exports.get = function get(options, cb, errorCb) {
    HttpService.get(namespace + '/config', options, cb, errorCb);
};

/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.regenerate = exports.history = exports.get = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var get = function get(cb, errorCb) {
    HttpService.get('daily-insight', {}, cb, errorCb);
};

var history = function history(cb, errorCb) {
    HttpService.get('daily-insight/history', {}, cb, errorCb);
};

var regenerate = function regenerate(cb, errorCb) {
    HttpService.post('daily-insight/regenerate', {}, cb, errorCb);
};

exports.get = get;
exports.history = history;
exports.regenerate = regenerate;

/***/ }),
/* 482 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.report = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'minuba-budgets-report';

var report = function report(options, cb, errorCb) {
    HttpService.get(namespace, options, cb, errorCb);
};

exports.report = report;

/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.all = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'possible-efforts';

var all = function all(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

exports.all = all;

/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.update = exports.statusTypes = exports.findAll = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'project-statuses';

var findAll = function findAll(params, cb, errorCb) {
    HttpService.get(namespace, params, cb, errorCb);
};

var statusTypes = function statusTypes(params, cb, errorCb) {
    HttpService.get('status-types', params, cb, errorCb);
};

var update = function update(uuid, body, cb, errorCb) {
    HttpService.patch(namespace + '/' + uuid, body, cb, errorCb);
};

exports.findAll = findAll;
exports.statusTypes = statusTypes;
exports.update = update;

/***/ }),
/* 485 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.update = exports.list = undefined;

var _HttpService = __webpack_require__(3);

var HttpService = _interopRequireWildcard(_HttpService);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var namespace = 'timelogging-types';

var list = function list(params, cb, errorCb) {
    HttpService.get(namespace + '/list', params, cb, errorCb);
};

var update = function update(id, params, cb, errorCb) {
    HttpService.get(namespace + '/' + id + '/update', params, cb, errorCb);
};

exports.list = list;
exports.update = update;

/***/ }),
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 573 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 574 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 575 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 577 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 578 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 579 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 581 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 582 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 583 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 585 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 586 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 587 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 589 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 590 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 591 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 593 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 594 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 595 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 596 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 597 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 599 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 600 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 601 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 602 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 603 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 604 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 606 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 607 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 608 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 612 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 614 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 615 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 616 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 618 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 619 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 620 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 621 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 622 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 623 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 624 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 625 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 626 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 627 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 628 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 629 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 630 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 631 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 632 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 633 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 634 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 635 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 636 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 637 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 638 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 639 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 640 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */,
/* 646 */,
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 108,
	"./af.js": 108,
	"./ar": 115,
	"./ar-dz": 109,
	"./ar-dz.js": 109,
	"./ar-kw": 110,
	"./ar-kw.js": 110,
	"./ar-ly": 111,
	"./ar-ly.js": 111,
	"./ar-ma": 112,
	"./ar-ma.js": 112,
	"./ar-sa": 113,
	"./ar-sa.js": 113,
	"./ar-tn": 114,
	"./ar-tn.js": 114,
	"./ar.js": 115,
	"./az": 116,
	"./az.js": 116,
	"./be": 117,
	"./be.js": 117,
	"./bg": 118,
	"./bg.js": 118,
	"./bm": 119,
	"./bm.js": 119,
	"./bn": 121,
	"./bn-bd": 120,
	"./bn-bd.js": 120,
	"./bn.js": 121,
	"./bo": 122,
	"./bo.js": 122,
	"./br": 123,
	"./br.js": 123,
	"./bs": 124,
	"./bs.js": 124,
	"./ca": 125,
	"./ca.js": 125,
	"./cs": 126,
	"./cs.js": 126,
	"./cv": 127,
	"./cv.js": 127,
	"./cy": 128,
	"./cy.js": 128,
	"./da": 45,
	"./da.js": 45,
	"./de": 131,
	"./de-at": 129,
	"./de-at.js": 129,
	"./de-ch": 130,
	"./de-ch.js": 130,
	"./de.js": 131,
	"./dv": 132,
	"./dv.js": 132,
	"./el": 133,
	"./el.js": 133,
	"./en-au": 134,
	"./en-au.js": 134,
	"./en-ca": 135,
	"./en-ca.js": 135,
	"./en-gb": 136,
	"./en-gb.js": 136,
	"./en-ie": 137,
	"./en-ie.js": 137,
	"./en-il": 138,
	"./en-il.js": 138,
	"./en-in": 139,
	"./en-in.js": 139,
	"./en-nz": 140,
	"./en-nz.js": 140,
	"./en-sg": 141,
	"./en-sg.js": 141,
	"./eo": 142,
	"./eo.js": 142,
	"./es": 146,
	"./es-do": 143,
	"./es-do.js": 143,
	"./es-mx": 144,
	"./es-mx.js": 144,
	"./es-us": 145,
	"./es-us.js": 145,
	"./es.js": 146,
	"./et": 147,
	"./et.js": 147,
	"./eu": 148,
	"./eu.js": 148,
	"./fa": 149,
	"./fa.js": 149,
	"./fi": 150,
	"./fi.js": 150,
	"./fil": 151,
	"./fil.js": 151,
	"./fo": 152,
	"./fo.js": 152,
	"./fr": 155,
	"./fr-ca": 153,
	"./fr-ca.js": 153,
	"./fr-ch": 154,
	"./fr-ch.js": 154,
	"./fr.js": 155,
	"./fy": 156,
	"./fy.js": 156,
	"./ga": 157,
	"./ga.js": 157,
	"./gd": 158,
	"./gd.js": 158,
	"./gl": 159,
	"./gl.js": 159,
	"./gom-deva": 160,
	"./gom-deva.js": 160,
	"./gom-latn": 161,
	"./gom-latn.js": 161,
	"./gu": 162,
	"./gu.js": 162,
	"./he": 163,
	"./he.js": 163,
	"./hi": 164,
	"./hi.js": 164,
	"./hr": 165,
	"./hr.js": 165,
	"./hu": 166,
	"./hu.js": 166,
	"./hy-am": 167,
	"./hy-am.js": 167,
	"./id": 168,
	"./id.js": 168,
	"./is": 169,
	"./is.js": 169,
	"./it": 171,
	"./it-ch": 170,
	"./it-ch.js": 170,
	"./it.js": 171,
	"./ja": 172,
	"./ja.js": 172,
	"./jv": 173,
	"./jv.js": 173,
	"./ka": 174,
	"./ka.js": 174,
	"./kk": 175,
	"./kk.js": 175,
	"./km": 176,
	"./km.js": 176,
	"./kn": 177,
	"./kn.js": 177,
	"./ko": 178,
	"./ko.js": 178,
	"./ku": 179,
	"./ku.js": 179,
	"./ky": 180,
	"./ky.js": 180,
	"./lb": 181,
	"./lb.js": 181,
	"./lo": 182,
	"./lo.js": 182,
	"./lt": 183,
	"./lt.js": 183,
	"./lv": 184,
	"./lv.js": 184,
	"./me": 185,
	"./me.js": 185,
	"./mi": 186,
	"./mi.js": 186,
	"./mk": 187,
	"./mk.js": 187,
	"./ml": 188,
	"./ml.js": 188,
	"./mn": 189,
	"./mn.js": 189,
	"./mr": 190,
	"./mr.js": 190,
	"./ms": 192,
	"./ms-my": 191,
	"./ms-my.js": 191,
	"./ms.js": 192,
	"./mt": 193,
	"./mt.js": 193,
	"./my": 194,
	"./my.js": 194,
	"./nb": 195,
	"./nb.js": 195,
	"./ne": 196,
	"./ne.js": 196,
	"./nl": 198,
	"./nl-be": 197,
	"./nl-be.js": 197,
	"./nl.js": 198,
	"./nn": 199,
	"./nn.js": 199,
	"./oc-lnc": 200,
	"./oc-lnc.js": 200,
	"./pa-in": 201,
	"./pa-in.js": 201,
	"./pl": 202,
	"./pl.js": 202,
	"./pt": 204,
	"./pt-br": 203,
	"./pt-br.js": 203,
	"./pt.js": 204,
	"./ro": 205,
	"./ro.js": 205,
	"./ru": 206,
	"./ru.js": 206,
	"./sd": 207,
	"./sd.js": 207,
	"./se": 208,
	"./se.js": 208,
	"./si": 209,
	"./si.js": 209,
	"./sk": 210,
	"./sk.js": 210,
	"./sl": 211,
	"./sl.js": 211,
	"./sq": 212,
	"./sq.js": 212,
	"./sr": 214,
	"./sr-cyrl": 213,
	"./sr-cyrl.js": 213,
	"./sr.js": 214,
	"./ss": 215,
	"./ss.js": 215,
	"./sv": 216,
	"./sv.js": 216,
	"./sw": 217,
	"./sw.js": 217,
	"./ta": 218,
	"./ta.js": 218,
	"./te": 219,
	"./te.js": 219,
	"./tet": 220,
	"./tet.js": 220,
	"./tg": 221,
	"./tg.js": 221,
	"./th": 222,
	"./th.js": 222,
	"./tk": 223,
	"./tk.js": 223,
	"./tl-ph": 224,
	"./tl-ph.js": 224,
	"./tlh": 225,
	"./tlh.js": 225,
	"./tr": 226,
	"./tr.js": 226,
	"./tzl": 227,
	"./tzl.js": 227,
	"./tzm": 229,
	"./tzm-latn": 228,
	"./tzm-latn.js": 228,
	"./tzm.js": 229,
	"./ug-cn": 230,
	"./ug-cn.js": 230,
	"./uk": 231,
	"./uk.js": 231,
	"./ur": 232,
	"./ur.js": 232,
	"./uz": 234,
	"./uz-latn": 233,
	"./uz-latn.js": 233,
	"./uz.js": 234,
	"./vi": 235,
	"./vi.js": 235,
	"./x-pseudo": 236,
	"./x-pseudo.js": 236,
	"./yo": 237,
	"./yo.js": 237,
	"./zh-cn": 238,
	"./zh-cn.js": 238,
	"./zh-hk": 239,
	"./zh-hk.js": 239,
	"./zh-mo": 240,
	"./zh-mo.js": 240,
	"./zh-tw": 241,
	"./zh-tw.js": 241
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 647;

/***/ }),
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(593)
__webpack_require__(592)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(331),
  /* template */
  __webpack_require__(828),
  /* scopeId */
  "data-v-2631a998",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(332),
  /* template */
  __webpack_require__(893),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(581)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(333),
  /* template */
  __webpack_require__(816),
  /* scopeId */
  "data-v-1c902d9d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(337),
  /* template */
  __webpack_require__(799),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(338),
  /* template */
  __webpack_require__(872),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(339),
  /* template */
  __webpack_require__(788),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(340),
  /* template */
  __webpack_require__(868),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(577)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(342),
  /* template */
  __webpack_require__(806),
  /* scopeId */
  "data-v-1313447a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(616)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(349),
  /* template */
  __webpack_require__(879),
  /* scopeId */
  "data-v-5ebecd11",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(582)
__webpack_require__(583)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(350),
  /* template */
  __webpack_require__(817),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(637)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(363),
  /* template */
  __webpack_require__(931),
  /* scopeId */
  "data-v-d0871cc6",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(596)

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(837),
  /* scopeId */
  "data-v-301a1469",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(886),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(572)
__webpack_require__(573)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(364),
  /* template */
  __webpack_require__(791),
  /* scopeId */
  "data-v-06756f52",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(365),
  /* template */
  __webpack_require__(921),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(366),
  /* template */
  __webpack_require__(807),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(367),
  /* template */
  __webpack_require__(847),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(368),
  /* template */
  __webpack_require__(843),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(369),
  /* template */
  __webpack_require__(801),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(370),
  /* template */
  __webpack_require__(858),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(371),
  /* template */
  __webpack_require__(827),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(373),
  /* template */
  __webpack_require__(849),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(374),
  /* template */
  __webpack_require__(927),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(375),
  /* template */
  __webpack_require__(898),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(376),
  /* template */
  __webpack_require__(940),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(377),
  /* template */
  __webpack_require__(884),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(378),
  /* template */
  __webpack_require__(880),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(379),
  /* template */
  __webpack_require__(803),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 690 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(380),
  /* template */
  __webpack_require__(862),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 691 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(641)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(381),
  /* template */
  __webpack_require__(938),
  /* scopeId */
  "data-v-e1cbaa30",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 692 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(578)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(382),
  /* template */
  __webpack_require__(811),
  /* scopeId */
  "data-v-1837e2a0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 693 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(383),
  /* template */
  __webpack_require__(913),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 694 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(384),
  /* template */
  __webpack_require__(890),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 695 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(385),
  /* template */
  __webpack_require__(881),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(386),
  /* template */
  __webpack_require__(932),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(387),
  /* template */
  __webpack_require__(797),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(388),
  /* template */
  __webpack_require__(832),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(634)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(389),
  /* template */
  __webpack_require__(925),
  /* scopeId */
  "data-v-bd4df050",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 700 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(625)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(390),
  /* template */
  __webpack_require__(905),
  /* scopeId */
  "data-v-794c9c50",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(609)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(391),
  /* template */
  __webpack_require__(864),
  /* scopeId */
  "data-v-501bbe0c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(571)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(392),
  /* template */
  __webpack_require__(790),
  /* scopeId */
  "data-v-0466fc80",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(393),
  /* template */
  __webpack_require__(860),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(394),
  /* template */
  __webpack_require__(835),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(585)
__webpack_require__(584)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(395),
  /* template */
  __webpack_require__(818),
  /* scopeId */
  "data-v-1fe26433",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(614)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(396),
  /* template */
  __webpack_require__(876),
  /* scopeId */
  "data-v-5d6ac280",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(397),
  /* template */
  __webpack_require__(939),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(833),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(398),
  /* template */
  __webpack_require__(899),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(399),
  /* template */
  __webpack_require__(916),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(400),
  /* template */
  __webpack_require__(920),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(594)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(401),
  /* template */
  __webpack_require__(829),
  /* scopeId */
  "data-v-2815c14f",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(402),
  /* template */
  __webpack_require__(903),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(404),
  /* template */
  __webpack_require__(892),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(405),
  /* template */
  __webpack_require__(871),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(406),
  /* template */
  __webpack_require__(924),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(407),
  /* template */
  __webpack_require__(796),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(408),
  /* template */
  __webpack_require__(812),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(409),
  /* template */
  __webpack_require__(865),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(410),
  /* template */
  __webpack_require__(793),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(621)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(411),
  /* template */
  __webpack_require__(896),
  /* scopeId */
  "data-v-70ce8938",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(412),
  /* template */
  __webpack_require__(813),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(414),
  /* template */
  __webpack_require__(830),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(415),
  /* template */
  __webpack_require__(933),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(416),
  /* template */
  __webpack_require__(907),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(417),
  /* template */
  __webpack_require__(857),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(418),
  /* template */
  __webpack_require__(918),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(419),
  /* template */
  __webpack_require__(947),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(420),
  /* template */
  __webpack_require__(798),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(421),
  /* template */
  __webpack_require__(831),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(422),
  /* template */
  __webpack_require__(834),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(576)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(423),
  /* template */
  __webpack_require__(805),
  /* scopeId */
  "data-v-12488532",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(630)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(424),
  /* template */
  __webpack_require__(912),
  /* scopeId */
  "data-v-8e787f18",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(611)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(425),
  /* template */
  __webpack_require__(867),
  /* scopeId */
  "data-v-55170067",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 735 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(627)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(426),
  /* template */
  __webpack_require__(909),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 736 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(600)
__webpack_require__(599)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(428),
  /* template */
  __webpack_require__(840),
  /* scopeId */
  "data-v-3390115e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(605)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(429),
  /* template */
  __webpack_require__(855),
  /* scopeId */
  "data-v-45eaf5ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 738 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(589)
__webpack_require__(588)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(430),
  /* template */
  __webpack_require__(822),
  /* scopeId */
  "data-v-238bdf1c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 739 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(619)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(431),
  /* template */
  __webpack_require__(885),
  /* scopeId */
  "data-v-64625cd5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(602)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(432),
  /* template */
  __webpack_require__(844),
  /* scopeId */
  "data-v-3c3ae255",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(631)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(433),
  /* template */
  __webpack_require__(917),
  /* scopeId */
  "data-v-9db0b6c0",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(626)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(434),
  /* template */
  __webpack_require__(906),
  /* scopeId */
  "data-v-798d4fd5",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 743 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(623)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(435),
  /* template */
  __webpack_require__(901),
  /* scopeId */
  "data-v-753288f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 744 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(437),
  /* template */
  __webpack_require__(809),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 745 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(438),
  /* template */
  __webpack_require__(891),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 746 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(439),
  /* template */
  __webpack_require__(795),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 747 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(440),
  /* template */
  __webpack_require__(873),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 748 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(441),
  /* template */
  __webpack_require__(789),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 749 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(442),
  /* template */
  __webpack_require__(902),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(443),
  /* template */
  __webpack_require__(851),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 751 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(444),
  /* template */
  __webpack_require__(870),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 752 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(617)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(445),
  /* template */
  __webpack_require__(882),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 753 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(639)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(446),
  /* template */
  __webpack_require__(935),
  /* scopeId */
  "data-v-d921176c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 754 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(447),
  /* template */
  __webpack_require__(808),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 755 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(448),
  /* template */
  __webpack_require__(889),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 756 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(449),
  /* template */
  __webpack_require__(794),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 757 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(450),
  /* template */
  __webpack_require__(841),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 758 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(451),
  /* template */
  __webpack_require__(948),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 759 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(452),
  /* template */
  __webpack_require__(810),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 760 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(453),
  /* template */
  __webpack_require__(875),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 761 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(644)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(454),
  /* template */
  __webpack_require__(946),
  /* scopeId */
  "data-v-f49ff36e",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 762 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(455),
  /* template */
  __webpack_require__(887),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 763 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(456),
  /* template */
  __webpack_require__(944),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 764 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(457),
  /* template */
  __webpack_require__(945),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 765 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(458),
  /* template */
  __webpack_require__(895),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(459),
  /* template */
  __webpack_require__(937),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 767 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(460),
  /* template */
  __webpack_require__(877),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(461),
  /* template */
  __webpack_require__(854),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(462),
  /* template */
  __webpack_require__(802),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 770 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(463),
  /* template */
  __webpack_require__(825),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 771 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(575)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(464),
  /* template */
  __webpack_require__(800),
  /* scopeId */
  "data-v-0d2a8562",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 772 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(642)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(465),
  /* template */
  __webpack_require__(941),
  /* scopeId */
  "data-v-ed1d8338",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 773 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(612)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(466),
  /* template */
  __webpack_require__(869),
  /* scopeId */
  "data-v-57bd4472",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 774 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(640)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(467),
  /* template */
  __webpack_require__(936),
  /* scopeId */
  "data-v-db2305ca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 775 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(468),
  /* template */
  __webpack_require__(914),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 776 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(601)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(469),
  /* template */
  __webpack_require__(842),
  /* scopeId */
  "data-v-3756a0f3",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 777 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(632)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(470),
  /* template */
  __webpack_require__(922),
  /* scopeId */
  "data-v-ad10ac3c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 778 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(603)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(471),
  /* template */
  __webpack_require__(845),
  /* scopeId */
  "data-v-3d3aa354",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 779 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(622)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(472),
  /* template */
  __webpack_require__(900),
  /* scopeId */
  "data-v-74a30572",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 780 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(473),
  /* template */
  __webpack_require__(859),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 781 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(620)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(474),
  /* template */
  __webpack_require__(888),
  /* scopeId */
  "data-v-68993e6c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 782 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(591)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(475),
  /* template */
  __webpack_require__(824),
  /* scopeId */
  "data-v-242b0c66",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 783 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(613)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(476),
  /* template */
  __webpack_require__(874),
  /* scopeId */
  "data-v-59df3e14",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 784 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(477),
  /* template */
  __webpack_require__(919),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 785 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(618)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(478),
  /* template */
  __webpack_require__(883),
  /* scopeId */
  "data-v-60f315bb",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 786 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  null,
  /* template */
  __webpack_require__(897),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 787 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(610)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(326),
  /* template */
  __webpack_require__(866),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 788 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "possible-efforts-sub-menu"
  }, [_c('div', {
    staticClass: "switcher"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'moreTime'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'moreTime'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.moreTime.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'lessSickness'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'lessSickness'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.lessSickness.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'rightPeople'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'rightPeople'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.rightPeople.boksTekst))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'moreTime'),
      expression: "selectedItem === 'moreTime'"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "lg",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.texts.moreTime.tykTekst1) + "\n                    " + _vm._s(_vm._f("number")(_vm.data.more_time.percentage_with_customers)) + "%\n                    "), _c('br'), _c('br'), _vm._v("\n                    " + _vm._s(_vm.texts.moreTime.tykTekst2) + "\n                    " + _vm._s(_vm._f("currency")(_vm.data.more_time.possible_revenue_increase)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.moreTime.tyndTekst1)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.texts.moreTime.tyndTekst1) + "\n                ")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                            Hvad bruger vi tiden på i dag?\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.moreTimeColumns,
      "rows": _vm.data.more_time.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'type') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(props.row.type) + "\n                                    ")]) : (props.column.field == 'percentage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(props.row.percentage)) + "%\n                                    ")]) : (props.column.field == 'hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(props.row.hours)) + "\n                                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                                    Ingen data ...\n                                ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot right"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('EmployeesLearning', 'timeUsage')
      }
    }
  }, [_vm._v("\n                        Gå til \"Hvad bruger vi tiden på?\" →\n                    ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'lessSickness'),
      expression: "selectedItem === 'lessSickness'"
    }]
  }, [_c('div', {
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "lg",
    staticStyle: {
      "margin-top": "0px"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.texts.lessSickness.tykTekst1) + "\n                    " + _vm._s(_vm._f("number")(_vm.data.less_sickness.percentage)) + "%\n                    "), _c('br'), _c('br'), _vm._v("\n                    " + _vm._s(_vm.texts.lessSickness.tykTekst2) + "\n                    " + _vm._s(_vm._f("currency")(_vm.data.less_sickness.possible_revenue_increase)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.lessSickness.tyndTekst1)
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.texts.lessSickness.tyndTekst1) + "\n                ")])]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                            Medarbejdernes sygefravær\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.employeesSicknessRateColumns,
      "rows": _vm.data.employees_sickness_rate,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.employeesSicknessRateSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(props.row.name) + "\n                                    ")]) : (props.column.field == 'sickness_percentage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(props.row.sickness_percentage)) + "%\n                                    ")]) : (props.column.field == 'sickness_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(props.row.sickness_hours)) + "\n                                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                                    Ingen data ...\n                                ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot right"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('EmployeesLearning', 'timeUsage')
      }
    }
  }, [_vm._v("\n                        Gå til \"Hvad bruger vi tiden på?\" →\n                    ")])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'rightPeople'),
      expression: "selectedItem === 'rightPeople'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.rightPeople.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.employeesRightPeoplePossibleRevenue)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.texts.rightPeople.tyndTekst1)
    }
  }, [_vm._v("\n                " + _vm._s(_vm.texts.rightPeople.tyndTekst1) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("Antal timer brugt på alle kundeopgaver i perioden")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("number")(_vm.data.right_people.total_coverage / _vm.data.right_people.avg_coverage_per_hour)))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding-right": "15px"
    }
  }, [_vm._v("Gennemsnitligt dækningsbidrag pr. time")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("currency")(_vm.data.right_people.avg_coverage_per_hour)))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.employeeRevenue"
    }
  }), _vm._v("\n                    Hvordan er medarbejdernes indtjening?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.rightPeopleColumns,
      "rows": _vm.data.right_people.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.rightPeopleSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_projects') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.total_projects) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('ProjectsLearning', 'projectTypeSkills')
      }
    }
  }, [_vm._v("\n                Gå til \"Hvilke svende er gode til hvilke opgaver?\" →\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 789 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-skills-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.employees,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'first_name') ? _c('div', [_vm._v("\n                        " + _vm._s(props.row.first_name) + "\n                        " + _vm._s(props.row.last_name) + "\n                    ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'timelog_hours') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.selectedRow) ? _c('div', [_vm._v("\n        Vælg en medarbejder for at se de enkelte opgaver her\n    ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('project-type-skills-single-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 790 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-compare"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.ebitda"
    }
  }), _vm._v("\n                    Kontoplan\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "journal-toggle-wrap"
  }, [_c('label', {
    staticClass: "journal-toggle"
  }, [_c('span', {
    staticClass: "journal-toggle__switch",
    class: {
      'is-on': _vm.includeJournal
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.includeJournal),
      expression: "includeJournal"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.includeJournal) ? _vm._i(_vm.includeJournal, null) > -1 : (_vm.includeJournal)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.includeJournal,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.includeJournal = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.includeJournal = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.includeJournal = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "journal-toggle__slider"
  })]), _vm._v(" "), _c('span', {
    staticClass: "journal-toggle__label"
  }, [_vm._v("Medtag kassekladder")])])]), _vm._v(" "), (_vm.accountingYearsCheck && 'last_year_closed' in _vm.accountingYearsCheck && _vm.accountingYearsCheck.last_year_closed === false && !_vm.$auth.user().name.includes('Demo')) ? _c('div', {
    staticClass: "warning"
  }, [_c('b', [_vm._v("OBS! Seneste regnskabsår (" + _vm._s(_vm.accountingYearsCheck.year) + ") er ikke lukket i e-conomic.")]), _vm._v("\n                        Dette betyder, at tallene i din kontoplan summeres for både seneste regnskabsår samt det nuværende. Log in på e-conomic og luk det seneste regnskabsår for at se de korrekte tal. OBS! Du kan lukke og åbne et regnskabsår lige så ofte, det er nødvendigt.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.sortedAccounts) ? _c('div', {
    staticClass: "ebitda-wrapper"
  }, [_c('div', {
    staticClass: "line top"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("Bogført")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("Kassekladde")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("Total")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.sortedAccounts), function(accountCategory) {
    return _c('div', {
      key: accountCategory.uuid + '_' + accountCategory.name,
      staticClass: "line",
      class: {
        'bold': accountCategory.account_type === 'custom', 'selected': _vm.selectedAccountCategory && _vm.selectedAccountCategory.uuid === accountCategory.uuid, 'no-hover': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      on: {
        "click": function($event) {
          return _vm.selectAccountCategory(accountCategory)
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                                " + _vm._s(accountCategory.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(accountCategory.entries_total)) + "\n                            ")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(accountCategory.journal_total)) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(accountCategory.total)) + "\n                            ")]) : _vm._e()])
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedAccountCategory) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.selectedAccountCategory.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.includeJournal && _vm.categoryHasJournalAccounts) ? _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#666",
      "text-align": "center",
      "margin-top": "-15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                        Konti med posteringer fra kassekladden er markeret med farvet baggrund.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.selectedAccountCategory.accounts.length > 0) ? _c('div', {
    staticClass: "ebitda-wrapper child"
  }, [_c('div', {
    staticClass: "line top"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("Bogført")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("Kassekladde")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("Total")]) : _vm._e()]), _vm._v(" "), _vm._l((_vm.selectedAccountCategory.accounts), function(account) {
    return ((_vm.includeJournal ? account.total : account.entries_total) !== 0) ? _c('div', {
      key: account.account_number,
      staticClass: "line",
      class: {
        'selected': _vm.selectedAccount && _vm.selectedAccount.uuid === account.uuid, 'is-journal': _vm.includeJournal && Number(account.journal_total) !== 0
      },
      on: {
        "click": function($event) {
          return _vm.selectAccount(account)
        }
      }
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                                " + _vm._s(account.account_number) + "\n                                -\n                                " + _vm._s(account.name) + "\n                            ")]), _vm._v(" "), _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(account.entries_total)) + "\n                            ")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(account.journal_total)) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
      staticClass: "balance"
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(account.total)) + "\n                            ")]) : _vm._e()]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                                " + _vm._s(_vm.selectedAccountCategory.name) + " i alt\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "balance"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.selectedAccountCategory.entries_total)) + "\n                            ")]), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.selectedAccountCategory.journal_total)) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.includeJournal) ? _c('div', {
    staticClass: "balance"
  }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(_vm.selectedAccountCategory.total)) + "\n                            ")]) : _vm._e()])], 2) : _c('div', [_vm._v("\n                        Denne konto har ingen underkonti\n                    ")])])]) : _c('div', [_vm._v("\n                Vælg en konto for at se dens underkonti her\n            ")]), _vm._v(" "), (_vm.selectedAccount) ? _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Posteringer: " + _vm._s(_vm.selectedAccount.account_number) + " - " + _vm._s(_vm.selectedAccount.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.includeJournal && _vm.entriesHaveJournal) ? _c('p', {
    staticStyle: {
      "font-size": "12px",
      "color": "#666",
      "text-align": "center",
      "margin-top": "-15px",
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                        Posteringer fra kassekladden er markeret med farvet baggrund.\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.filteredAccountEntries) ? _c('div', {
    staticClass: "entries-table"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.filteredAccountEntries), function(entry) {
    return _c('div', {
      key: entry._source + '_' + entry.uuid,
      staticClass: "entry-line",
      class: {
        'is-journal': entry._source === 'journal'
      }
    }, [_c('div', {
      staticClass: "entry-date"
    }, [_vm._v(_vm._s(entry.date.split('-').reverse().join('/')))]), _vm._v(" "), _c('div', {
      staticClass: "entry-number"
    }, [(entry.voucher_number) ? _c('a', {
      attrs: {
        "href": 'https://secure.e-conomic.com/vouchers/' + entry.voucher_number,
        "target": "_blank"
      }
    }, [_vm._v("\n                                    " + _vm._s(entry.voucher_number) + "\n                                ")]) : _c('span', [_vm._v(_vm._s(entry.entry_number))])]), _vm._v(" "), _c('div', {
      staticClass: "entry-text"
    }, [_vm._v(_vm._s(entry.text))]), _vm._v(" "), _c('div', {
      staticClass: "entry-attachment"
    }, [(entry.hasAttachment) ? _c('a', {
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openAttachment(entry)
        }
      }
    }, [(entry.loadingAttachment) ? _c('span', [_vm._v("Henter...")]) : _c('span', [_vm._v("Vis")])]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "entry-amount"
    }, [_vm._v(_vm._s(_vm._f("currency")(entry.amount)))])])
  }), _vm._v(" "), (_vm.filteredAccountEntries.length === 0) ? _c('div', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "13px"
    }
  }, [_vm._v("\n                            Ingen posteringer i denne periode\n                        ")]) : _vm._e()], 2) : _c('box-loading', {
    attrs: {
      "height": "100"
    }
  })], 1)]) : _vm._e()])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entry-line top"
  }, [_c('div', {
    staticClass: "entry-date"
  }, [_vm._v("Dato")]), _vm._v(" "), _c('div', {
    staticClass: "entry-number"
  }, [_vm._v("Bilagsnr.")]), _vm._v(" "), _c('div', {
    staticClass: "entry-text"
  }, [_vm._v("Tekst")]), _vm._v(" "), _c('div', {
    staticClass: "entry-attachment"
  }, [_vm._v("Bilag")]), _vm._v(" "), _c('div', {
    staticClass: "entry-amount"
  }, [_vm._v("Beløb")])])
}]}

/***/ }),
/* 791 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Tips & tricks</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  })]), _vm._v(" "), (_vm.tips.length) ? _c('div', _vm._l((_vm.tips.filter(function (x) { return x.tips.length; })), function(tipGroup) {
    return _c('div', {
      key: tipGroup.group,
      staticClass: "tip__group"
    }, [_c('div', {
      staticClass: "tip__group__headline"
    }, [(tipGroup.group === 'Overblik') ? _c('i', {
      staticClass: "fas fa-th-large fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Mulige indsatser') ? _c('i', {
      staticClass: "fas fa-clock fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Økonomi') ? _c('i', {
      staticClass: "fas fa-wallet fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Kunder') ? _c('i', {
      staticClass: "fas fa-briefcase fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Opgaver') ? _c('i', {
      staticClass: "fas fa-clipboard-list-check fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Medarbejdere') ? _c('i', {
      staticClass: "fas fa-users fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Ansvarlige') ? _c('i', {
      staticClass: "fas fa-user-hard-hat fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Potentiale') ? _c('i', {
      staticClass: "fas fa-star fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Indstillinger') ? _c('i', {
      staticClass: "fas fa-cog fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Entreprise') ? _c('i', {
      staticClass: "fas fa-tools fa-fw"
    }) : _vm._e(), _vm._v(" "), (tipGroup.group === 'Læg budget') ? _c('i', {
      staticClass: "fas fa-money-check-edit-alt fa-fw"
    }) : _vm._e(), _vm._v("\n                     \n                    " + _vm._s(tipGroup.group) + "\n                ")]), _vm._v(" "), _c('div', {
      staticClass: "tip__wrapper"
    }, _vm._l((tipGroup.tips), function(tip, index) {
      return _c('div', {
        key: ((tipGroup.group) + "_" + index),
        staticClass: "tip__single"
      }, [_c('div', {
        staticClass: "inner",
        class: {
          'show': _vm.show === tip.id
        }
      }, [_c('div', {
        staticClass: "headline",
        on: {
          "click": function($event) {
            _vm.show === tip.id ? _vm.show = null : _vm.show = tip.id
          }
        }
      }, [_c('div', {
        staticClass: "left"
      }, [_vm._v("\n                                    " + _vm._s(tip.headline) + "\n                                ")]), _vm._v(" "), _c('div', {
        staticClass: "right"
      }, [(_vm.show !== tip.id) ? _c('i', {
        staticClass: "fas fa-plus fa-fw"
      }) : _vm._e(), _vm._v(" "), (_vm.show === tip.id) ? _c('i', {
        staticClass: "fas fa-minus fa-fw"
      }) : _vm._e()])]), _vm._v(" "), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.show === tip.id),
          expression: "show === tip.id"
        }],
        staticClass: "content",
        domProps: {
          "innerHTML": _vm._s(tip.content)
        }
      })])])
    }), 0)])
  }), 0) : _vm._e()], 1)])
},staticRenderFns: []}

/***/ }),
/* 792 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "summary-card"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('count-to', {
    attrs: {
      "startVal": 0,
      "endVal": parseInt(_vm.number, 10),
      "duration": 2000
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 793 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-usage"
  }, [_c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === ''
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = ''
      }
    }
  }, [_vm._v("\n            Alle medarbejdere\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, funktionær'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, funktionær'
      }
    }
  }, [_vm._v("\n            Svende, funktionær\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, timelønnet'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, timelønnet'
      }
    }
  }, [_vm._v("\n            Svende, timelønnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Lærling'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Lærling'
      }
    }
  }, [_vm._v("\n            Lærlinge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsage"
    }
  }), _vm._v("\n                    Opsummering\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('pie', {
    attrs: {
      "headline": "Hvad bruger vi tiden på?",
      "series": _vm.hoursDivision.series,
      "labels": _vm.hoursDivision.labels,
      "division": true,
      "height": "220px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('pie', {
    attrs: {
      "headline": "Fordeling af tid hos kunderne",
      "series": _vm.hoursWithCustomers.series,
      "labels": _vm.hoursWithCustomers.labels,
      "division": false,
      "height": "220px"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.hoursWithoutCustomers.labels && _vm.hoursWithoutCustomers.labels.length > 0) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af anden tid",
      "series": _vm.hoursWithoutCustomers.series,
      "labels": _vm.hoursWithoutCustomers.labels,
      "division": false,
      "height": "220px"
    }
  }) : _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af anden tid\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Ingen anden tid registreret\n                                ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.hoursExcluded.labels && _vm.hoursExcluded.labels.length > 0) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af fravær",
      "series": _vm.hoursExcluded.series,
      "labels": _vm.hoursExcluded.labels,
      "division": false,
      "height": "220px"
    }
  }) : _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af fravær\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Intet fravær registreret\n                                ")])])], 1)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])]), _vm._v(" "), _c('employee-time-usage', {
    attrs: {
      "employeeWorkingFieldName": _vm.employeeWorkingFieldName
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 794 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-responsible-employees"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.selectedRow ? 'col-lg-3' : 'col-lg-9'
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Ansvarlige\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                            ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3414427670)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data. Husk at angive i indstillingerne hvilke medarbejdere, der skal listes her\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: _vm.selectedRow ? 'col-lg-9' : 'col-lg-3'
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en ansvarlig for at se et overblik over de enkelte opgaver og opgavetyper her\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('responsible-project-types', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 795 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.coverageDevelopment"
    }
  }), _vm._v("\n                    Udviklingen i DB / DB pr. time\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage.progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.coverage_progress_percent === 0 || props.row.coverage_progress_percent > -5 && props.row.coverage_progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_per_hour.progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage_per_hour.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.coverage_per_hour_progress_percent === 0 || props.row.coverage_per_hour_progress_percent > -5 && props.row.coverage_per_hour_progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'coverage_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage_per_hour_total) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour_total < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour_total) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour_total) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.coverage_per_hour_total)) + " \n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 497252192)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.series[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "apex-charts-wrapper"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.generateSeries(),
      "type": "line"
    }
  }) : _vm._e()], 1)])]) : _c('div', [_vm._v("\n                Vælg en opgavetype for at se fremgangen i en graf\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 796 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_projects') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.total_projects) + "\n                    ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")], 1) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 4020860139)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 797 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-followup"
  }, [(_vm.data && !_vm.loading) ? _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding-top": "15px",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n            Du har lagt budget for perioden "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.to, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "employee-switcher",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.selectedSubMenuItem === 'hours'
    },
    on: {
      "click": function($event) {
        _vm.selectedSubMenuItem = 'hours'
      }
    }
  }, [_vm._v("\n                    Solgte timer\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.selectedSubMenuItem === 'cph'
    },
    on: {
      "click": function($event) {
        _vm.selectedSubMenuItem = 'cph'
      }
    }
  }, [_vm._v("\n                    DB pr. time\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.selectedSubMenuItem === 'ebitda'
    },
    on: {
      "click": function($event) {
        _vm.selectedSubMenuItem = 'ebitda'
      }
    }
  }, [_vm._v("\n                    EBITDA\n                ")])])]), _vm._v(" "), _c('budget-hours', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSubMenuItem === 'hours'),
      expression: "selectedSubMenuItem === 'hours'"
    }]
  }), _vm._v(" "), _c('budget-cph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSubMenuItem === 'cph'),
      expression: "selectedSubMenuItem === 'cph'"
    }]
  }), _vm._v(" "), _c('budget-ebitda', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedSubMenuItem === 'ebitda'),
      expression: "selectedSubMenuItem === 'ebitda'"
    }]
  })], 1) : (!_vm.data && !_vm.loading) ? _c('div', [_c('div', {
    staticClass: "placeholder padding",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            Du har endnu ikke lagt et budget\n            "), _c('br'), _c('br'), _vm._v(" "), _c('router-link', {
    staticClass: "budget-btn",
    attrs: {
      "to": {
        name: 'BudgetPlanning'
      },
      "tag": "button"
    }
  }, [_vm._v("\n                Læg et budget\n            ")])], 1)]) : _c('div', [_c('box-loading')], 1)])
},staticRenderFns: []}

/***/ }),
/* 798 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-project-types-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name ? props.row.name : '-') + "\n                    ")]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 799 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "possible-efforts-sub-menu"
  }, [_c('div', {
    staticClass: "switcher"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'makingMoney'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'makingMoney'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.makingMoney.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'smallAndBig'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'smallAndBig'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.smallAndBig.boksTekst))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'makingMoney'),
      expression: "selectedItem === 'makingMoney'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.makingMoney.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.customersMakingMoneyRange ? _vm.customersMakingMoneyRange[0] : 0)) + " til " + _vm._s(_vm._f("currency")(_vm.customersMakingMoneyRange ? _vm.customersMakingMoneyRange[1] : 0)) + " i timen\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.makingMoney.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.makingMoney.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerRevenue"
    }
  }), _vm._v("\n                    Er de største kunder lønsomme?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.customersColumns,
      "rows": _vm.data.making_money.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'timelog_hours_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.timelog_hours_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('CustomersLearning', 'customerRevenue')
      }
    }
  }, [_vm._v("\n                Gå til alle kunder →\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'smallAndBig'),
      expression: "selectedItem === 'smallAndBig'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.smallAndBig.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.smallAndBigRange[0].coverage_per_hour)) + " og " + _vm._s(_vm._f("currency")(_vm.smallAndBigRange[1].coverage_per_hour)) + " pr. time\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.smallAndBig.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.smallAndBig.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerGroups"
    }
  }), _vm._v("\n                    Kan vi tjene penge på både små og store kunder?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.smallAndBigColumns,
      "rows": _vm.data.small_and_big.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'bracket') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.bracket) + " kr.\n                            ")]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('CustomersLearning', 'customerRevenueGrouped')
      }
    }
  }, [_vm._v("\n                Gå til alle kunder →\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-project-types-for-responsibles"
  }, [(!_vm.loading) ? _c('div', [(_vm.employees && !_vm.loading && _vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    staticClass: "employees-wrapper"
  }, _vm._l((_vm.employees), function(employee) {
    return _c('div', {
      key: 'employee_' + employee.relation_id
    }, [_c('div', {
      staticClass: "employee",
      class: {
        'selected': _vm.selectedEmployee && _vm.selectedEmployee.relation_id === employee.relation_id
      },
      on: {
        "click": function($event) {
          _vm.selectedEmployee = employee
        }
      }
    }, [_vm._v("\n                    " + _vm._s(employee.first_name) + " " + _vm._s(employee.last_name) + "\n                ")])])
  }), 0) : _vm._e(), _vm._v(" "), _c('div', [(!_vm.selectedEmployee && _vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en opgaveansvarlig for at se et overblik over hans/hendes værdikæde her\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.selectedEmployee && _vm.$auth.user().roles[0].name === 'project-responsible') ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vi kunne ikke finde din værdikæde. Kontakt venligst din administrator.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedEmployee) ? _c('div', [_c('responsible-valuechain-single', {
    attrs: {
      "data": _vm.selectedEmployee
    }
  })], 1) : _vm._e()])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-9': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerRevenue"
    }
  }), _vm._v("\n                    Hvilke konkrete kunder tjener vi penge på?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectCustomer
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'timelog_hours_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.timelog_hours_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1301970476)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en kunde for at se en liste over alle kundens opgaver\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('customer-revenue-project-types', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.snoozedProjects"
    }
  }), _vm._v("\n        Opgaver uden bevægelse de sidste " + _vm._s(_vm.$store.state.config.companyMeta.settings.snoozed_days) + " dage (" + _vm._s(_vm.employeeName) + ")\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2850899247)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 803 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-keyfigures"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "economy.compare.keyFigures"
    }
  }), _vm._v("\n            Nøgletal\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [(props.row.coverage_percent !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                            "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'total_revenue') ? _c('div', [(props.row.total_revenue !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'coverage') ? _c('div', [(props.row.coverage !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [(props.row.coverage_per_hour !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                            "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'hours_with_customers') ? _c('div', {
          staticClass: "coverage-cell",
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.hours_with_customers !== 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("rounded")(props.row.hours_with_customers)) + " %\n                            "), (props.row.hours_with_customers) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.hours_with_customers < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(props.row.hours_with_customers) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(props.row.hours_with_customers) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
          }
        }) : _vm._e()]) : _c('span', [_vm._v("\n                            -\n                        ")])]) : (props.column.field == 'name') ? _c('div', [_c('strong', [_vm._v(_vm._s(props.row.name))])]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 16450828)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 804 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.claims"
    }
  }), _vm._v("\n        Afsluttede reklamationer\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.case_number) + "\n                ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.description) + "\n                ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                    }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                    " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                ")]) : (props.column.field == 'timelog_hours') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n                ")]) : (props.column.field == 'coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                    "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 3823040841)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 805 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-info-circle fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(_vm.title) ? _c('div', {
    staticClass: "line title"
  }, [_vm._v(_vm._s(_vm.title))]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lines), function(line, index) {
    return [(line.total) ? _c('div', {
      key: 'd' + index,
      staticClass: "divider",
      staticStyle: {
        "margin": "10px 0"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', {
      key: index,
      staticClass: "line",
      class: {
        total: line.total
      }
    }, [_c('div', {
      staticClass: "left"
    }, [_vm._v("\n                        " + _vm._s(line.label) + "\n                        "), (line.formula) ? _c('br') : _vm._e(), (line.formula) ? _c('span', {
      staticClass: "formula"
    }, [_vm._v(_vm._s(line.formula))]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_vm._v(_vm._s(_vm._f("lineAmount")(line)))])])]
  })], 2)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 806 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar"
  }, [_vm._m(0), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    staticClass: "menu-items"
  }, [_c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-th-large"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Overblik\n            ")])]), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/oekonomi')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'EconomyLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-wallet"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Økonomi\n            ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/kunder')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'CustomersLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-briefcase"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Kunder\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/opgaver')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'ProjectsLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-clipboard-list-check"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Opgaver\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/medarbejdere')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'EmployeesLearning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-users"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Medarbejdere\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/ansvarlige')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Responsibles'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-user-hard-hat"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Ansvarlige\n            ")])]), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/potentiale')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Potential'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fas fa-fw fa-star"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Potentiale\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'user' && _vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Settings'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-cog"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Indstillinger\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('router-link', {
    staticClass: "menu-item",
    class: {
      'router-link-exact-active': _vm.subIsActive('/entreprise')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'Enterprise'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-tools"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Entreprise\n            ")])]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item",
    attrs: {
      "tag": "div",
      "to": {
        name: 'BudgetPlanning'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-money-check-edit-alt"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Læg budget\n            ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item tips",
    class: {
      'router-link-exact-active': _vm.subIsActive('/mulige-indsatser')
    },
    attrs: {
      "tag": "div",
      "to": {
        name: 'PossibleEfforts'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-clock"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Mulige indsatser\n            ")])]), _vm._v(" "), _c('router-link', {
    staticClass: "menu-item tips",
    attrs: {
      "tag": "div",
      "to": {
        name: 'Tips'
      }
    }
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-fw fa-lightbulb"
  })]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("\n                Tips & tricks\n            ")])])], 1) : _c('div', [_vm._v("\n        Du er logget ind som opgaveansvarlig og har udelukkende adgang til din egen personlige værdikæde.\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [(_vm.lastSync) ? _c('div', {
    staticClass: "last-sync"
  }, [_vm._v("\n            Data opdateret:\n            "), _c('br'), _vm._v("\n            " + _vm._s(_vm.lastSync) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "user",
    on: {
      "click": _vm.logout
    }
  }, [_c('div', {
    staticClass: "avatar"
  }, [_vm._v("\n                " + _vm._s(_vm.initials) + "\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                    " + _vm._s(_vm.$auth.user().name) + "\n                ")]), _vm._v(" "), (_vm.$store.state.config.companyMeta) ? _c('div', {
    staticClass: "company"
  }, [_vm._v("\n                    " + _vm._s(_vm.$store.state.config.companyMeta.name) + "\n                ")]) : _vm._e()])]), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('router-link', {
    staticClass: "super-admin-options",
    attrs: {
      "tag": "div",
      "to": {
        name: 'ChangeCompany'
      }
    }
  }, [_c('div', {
    staticClass: "change-company"
  }, [_c('i', {
    staticClass: "fas fa-building fa-fw"
  }), _vm._v("\n                Skift virksomhed\n            ")])]) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/proebitda_logo_color.png"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding": "5px 0",
      "margin": "10px 0",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "1px",
      "width": "100%",
      "background": "rgba(255,255,255,0.15)"
    }
  })])
}]}

/***/ }),
/* 807 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('customer-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerRevenue'),
      expression: "selectedItem === 'customerRevenue'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('customerRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('customer-type-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerTypeRevenue'),
      expression: "selectedItem === 'customerTypeRevenue'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('customerTypeRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('customer-revenue-grouped', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'customerRevenueGrouped'),
      expression: "selectedItem === 'customerRevenueGrouped'"
    }]
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 808 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsibles"
  }, [(_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('box-helper', {
    attrs: {
      "headline": "Ansvarlige",
      "identifier": "responsibles"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [(_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Ansvarlige</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine ansvarlige\n            ")])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('compare-responsible-employees', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'compareResponsibleEmployees'),
      expression: "selectedItem === 'compareResponsibleEmployees'"
    }]
  }), _vm._v(" "), _c('compare-project-types-for-responsibles', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'compareProjectTypesForResponsibles'),
      expression: "selectedItem === 'compareProjectTypesForResponsibles'"
    }]
  }), _vm._v(" "), _c('responsible-valuechain', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'responsibleValuechain'),
      expression: "selectedItem === 'responsibleValuechain'"
    }]
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 809 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-coverage-per-hour-development"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.coveragePerHourDevelopment"
    }
  }), _vm._v("\n                    Udviklingen i DB pr. time pr. opgavetype\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.progress_percent === 0 || props.row.progress_percent > -5 && props.row.progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_per_hour_avg') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour_avg)) + " \n                                "), (props.row.coverage_per_hour_avg) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour_avg < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour_avg) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour_avg) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1958614940)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.series[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _vm._e()], 1)]) : _c('div', [_vm._v("\n                Vælg en opgavetype for at se fremgangen i en graf\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 810 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsible-project-types"
  }, [_c('div', {
    staticClass: "placeholder mb-4"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.project_types,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                    ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)]), _vm._v(" "), (_vm.selectedRow) ? _c('responsible-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _c('div', [_vm._v("\n        Vælg en opgavetype for at se de enkelte opgaver her\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.fordeling"
    }
  }), _vm._v("\n        Fordeling mellem time- og vareforbrug (kostpriser)\n    ")], 1), _vm._v(" "), (_vm.data && !_vm.loading && _vm.data.timeloggings.total > 0 && _vm.data.materials.total > 0) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "progress"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.data),
      expression: "data"
    }],
    staticClass: "timeloggings",
    style: ('width:' + _vm.data.timeloggings.percent + '%;')
  }), _vm._v(" "), _c('div', {
    staticClass: "overlay"
  }, [_c('div', {
    staticClass: "timeloggings-percent"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(_vm.data.timeloggings.percent)) + " %\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "materials-percent"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("rounded")(_vm.data.materials.percent)) + " %\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "explainer"
  }, [_c('div', {
    staticClass: "timeloggings"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.timeloggings.total)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "materials"
  }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.materials.total)) + "\n                ")])])])]) : (!_vm.data && _vm.loading) ? _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }) : _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n        Vi kunne ikke udregne fordelingen af udgifter. Tjek, at du har angivet hvilke medarbejdere, der skal regnes med i denne udregning. Dette kan du ændre i indstillinger under \"Medarbejdere\"\n    ")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "explainer bold"
  }, [_c('div', {
    staticClass: "timeloggings"
  }, [_c('i', {
    staticClass: "fas fa-clock fa-fw"
  }), _vm._v("\n                    Timer\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "materials"
  }, [_vm._v("\n                    Materialer\n                    "), _c('i', {
    staticClass: "fas fa-wrench fa-fw"
  })])])
}]}

/***/ }),
/* 812 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-skills"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.employeeSkills"
    }
  }), _vm._v("\n                    Hvilke svende er gode til hvilke opgaver?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [_c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1212287911)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en medarbejder for at se hvor god denne er til forskellige opgavetyper\n            ")]) : _c('employee-skills-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('claims-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'claims'),
      expression: "selectedItem === 'claims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('claims', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n            Opgaver under \"" + _vm._s(_vm.type) + "\"\n        ")]), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left",
            "white-space": "nowrap"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.case_number) + "\n                    "), (props.row.minuba_price && props.row.minuba_budget_id) ? _c('minuba-budget-tooltip', {
          attrs: {
            "closed": true,
            "project": props.row
          }
        }) : _vm._e()], 1) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.description) + "\n                ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                    }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                    " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                ")]) : (props.column.field == 'timelog_hours') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n                ")]) : (props.column.field == 'coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                    "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loader"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "lds-ellipsis"
  }, [_c('div'), _c('div'), _c('div'), _c('div')]), _vm._v(" "), _c('div', [_vm._v("Indlæser")])])])
}]}

/***/ }),
/* 816 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.current !== -1) ? _c('div', {
    staticClass: "ebitda-development"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Akkumuleret EBITDA i regnskabsåret")]), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "type": "bar",
      "height": 300,
      "series": _vm.series,
      "options": _vm.options
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "legend"
  }, [_c('span', [_c('i', {
    style: ({
      background: _vm.colors.budget
    })
  }), _vm._v("Budget")]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (_vm.wip && _vm.wip.total) ? _c('div', {
    staticClass: "note"
  }, [_vm._v("\n        Starter fra realiseret EBITDA i regnskabsåret indtil i dag. Værdi af opgaver for " + _vm._s(_vm._f("currency")(_vm.wip.total)) + " indgår: afsluttede, ikke fakturerede i " + _vm._s(_vm._f("moment")(_vm.months[_vm.current].month, 'MMMM')) + ", igangværende fordelt jævnt til og med " + _vm._s(_vm._f("moment")(_vm.months[_vm.months.length - 1].month, 'MMMM')) + "\n    ")]) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "forecast"
  }), _vm._v("Forventet")])
}]}

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$auth.ready()) ? _c('div', {
    staticClass: "layout"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$store.state.showDailyTip && _vm.dailyTip),
      expression: "$store.state.showDailyTip && dailyTip"
    }],
    staticClass: "daily-tip"
  }, [_c('div', {
    staticClass: "outer"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("\n                    " + _vm._s(_vm.dailyTip.headline) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.dailyTip.content)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "cta"
  }, [_c('div', {
    staticClass: "cta__inner",
    on: {
      "click": function($event) {
        _vm.$store.state.showDailyTip = false
      }
    }
  }, [_vm._v("\n                        Luk besked\n                    ")])])])])]), _vm._v(" "), (_vm.$auth.check()) ? _c('div', [(_vm.$store.state.config.loaded) ? _c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "sidebar"
  }, [_c('sidebar')], 1), _vm._v(" "), _c('div', {
    staticClass: "page"
  }, [_c('config-bar'), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('router-view')], 1), _vm._v(" "), _c('foo')], 1)]) : _c('loader')], 1) : _c('login')], 1) : _c('loader')
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-headline"
  }, [_c('i', {
    staticClass: "fas fa-lightbulb"
  }), _vm._v("\n                    Tips & tricks\n                ")])
}]}

/***/ }),
/* 818 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-claims"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_vm._m(0), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("\n                Hvordan vil din bundlinje se ud, hvis du kan opnå...\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Flere timer hos kunderne\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm.customerHours.now) + " %\n                            ")])]), _vm._v(" "), (_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerHours.value),
      expression: "customerHours.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.customerHours.min,
      "max": _vm.customerHours.max
    },
    domProps: {
      "value": (_vm.customerHours.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.customerHours, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                +\n                                " + _vm._s(_vm.customerHours.value) + "\n                                " + _vm._s(_vm.customerHours.label) + "\n                            ")])]) : _vm._e(), _vm._v(" "), (_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "result"
  }, [(_vm.customerHours.value != _vm.customerHours.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.customerHoursTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]) : _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Timer hos kunderne kan ikke udregnes. Tjek, at du har angivet hvilke medarbejdere, der skal tages med i denne udregning.\n                        ")]), _vm._v(" "), (_vm.customerHours.value != _vm.customerHours.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at svendene i gennemsnit bruger "), _c('b', [_vm._v(_vm._s(Number(_vm.customerHours.now) + Number(_vm.customerHours.value)) + "%")]), _vm._v(" af deres tid hos kunderne\n                        ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Meromsætning pr. opgave\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm._f("currency")(_vm.data.revenue.avg_per_project)) + " pr. opgave\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectRevenue.value),
      expression: "projectRevenue.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.projectRevenue.min,
      "max": _vm.projectRevenue.max
    },
    domProps: {
      "value": (_vm.projectRevenue.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.projectRevenue, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                +\n                                " + _vm._s(_vm.projectRevenue.value) + "\n                                " + _vm._s(_vm.projectRevenue.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.projectRevenueTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at den gennemsnitlige pris pr. opgave øges med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.projectRevenueTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            Besparelse på vareforbrug\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                I dag: " + _vm._s(_vm._f("currency")(_vm.data.materials.total / _vm.data.revenue.total_projects)) + " pr. opgave\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialsUsage.value),
      expression: "materialsUsage.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.materialsUsage.min,
      "max": _vm.materialsUsage.max
    },
    domProps: {
      "value": (_vm.materialsUsage.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.materialsUsage, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                " + _vm._s(_vm.materialsUsage.value) + "\n                                " + _vm._s(_vm.materialsUsage.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.materialsUsageTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen svarer til, at den gennemsnitlige udgift til vareforbrug pr. opgave skal nedjusteres med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.materialsUsageTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "heading"
  }, [_vm._v("\n                            En forøgelse af mindste DG\n                            "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                Gns. DG pr. opgave i dag: " + _vm._s(_vm._f("coveragePercent")(_vm.data.coverage.average_percent)) + "%\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coveragePercent.value),
      expression: "coveragePercent.value"
    }],
    attrs: {
      "type": "range",
      "min": _vm.coveragePercent.min,
      "max": _vm.coveragePercent.max
    },
    domProps: {
      "value": (_vm.coveragePercent.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.coveragePercent, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                " + _vm._s(_vm.coveragePercent.value) + "\n                                " + _vm._s(_vm.coveragePercent.label) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "result"
  }, [(_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('span', [_vm._v("\n                                + " + _vm._s(_vm._f("currency")(_vm.coveragePercentTotal)) + "\n                            ")]) : _c('span', [_vm._v("\n                                -\n                            ")])]), _vm._v(" "), (_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Udregningen viser hvad du kan opnå, hvis du kan forbedre DG på alle opgaver til minimum "), _c('b', [_vm._v(_vm._s(_vm.coveragePercent.value) + "%")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "break"
  }), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "blank"
  }), _vm._v(" "), _c('div', {
    staticClass: "today"
  }, [_vm._v("\n                    EBITDA i dag\n                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.ebitda)) + "\n                    ")])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "potential"
  }, [_vm._v("\n                    Potentielt fremtidigt EBITDA\n                    "), (_vm.totalPotential != _vm.ebitda) ? _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.totalPotential)) + "\n                    ")]) : _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        -\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "blank"
  })])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Hvad kan give effekt "), _c('u', [_vm._v("direkte")]), _vm._v(" på bundlinjen?\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "arrow"
  }, [_c('i', {
    staticClass: "far fa-arrow-right"
  })])
}]}

/***/ }),
/* 819 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coming-soon"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('i', {
    staticClass: "fal fa-cog"
  }), _vm._v(" "), _c('br'), _vm._v("\n        Vi arbejder pt. på denne funktion. Kig ind senere!\n    ")])])
}]}

/***/ }),
/* 820 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.projectTypeRevenue"
    }
  }), _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")], 1), _vm._v(" "), (_vm.rows.length > 0 || _vm.$store.state.closedRows && _vm.$store.state.closedRows.length === 0) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("truncate")(props.row.description)) + "\n            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")]) : (props.column.field == 'timelog_hours') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type : '-') + "\n            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1169051185)
  }, [_vm._v("\n    >\n        "), _c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 821 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-usd-circle fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticClass: "line good"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm.valueBased ? 'Aconto faktureret' : 'Omsætning'))]), _vm._v(" "), _c('div', {
    staticClass: "right good"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.invoices_total ? _vm.project.invoices_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm._f("realNumber")(_vm.project.timelog_hours ? _vm.project.timelog_hours : 0)) + " timer")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.timelog_total ? _vm.project.timelog_total : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v(_vm._s(_vm._f("realNumber")(_vm.project.materials_count ? _vm.project.materials_count : 0)) + " materialer")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.material_total ? _vm.project.material_total : 0)))])]), _vm._v(" "), (_vm.valueBased && _vm.project.type) ? _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Gns. DG \"" + _vm._s(_vm.project.type.name) + "\""), _c('br'), _c('span', {
    staticStyle: {
      "opacity": "0.5",
      "font-size": "12px"
    }
  }, [_vm._v("DG udregnet for de seneste 6 mdr.")])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("coveragePercent")(_vm.project.type.avg_coverage_percent)) + " %")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), (!_vm.valueBased) ? _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Dækningsbidrag")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.coverage > 0, 'bad': _vm.project.coverage < 0
    }
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.coverage ? _vm.project.coverage : 0)))])]) : _vm._e(), _vm._v(" "), (_vm.valueBased && !_vm.valueBasedWithCP) ? _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Værdi")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.value > 0, 'bad': _vm.project.value < 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("realCurrency")(_vm.project.value)) + "\n                    ")])]) : _vm._e(), _vm._v(" "), (_vm.valueBased && _vm.valueBasedWithCP) ? _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Værdi")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.value_with_avg_cp > 0, 'bad': _vm.project.value_with_avg_cp < 0
    }
  }, [_vm._v("\n                    " + _vm._s(_vm._f("realCurrency")(_vm.project.value_with_avg_cp)) + "\n                    ")])]) : _vm._e()])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "potential"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Potentiale",
      "identifier": "potential"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Virksomhedens potentiale</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Hvor lidt skal der til for at forbedre bundlinjen?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "economy-learning-claims"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_vm._m(0), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("\n                        Her ser du, hvad der skal til for at øge EBITDA med den eksisterende organisation. \n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "15px",
      "padding-bottom": "15px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Flere timer hos kunderne\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.moreCustomerHours",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        I dag: " + _vm._s(_vm.customerHours.now) + " %\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customerHours.value),
      expression: "customerHours.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.customerHours.min,
      "max": _vm.customerHours.max
    },
    domProps: {
      "value": (_vm.customerHours.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.customerHours, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        +\n                                        " + _vm._s(_vm.customerHours.value) + "\n                                        " + _vm._s(_vm.customerHours.label) + "\n                                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "result"
  }, [(_vm.customerHours.value != _vm.customerHours.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.customerHoursTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(!_vm.customerHours.now > 0) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Timer hos kunderne kan ikke udregnes. Tjek, at du har angivet hvilke medarbejdere, der skal tages med i denne udregning.\n                                ")]) : _vm._e(), _vm._v(" "), (_vm.customerHours.value != _vm.customerHours.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen svarer til, at svendene i gennemsnit bruger "), _c('b', [_vm._v(_vm._s(Number(_vm.customerHours.now) + Number(_vm.customerHours.value)) + "%")]), _vm._v(" af deres tid hos kunderne\n                                ")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "15px",
      "padding-bottom": "15px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Meromsætning pr. opgave\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.moreRevenue",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        I dag: " + _vm._s(_vm._f("currency")(_vm.data.revenue.avg_per_project)) + " pr. opgave\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.projectRevenue.value),
      expression: "projectRevenue.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.projectRevenue.min,
      "max": _vm.projectRevenue.max
    },
    domProps: {
      "value": (_vm.projectRevenue.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.projectRevenue, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        +\n                                        " + _vm._s(_vm.projectRevenue.value) + "\n                                        " + _vm._s(_vm.projectRevenue.label) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.projectRevenueTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.projectRevenue.value != _vm.projectRevenue.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen svarer til, at den gennemsnitlige pris pr. opgave øges med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.projectRevenueTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "15px",
      "padding-bottom": "15px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Besparelse på vareforbrug\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.materialSavings",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        I dag: " + _vm._s(_vm._f("currency")(_vm.data.materials.total / _vm.data.revenue.total_projects)) + " pr. opgave\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.materialsUsage.value),
      expression: "materialsUsage.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.materialsUsage.min,
      "max": _vm.materialsUsage.max
    },
    domProps: {
      "value": (_vm.materialsUsage.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.materialsUsage, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        " + _vm._s(_vm.materialsUsage.value) + "\n                                        " + _vm._s(_vm.materialsUsage.label) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.materialsUsageTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.materialsUsage.value != _vm.materialsUsage.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen svarer til, at den gennemsnitlige udgift til vareforbrug pr. opgave skal nedjusteres med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.materialsUsageTotal / _vm.data.revenue.total_projects)))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "margin-bottom": "15px",
      "padding-bottom": "15px",
      "border-bottom": "1px solid rgba(0,0,0,0.1)"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    En forøgelse af mindste DG\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.coverageIncrease",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        Gns. DG pr. opgave i dag: " + _vm._s(_vm._f("coveragePercent")(_vm.data.coverage.average_percent)) + "%\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.coveragePercent.value),
      expression: "coveragePercent.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.coveragePercent.min,
      "max": _vm.coveragePercent.max
    },
    domProps: {
      "value": (_vm.coveragePercent.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.coveragePercent, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        " + _vm._s(_vm.coveragePercent.value) + "\n                                        " + _vm._s(_vm.coveragePercent.label) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.coveragePercentTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.coveragePercent.value != _vm.coveragePercent.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen viser hvad du kan opnå, hvis du kan forbedre DG på alle opgaver til minimum "), _c('b', [_vm._v(_vm._s(_vm.coveragePercent.value) + "%")])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "box last",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "heading",
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Forøgelse af timepris\n                                    "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.hourPriceIncrease",
      "icon": "question-square"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                        Timer i perioden: " + _vm._s(_vm._f("number")(_vm.data.timeloggings.total_with_project)) + "\n                                    ")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "slider",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.hourPrice.value),
      expression: "hourPrice.value"
    }],
    staticStyle: {
      "margin-bottom": "10px"
    },
    attrs: {
      "type": "range",
      "min": _vm.hourPrice.min,
      "max": _vm.hourPrice.max
    },
    domProps: {
      "value": (_vm.hourPrice.value)
    },
    on: {
      "__r": function($event) {
        return _vm.$set(_vm.hourPrice, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', [_vm._v("\n                                        " + _vm._s(_vm.hourPrice.value) + "\n                                        " + _vm._s(_vm.hourPrice.label) + "\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "result"
  }, [(_vm.hourPrice.value != _vm.hourPrice.min) ? _c('span', [_vm._v("\n                                        + " + _vm._s(_vm._f("currency")(_vm.hourPriceTotal)) + "\n                                    ")]) : _c('span', [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [(_vm.hourPrice.value != _vm.hourPrice.min) ? _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "0",
      "text-align": "left"
    }
  }, [_vm._v("\n                                    Udregningen viser hvad du kan opnå, hvis du forøger din timepris med "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.hourPrice.value)))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "overview"
  }, [_c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "today"
  }, [_vm._v("\n                                    EBITDA i dag\n                                    "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.ebitda)) + "\n                                    ")])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "potential"
  }, [_vm._v("\n                                    Potentielt årligt ekstra EBITDA\n                                    "), (_vm.totalPotential != _vm.ebitda) ? _c('div', {
    staticClass: "value"
  }, [(_vm.totalPotential > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v("\n                                        " + _vm._s(_vm._f("currency")(_vm.totalPotential)) + "\n                                    ")]) : _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                                        -\n                                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_vm._v("\n                                 \n                            ")])])])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "15px 0px 30px 0px"
    }
  }, [_vm._v("\n                Tallene tager udgangspunkt i den valgte periode i toppen. Hvis du er i starten af et nyt regnskabsår, kan det give mening at vælge det forrige regnskabsår i toppen for at se et mere retvisende billede af potentialet for din virksomhed\n            ")]), _vm._v(" "), _c('project-types-potential')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Hvad kan give effekt "), _c('u', [_vm._v("direkte")]), _vm._v(" på bundlinjen?\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "arrow"
  }, [_c('i', {
    staticClass: "far fa-arrow-right"
  })])])
}]}

/***/ }),
/* 823 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "no-data"
  }, [_vm._v("\n    Vi fandt desværre ingen data her.\n    "), _c('br'), _vm._v("\n    Hvis du mener dette er en fejl, så "), _c('a', {
    attrs: {
      "href": "mailto:troels@proebitda.dk"
    }
  }, [_vm._v("kontakt os")]), _vm._v(" venligst.\n")])
}]}

/***/ }),
/* 824 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Rediger dine oplysninger\n    ")]), _vm._v(" "), _c('form', {
    staticClass: "create-user",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "hidden",
      "type": "text",
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('label', [_vm._v("Navn *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$auth.user().name),
      expression: "$auth.user().name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Navn"
    },
    domProps: {
      "value": (_vm.$auth.user().name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$auth.user(), "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('label', [_vm._v("Brugerrolle")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "40px",
      "line-height": "40px"
    }
  }, [(_vm.$auth.user().roles[0].name === 'super-admin') ? _c('span', [_vm._v("Super Admin")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'admin') ? _c('span', [_vm._v("Administrator")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name === 'user') ? _c('span', [_vm._v("Bruger")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('label', [_vm._v("E-mail *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.$auth.user().email),
      expression: "$auth.user().email"
    }],
    attrs: {
      "type": "email",
      "name": "iufbw379fb",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.$auth.user().email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.$auth.user(), "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "password"
  }, [_c('label', [_vm._v("Ny adgangskode *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.new_password),
      expression: "user.new_password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "Ny adgangskode"
    },
    domProps: {
      "value": (_vm.user.new_password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.user, "new_password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Min. 8 karakterer (udfyldes kun hvis du vil skifte adgangskode)")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "action",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.updateUser()
      }
    }
  }, [_vm._v("\n                Opdater\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 825 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "oekonomi.unpaidInvoices",
      "placement": "left"
    }
  }), _vm._v("\n        Fakturaer, der ikke er betalt (" + _vm._s(_vm.employeeName) + ")\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number ? props.row.invoice_number : '-') + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                    Betalt\n                ")]) : _c('span', [_vm._v("\n                    Ikke betalt\n                ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2812794680)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 826 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar-menu"
  }, [_c('div', {
    staticClass: "items"
  }, _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "item",
      class: {
        'selected': _vm.selectedItem === item.slug
      },
      on: {
        "click": function($event) {
          return _vm.handleClick(item.slug)
        }
      }
    }, [_c('div', {
      staticClass: "inner"
    }, [(_vm.counts[item.slug] !== null && _vm.counts[item.slug] !== '-') ? _c('div', {
      staticClass: "count"
    }, [(_vm.counts[item.slug] !== null || _vm.counts[item.slug] !== '-') ? _c('span', [_vm._v("\n                        " + _vm._s(_vm.counts[item.slug]) + "\n                    ")]) : _vm._e()]) : (_vm.counts[item.slug] === '-') ? _c('div', {
      staticClass: "count"
    }, [_c('span', [_vm._v("\n                        -\n                    ")])]) : _c('div', {
      staticClass: "count"
    }, [_c('i', {
      staticClass: "fal fa-spinner fa-spin"
    })]), _vm._v(" "), (item.comingsoon) ? _c('div', {
      staticClass: "coming-soon"
    }, [_vm._v("\n                    Kommer snart\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                    " + _vm._s(item.name) + "\n                    "), (item.dTooltip) ? _c('d-tooltip', {
      attrs: {
        "placement": "inline",
        "identifier": item.dTooltip
      }
    }) : _vm._e()], 1)]), _vm._v(" "), (_vm.selectedItem === item.slug) ? _c('div', {
      staticClass: "icon"
    }, [_c('svg', {
      attrs: {
        "width": "600px",
        "height": "300px",
        "viewBox": "0 0 600 300",
        "version": "1.1",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlns:xlink": "http://www.w3.org/1999/xlink"
      }
    }, [_c('g', {
      attrs: {
        "id": "Page-1",
        "stroke": "none",
        "stroke-width": "1",
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('polygon', {
      attrs: {
        "id": "Rectangle",
        "fill": "#D8D8D8",
        "points": "0 0 600 0 300 300"
      }
    })])])]) : _vm._e()])
  }), 0)])
},staticRenderFns: []}

/***/ }),
/* 827 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue-project-types"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.project_types,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'timelog_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Vælg en opgavetype for at se en liste over alle opgaverne her\n    ")]) : _c('customer-revenue-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 828 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "configbar"
  }, [(_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    attrs: {
      "align": "left"
    }
  }, [(_vm.$auth.user().roles[0].name === 'department-responsible' && _vm.selectedDepartment) ? _c('div', [_c('b', [_vm._v(_vm._s(_vm.selectedDepartment.name))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('i', [_vm._v("Logget ind som afdelingsansvarlig")])]) : _c('div', [(_vm.selectedDepartment !== null) ? _c('dropdown', {
    attrs: {
      "options": _vm.departments,
      "selected": _vm.selectedDepartment,
      "placeholder": 'Vælg afdeling',
      "closeOnOutsideClick": true
    },
    on: {
      "updateOption": _vm.selectDepartment
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    staticClass: "date-range"
  }, [_c('div', {
    staticClass: "flex"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "monday-first": "",
      "language": _vm.datepickerLocale,
      "placeholder": "Startdato"
    },
    model: {
      value: (_vm.$store.state.config.startDate),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.config, "startDate", $$v)
      },
      expression: "$store.state.config.startDate"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "monday-first": "",
      "language": _vm.datepickerLocale,
      "placeholder": "Slutdato"
    },
    model: {
      value: (_vm.$store.state.config.endDate),
      callback: function($$v) {
        _vm.$set(_vm.$store.state.config, "endDate", $$v)
      },
      expression: "$store.state.config.endDate"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "custom-time-period"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedTimePeriod),
      expression: "selectedTimePeriod"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedTimePeriod = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.selectTimePeriod($event)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "Vælg tidsinterval",
      "selected": "",
      "disabled": ""
    }
  }, [_vm._v("Vælg tidsinterval ↓")]), _vm._v(" "), _vm._l((_vm.customTimeIntervals), function(timeInterval, index) {
    return _c('option', {
      key: index,
      attrs: {
        "startDate": 2019,
        "endDate": 2020
      },
      domProps: {
        "value": timeInterval.name
      }
    }, [_vm._v("\n                    " + _vm._s(timeInterval.name) + "\n                ")])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().roles[0].name !== 'project-responsible') ? _c('div', {
    staticClass: "smart",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "options reversed"
  }, [_vm._m(2), _vm._v(" "), _vm._l((_vm.$store.state.config.availableAccountingYears), function(accountingYear, index) {
    return (index < 3) ? _c('div', {
      key: accountingYear.year,
      staticClass: "single-option",
      class: {
        'selected': accountingYear.from_date === _vm.$store.getters.getStartDate && accountingYear.to_date === _vm.$store.getters.getEndDate
      },
      on: {
        "click": function($event) {
          return _vm.selectAccountingYear(accountingYear)
        }
      }
    }, [_vm._v("\n                " + _vm._s(accountingYear.year) + "\n            ")]) : _vm._e()
  })], 2)]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "white-space": "nowrap"
    }
  }, [_c('b', [_vm._v("Vælg periode:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('i', {
    staticClass: "fal fa-chevron-right"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "white-space": "nowrap",
      "margin-right": "30px"
    }
  }, [_c('b', [_vm._v("Vælg regnskabsår:")])])
}]}

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-time-usage"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Medarbejdere\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectCustomer
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'hoursWithCustomers') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.hoursWithCustomers) + " %\n                            ")]) : (props.column.field == 'sicknessPercent') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.sicknessPercent) + " %\n                            ")]) : _vm._e()]
      }
    }], null, false, 6116341)
  }) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.selectedRow && !_vm.loading) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsage.singleEmployee"
    }
  }), _vm._v("\n                    " + _vm._s(_vm.selectedRow.name) + "\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow.hours_division.series[0] > 0 && _vm.selectedRow !== null) ? _c('pie', {
    attrs: {
      "headline": 'Hvad bruger ' + _vm.selectedRow.name.split(' ')[0] + ' tiden på?',
      "series": _vm.selectedRow.hours_division.series,
      "labels": _vm.selectedRow.hours_division.labels,
      "division": true
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedRow.hours_division.series[0] === 0) ? _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Hvad bruger " + _vm._s(_vm.selectedRow.name.split(' ')[0]) + " tiden på?\n                                ")]), _vm._v(" "), _vm._m(0)]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow.hours_with_customers.labels.length > 0 && _vm.selectedRow !== null) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af tid hos kunderne",
      "series": _vm.selectedRow.hours_with_customers.series,
      "labels": _vm.selectedRow.hours_with_customers.labels,
      "division": false
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedRow.hours_with_customers.labels.length === 0) ? _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af tid hos kunderne\n                                ")]), _vm._v(" "), _vm._m(1)]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow.hours_without_customers.labels.length > 0) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af anden tid",
      "series": _vm.selectedRow.hours_without_customers.series,
      "labels": _vm.selectedRow.hours_without_customers.labels,
      "division": false
    }
  }) : _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af anden tid\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Ingen anden tid registreret\n                                ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.selectedRow.hours_excluded && _vm.selectedRow.hours_excluded.labels.length > 0) ? _c('pie', {
    attrs: {
      "headline": "Fordeling af fravær",
      "series": _vm.selectedRow.hours_excluded.series,
      "labels": _vm.selectedRow.hours_excluded.labels,
      "division": false
    }
  }) : _c('div', [_c('div', {
    staticClass: "headline",
    staticStyle: {
      "text-align": "center",
      "font-weight": "600",
      "font-family": "'Open Sans', sans-serif"
    }
  }, [_vm._v("\n                                    Fordeling af fravær\n                                ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Intet fravær registreret\n                                ")])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "footnote"
  }, [_c('strong', [_vm._v("Tid brugt hos kunderne")]), _vm._v(" er beregnet ud af medarbejderens reelle tid til rådighed: den teoretiske arbejdstid (arbejdsdage × timer/uge) fratrukket fraværstimer. "), _c('strong', [_vm._v("Fravær")]), _vm._v(" er de tidsregistreringstyper, der er sat til \"Skjult\" under "), _c('router-link', {
    attrs: {
      "to": "/indstillinger"
    }
  }, [_vm._v("Indstillinger → Tidsregistreringstyper")]), _vm._v(" — de fratrækkes tid til rådighed og tæller derfor ikke med i kundetidsprocenten.\n                    ")], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("selectedRow")]), _c('br'), _vm._v("\n                        labels: " + _vm._s(_vm.selectedRow.hours_without_customers.labels)), _c('br'), _vm._v("\n                        series: " + _vm._s(_vm.selectedRow.hours_without_customers.series) + "\n                        "), _c('br'), _c('br'), _vm._v(" "), _c('b', [_vm._v("Allan Jensen")]), _c('br'), _vm._v("\n                        labels: " + _vm._s(_vm.rows[1].hours_without_customers.labels)), _c('br'), _vm._v("\n                        series: " + _vm._s(_vm.rows[1].hours_without_customers.series) + "\n                    ")])])]) : _c('div', [_vm._v("\n                Vælg en svend for at se fordelingen af hans registrerede timer\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Ingen tid hos kunderne\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("\n                                    Ingen tid hos kunderne\n                                ")])
}]}

/***/ }),
/* 830 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees-sub-projects"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Medarbejdere\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.first_name ? ((props.row.first_name) + " " + (props.row.last_name)) : '-') + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'sub_projects_total_expenses') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.sub_projects_total_expenses)) + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 34418348)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en medarbejder for at se en liste over dennes underopgaver med effektivitet\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('employee-sub-projects-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-projects"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Ordre " + _vm._s(_vm.data.case_number) + " - " + _vm._s(_vm.data.customer.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'budget_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'efficiency_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$store.state.config.availableDepartments) ? _c('div', {
    staticClass: "economy-learning-potential"
  }, [(_vm.$store.getters.getAvailableDepartments.length > 1) ? _c('div', {
    staticClass: "has-departments"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('compare-keyfigures')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-revenue')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage-percent')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('compare-coverage-per-hour')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('compare-customer-hours')], 1)])]) : _c('div', {
    staticClass: "no-departments"
  }, [_vm._v("\n        Virksomheden har ingen afdelinger at sammenligne.\n    ")])]) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 833 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-operations-future-revenue"
  }, [_c('exceededPayments-table', {
    on: {
      "finishedLoading": function($event) {
        return _vm.$emit('finishedLoading', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 834 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "enterprise"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Entreprise",
      "identifier": "enterprise"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Entreprise</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over din entreprise-forretning\n            ")])]), _vm._v(" "), _c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('main-project-types', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'mainProjectTypes'),
      expression: "selectedItem === 'mainProjectTypes'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('mainProjectTypes', $event)
      }
    }
  }), _vm._v(" "), _c('main-projects', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'mainProjects'),
      expression: "selectedItem === 'mainProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('mainProjects', $event)
      }
    }
  }), _vm._v(" "), _c('employees-sub-projects', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'employeesSubProjects'),
      expression: "selectedItem === 'employeesSubProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('employeesSubProjects', $event)
      }
    }
  }), _vm._v(" "), _c('sub-project-types', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'subProjectTypes'),
      expression: "selectedItem === 'subProjectTypes'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('subProjectTypes', $event)
      }
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-materials"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('material-usage')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('suppliers')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pie"
  }, [(_vm.headline) ? _c('div', {
    staticClass: "headline"
  }, [_vm._v("\n        " + _vm._s(_vm.headline) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "options": _vm.chartOptions,
      "series": _vm.series,
      "labels": _vm.labels,
      "height": _vm.chartOptions.chart.height
    }
  }), _vm._v(" "), (_vm.total > 0) ? _c('div', {
    staticClass: "total"
  }, [_vm._v("\n        I alt " + _vm._s(_vm._f("rounded")(_vm.total)) + " timer\n    ")]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 837 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "error-page-wrapper"
  }, [_c('div', {
    staticClass: "error-page-inner"
  }, [_c('h1', [_vm._v("404")]), _vm._v(" "), _c('h3', [_vm._v("Whoops! Something went wrong...")]), _vm._v(" "), _c('p', [_vm._v("We could not find what you were looking for.")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: _vm.$route.name
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Refresh this page\n            ")])]), _vm._v("\n        |\n        "), _c('router-link', {
    attrs: {
      "tag": "a",
      "to": {
        name: 'Index'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-xs btn-primary"
  }, [_vm._v("\n                Go to \"home\"\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 838 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "table-card"
  }, [_c('box-helper'), _vm._v(" "), (_vm.heading) ? _c('div', {
    staticClass: "table-title"
  }, [(_vm.icon) ? _c('i', {
    class: 'fas fa-fw fa-' + _vm.icon
  }) : _vm._e(), _vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('v-data-table', {
    class: _vm.customClass,
    attrs: {
      "search": _vm.search,
      "headers": _vm.headers,
      "items": _vm.items,
      "items-per-page": 50
    }
  }, [_c('no-data', {
    attrs: {
      "slot": "no-data"
    },
    slot: "no-data"
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer.page-text"
    },
    slot: "footer.page-text"
  }, [_vm._v("\n            Footer text?\n        ")])], 1) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "box-date-range"
  }, [_vm._m(0), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "language": _vm.datepickerLocale,
      "placeholder": "Startdato"
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('datepicker', {
    staticClass: "date-picker",
    attrs: {
      "language": _vm.datepickerLocale,
      "placeholder": "Slutdato"
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('i', {
    staticClass: "fal fa-calendar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "to"
  }, [_c('i', {
    staticClass: "fal fa-chevron-right"
  })])
}]}

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rows.length) ? _c('div', {
    staticClass: "value-wrapper"
  }, [_c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                Værdi, salgspris i alt\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.totalValueWithCP)) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.ongoingProjects"
    }
  }), _vm._v("\n            Igangværende opgaver\n        ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function(props) {
        return [(props.column.field == 'case_number') ? _c('span', [_vm._v("\n                    " + _vm._s(props.column.label) + "\n                    "), _c('d-tooltip', {
          attrs: {
            "placement": "inline",
            "identifier": "projects.ongoing.budget"
          }
        })], 1) : _c('span', [_vm._v("\n                    " + _vm._s(props.column.label) + "\n                ")])]
      }
    }, {
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(props.row.status.name) + "\n                    "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.case_number) + "\n                    "), (props.row.minuba_price && props.row.minuba_budget_id) ? _c('minuba-budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), (props.row.minuba_price && props.row.minuba_budget_id && props.row.completion_rate) ? _c('div', {
          staticStyle: {
            "display": "inline-block",
            "position": "relative",
            "height": "8px",
            "width": "50px",
            "background": "#ddd",
            "border-radius": "100px",
            "overflow": "hidden",
            "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
          }
        }, [_c('div', {
          style: (("height:8px;background:" + (props.row.completion_rate > 99 ? '#FF5252' : props.row.completion_rate > 80 ? '#FFA000' : '#4CAF50') + ";width:" + (Math.ceil((50 / 100) * props.row.completion_rate)) + "px;max-width:50px;"))
        }, [_vm._v(" ")])]) : _vm._e()], 1) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description ? props.row.description : '-'
          }
        }, [_vm._v(_vm._s(props.row.description ? props.row.description : '-'))])], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                    }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                    " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                ")]) : (props.column.field == 'invoices_total') ? _c('div', [(props.row.invoices_total > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(props.row.invoices_total)))]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'total_expenses') ? _c('div', [(props.row.total_expenses > 0) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'value') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.value)) + "\n                ")], 1) : (props.column.field == 'value_with_avg_cp') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "valueBasedWithCP": true,
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.value_with_avg_cp)) + "\n                ")], 1) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 4223637523)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "container section"
  }, [(_vm.localEnv) ? _c('div', [(_vm.localEnv) ? _c('button', {
    on: {
      "click": function($event) {
        return _vm.getData()
      }
    }
  }, [_vm._v("\n                getData()\n            ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Inspiration til, hvor der kan sættes ind for at øge indtjeningen og likviditeten</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Vælg et område og se nogle eksempler på, hvordan virksomheden kan øge indtjeningen.\n            ")])]), _vm._v(" "), (!_vm.loading && _vm.textsLoaded === this.identifiers.length) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "-30px",
      "height": "30px",
      "display": "flex",
      "justify-content": "center",
      "align-items": "center",
      "margin-bottom": "30px",
      "font-weight": "bold"
    }
  }, [(_vm.selectedMenuItem) ? _c('span', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.selectedMenuItem = null;
        _vm.selectedBox = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-fw fa-arrow-left"
  }), _vm._v(" Tilbage til oversigt")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-bottom": "30px"
    }
  }, [_vm._v("\n                Alle beregninger er baseret på de seneste 12 hele måneders resultater\n                (" + _vm._s(_vm._f("moment")(_vm.data.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.to, 'DD/MM/YYYY')) + ")\n            ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem),
      expression: "selectedMenuItem"
    }],
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'economy'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('economy')
      }
    }
  }, [_c('span', [_vm._v("Økonomi")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'customers'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('customers')
      }
    }
  }, [_c('span', [_vm._v("Kunder")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'projects'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('projects')
      }
    }
  }, [_c('span', [_vm._v("Opgaver")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'employees'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('employees')
      }
    }
  }, [_c('span', [_vm._v("Medarbejdere")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline ss",
    class: {
      'selected': _vm.selectedMenuItem === 'potential'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('potential')
      }
    }
  }, [_c('span', [_vm._v("Potentiale")])])])]), _vm._v(" "), (!_vm.selectedMenuItem) ? _c('div', {
    staticClass: "ai-insight-box"
  }, [_c('div', {
    staticClass: "ai-insight-header"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "ai-insight-actions"
  }, [(_vm.insight) ? _c('span', {
    staticClass: "ai-insight-date"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.insight.generated_at, 'DD/MM/YYYY HH:mm')))]) : _vm._e(), _vm._v(" "), (_vm.showHistory) ? _c('span', {
    staticClass: "ai-insight-history",
    on: {
      "click": function($event) {
        _vm.showHistory = false
      }
    }
  }, [_vm._v("Skjul historik")]) : (_vm.insightHistory.length > 0) ? _c('span', {
    staticClass: "ai-insight-history",
    on: {
      "click": _vm.loadHistory
    }
  }, [_vm._v("Vis historik")]) : _vm._e(), _vm._v(" "), (_vm.isSuperAdmin) ? _c('span', {
    staticClass: "ai-insight-regenerate",
    on: {
      "click": _vm.regenerateInsight
    }
  }, [_c('i', {
    staticClass: "fas fa-sync-alt",
    class: {
      'fa-spin': _vm.insightLoading
    }
  }), _vm._v(" Ny indsigt\n                        ")]) : _vm._e()])]), _vm._v(" "), (_vm.insightLoading && !_vm.insight) ? _c('div', {
    staticClass: "ai-insight-content"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  }), _vm._v(" Genererer indsigt...\n                ")]) : (_vm.insight) ? _c('div', {
    staticClass: "ai-insight-content",
    domProps: {
      "innerHTML": _vm._s(_vm.insight.insight)
    }
  }) : _c('div', {
    staticClass: "ai-insight-content ai-insight-empty"
  }, [_vm._v("\n                    Ingen indsigt tilgængelig endnu.\n                ")]), _vm._v(" "), (_vm.insight) ? _c('div', {
    staticClass: "ai-insight-footer"
  }, [_c('i', {
    staticClass: "fas fa-robot"
  }), _vm._v(" Genereret af AI baseret på jeres data. Indsigten er et forslag og bør altid vurderes i kontekst af jeres virksomhed.\n                ")]) : _vm._e(), _vm._v(" "), (_vm.showHistory && _vm.insightHistory.length > 0) ? _c('div', {
    staticClass: "ai-insight-history-list"
  }, _vm._l((_vm.insightHistory), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "ai-insight-history-item"
    }, [_c('span', {
      staticClass: "ai-insight-history-date"
    }, [_vm._v(_vm._s(_vm._f("moment")(item.generated_at, 'DD/MM/YYYY')))]), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(item.insight)
      }
    })])
  }), 0) : _vm._e()]) : _vm._e(), _vm._v(" "), (!_vm.selectedMenuItem) ? _c('div', {
    staticClass: "flex"
  }, [_c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'economy'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('economy')
      }
    }
  }, [_c('span', [_vm._v("Økonomi")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('economy', 'projects')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.economy.projects.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.totalOpenValue)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('economy', 'aconto')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.economy.aconto.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.economy.aconto.value)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('economy', 'reminders')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.economy.reminders.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.economy.reminders.value)) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'customers'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('customers')
      }
    }
  }, [_c('span', [_vm._v("Kunder")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('customers', 'makingMoney')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.customers.makingMoney.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.customersMakingMoneyRange ? _vm.customersMakingMoneyRange[0] : 0)) + " til " + _vm._s(_vm._f("currency")(_vm.customersMakingMoneyRange ? _vm.customersMakingMoneyRange[1] : 0)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('customers', 'smallAndBig')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.customers.smallAndBig.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.smallAndBigRange[0].coverage_per_hour)) + "\n                            "), _c('span', [_vm._v("Omsætning " + _vm._s(_vm.smallAndBigRange[0].name))])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.smallAndBigRange[1].coverage_per_hour)) + "\n                            "), _c('span', [_vm._v("Omsætning " + _vm._s(_vm.smallAndBigRange[1].name))])])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'projects'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('projects')
      }
    }
  }, [_c('span', [_vm._v("Opgaver")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('projects', 'rightProjects')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.projects.rightProjects.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.projectsRightProjectsRange[0])) + " til\n                            " + _vm._s(_vm._f("currency")(_vm.projectsRightProjectsRange[1])) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('projects', 'mostImportant')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.projects.mostImportantFirst.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectsMostImportantRange[0].name) + "\n                                "), (_vm.projectsMostImportantRange[0].coverage_per_hour_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[0].coverage_per_hour_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[0].coverage_per_hour_change))))])])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [(_vm.projectsMostImportantRange.length > 1) ? _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectsMostImportantRange[1].name) + "\n                                "), (_vm.projectsMostImportantRange[1].coverage_per_hour_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[1].coverage_per_hour_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[1].coverage_per_hour_change))))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('projects', 'mostImportant')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.projects.mostImportantSecond.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectsMostImportantRange[0].name) + "\n                                "), (_vm.projectsMostImportantRange[0].coverage_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[0].coverage_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[0].coverage_change))))])])]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [(_vm.projectsMostImportantRange.length > 1) ? _c('span', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.projectsMostImportantRange[1].name) + "\n                                "), (_vm.projectsMostImportantRange[1].coverage_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[1].coverage_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[1].coverage_change))))])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'employees'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('employees')
      }
    }
  }, [_c('span', [_vm._v("Medarbejdere")])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('employees', 'moreTime')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.employees.moreTime.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.employees.more_time.possible_revenue_increase)) + "\n                            "), _c('span', [_vm._v("Kundetid i dag: " + _vm._s(_vm._f("number")(_vm.data.employees.more_time.percentage_with_customers)) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('employees', 'lessSickness')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.employees.lessSickness.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.employees.less_sickness.possible_revenue_increase)) + "\n                            "), _c('span', [_vm._v("Sygefravær i dag: " + _vm._s(_vm._f("number")(_vm.data.employees.less_sickness.percentage)) + "%")])])]), _vm._v(" "), _c('div', {
    staticClass: "box",
    on: {
      "click": function($event) {
        return _vm.selectBox('employees', 'rightPeople')
      }
    }
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.employees.rightPeople.tekstPOverblik) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "number"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.employeesRightPeoplePossibleRevenue)) + "\n                        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "flex-item"
  }, [_c('div', {
    staticClass: "headline",
    class: {
      'selected': _vm.selectedMenuItem === 'potential'
    },
    on: {
      "click": function($event) {
        return _vm.selectMenuItem('potential')
      }
    }
  }, [_c('span', [_vm._v("Potentiale")])]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "text",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.potential.tekstPOverblik)
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.texts.potential.tekstPOverblik) + "\n                        ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "padding": "15px"
    }
  }, [_c('possible-efforts-economy', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem === 'economy'),
      expression: "selectedMenuItem === 'economy'"
    }],
    attrs: {
      "selectedBox": _vm.selectedBox,
      "data": _vm.data.economy,
      "totalOpenValue": _vm.totalOpenValue,
      "totalAcontoValue": _vm.totalAcontoValue,
      "totalRemindersValue": _vm.totalRemindersValue,
      "texts": _vm.texts.economy
    }
  }), _vm._v(" "), _c('possible-efforts-customers', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem === 'customers'),
      expression: "selectedMenuItem === 'customers'"
    }],
    attrs: {
      "selectedBox": _vm.selectedBox,
      "data": _vm.data.customers,
      "customersMakingMoneyRange": _vm.customersMakingMoneyRange,
      "smallAndBigRange": _vm.smallAndBigRange,
      "texts": _vm.texts.customers
    }
  }), _vm._v(" "), _c('possible-efforts-projects', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem === 'projects'),
      expression: "selectedMenuItem === 'projects'"
    }],
    attrs: {
      "selectedBox": _vm.selectedBox,
      "data": _vm.data.projects,
      "projectsRightProjectsRange": _vm.projectsRightProjectsRange,
      "projectsMostImportantRange": _vm.projectsMostImportantRange,
      "texts": _vm.texts.projects
    }
  }), _vm._v(" "), _c('possible-efforts-employees', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedMenuItem === 'employees'),
      expression: "selectedMenuItem === 'employees'"
    }],
    attrs: {
      "selectedBox": _vm.selectedBox,
      "data": _vm.data.employees,
      "employeesRightPeoplePossibleRevenue": _vm.employeesRightPeoplePossibleRevenue,
      "projects": _vm.data.projects,
      "texts": _vm.texts.employees
    }
  })], 1)]) : _c('box-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fas fa-lightbulb"
  }), _vm._v(" Dagens indsigt")])
}]}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n        " + _vm._s(_vm.data.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                ")]) : (props.column.field == 'total_coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                    "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'customer_name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer_name
          }
        }, [(props.row.customer_name) ? _c('span', [_vm._v("\n                        " + _vm._s(props.row.customer_name) + "\n                    ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees"
  }, [_c('div', {
    staticClass: "toggle-bar"
  }, [_c('span', {
    staticClass: "toggle-option",
    class: {
      active: _vm.showActive
    },
    on: {
      "click": function($event) {
        _vm.showActive = true
      }
    }
  }, [_vm._v("\n            Aktive i " + _vm._s(_vm.providerName) + " (" + _vm._s(_vm.activeEmployees.length) + ")\n        ")]), _vm._v(" "), _c('span', {
    staticClass: "toggle-option",
    class: {
      active: !_vm.showActive
    },
    on: {
      "click": function($event) {
        _vm.showActive = false
      }
    }
  }, [_vm._v("\n            Inaktive i " + _vm._s(_vm.providerName) + " (" + _vm._s(_vm.inactiveEmployees.length) + ")\n        ")])]), _vm._v(" "), _vm._l((_vm.filteredEmployees), function(employee) {
    return _c('div', {
      key: employee.uuid,
      staticClass: "employee"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n            " + _vm._s(employee.full_name) + "\n            "), _c('span', {
      staticClass: "employee-id"
    }, [_vm._v("#" + _vm._s(employee.external_id))])]), _vm._v(" "), _c('div', {
      staticClass: "hours"
    }, [_vm._v("\n            Timer/uge:\n            "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.weekly_hours_working),
        expression: "employee.weekly_hours_working"
      }],
      attrs: {
        "type": "number"
      },
      domProps: {
        "value": (employee.weekly_hours_working)
      },
      on: {
        "keydown": function($event) {
          _vm.showUpdateButton = employee.uuid
        },
        "change": function($event) {
          _vm.showUpdateButton = employee.uuid
        },
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(employee, "weekly_hours_working", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('button', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.showUpdateButton === employee.uuid),
        expression: "showUpdateButton === employee.uuid"
      }],
      on: {
        "click": function($event) {
          return _vm.updateEmployee(employee)
        }
      }
    }, [_vm._v("\n                 \n                Opdater\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "working-responsible"
    }, [_c('div', {
      staticClass: "mb-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.employed_field),
        expression: "employee.employed_field"
      }],
      staticStyle: {
        "transform": "scale(1.2)"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(employee.employed_field) ? _vm._i(employee.employed_field, null) > -1 : (employee.employed_field)
      },
      on: {
        "change": [function($event) {
          var $$a = employee.employed_field,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(employee, "employed_field", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(employee, "employed_field", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(employee, "employed_field", $$c)
          }
        }, function($event) {
          return _vm.updateEmployee(employee)
        }]
      }
    }), _vm._v("\n                Ansættelse aktiv\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "mb-2"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.working_field),
        expression: "employee.working_field"
      }],
      staticStyle: {
        "transform": "scale(1.2)"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(employee.working_field) ? _vm._i(employee.working_field, null) > -1 : (employee.working_field)
      },
      on: {
        "change": [function($event) {
          var $$a = employee.working_field,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(employee, "working_field", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(employee, "working_field", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(employee, "working_field", $$c)
          }
        }, function($event) {
          return _vm.updateEmployee(employee)
        }]
      }
    }), _vm._v("\n                Udfører arbejde hos kunder\n            ")]), _vm._v(" "), _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.responsible_field),
        expression: "employee.responsible_field"
      }],
      staticStyle: {
        "transform": "scale(1.2)"
      },
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(employee.responsible_field) ? _vm._i(employee.responsible_field, null) > -1 : (employee.responsible_field)
      },
      on: {
        "change": [function($event) {
          var $$a = employee.responsible_field,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(employee, "responsible_field", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(employee, "responsible_field", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(employee, "responsible_field", $$c)
          }
        }, function($event) {
          return _vm.updateEmployee(employee)
        }]
      }
    }), _vm._v("\n                Er opgaveansvarlig\n            ")])]), _vm._v(" "), _c('div', {
      staticClass: "working-field-name"
    }, [_c('b', {
      staticStyle: {
        "display": "block",
        "margin-bottom": "4px"
      }
    }, [_vm._v("Medarbejdertype")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.working_field_name),
        expression: "employee.working_field_name"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(employee, "working_field_name", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateEmployee(employee, $event)
        }]
      }
    }, _vm._l((_vm.employeeTypes), function(employeeType) {
      return _c('option', {
        key: employeeType,
        domProps: {
          "value": employeeType
        }
      }, [_vm._v("\n                    " + _vm._s(employeeType) + "\n                ")])
    }), 0)])])
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 843 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.name) + " kr.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.customers,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "v-if": _vm.customers.length
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n            " + _vm._s(_vm.type) + "\n        ")]), _vm._v(" "), _c('vue-good-table', {
    key: _vm.tableKey,
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.description) + "\n                ")]) : (props.column.field == 'proposal_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.proposal_cost)) + "\n                ")]) : (props.column.field == 'expended_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.expended_cost)) + "\n                ")]) : (props.column.field == 'difference') ? _c('div', {
          class: {
            'good': (props.row.proposal_cost - props.row.expended_cost) > 0, 'bad': (props.row.proposal_cost - props.row.expended_cost) < 0
          },
          staticStyle: {
            "text-align": "left"
          }
        }, [((props.row.proposal_cost - props.row.expended_cost) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.proposal_cost - props.row.expended_cost)) + "\n                ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                        Betalt\n                    ")]) : _c('span', [_vm._v("\n                        Ikke betalt\n                    ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.selectedProjectType) ? _c('div', [_c('minuba-budget-single-projects', {
    attrs: {
      "rows": _vm.selectedProjectType.projects,
      "type": _vm.selectedProjectType.name
    }
  })], 1) : _c('div', [_vm._v("\n            Vælg en opgavetype for at se de enkelte opgaver her\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 845 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "general"
  }, [(_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Dækningsgrad (DG)\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.coverage_percent.medium.value - 1) + " %")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_percent.medium.value),
      expression: "settings.coverage_percent.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_medium",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.coverage_percent.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_percent.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.coverage_percent.high.value - 1) + " %")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_percent.high.value),
      expression: "settings.coverage_percent.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_high",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.coverage_percent.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_percent.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - 100 %")]), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Dækningsbidrag (DB) pr. time\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.coverage_per_hour.medium.value - 1) + " kr.")])]), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_per_hour.medium.value),
      expression: "settings.coverage_per_hour.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_per_hour_medium",
      "min": "0",
      "max": "8000",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.settings.coverage_per_hour.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_per_hour.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.coverage_per_hour.high.value - 1) + " kr.")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _vm._m(9)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_vm._v("\n                        + \n                        "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.coverage_per_hour.high.value),
      expression: "settings.coverage_per_hour.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_per_hour_high",
      "min": "0",
      "max": "8000",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "4"
    },
    domProps: {
      "value": (_vm.settings.coverage_per_hour.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.coverage_per_hour.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" kr.")]), _vm._v(" "), _vm._m(10), _vm._v(" "), _vm._m(11)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Registreret tid\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option"
  }, [_c('div', {
    staticClass: "fake-input"
  }, [_c('b', [_vm._v("0 - " + _vm._s(_vm.settings.timelogging.medium.value - 1) + " %")])]), _vm._v(" "), _vm._m(12), _vm._v(" "), _vm._m(13)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.timelogging.medium.value),
      expression: "settings.timelogging.medium.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_medium",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.timelogging.medium.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.timelogging.medium, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - " + _vm._s(_vm.settings.timelogging.high.value - 1) + " %")]), _vm._v(" "), _vm._m(14), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('div', {
    staticClass: "option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.timelogging.high.value),
      expression: "settings.timelogging.high.value"
    }],
    attrs: {
      "type": "number",
      "name": "coverage_percent_high",
      "min": "0",
      "max": "80",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.timelogging.high.value)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings.timelogging.high, "value", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v(" - 100 %")]), _vm._v(" "), _vm._m(16), _vm._v(" "), _vm._m(17)])])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Beregning af medarbejdernes indtjening\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "width": "1.4em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employeeCalc),
      expression: "employeeCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "employee-calculation",
      "value": "responsible"
    },
    domProps: {
      "checked": _vm._q(_vm.employeeCalc, "responsible")
    },
    on: {
      "change": [function($event) {
        _vm.employeeCalc = "responsible"
      }, function($event) {
        return _vm.selectEmployeeCalc('responsible')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Indtjening tilfalder den medarbejder, der har arbejdet mest på opgaven")])]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.main_employee_percent),
      expression: "settings.main_employee_percent"
    }],
    attrs: {
      "type": "number",
      "name": "main_employee_percent",
      "min": "50",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.main_employee_percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "main_employee_percent", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("%")])])]), _vm._v(" "), _c('i', [_vm._v("Bemærk, at en ændring i dette felt først træder ikraft næste dag.")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                Her fastsættes, hvor stor en andel af det samlede antal timer på en opgave, som skal være udført af 1 svend, før indtjeningen tildeles 1 svend. Andelen kan ikke komme under 50%\n                            ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('span', {
    staticStyle: {
      "display": "block",
      "width": "1.4em"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.employeeCalc),
      expression: "employeeCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "employee-calculation",
      "value": "calculation"
    },
    domProps: {
      "checked": _vm._q(_vm.employeeCalc, "calculation")
    },
    on: {
      "change": [function($event) {
        _vm.employeeCalc = "calculation"
      }, function($event) {
        return _vm.selectEmployeeCalc('calculation')
      }]
    }
  })]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "10px"
    }
  }, [_vm._v("Indtjening fordeles ud fra antal timer lagt i en opgave")])]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                                De enkelte opgavers omsætning/omkostning/indtjening fordeles forholdsmæssigt på ALLE medarbejdere, som har arbejdet på opgaven. Hvis f.eks. “Mads” har udført 30% af timerne, tildeles han 30% af indtjeningen.\n                            ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin-top": "15px",
      "font-size": "14px"
    }
  }, [_vm._v("\n                    Bemærk, at ændringerne for begge ovenstående beregninger først træder ikraft næste dag.\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.settings) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Fakturaer med overskredet betaling\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.overdue_days),
      expression: "settings.overdue_days"
    }],
    attrs: {
      "type": "number",
      "name": "overdue_days",
      "min": "0",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.overdue_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "overdue_days", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("dage")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Her fastsættes, hvor mange dage betalingsfristen må være overskredet, før den skal vises på oversigten.\n                        ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "box coverage"
  }, [_c('div', {
    staticClass: "box__title"
  }, [_vm._v("\n                    Opgaver uden bevægelse\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option fw"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.settings.snoozed_days),
      expression: "settings.snoozed_days"
    }],
    attrs: {
      "type": "number",
      "name": "snoozed_days",
      "min": "0",
      "max": "99",
      "step": "1",
      "pattern": "\\d*",
      "maxlength": "2"
    },
    domProps: {
      "value": (_vm.settings.snoozed_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.settings, "snoozed_days", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('b', [_vm._v("dage")]), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Her fastsættes, hvor mange dage der må gå uden registrering af timer eller materialer på en opgave, før den skal vises på oversigten.\n                        ")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button inverse",
    on: {
      "click": function($event) {
        return _vm.doReset()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-history fa-fw"
  }), _vm._v("\n                Gendan standardindstillinger\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.doSave()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-save fa-fw"
  }), _vm._v("\n                Gem\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DG vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            DB pr. time vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er over dette tal\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator bad"
  }), _vm._v("\n                            Utilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color bad"
  }, [_vm._v("rød")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator avg"
  }), _vm._v("\n                            Middel\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color avg"
  }, [_vm._v("gul")]), _vm._v(", hvis den er i dette interval\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "coverage-indicator good"
  }), _vm._v("\n                            Tilfredsstillende\n                        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small"
  }, [_vm._v("\n                            Registreret tid vil være "), _c('span', {
    staticClass: "color good"
  }, [_vm._v("grøn")]), _vm._v(", hvis den er i dette interval\n                        ")])
}]}

/***/ }),
/* 846 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.overdueInvoices"
    }
  }), _vm._v("\n        Fakturaer hvor betalingsfristen er overskredet med " + _vm._s(_vm.$store.state.config.companyMeta.settings.overdue_days) + " dage\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description--long",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number) + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.project && props.row.project.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.project.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.project.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'project.minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 83141174)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-operations"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('openProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openProjects'),
      expression: "selectedItem === 'openProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openProjects', $event)
      }
    }
  }), _vm._v(" "), _c('snoozedProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'snoozedProjects'),
      expression: "selectedItem === 'snoozedProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('snoozedProjects', $event)
      }
    }
  }), _vm._v(" "), _c('noInvoiceProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'noInvoiceProjects'),
      expression: "selectedItem === 'noInvoiceProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('noInvoiceProjects', $event)
      }
    }
  }), _vm._v(" "), _c('ongoingProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'ongoingProjects'),
      expression: "selectedItem === 'ongoingProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('ongoingProjects', $event)
      }
    }
  }), _vm._v(" "), _c('claimsProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openClaims'),
      expression: "selectedItem === 'openClaims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openClaims', $event)
      }
    }
  }), _vm._v(" "), _c('coming-soon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectsCloseToBudget'),
      expression: "selectedItem === 'projectsCloseToBudget'"
    }]
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rows.length) ? _c('div', {
    staticClass: "value-wrapper"
  }, [_c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                Værdi, salgspris i alt\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.totalValueWithCP)) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "oekonomi.unbilledProjects",
      "placement": "left"
    }
  }), _vm._v("\n            Afsluttede opgaver, der ikke er fakturerede\n        ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.case_number) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description ? props.row.description : '-'
          }
        }, [_vm._v(_vm._s(props.row.description ? props.row.description : '-'))])], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [(props.row.invoices_total > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(props.row.invoices_total)))]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'total_expenses') ? _c('div', [(props.row.total_expenses > 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                        ")]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'value') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.value)) + "\n                    ")], 1) : (props.column.field == 'value_with_avg_cp') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "valueBasedWithCP": true,
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.value_with_avg_cp)) + "\n                    ")], 1) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 517486020)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 849 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-type-revenue"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-9': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerTypeRevenue"
    }
  }), _vm._v("\n                    Hvilke kundetyper tjener vi penge på?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectCustomerType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : ''
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '') + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'timelog_hours_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.timelog_hours_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3856016748)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en kundetype for at se en liste over alle opgaver med den type\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('customer-type-revenue-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 850 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.offerProjects"
    }
  }), _vm._v("\n        Tilbud\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2850899247)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 851 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-learning"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeRevenue'),
      expression: "selectedItem === 'projectTypeRevenue'"
    }],
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-9': !_vm.selectedProjectType, 'col-lg-3': _vm.selectedProjectType
    }
  }, [_c('projectTypeRevenue-table', {
    attrs: {
      "title": "Hvilke opgavetyper tjenes der penge på?"
    },
    on: {
      "selectProjectType": function($event) {
        return _vm.setSelectedProjectType($event)
      },
      "finishedLoading": function($event) {
        return _vm.updateCount('projectTypeRevenue', $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.selectedProjectType) ? _c('div', {
    staticClass: "col-lg-9"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedProjectType = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])]), _vm._v(" "), _c('showTypeRevenue-table', {
    attrs: {
      "rows": _vm.$store.getters.groupedProjects[_vm.selectedProjectType],
      "title": "Konkrete opgaver"
    }
  })], 1) : _c('div', {
    staticClass: "col-lg-3"
  }, [_vm._v("\n                Vælg en opgavetype for at se en liste over alle opgaver og deres konkrete indtjening.\n            ")])]), _vm._v(" "), _c('closedProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'closedProjectsRevenue'),
      expression: "selectedItem === 'closedProjectsRevenue'"
    }],
    attrs: {
      "title": "Hvilke konkrete opgaver tjenes der penge på?"
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('closedProjectsRevenue', $event)
      }
    }
  }), _vm._v(" "), _c('project-type-skills', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeSkills'),
      expression: "selectedItem === 'projectTypeSkills'"
    }]
  }), _vm._v(" "), _c('project-type-development', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeDevelopment'),
      expression: "selectedItem === 'projectTypeDevelopment'"
    }]
  }), _vm._v(" "), _c('project-type-coverage-per-hour-development', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'coveragePerHourPerProjectTypeDevelopment'),
      expression: "selectedItem === 'coveragePerHourPerProjectTypeDevelopment'"
    }]
  }), _vm._v(" "), _c('project-type-graphs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectTypeGraphs'),
      expression: "selectedItem === 'projectTypeGraphs'"
    }]
  }), _vm._v(" "), _c('claims-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'claims'),
      expression: "selectedItem === 'claims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('claims', $event)
      }
    }
  }), _vm._v(" "), _c('minuba-budget-report', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'minubaBudgetReport'),
      expression: "selectedItem === 'minubaBudgetReport'"
    }]
  }), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'closedProjectsRevenue'),
      expression: "selectedItem === 'closedProjectsRevenue'"
    }]
  })])], 1)])
},staticRenderFns: []}

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n        " + _vm._s(_vm.title) + "\n    ")]), _vm._v(" "), (_vm.rows) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'timelog_hours') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 4087060905)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('layout')], 1)
},staticRenderFns: []}

/***/ }),
/* 854 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n        Fakturaer hvor betalingsfristen er overskredet med " + _vm._s(_vm.$store.state.config.companyMeta.settings.overdue_days) + " dage\n        (" + _vm._s(_vm.employeeName) + ")\n    ")]), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number ? props.row.invoice_number : '-') + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                    Betalt\n                ")]) : _c('span', [_vm._v("\n                    Ikke betalt\n                ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2812794680)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 855 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-types-potential"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Potentielt ekstra årligt EBITDA pr. opgavetype\n            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "potential.projectTypePotential"
    }
  })], 1), _vm._v(" "), (_vm.projectTypes && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "intro"
  }, [_vm._v("\n                Her ser du, hvad det giver i øget årligt EBITDA, at øge prisen med få procent.\n            ")]), _vm._v(" "), (_vm.projectTypes.length > 0) ? _c('div', {
    staticClass: "list"
  }, [_vm._l((_vm.projectTypes), function(projectType) {
    return _c('div', {
      key: projectType.name,
      staticClass: "single"
    }, [_c('div', {
      staticClass: "info"
    }, [_c('strong', [_vm._v("\n                            " + _vm._s(projectType.name) + "\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "small"
    }, [_c('b', [_vm._v(_vm._s(projectType.projects_count))]), _vm._v("\n                            opgaver m. samlet omsætning på\n                            "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(projectType.total_revenue)))]), _vm._v(" "), _c('br'), _vm._v("\n                            Gns. DG pr. opgave: "), _c('b', [_vm._v(_vm._s(_vm._f("coveragePercent")(projectType.coverage_percent)) + "%")])])]), _vm._v(" "), _c('div', {
      staticClass: "slider"
    }, [(projectType.total_revenue > 0) ? _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (projectType.value),
        expression: "projectType.value"
      }],
      attrs: {
        "type": "range",
        "min": -100,
        "max": 100
      },
      domProps: {
        "value": (projectType.value)
      },
      on: {
        "__r": function($event) {
          return _vm.$set(projectType, "value", $event.target.value)
        }
      }
    }), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "slider-value"
    }, [_c('div', {
      staticClass: "small",
      staticStyle: {
        "display": "flex",
        "justify-content": "space-between"
      }
    }, [_c('div', [_vm._v("\n                                        Meromsætning\n                                    ")]), _vm._v(" "), _c('div', [(projectType.value > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(projectType.value) + " %\n                                    ")])])])]) : _c('div', {
      staticClass: "small",
      attrs: {
        "align": "center"
      }
    }, [_vm._v("\n                            Ingen data for perioden\n                        ")])]), _vm._v(" "), _c('div', {
      staticClass: "result",
      class: {
        'positive': (projectType.total_revenue / 100) * projectType.value > 0, 'negative': (projectType.total_revenue / 100) * projectType.value < 0
      }
    }, [(projectType.total_revenue > 0 && projectType.value !== 0 && projectType.value !== '0') ? _c('div', [(projectType.value > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(((projectType.total_revenue / 100) * projectType.value * _vm.convertToYear))) + "\n                        ")]) : _c('div', [_vm._v("\n                            -\n                        ")])])])
  }), _vm._v(" "), _c('div', {
    staticClass: "single"
  }, [_c('div', {
    staticClass: "info big"
  }, [_vm._v("\n                        Potentielt ekstra årligt EBITDA\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "slider"
  }), _vm._v(" "), _c('div', {
    staticClass: "result big",
    class: {
      'positive': _vm.total > 0, 'negative': _vm.total < 0
    }
  }, [(_vm.total > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.total)) + "\n                    ")])])], 2) : _vm._e()]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "graph-card"
  }, [_c('div', {
    staticClass: "graph-header"
  }, [_c('div', {
    staticClass: "table-heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeWithCustomers"
    }
  }), _vm._v("\n            " + _vm._s(_vm.heading) + "\n            "), _vm._t("default")], 2)]), _vm._v(" "), (!_vm.loading) ? _c('vue-apex-charts', {
    staticClass: "graph-data-box",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.getSeries
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "465"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-project-types"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "enterprise.mainProjectType"
    }
  }), _vm._v("\n                    Hvilke entreprisetyper tjenes der penge på?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectMainProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 2007174650)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en entreprisetype for at se en liste over alle under-entreprisetyper til denne entreprisetype\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null;
        _vm.selectedSubProjectType = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('main-project-type-single', {
    attrs: {
      "data": _vm.selectedRow
    },
    on: {
      "showSubProjects": function($event) {
        return _vm.setSubProjects($event)
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), (!_vm.selectedSubProjectType) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_vm._v("\n            Vælg en entrepriseopgave for at se alle underopgaverne her\n        ")]) : _vm._e(), _vm._v(" "), (_vm.selectedSubProjectType) ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('sub-projects', {
    attrs: {
      "data": _vm.selectedSubProjectType
    }
  })], 1) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 858 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-invoices_total"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-9': !_vm.selectedBracket, 'col-lg-3': _vm.selectedBracket
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerGroups"
    }
  }), _vm._v("\n                    Hvordan er kunderne fordelt på omsætning?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading && _vm.rows.length > 0) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.handleRowClick
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'bracket') ? _c('div', [_vm._v("\n                                " + _vm._s(props.row.bracket) + " kr.\n                            ")]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3838996434)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.selectedBracket, 'col-lg-9': _vm.selectedBracket
    }
  }, [(!_vm.selectedBracket) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg et interval for at se en liste over alle kunder i intervallet.\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedBracket) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedBracket = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedBracket) ? _c('customer-grouped-single', {
    attrs: {
      "customers": _vm.groupedCustomers[_vm.selectedBracket],
      "name": _vm.selectedBracket
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Opgaver uden budget (" + _vm._s(_vm.rows ? _vm.rows.length : '-') + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "searchOptions": _vm.searchOptions,
      "paginationOptions": _vm.paginationOptions,
      "sortOptions": _vm.sortOptions,
      "styleClass": "vgt-table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1701807419)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-potential"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('costprice-per-hour')], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('costs-division')], 1)])])
},staticRenderFns: []}

/***/ }),
/* 861 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calculator fa-fw"
  }), _vm._v(" "), (_vm.closed) ? _c('span', [_c('div', {
    staticClass: "coverage-indicator",
    class: {
      'bad': _vm.project.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(_vm.project.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(_vm.project.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
    }
  })]) : _vm._e()]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [(_vm.minubaBudget && !_vm.loading) ? _c('div', [_c('table', {
    staticStyle: {
      "white-space": "nowrap",
      "margin": "0 -10px",
      "font-size": "12px"
    },
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Tilbud")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Ordre")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Realiseret til dato")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "3px 10px 3px 20px",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Difference")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Omsætning")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price)))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.invoices_total)))]), _vm._v(" "), _c('td', {
    class: {
      'bad': (_vm.project.minuba_price - _vm.project.invoices_total) < 0
    },
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price - _vm.project.invoices_total)))])]), _vm._v(" "), _vm._l((_vm.filteredBudgetLines), function(budgetLine, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticStyle: {
        "padding": "3px 10px"
      },
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(budgetLine.type))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px 10px"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(budgetLine.proposal_cost)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px 10px"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(budgetLine.order_cost)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding": "3px 10px"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(budgetLine.expended_cost)))]), _vm._v(" "), _c('td', {
      class: {
        'bad': (budgetLine.order_cost - budgetLine.expended_cost) < 0
      },
      staticStyle: {
        "padding": "3px 10px",
        "font-style": "italic"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(budgetLine.order_cost - budgetLine.expended_cost)))])])
  }), _vm._v(" "), (_vm.notBudgetted() > 0) ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Ikke budgetteret")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.notBudgetted())))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.notBudgetted())))])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "height": "0",
      "padding": "0",
      "margin": "0"
    },
    attrs: {
      "colspan": "8"
    }
  }, [_vm._v(" ")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Omkostning")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.minubaBudget.budget_lines, 'proposal_cost'))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.minubaBudget.budget_lines, 'order_cost'))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())))]), _vm._v(" "), _c('td', {
    class: {
      'bad': (_vm.sum(_vm.minubaBudget.budget_lines, 'order_cost') - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())) < 0
    },
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.minubaBudget.budget_lines, 'order_cost') - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted()))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Dækningsbidrag")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'proposal_cost'))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost'))))]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted()))))]), _vm._v(" "), _c('td', {
    class: {
      'bad': ((_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())) - (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost'))) < 0
    },
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")((_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())) - (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost')))))])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Dækningsgrad")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.ccp(_vm.project.minuba_price, (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'proposal_cost')))) + " %")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm.ccp(_vm.project.minuba_price, (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost')))) + " %")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.closed) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.ccp(_vm.project.invoices_total, (_vm.project.minuba_price - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())))) + " %\n                                ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "3px 10px",
      "font-weight": "600",
      "border-top": "1px solid #172b43",
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.closed) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm.ccp(_vm.project.invoices_total, (_vm.project.minuba_price - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted()))) - _vm.ccp(_vm.project.minuba_price, (_vm.project.minuba_price - _vm.sum(_vm.minubaBudget.budget_lines, 'order_cost')))) + " %\n                                ")]) : _c('span', [_vm._v("-")])])])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-around",
      "text-align": "center"
    }
  }, [(!_vm.closed) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-weight": "600"
    }
  }, [(_vm.closed) ? _c('span', [_vm._v("\n                                Lønsomhed: " + _vm._s(_vm._f("currency")(_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted()))) + "\n                            ")]) : _c('span', [_vm._v("\n                                Færdiggørelsesgrad: " + _vm._s(Math.round(_vm.project.completion_rate)) + " %\n                            ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [(_vm.closed) ? _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "height": "16px",
      "width": "100px",
      "background": "#ddd",
      "border-radius": "100px",
      "overflow": "hidden",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    }
  }, [((_vm.project.invoices_total - (_vm.sum(_vm.minubaBudget.budget_lines, 'expended_cost') + _vm.notBudgetted())) > 0) ? _c('div', {
    staticStyle: {
      "height": "16px",
      "background": "#4CAF50"
    }
  }) : _c('div', {
    staticStyle: {
      "height": "16px",
      "background": "#FF5252"
    }
  })]) : _c('div', {
    staticStyle: {
      "display": "inline-block",
      "position": "relative",
      "height": "16px",
      "width": "100px",
      "background": "#ddd",
      "border-radius": "100px",
      "overflow": "hidden",
      "box-shadow": "0px 5px 15px rgba(0,0,0,0.15)"
    }
  }, [_c('div', {
    style: (("height:16px;background:" + (_vm.project.completion_rate > 99 ? '#FF5252' : _vm.project.completion_rate > 80 ? '#FFA000' : '#4CAF50') + ";width:" + (Math.ceil((100 / 100) * _vm.project.completion_rate)) + "px;max-width:100px;"))
  }, [_vm._v(" ")])])]), _vm._v(" "), (!_vm.closed) ? _c('div', {
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('span', {
    staticStyle: {
      "font-size": "10px",
      "font-weight": "normal"
    }
  }, [_vm._v("Realiserede ift. budgetterede omkostninger")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.closed) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-top": "20px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                            DB pr. time\n                        ")]), _vm._v(" "), _c('div', [(_vm.project.coverage_per_hour !== null) ? _c('div', {
    staticClass: "coverage-indicator",
    class: {
      'bad': _vm.project.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(_vm.project.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(_vm.project.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
    }
  }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.project.coverage_per_hour)) + " \n                        ")])]) : _vm._e()])]) : _c('div', [(_vm.loading) ? _c('div', [_vm._v("\n                    Indlæser ...\n                ")]) : _c('div', [_vm._v("\n                    Hov, vi kunne ikke hente budgettet.\n                ")])])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 862 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-revenue"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Omsætning\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 863 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.closedProjects"
    }
  }), _vm._v("\n        " + _vm._s(_vm.title) + "\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-column",
      fn: function(props) {
        return [(props.column.field == 'case_number') ? _c('span', [_vm._v("\n                " + _vm._s(props.column.label) + "\n                "), _c('d-tooltip', {
          attrs: {
            "placement": "inline",
            "identifier": "projects.closed.budget"
          }
        })], 1) : _c('span', [_vm._v("\n                " + _vm._s(props.column.label) + "\n            ")])]
      }
    }, {
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left",
            "white-space": "nowrap"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n                "), (props.row.minuba_price && props.row.minuba_budget_id) ? _c('minuba-budget-tooltip', {
          attrs: {
            "closed": true,
            "project": props.row
          }
        }) : _vm._e()], 1) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'timelog_hours') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 204464668)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 864 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-followup-hours"
  }, [(_vm.data) ? _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "budgetfollowup.hours.graph",
      "placement": "left"
    }
  }), _vm._v("\n                        Solgte timer fordelt pr. måned\n                    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(_vm.data && _vm.hoursGraphSeries.length > 0) ? _c('vue-apex-charts', {
    attrs: {
      "height": 300,
      "series": _vm.hoursGraphSeries,
      "options": _vm.hoursGraphOptions,
      "type": "bar"
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "budgetfollowup.hours.yeartodate",
      "placement": "left"
    }
  }), _vm._v("\n                        Budgetåret til dato\n                    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Faktisk")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.data.hours.year_to_date.actual)) + " timer")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Budget")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.data.hours.year_to_date.budget)) + " timer")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Difference")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'color-good': _vm.data.hours.year_to_date.diff > 0, 'color-bad': _vm.data.hours.year_to_date.diff < 0
    }
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.data.hours.year_to_date.diff)) + " timer")])])])])])])]) : _c('div', [_c('box-loading')], 1)])
},staticRenderFns: []}

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-skills-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.full_name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name ? props.row.name : '-') + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 820092425)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.selectedRow) ? _c('employee-skills-single-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _c('div', [_vm._v("\n        Vælg en opgavetype for at se de enkelte opgaver her\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 866 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "btn-group"
  }, [(_vm.selectedOption.name !== undefined) ? _c('li', {
    staticClass: "dropdown-toggle",
    on: {
      "click": function($event) {
        return _vm.toggleMenu()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.selectedOption.name) + "\n      "), _c('span', {
    staticClass: "caret"
  })]) : _vm._e(), _vm._v(" "), (_vm.selectedOption.name === undefined) ? _c('li', {
    staticClass: "dropdown-toggle dropdown-toggle-placeholder",
    on: {
      "click": function($event) {
        return _vm.toggleMenu()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.placeholderText) + "\n      "), _c('span', {
    staticClass: "caret"
  })]) : _vm._e(), _vm._v(" "), (_vm.showMenu) ? _c('ul', {
    staticClass: "dropdown-menu"
  }, _vm._l((_vm.options), function(option, idx) {
    return _c('li', {
      key: idx
    }, [_c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          return _vm.updateOption(option)
        }
      }
    }, [_vm._v("\n                " + _vm._s(option.name) + "\n            ")])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 867 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-chain"
  }, [(_vm.loading && !_vm.data) ? _c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "chain__title"
  }, [_vm._v("\n            Værdikæde\n            "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "display": "inline-block"
    }
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.valuechain"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('box-loading')], 1)]) : _vm._e(), _vm._v(" "), (_vm.data) ? _c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "chain__title"
  }, [_vm._v("\n            Værdikæde\n            "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "display": "inline-block"
    }
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": "index.valuechain"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-file-alt fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.offer.count) + "\n                    ")]), _vm._v("\n                    tilbud, der afventer afgørelse\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentielt DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentiel omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.offer.count > 0 ? ((_vm.data.offer.has_budget / _vm.data.offer.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.offer.has_budget) + " / " + _vm._s(_vm.data.offer.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-inbox-in fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.open.count) + "\n                    ")]), _vm._v("\n                    opgaver, der ikke er påbegyndt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.open.count > 0 ? ((_vm.data.open.has_budget / _vm.data.open.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.open.has_budget) + " / " + _vm._s(_vm.data.open.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-clock fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.ongoing.count) + "\n                    ")]), _vm._v("\n                    igangværende opgaver,\n                    "), _c('br'), _vm._v("\n                    der arbejdes på\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Værdi, salgspris")]), _vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.data.ongoing.value_with_avg_cp)) + "\n                    ")])]), _vm._v(" "), _vm._m(0), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.ongoing.count > 0 ? ((_vm.data.ongoing.has_budget / _vm.data.ongoing.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.ongoing.has_budget) + " / " + _vm._s(_vm.data.ongoing.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-check-circle fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unbilled.count) + "\n                    ")]), _vm._v("\n                    afsluttede opgaver,\n                    "), _c('br'), _vm._v("\n                    der ikke er fakturerede\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Værdi, salgspris")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unbilled.value_with_avg_cp)) + "\n                ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.unbilled.count > 0 ? ((_vm.data.unbilled.has_budget / _vm.data.unbilled.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.unbilled.has_budget) + " / " + _vm._s(_vm.data.unbilled.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-envelope-open-dollar fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unpaid_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer, der endnu ikke er betalt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_revenue)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-calendar-exclamation fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.overdue_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer med overskredet betaling\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_revenue)) + "\n                ")])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revenue",
    staticStyle: {
      "opacity": "0"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Placeholder")]), _vm._v("\n                    Placeholder\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revenue",
    staticStyle: {
      "opacity": "0"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Placeholder")]), _vm._v("\n                    Placeholder\n                ")])
}]}

/***/ }),
/* 868 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "possible-efforts-sub-menu"
  }, [_c('div', {
    staticClass: "switcher"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'rightProjects'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'rightProjects'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.rightProjects.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'mostImportant'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'mostImportant'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.mostImportantFirst.boksTekst))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'rightProjects'),
      expression: "selectedItem === 'rightProjects'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.rightProjects.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.projectsRightProjectsRange[0])) + " til " + _vm._s(_vm._f("currency")(_vm.projectsRightProjectsRange[1])) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.rightProjects.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.rightProjects.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "customers.customerRevenue"
    }
  }), _vm._v("\n                    Arbejdes der med de rigtige opgaver?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.rightProjectsColumns,
      "rows": _vm.data.right_projects.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'timelog_hours_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.timelog_hours_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('ProjectsLearning', 'projectTypeRevenue')
      }
    }
  }, [_vm._v("\n                Gå til alle opgavetyper →\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'mostImportant'),
      expression: "selectedItem === 'mostImportant'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.mostImportantFirst.tykTekst1) + "\n            "), _c('table', [_vm._m(0), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px",
      "font-weight": "normal"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.projectsMostImportantRange[0].name) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.projectsMostImportantRange[0].coverage_per_hour_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[0].coverage_per_hour_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[0].coverage_per_hour_change))))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.projectsMostImportantRange[0].coverage_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green",
      "margin-left": "10px"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[0].coverage_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red",
      "margin-left": "10px"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[0].coverage_change))))])])]), _vm._v(" "), (_vm.projectsMostImportantRange.lenght > 1) ? _c('tr', [_c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px",
      "font-weight": "normal"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.projectsMostImportantRange[1].name) + "\n                        ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.projectsMostImportantRange[1].coverage_per_hour_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[1].coverage_per_hour_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[1].coverage_per_hour_change))))])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.projectsMostImportantRange[1].coverage_change > 0) ? _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "green",
      "margin-left": "10px"
    }
  }, [_vm._v("↑ " + _vm._s(_vm._f("currency")(_vm.projectsMostImportantRange[1].coverage_change)))]) : _c('p', {
    staticStyle: {
      "display": "inline-block",
      "color": "red",
      "margin-left": "10px"
    }
  }, [_vm._v("↓ " + _vm._s(_vm._f("currency")(Math.abs(_vm.projectsMostImportantRange[1].coverage_change))))])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.mostImportantFirst.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.mostImportantFirst.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Udviklingen i DB / DB pr. time\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.mostImportantColumns,
      "rows": _vm.data.most_important.table.values,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.mostImportantSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage.progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.coverage_progress_percent === 0 || props.row.coverage_progress_percent > -5 && props.row.coverage_progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_per_hour.progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage_per_hour.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.coverage_per_hour_progress_percent === 0 || props.row.coverage_per_hour_progress_percent > -5 && props.row.coverage_per_hour_progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'coverage_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.coverage_per_hour_total) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour_total < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour_total) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour_total) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.coverage_per_hour_total)) + " \n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('ProjectsLearning', 'projectTypeGraphs')
      }
    }
  }, [_vm._v("\n                Gå til udviklingen i DB / DB pr. time →\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Opgavetype")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("DB pr. time")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "padding": "10px 10px 0 10px"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Samlet DB")])])])
}]}

/***/ }),
/* 869 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(!_vm.loading) ? _c('div', {
    staticClass: "budget"
  }, [_vm._v("\n        Tryk udenfor input-feltet, når du har indtastet et beløb, for at gemme budgettet.\n        "), _c('br'), _c('br'), _vm._v("\n        Scroll til højre på skærmen for at se alle månederne.\n        "), _c('br'), _c('br'), _vm._v(" "), _vm._l((_vm.accountCategories), function(accountCategory) {
    return (_vm.accountCategories.length > 0) ? _c('div', {
      key: accountCategory.slug,
      staticClass: "placeholder padding",
      staticStyle: {
        "overflow-x": "scroll",
        "margin-bottom": "15px"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v("\n                " + _vm._s(accountCategory.name) + "\n            ")]), _vm._v(" "), (accountCategory.accounts.length > 0) ? _c('table', [_vm._m(0, true), _vm._v(" "), _c('tbody', [_vm._l((accountCategory.accounts), function(account) {
      return _c('tr', {
        key: account.uuid
      }, [_c('td', [_vm._v(_vm._s(account.account_number))]), _vm._v(" "), _c('td', {
        staticClass: "name"
      }, [_vm._v(_vm._s(account.name))]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.january),
          expression: "account.budgets.january"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.january)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'january', account.budgets.january)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "january", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.february),
          expression: "account.budgets.february"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.february)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'february', account.budgets.february)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "february", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.march),
          expression: "account.budgets.march"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.march)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'march', account.budgets.march)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "march", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.april),
          expression: "account.budgets.april"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.april)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'april', account.budgets.april)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "april", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.may),
          expression: "account.budgets.may"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.may)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'may', account.budgets.may)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "may", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.june),
          expression: "account.budgets.june"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.june)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'june', account.budgets.june)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "june", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.july),
          expression: "account.budgets.july"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.july)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'july', account.budgets.july)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "july", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.august),
          expression: "account.budgets.august"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.august)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'august', account.budgets.august)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "august", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.september),
          expression: "account.budgets.september"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.september)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'september', account.budgets.september)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "september", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.october),
          expression: "account.budgets.october"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.october)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'october', account.budgets.october)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "october", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.november),
          expression: "account.budgets.november"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.november)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'november', account.budgets.november)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "november", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', [_c('input', {
        directives: [{
          name: "model",
          rawName: "v-model",
          value: (account.budgets.december),
          expression: "account.budgets.december"
        }],
        attrs: {
          "type": "text"
        },
        domProps: {
          "value": (account.budgets.december)
        },
        on: {
          "blur": function($event) {
            return _vm.updateValue(account.uuid, 'december', account.budgets.december)
          },
          "input": function($event) {
            if ($event.target.composing) { return; }
            _vm.$set(account.budgets, "december", $event.target.value)
          }
        }
      })]), _vm._v(" "), _c('td', {
        staticClass: "totals"
      }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(Number(account.budgets.january) + Number(account.budgets.february) + Number(account.budgets.march) + Number(account.budgets.april) + Number(account.budgets.may) + Number(account.budgets.june) + Number(account.budgets.july) + Number(account.budgets.august) + Number(account.budgets.september) + Number(account.budgets.october) + Number(account.budgets.november) + Number(account.budgets.december))) + "\n                        ")])])
    }), _vm._v(" "), _c('tr', {
      staticClass: "totals"
    }, [_c('td'), _vm._v(" "), _c('td', {
      staticClass: "name"
    }, [_vm._v("Total")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.january))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.february))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.march))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.april))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.may))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.june))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.july))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.august))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.september))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.october))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.november))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = Number(_vm.count + Number(account.budgets.december))
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")]), _vm._v(" "), _c('td', [_vm._v("\n                            " + _vm._s(_vm.count = null) + "\n                            " + _vm._s(accountCategory.accounts.forEach(function (account) {
      _vm.count = _vm.count + Number(account.budgets.january) + Number(account.budgets.february) + Number(account.budgets.march) + Number(account.budgets.april) + Number(account.budgets.may) + Number(account.budgets.june) + Number(account.budgets.july) + Number(account.budgets.august) + Number(account.budgets.september) + Number(account.budgets.october) + Number(account.budgets.november) + Number(account.budgets.december)
    })) + "\n                            " + _vm._s(_vm._f("currency")(_vm.count)) + "\n                        ")])])], 2)]) : _c('div', [_vm._v("\n                Ingen konti i denne kategori\n            ")])]) : _vm._e()
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("#")]), _vm._v(" "), _c('th', {
    staticClass: "name"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', [_vm._v("Jan")]), _vm._v(" "), _c('th', [_vm._v("Feb")]), _vm._v(" "), _c('th', [_vm._v("Mar")]), _vm._v(" "), _c('th', [_vm._v("Apr")]), _vm._v(" "), _c('th', [_vm._v("Maj")]), _vm._v(" "), _c('th', [_vm._v("Jun")]), _vm._v(" "), _c('th', [_vm._v("Jul")]), _vm._v(" "), _c('th', [_vm._v("Aug")]), _vm._v(" "), _c('th', [_vm._v("Sep")]), _vm._v(" "), _c('th', [_vm._v("Okt")]), _vm._v(" "), _c('th', [_vm._v("Nov")]), _vm._v(" "), _c('th', [_vm._v("Dec")]), _vm._v(" "), _c('th', {
    staticClass: "totals"
  }, [_vm._v("Total")])])])
}]}

/***/ }),
/* 870 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects-operations"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('offerProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'offerProjects'),
      expression: "selectedItem === 'offerProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('offerProjects', $event)
      }
    }
  }), _vm._v(" "), _c('openProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openProjects'),
      expression: "selectedItem === 'openProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openProjects', $event)
      }
    }
  }), _vm._v(" "), _c('snoozedProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'snoozedProjects'),
      expression: "selectedItem === 'snoozedProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('snoozedProjects', $event)
      }
    }
  }), _vm._v(" "), _c('noInvoiceProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'noInvoiceProjects'),
      expression: "selectedItem === 'noInvoiceProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('noInvoiceProjects', $event)
      }
    }
  }), _vm._v(" "), _c('ongoingProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'ongoingProjects'),
      expression: "selectedItem === 'ongoingProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('ongoingProjects', $event)
      }
    }
  }), _vm._v(" "), _c('claimsProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'openClaims'),
      expression: "selectedItem === 'openClaims'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('openClaims', $event)
      }
    }
  }), _vm._v(" "), _c('coming-soon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projectsCloseToBudget'),
      expression: "selectedItem === 'projectsCloseToBudget'"
    }]
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-revenue"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-3': _vm.selectedRow, 'col-lg-9': !_vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.employeeRevenue"
    }
  }), _vm._v("\n                    Hvordan er medarbejdernes indtjening?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_projects') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.total_projects) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 4054174486)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en medarbejder for at se de enkelte opgavetyper og opgaver her\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null;
        _vm.selectedProjectType = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('employee-revenue-project-types', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "possible-efforts-sub-menu"
  }, [_c('div', {
    staticClass: "switcher"
  }, [_c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'projects'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'projects'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.projects.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'aconto'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'aconto'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.aconto.boksTekst))])]), _vm._v(" "), _c('div', {
    staticClass: "item",
    class: {
      'selected': _vm.selectedItem === 'reminders'
    },
    on: {
      "click": function($event) {
        _vm.selectedItem = 'reminders'
      }
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.texts.reminders.boksTekst))])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'projects'),
      expression: "selectedItem === 'projects'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.projects.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.data.projects.value)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.projects.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.projects.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.openProjects"
    }
  }), _vm._v("\n                Ikke igangsatte opgaver\n            ")], 1), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.openColumns,
      "rows": _vm.data.projects.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.openSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.case_number) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                        " + _vm._s(props.row.description ? props.row.description : '-') + "\n                    ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                    ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : (props.column.field == 'expected_coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.expected_coverage)) + "\n                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('ProjectsOperations', 'openProjects')
      }
    }
  }, [_vm._v("\n                Gå til alle opgaver, der ikke er sat i gang →\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'aconto'),
      expression: "selectedItem === 'aconto'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.aconto.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.data.aconto.value)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.aconto.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.aconto.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.ongoingProjects"
    }
  }), _vm._v("\n                Igangværende opgaver\n            ")], 1), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.acontoColumns,
      "rows": _vm.data.aconto.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.acontoSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.case_number) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description ? props.row.description : '-'
          }
        }, [_vm._v(_vm._s(props.row.description ? props.row.description : '-'))])], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [(props.row.invoices_total > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(props.row.invoices_total)))]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'total_expenses') ? _c('div', [(props.row.total_expenses > 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                        ")]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'value') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.value)) + "\n                    ")], 1) : (props.column.field == 'value_with_avg_cp') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "valueBasedWithCP": true,
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.value_with_avg_cp)) + "\n                    ")], 1) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('ProjectsOperations', 'ongoingProjects')
      }
    }
  }, [_vm._v("\n                Gå til alle igangværende opgaver →\n            ")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'reminders'),
      expression: "selectedItem === 'reminders'"
    }]
  }, [_c('div', {
    staticClass: "lg"
  }, [_vm._v("\n            " + _vm._s(_vm.texts.reminders.tykTekst1) + "\n            " + _vm._s(_vm._f("currency")(_vm.data.reminders.value)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "sub",
    domProps: {
      "innerHTML": _vm._s(_vm.texts.reminders.tyndTekst1)
    }
  }, [_vm._v("\n            " + _vm._s(_vm.texts.reminders.tyndTekst1) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper",
    staticStyle: {
      "margin-top": "15px"
    }
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "oekonomi.unpaidInvoices",
      "placement": "left"
    }
  }), _vm._v("\n                Fakturaer, der ikke er betalt\n            ")], 1), _vm._v(" "), _c('vue-good-table', {
    attrs: {
      "columns": _vm.unpaidInvoicesColumns,
      "rows": _vm.data.reminders.table,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.unpaidInvoicesSortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.invoice_number ? props.row.invoice_number : '-') + "\n                    ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                        " + _vm._s(props.row.external_id) + "\n                    ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n                    ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                            Betalt\n                        ")]) : _c('span', [_vm._v("\n                            Ikke betalt\n                        ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "foot"
  }, [_c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.goToRoute('EconomyOperations', 'unpaidInvoices')
      }
    }
  }, [_vm._v("\n                Gå til alle fakturaer, der ikke er betalt →\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-skills"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-3': _vm.selectedRow, 'col-lg-9': !_vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.projectTypeSkills"
    }
  }), _vm._v("\n                    Hvilke svende er gode til hvilke opgaver?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectEmployee
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_projects') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.total_projects) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'timelog_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 208773978)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-9': _vm.selectedRow, 'col-lg-3': !_vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en opgavetype for at se hvilke medarbejdere, der er gode til denne\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null;
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('project-type-skills-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 874 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Opret ny bruger\n    ")]), _vm._v(" "), _c('form', {
    staticClass: "create-user",
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "name": "hidden",
      "type": "text",
      "autocomplete": "off"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('label', [_vm._v("Navn *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.name),
      expression: "newUser.name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "Navn"
    },
    domProps: {
      "value": (_vm.newUser.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-3': _vm.newUser.role_id === 4, 'col-lg-6': _vm.newUser.role_id !== 4
    }
  }, [_c('div', {
    staticClass: "role"
  }, [_c('label', [_vm._v("Brugerrolle *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.role_id),
      expression: "newUser.role_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": 2
    }
  }, [_vm._v("Administrator")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": 3
    }
  }, [_vm._v("Bruger")]), _vm._v(" "), (_vm.availableDepartments.length > 0) ? _c('option', {
    domProps: {
      "value": 4
    }
  }, [_vm._v("Afdelingsansvarlig")]) : _vm._e(), _vm._v(" "), _c('option', {
    domProps: {
      "value": 5
    }
  }, [_vm._v("Opgaveansvarlig")])])])]), _vm._v(" "), (_vm.newUser.role_id === 4) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('label', [_vm._v("Vælg afdeling *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.relation_department_id),
      expression: "newUser.relation_department_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "relation_department_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vælg afdeling ...")]), _vm._v(" "), _vm._l((_vm.availableDepartments), function(department) {
    return (department.name !== 'Virksomheden' && department.name !== 'Ingen afdeling tilknyttet') ? _c('option', {
      key: department.id,
      domProps: {
        "value": department.relation_id
      }
    }, [_vm._v("\n                            " + _vm._s(department.name) + "\n                        ")]) : _vm._e()
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.newUser.role_id === 5) ? _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('label', [_vm._v("Vælg medarbejder *")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.relation_employee_id),
      expression: "newUser.relation_employee_id"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newUser, "relation_employee_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "selected": "",
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Vælg medarbejder ...")]), _vm._v(" "), _vm._l((_vm.employees), function(employee) {
    return _c('option', {
      key: employee.id,
      domProps: {
        "value": employee.relation_id
      }
    }, [_vm._v("\n                            " + _vm._s(employee.full_name) + "\n                        ")])
  })], 2)])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "email"
  }, [_c('label', [_vm._v("E-mail *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.email),
      expression: "newUser.email"
    }],
    attrs: {
      "type": "email",
      "name": "iufbw379fb",
      "placeholder": "E-mail"
    },
    domProps: {
      "value": (_vm.newUser.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "password"
  }, [_c('label', [_vm._v("Adgangskode *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newUser.password),
      expression: "newUser.password"
    }],
    attrs: {
      "type": "password",
      "autocomplete": "new-password",
      "placeholder": "Adgangskode"
    },
    domProps: {
      "value": (_vm.newUser.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newUser, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "small"
  }, [_vm._v("Min. 8 karakterer")])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "action",
    attrs: {
      "align": "right"
    }
  }, [_c('div', {
    staticClass: "pretty-button",
    on: {
      "click": function($event) {
        return _vm.createUser()
      }
    }
  }, [_vm._v("\n                Opret\n            ")])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n        Alle brugere\n    ")]), _vm._v(" "), (_vm.users && !_vm.loading) ? _c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.sortedUsers), function(user) {
    return _c('div', {
      key: user.uuid,
      staticClass: "col-lg-6"
    }, [_c('div', {
      staticClass: "user"
    }, [_c('div', {
      staticClass: "name"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.name),
        expression: "user.name"
      }],
      attrs: {
        "type": "text"
      },
      domProps: {
        "value": (user.name)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "name", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "role"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.role_id),
        expression: "user.role_id"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "role_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          user.name = user.name + ' ';
          user.name = user.name.slice(0, -1)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": 2
      }
    }, [_vm._v("Administrator")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 3
      }
    }, [_vm._v("Bruger")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 4
      }
    }, [_vm._v("Afdelingsansvarlig")]), _vm._v(" "), _c('option', {
      domProps: {
        "value": 5
      }
    }, [_vm._v("Opgaveansvarlig")])])]), _vm._v(" "), (user.role_id === 4) ? _c('div', {
      staticClass: "department"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.relation_department_id),
        expression: "user.relation_department_id"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "relation_department_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Vælg afdeling ...")]), _vm._v(" "), _vm._l((_vm.availableDepartments), function(department) {
      return (department.name !== 'Virksomheden' && department.name !== 'Ingen afdeling tilknyttet') ? _c('option', {
        key: department.id,
        domProps: {
          "value": department.relation_id
        }
      }, [_vm._v("\n                                " + _vm._s(department.name) + "\n                            ")]) : _vm._e()
    })], 2)]) : _vm._e(), _vm._v(" "), (user.role_id === 5) ? _c('div', {
      staticClass: "department"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.relation_employee_id),
        expression: "user.relation_employee_id"
      }],
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(user, "relation_employee_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "selected": "",
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v("Vælg medarbejder ...")]), _vm._v(" "), _vm._l((_vm.employees), function(employee) {
      return _c('option', {
        key: employee.id,
        domProps: {
          "value": employee.relation_id
        }
      }, [_vm._v("\n                                " + _vm._s(employee.full_name) + "\n                            ")])
    })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "email"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.email),
        expression: "user.email"
      }],
      attrs: {
        "type": "email"
      },
      domProps: {
        "value": (user.email)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "email", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "password"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (user.new_password),
        expression: "user.new_password"
      }],
      attrs: {
        "type": "password",
        "placeholder": "Evt. ny adgangskode"
      },
      domProps: {
        "value": (user.new_password)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(user, "new_password", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "actions"
    }, [_c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.updateUser(user)
        }
      }
    }, [_vm._v("\n                            Opdatér\n                        ")]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.deleteUser(user)
        }
      }
    }, [_vm._v("\n                            Slet\n                        ")])])])])
  }), 0)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('div', [_c('b', [_vm._v("Administrator:")]), _vm._v(" Adgang til alle faner og kan ændre indstillinger, administrere brugere mv.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b', [_vm._v("Bruger:")]), _vm._v(" Læseadgang til alle faner.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b', [_vm._v("Afdelingsansvarlig:")]), _vm._v(" Læseadgang til alle faner undtagen økonomi-relaterede faner og potentiale. Kan kun se data for sin egen afdeling.")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_c('b', [_vm._v("Opgaveansvarlig:")]), _vm._v(" Læseadgang til ens personlige værdikæde.")])])
}]}

/***/ }),
/* 875 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n        " + _vm._s(_vm.data.name) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                ")]) : (props.column.field == 'total_coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                ")], 1) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                    "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'customer_name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer_name
          }
        }, [(props.row.customer_name) ? _c('span', [_vm._v("\n                        " + _vm._s(props.row.customer_name) + "\n                    ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning-claims"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.vaerdikaede"
    }
  }), _vm._v("\n            Værdikæde\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "lines"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.offer.count) + "\n                        tilbud, der afventer afgørelse\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.offer.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.offer.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.open.count) + "\n                        opgaver, der ikke er påbegyndt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.open.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.open.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.ongoing.count) + "\n                        igangværende opgaver, der arbejdes på\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.ongoing.value_with_avg_cp)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.ongoing.value_with_avg_cp - _vm.figures.ongoing.value)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.unbilled.count) + "\n                        afsluttede opgaver, der ikke er fakturerede\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unbilled.value_with_avg_cp)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unbilled.value_with_avg_cp - _vm.figures.unbilled.value)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.unpaid_invoices.count) + "\n                        fakturaer, der endnu ikke er betalt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unpaid_invoices.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.unpaid_invoices.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        " + _vm._s(_vm.figures.overdue_invoices.count) + "\n                        fakturaer med overskredet betaling\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.overdue_invoices.expected_revenue)) + "\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.figures.overdue_invoices.expected_coverage)) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "line bold"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Total")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.revenueTotal)))]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.coverageTotal)))])])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "line bold"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("Pipeline")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_vm._v("Potentiel omsætning")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_vm._v("Potentielt DB")])])
}]}

/***/ }),
/* 877 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.openProjects"
    }
  }), _vm._v("\n        Ikke igangsatte opgaver (" + _vm._s(_vm.employeeName) + ")\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2850899247)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 878 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'inline': _vm.placement === 'inline'
    }
  }, [(_vm.identifier !== null && _vm.options.content !== null && _vm.options.content !== '') ? _c('button', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: (_vm.options),
      expression: "options"
    }],
    class: {
      'spaced': _vm.space
    },
    style: (_vm.styleOptions),
    on: {
      "click": function($event) {
        return _vm.click()
      }
    }
  }, [(_vm.icon) ? _c('i', {
    class: 'fas fa-' + _vm.icon
  }) : _c('i', {
    staticClass: "fas fa-question"
  })]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "toggle",
    on: {
      "click": function($event) {
        return _vm.toggle()
      }
    }
  }, [_c('i', {
    staticClass: "far fa-book fa-fw"
  }), _vm._v(" "), (_vm.show) ? _c('span', [_vm._v("\n                Skjul ordforklaring\n                "), _c('i', {
    staticClass: "far fa-chevron-up fa-fw"
  })]) : _c('span', [_vm._v("\n                Vis ordforklaring\n                "), _c('i', {
    staticClass: "far fa-chevron-down fa-fw"
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show),
      expression: "show"
    }],
    staticClass: "explainer"
  }, [_c('div', {
    staticClass: "lines"
  }, _vm._l((_vm.abbreviations), function(line) {
    return _c('div', {
      key: line.abb,
      staticClass: "line"
    }, [_c('div', {
      staticClass: "abb"
    }, [_vm._v("\n                        " + _vm._s(line.abb) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "exp"
    }, [_vm._v("\n                        " + _vm._s(line.exp) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "comment"
    }, [_vm._v("\n                        " + _vm._s(line.comment) + "\n                    ")])])
  }), 0)])])])
},staticRenderFns: []}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-customer-hours"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Svendenes tid hos kunderne\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 881 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Økonomi",
      "identifier": "economy"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Økonomi</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet økonomisk overblik over din virksomhed\n            ")])]), _vm._v(" "), (_vm.$route.name === 'EconomyOperations' && _vm.$auth.user().roles[0].name !== 'department-responsible') ? _c('view-toggle', {
    attrs: {
      "operationsName": "Drift",
      "operationsLink": "EconomyOperations",
      "learningName": "Økonomi",
      "learningLink": "EconomyLearning"
    }
  }) : _vm._e(), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Opgaver",
      "identifier": "projects"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Opgaver</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine opgaver\n            ")])]), _vm._v(" "), _c('view-toggle', {
    attrs: {
      "operationsName": "Drift",
      "operationsLink": "ProjectsOperations",
      "learningName": "Udvikling / læring",
      "learningLink": "ProjectsLearning"
    }
  }), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 883 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "settings-menu"
  }, [_c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'general'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'general'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-cogs"
  }), _vm._v("\n                         \n                        Generelt\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'accountPlan'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'accountPlan'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-list"
  }), _vm._v("\n                         \n                        Kontoplan\n                    ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'valuechainCalculation'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'valuechainCalculation'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-calculator"
  }), _vm._v("\n                         \n                        Værdikæde kalkulation\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'employees'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'employees'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-users"
  }), _vm._v("\n                         \n                        Medarbejdere\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'projectStatuses'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'projectStatuses'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-briefcase"
  }), _vm._v("\n                         \n                        Opgavestatus\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'excludeProjects'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'excludeProjects'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-times"
  }), _vm._v("\n                         \n                        Skjul opgaver\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'timeloggingTypes'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'timeloggingTypes'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-clock"
  }), _vm._v("\n                         \n                        Tidsregistreringstyper\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (['admin', 'super-admin'].includes(_vm.$auth.user().roles[0].name)) ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'users'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'users'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-users"
  }), _vm._v("\n                         \n                        Systembrugere\n                    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'user'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'user'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-user"
  }), _vm._v("\n                         \n                        Din profil\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "font-weight": "bold",
      "margin-bottom": "30px",
      "font-family": "'Montserrat'"
    }
  }, [_vm._v("\n                        Justering af information på opgaverne\n                    ")]), _vm._v(" "), (_vm.$store.state.config.availableDepartments.length > 2) ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'cleanup'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'cleanup'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-broom"
  }), _vm._v("\n                         \n                        Opgaver uden afdeling\n                    ")]) : _vm._e(), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "menu-item",
    class: {
      'selected': _vm.selected === 'projectsMissingBudget'
    },
    on: {
      "click": function($event) {
        _vm.selected = 'projectsMissingBudget'
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-fw fa-divide"
  }), _vm._v("\n                         \n                        Opgaver uden budget\n                    ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-9"
  }, [(_vm.selected === 'accountPlan') ? _c('accountPlan') : _vm._e(), _vm._v(" "), (_vm.selected === 'employees') ? _c('employees') : _vm._e(), _vm._v(" "), (_vm.selected === 'general') ? _c('general') : _vm._e(), _vm._v(" "), (_vm.selected === 'projectStatuses') ? _c('projectStatuses') : _vm._e(), _vm._v(" "), (_vm.selected === 'cleanup') ? _c('cleanup') : _vm._e(), _vm._v(" "), (_vm.selected === 'users') ? _c('users') : _vm._e(), _vm._v(" "), (_vm.selected === 'user') ? _c('user') : _vm._e(), _vm._v(" "), (_vm.selected === 'budget') ? _c('budget') : _vm._e(), _vm._v(" "), (_vm.selected === 'valuechainCalculation') ? _c('valuechain-calculation') : _vm._e(), _vm._v(" "), (_vm.selected === 'excludeProjects') ? _c('exclude-projects') : _vm._e(), _vm._v(" "), (_vm.selected === 'projectsMissingBudget') ? _c('projects-missing-budget') : _vm._e(), _vm._v(" "), (_vm.selected === 'timeloggingTypes') ? _c('timelogging-types-settings') : _vm._e()], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 884 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-coverage-percent"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            DG\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-12': !_vm.selectedType, 'col-lg-4': _vm.selectedType
    }
  }, [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n                Budgetlinjer\n            ")]), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    key: _vm.tableKey,
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.filteredRows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'proposal_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.proposal_cost)) + "\n                    ")]) : (props.column.field == 'expended_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.expended_cost)) + "\n                    ")]) : (props.column.field == 'difference') ? _c('div', {
          class: {
            'good': (props.row.proposal_cost - props.row.expended_cost) > 0, 'bad': (props.row.proposal_cost - props.row.expended_cost) < 0
          },
          staticStyle: {
            "text-align": "left"
          }
        }, [((props.row.proposal_cost - props.row.expended_cost) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.proposal_cost - props.row.expended_cost)) + "\n                    ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                            Betalt\n                        ")]) : _c('span', [_vm._v("\n                            Ikke betalt\n                        ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1087789773)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)]), _vm._v(" "), (_vm.selectedType) ? _c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.selectedType) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedType = null;
        _vm.tableKey = 0
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                ")])])]) : _vm._e(), _vm._v(" "), _c('minuba-budget-report-linetypes-projecttypes', {
    attrs: {
      "type": _vm.selectedType.name,
      "rows": _vm.selectedType.project_types
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coming-soon"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Kommer snart</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Vi er i fuld gang med at videreudvikle indhold til dette faneblad!\n            ")])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 887 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.claims"
    }
  }), _vm._v("\n        Igangværende reklamationer (" + _vm._s(_vm.employeeName) + ")\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                    }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                    " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 801382959)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    \n    Her kan du angive hvilke tidsregistreringstyper, der IKKE skal tælle med i eksempelvis udregningen af medarbejdernes tid hos kunderne.\n    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Tidsregistreringstyper (" + _vm._s(_vm.rows.length > 0 ? _vm.rows.length : '') + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "searchOptions": _vm.searchOptions,
      "paginationOptions": _vm.paginationOptions,
      "sortOptions": _vm.sortOptions,
      "styleClass": "vgt-table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'hours_last_year') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("number")(props.row.hours_last_year)) + "\n                    ")]) : (props.column.field == 'action') ? _c('div', [_c('input', {
          directives: [{
            name: "model",
            rawName: "v-model",
            value: (props.row.used_for_calculation),
            expression: "props.row.used_for_calculation"
          }],
          attrs: {
            "type": "checkbox"
          },
          domProps: {
            "checked": Array.isArray(props.row.used_for_calculation) ? _vm._i(props.row.used_for_calculation, null) > -1 : (props.row.used_for_calculation)
          },
          on: {
            "change": [function($event) {
              var $$a = props.row.used_for_calculation,
                $$el = $event.target,
                $$c = $$el.checked ? (true) : (false);
              if (Array.isArray($$a)) {
                var $$v = null,
                  $$i = _vm._i($$a, $$v);
                if ($$el.checked) {
                  $$i < 0 && (_vm.$set(props.row, "used_for_calculation", $$a.concat([$$v])))
                } else {
                  $$i > -1 && (_vm.$set(props.row, "used_for_calculation", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
                }
              } else {
                _vm.$set(props.row, "used_for_calculation", $$c)
              }
            }, function($event) {
              return _vm.update(props.row)
            }]
          }
        }), _vm._v("\n                         \n                        "), (props.row.used_for_calculation) ? _c('span', [_vm._v("\n                            Synlig\n                        ")]) : _c('span', [_vm._v("\n                            Skjult\n                        ")])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1880780003)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-project-types-for-responsibles"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.selectedRow ? 'col-lg-3' : 'col-lg-9'
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Opgavetyper\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder fit-content"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                            ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 2684557090)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data. Husk at angive i indstillingerne hvilke medarbejdere, der skal listes her\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: _vm.selectedRow ? 'col-lg-9' : 'col-lg-3'
  }, [(!_vm.selectedRow) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n                Vælg en opgavetype for at se et overblik over de enkelte ansvarlige her\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('project-types-responsibles', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 890 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.leverandoerer"
    }
  }), _vm._v("\n        Leverandører\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'total_quantity') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("number")(props.row.total_quantity)) + "\n                ")]) : (props.column.field == 'total_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_cost)) + "\n                ")]) : (props.column.field == 'avg_price_per_material') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.avg_price_per_material)) + "\n                ")]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 421130365)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 891 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-type-development"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.coverageDevelopment"
    }
  }), _vm._v("\n                    Udviklingen i DB pr. opgavetype\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'progress_percent') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.progress_percent >= 5) ? _c('span', {
          staticClass: "color-good"
        }, [_c('i', {
          staticClass: "fas fa-arrow-up"
        })]) : (props.row.progress_percent === 0 || props.row.progress_percent > -5 && props.row.progress_percent < 5) ? _c('span', [_c('i', {
          staticClass: "fas fa-arrow-right color-avg"
        })]) : _c('span', {
          staticClass: "color-bad"
        }, [_c('i', {
          staticClass: "fas fa-arrow-down"
        })])]) : (props.column.field == 'coverage_avg') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_avg)) + "\n                            ")]) : (props.column.field == 'projects_count') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.projects_count)) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 708878618)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    " + _vm._s(_vm.series[0].name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _vm._e()], 1)]) : _c('div', [_vm._v("\n                Vælg en opgavetype for at se fremgangen i en graf\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 892 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "efficiency-graph"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('graph-card', {
    attrs: {
      "heading": "Hvor meget tid bruger svendene hos kunderne?",
      "unit": "%",
      "ylabel": "Timer brugt på kundeopgaver",
      "height": "450",
      "trend": true,
      "endpoint": _vm.efficiencyGraph,
      "paramsInEndpoint": _vm.efficiencyGraphParams,
      "series": _vm.efficiencyGraphSeries
    }
  }, [_c('button', {
    staticStyle: {
      "position": "absolute",
      "top": "0",
      "right": "0",
      "line-height": "50px",
      "margin-right": "15px",
      "outline": "none"
    },
    on: {
      "click": function($event) {
        return _vm.toggleEfficiency()
      }
    }
  }, [(_vm.efficiencyGraph === 'efficiency') ? _c('span', [_vm._v("\n                Vis fordeling pr. ugedag\n            ")]) : (_vm.efficiencyGraph === 'efficiency?weekdays=1') ? _c('span', [_vm._v("\n                Vis fordeling pr. måned\n            ")]) : _vm._e()])])], 1)])
},staticRenderFns: []}

/***/ }),
/* 893 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    style: (_vm.type === 'icon' ? 'display:inline-block;float:left;' : '')
  }, [(_vm.type === 'icon') ? _c('i', {
    directives: [{
      name: "tooltip",
      rawName: "v-tooltip",
      value: ({
        content: _vm.content,
        popover: {
          defaultClass: 'd-tooltip',
          defaultbaseClass: 'd-tooltip'
        }
      }),
      expression: "{\n        content: content,\n        popover: {\n            defaultClass: 'd-tooltip',\n            defaultbaseClass: 'd-tooltip'\n        }\n    }"
    }],
    staticClass: "fas fa-question-circle"
  }) : _c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 894 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")], 1) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'timelog_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 895 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.offerProjects"
    }
  }), _vm._v("\n        Tilbud (" + _vm._s(_vm.employeeName) + ")\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2850899247)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 896 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "time-usage-skills"
  }, [_c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === ''
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = ''
      }
    }
  }, [_vm._v("\n            Alle medarbejdere\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, funktionær'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, funktionær'
      }
    }
  }, [_vm._v("\n            Svende, funktionær\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Svend, timelønnet'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Svend, timelønnet'
      }
    }
  }, [_vm._v("\n            Svende, timelønnet\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.employeeWorkingFieldName === 'Lærling'
    },
    on: {
      "click": function($event) {
        _vm.employeeWorkingFieldName = 'Lærling'
      }
    }
  }, [_vm._v("\n            Lærlinge\n        ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "employees.timeUsageSkills"
    }
  }), _vm._v("\n                    Hvor gode er vi til at registrere tid?\n                ")], 1), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }, [(_vm.data) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.employees,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'available_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.available_hours)) + "\n                            ")]) : (props.column.field == 'logged_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.logged_hours)) + "\n                            ")]) : (props.column.field == 'full_name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.full_name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.full_name) + "\n                            ")]) : (props.column.field == 'weekly_hours_working') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.weekly_hours_working) + "\n                            ")]) : (props.column.field == 'avg_per_week') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                                " + _vm._s(_vm._f("number")(props.row.avg_per_week)) + "\n                            ")]) : (props.column.field == 'efficiency') ? _c('div', {
          staticClass: "coverage-cell",
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("rounded")(props.row.efficiency)) + "\n                                    "), (props.row.efficiency) ? _c('span', [_vm._v("%")]) : _vm._e()]), _vm._v(" "), (props.row.efficiency) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.efficiency < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(props.row.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(props.row.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 3014051959)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _vm._e()], 1) : (!_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n                    Vi kunne ikke hente data. Tjek, at du har angivet hvilke svende, der skal baseres data på under indstillinger.\n                ")]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v("\n            OBS! Der vises kun medarbejdere, som har registreret tid i den valgte periode.\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Opsummering\n                ")]), _vm._v(" "), (_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticClass: "highlight"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Timer til rådighed\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("number")(_vm.data.totals.available_hours)) + "\n                        ")])]), _vm._v(" "), _c('div', {
    staticClass: "highlight"
  }, [_c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Timer registreret\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                            " + _vm._s(_vm._f("number")(_vm.data.totals.logged_hours)) + "\n                        ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "highlights",
    attrs: {
      "align": "center"
    }
  }, [_c('div', {
    staticClass: "value",
    staticStyle: {
      "font-size": "30px",
      "font-weight": "bold",
      "display": "flex",
      "align-items": "center",
      "justify-content": "center"
    }
  }, [(_vm.data.totals.efficiency) ? _c('div', {
    staticClass: "coverage-indicator",
    class: {
      'bad': _vm.data.totals.efficiency < _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'avg': _vm.$options.filters.rounded(_vm.data.totals.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.medium.value, 'good': _vm.$options.filters.rounded(_vm.data.totals.efficiency) >= _vm.$store.state.config.companyMeta.settings.timelogging.high.value
    }
  }) : _vm._e(), _vm._v("\n                            " + _vm._s(_vm._f("rounded")(_vm.data.totals.efficiency)) + " %\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n                            Af timer til rådighed er registreret\n                        ")])])]) : (!_vm.data && !_vm.loading) ? _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n                    Vi kunne ikke hente data. Tjek, at du har angivet hvilke svende, der skal baseres data på under indstillinger.\n                ")]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 897 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "super-admin"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Super admin</b>"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Super Admin indstillinger\n            ")])]), _vm._v(" "), _vm._m(0)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('b', [_vm._v("Funktioner:")]), _c('br'), _vm._v(" "), _c('ul', [_c('li', [_vm._v("Opret nye virksomheder (onboarding)")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_vm._v("\n                    Block\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6"
  }, [_vm._v("\n                    Block\n                ")])])])
}]}

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-coverage"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            DB\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Medarbejdere",
      "identifier": "employees"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Medarbejdere</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine medarbejdere\n            ")])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 900 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "project-statuses"
  }, [(_vm.statuses && _vm.statusTypes) ? _c('div', {
    staticClass: "list"
  }, _vm._l((_vm.statuses), function(status) {
    return _c('div', {
      key: status.uuid,
      staticClass: "project-status"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                " + _vm._s(status.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "type"
    }, [_c('b', {
      staticStyle: {
        "font-weight": "600"
      }
    }, [_vm._v("Vælg type:")]), _vm._v("\n                  \n                "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (status.type.uuid),
        expression: "status.type.uuid"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(status.type, "uuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.update(status, $event)
        }]
      }
    }, [_c('option', {
      domProps: {
        "value": null
      }
    }, [_vm._v("- Ingen type -")]), _vm._v(" "), _vm._l((_vm.statusTypes), function(statusType) {
      return _c('option', {
        key: statusType.uuid,
        domProps: {
          "value": statusType.uuid
        }
      }, [_vm._v("\n                        " + _vm._s(statusType.name) + "\n                    ")])
    })], 2)])])
  }), 0) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "center"
    }
  }, [_c('div', [_c('div', {
    staticClass: "value-wrapper"
  }, [_c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                        Budgetteret\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.totals[0])) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                        Realiseret\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.totals[1])) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                        Difference\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.totals[2] > 0, 'bad': _vm.totals[2] < 0
    }
  }, [(_vm.totals[2] > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.totals[2])) + "\n                    ")])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-left": "32px",
      "padding-bottom": "16px"
    }
  }, [_vm._v("\n            Fordeling:  \n            "), _c('div', {
    staticClass: "employee-switcher"
  }, [_c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.divisionOption === 1
    },
    on: {
      "click": function($event) {
        _vm.divisionOption = 1
      }
    }
  }, [_vm._v("\n                    Budgetlinjer\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option",
    class: {
      'selected': _vm.divisionOption === 2
    },
    on: {
      "click": function($event) {
        _vm.divisionOption = 2
      }
    }
  }, [_vm._v("\n                    Opgavetyper\n                ")])])])]), _vm._v(" "), _c('minuba-budget-report-linetypes', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.divisionOption === 1),
      expression: "divisionOption === 1"
    }],
    attrs: {
      "rows": _vm.lineTypes,
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('minuba-budget-report-projecttypes', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.divisionOption === 2),
      expression: "divisionOption === 2"
    }],
    attrs: {
      "rows": _vm.projectTypes,
      "loading": _vm.loading
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_projects') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.total_projects) + "\n                    ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")], 1) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hours-with-customers"
  }, [_c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "options": _vm.chartOptions,
      "series": _vm.chartOptions.series,
      "height": _vm.chartOptions.chart.height
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 904 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "view-toggle"
  }, [_c('div', {
    staticClass: "options"
  }, [_c('div', {
    staticClass: "option drift",
    class: {
      'selected': _vm.$store.state.view === 'operations'
    },
    on: {
      "click": function($event) {
        return _vm.doToggle('operations', _vm.operationsLink)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.operationsName) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "option udvikling",
    class: {
      'selected': _vm.$store.state.view === 'learning'
    },
    on: {
      "click": function($event) {
        return _vm.doToggle('learning', _vm.learningLink)
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.learningName) + "\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-followup-ebitda"
  }, [(_vm.data) ? _c('div', [(_vm.accountsModal) ? _c('div', {
    staticClass: "accounts-modal"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "inner__title"
  }, [_vm._v("\n                    Underkonti for \"" + _vm._s(_vm.accountsModal.name) + "\"\n                ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_vm._l((_vm.accountsModal.accounts), function(account, index) {
    return _c('tr', {
      key: 'account_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(account.account_number))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(account.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(account.real_expenses)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(account.expenses_budget_to_now !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(account.expenses_budget_to_now)) + "\n                                ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(account.expenses_budget_to_now !== 0) ? _c('span', [_c('span', {
      class: {
        'color-good': (account.real_expenses - account.expenses_budget_to_now) > 0, 'color-bad': (account.real_expenses - account.expenses_budget_to_now) < 0
      }
    }, [((account.real_expenses - account.expenses_budget_to_now) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(account.real_expenses - account.expenses_budget_to_now)) + "\n                                        ")])]) : _c('span', [_vm._v("-")])])])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "left"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.accountsModal.real_expenses)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.accountsModal.expenses_budget_to_now !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(_vm.accountsModal.expenses_budget_to_now)) + "\n                                ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.accountsModal.expenses_budget_to_now !== 0) ? _c('span', [_c('span', {
    class: {
      'color-good': (_vm.accountsModal.real_expenses - _vm.accountsModal.expenses_budget_to_now) > 0, 'color-bad': (_vm.accountsModal.real_expenses - _vm.accountsModal.expenses_budget_to_now) < 0
    }
  }, [((_vm.accountsModal.real_expenses - _vm.accountsModal.expenses_budget_to_now) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.accountsModal.real_expenses - _vm.accountsModal.expenses_budget_to_now)) + "\n                                        ")])]) : _c('span', [_vm._v("-")])])])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "close-wrapper"
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.accountsModal = null
      }
    }
  }, [_vm._v("\n                        Luk\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "budgetfollowup.ebitda",
      "placement": "left"
    }
  }), _vm._v("\n                EBITDA\n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "center"
    }
  }, [_c('div', {
    staticClass: "employee-switcher",
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.period === 'budgetyear'
    },
    on: {
      "click": function($event) {
        _vm.period = 'budgetyear'
      }
    }
  }, [_vm._v("\n                            Budgetåret til dato\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "employee-switcher-option lg",
    class: {
      'selected': _vm.period === 'month'
    },
    on: {
      "click": function($event) {
        _vm.period = 'month'
      }
    }
  }, [_vm._v("\n                            Denne måned\n                        ")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.data.account_categories), function(accountCategory, index) {
    return _c('tr', {
      key: 'accountCategory_' + index,
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      }
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [(accountCategory.accounts.length > 0) ? _c('i', {
      staticClass: "fas fa-list fa-fw",
      on: {
        "click": function($event) {
          _vm.accountsModal = accountCategory
        }
      }
    }) : _c('i', {
      staticClass: "fas fa-list fa-fw",
      staticStyle: {
        "opacity": "0"
      }
    }), _vm._v("\n                                 " + _vm._s(accountCategory.name) + "\n                            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(accountCategory.real_expenses)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(accountCategory.expenses_budget_to_now !== 0) ? _c('span', [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(accountCategory.expenses_budget_to_now)) + "\n                                ")]) : _c('span', [_vm._v("-")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(accountCategory.expenses_budget_to_now !== 0) ? _c('span', [_c('span', {
      class: {
        'color-good': (accountCategory.real_expenses - accountCategory.expenses_budget_to_now) > 0, 'color-bad': (accountCategory.real_expenses - accountCategory.expenses_budget_to_now) < 0
      }
    }, [((accountCategory.real_expenses - accountCategory.expenses_budget_to_now) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(accountCategory.real_expenses - accountCategory.expenses_budget_to_now)) + "\n                                        ")])]) : _c('span', [_vm._v("-")])])])
  }), 0)])])])]) : _c('div', [_c('box-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Realiseret")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Budget")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Difference")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Realiseret")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Budget")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "20%"
    }
  }, [_vm._v("Difference")])])])
}]}

/***/ }),
/* 906 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n            " + _vm._s(_vm.type) + "\n        ")]), _vm._v(" "), _c('vue-good-table', {
    key: _vm.tableKey,
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.description) + "\n                ")]) : (props.column.field == 'proposal_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.proposal_cost)) + "\n                ")]) : (props.column.field == 'expended_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.expended_cost)) + "\n                ")]) : (props.column.field == 'difference') ? _c('div', {
          class: {
            'good': (props.row.proposal_cost - props.row.expended_cost) > 0, 'bad': (props.row.proposal_cost - props.row.expended_cost) < 0
          },
          staticStyle: {
            "text-align": "left"
          }
        }, [((props.row.proposal_cost - props.row.expended_cost) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.proposal_cost - props.row.expended_cost)) + "\n                ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                        Betalt\n                    ")]) : _c('span', [_vm._v("\n                        Ikke betalt\n                    ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px"
    }
  }, [(_vm.selectedProjectType) ? _c('div', [_c('minuba-budget-single-projects', {
    attrs: {
      "rows": _vm.selectedProjectType.projects,
      "type": _vm.selectedProjectType.name
    }
  })], 1) : _c('div', [_vm._v("\n            Vælg en opgavetype for at se de enkelte opgaver her\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 907 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-project-type-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.main_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name ? props.row.name : '-') + "\n                    ")]) : (props.column.field == 'external_created_at') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.external_created_at, "DD. MMM YYYY")) + "\n                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.openProjects"
    }
  }), _vm._v("\n        Ikke igangsatte opgaver\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2850899247)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Overblik",
      "identifier": "index"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Overblik</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Hvad skal der fokus på i dag?\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "economy-overview-boxes"
  }, [_c('div', {
    staticClass: "row nomargin"
  }, [_c('div', {
    staticClass: "col-lg-7"
  }, [_c('div', {
    staticClass: "economy-overview-box"
  }, [_c('div', {
    staticClass: "period"
  }, [_vm._v("\n                                Realiseret for perioden\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "row nomargin"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                                            EBITDA\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "large-title"
  }, [(_vm.keyfigures) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.keyfigures.ebitda)))]) : _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                                            Solgte timer\n                                        ")]), _vm._v(" "), _c('div', {
    staticClass: "large-title"
  }, [(_vm.keyfigures) ? _c('span', [_vm._v(_vm._s(_vm._f("number")(_vm.keyfigures.hours)))]) : _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("\n                                            DB pr. time\n                                        ")]), _vm._v(" "), (_vm.keyfigures) ? _c('div', {
    staticClass: "large-title",
    class: {
      'color-bad': _vm.keyfigures.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'color-avg': _vm.$options.filters.rounded(_vm.keyfigures.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value && _vm.$options.filters.rounded(_vm.keyfigures.coverage_per_hour) < _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value, 'color-good': _vm.$options.filters.rounded(_vm.keyfigures.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(_vm.keyfigures.coverage_per_hour)) + "\n                                            \n                                        ")]) : _c('div', {
    staticClass: "large-title"
  }, [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-5"
  }, [_c('expected-ebitda')], 1)])]), _vm._v(" "), _c('value-chain'), _vm._v(" "), _c('div', {
    staticClass: "number-overview"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Tilbud",
      "description": "der afventer afgørelse",
      "number": _vm.calculations.offer,
      "icon": "file-alt",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "offerProjects",
      "tooltipIdentifier": "index.offerProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Opgaver",
      "description": "der endnu ikke er påbegyndt",
      "number": _vm.calculations.open,
      "icon": "inbox-in",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "openProjects",
      "tooltipIdentifier": "index.openProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": "der arbejdes på lige nu",
      "number": _vm.calculations.ongoing,
      "icon": "clock",
      "state": "bad",
      "linkParent": "ProjectsOperations",
      "linkChild": "ongoingProjects",
      "tooltipIdentifier": "index.ongoingProjects"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": 'uden registreringer i ' + _vm.$store.state.config.companyMeta.settings.snoozed_days + ' dage ',
      "number": _vm.calculations.snoozed,
      "icon": "snooze",
      "state": "bad",
      "linkParent": "ProjectsOperations",
      "linkChild": "snoozedProjects",
      "tooltipIdentifier": "index.snoozedProjects"
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Reklamationer",
      "description": "der ikke er afsluttet",
      "number": _vm.calculations.claims,
      "icon": "comment-exclamation",
      "state": "good",
      "linkParent": "ProjectsOperations",
      "linkChild": "openClaims",
      "tooltipIdentifier": "index.openClaims"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Afsluttede opgaver",
      "description": "der ikke er fakturerede",
      "number": _vm.calculations.unbilled,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "linkParent": "ProjectsOperations",
      "linkChild": "noInvoiceProjects",
      "tooltipIdentifier": "index.unbilledProjects"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": "der endnu ikke er betalt",
      "number": _vm.calculations.payment_pending,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "linkParent": "EconomyOperations",
      "linkChild": "unpaidInvoices",
      "tooltipIdentifier": "index.unpaidInvoices"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": 'hvor betaling er overskredet med ' + _vm.$store.state.config.companyMeta.settings.overdue_days + ' dage',
      "number": _vm.calculations.payment_exceeded,
      "icon": "calendar-exclamation",
      "state": "bad",
      "totalValue": _vm.calculations.payment_exceeded_total,
      "linkParent": "EconomyOperations",
      "linkChild": "exceededPayments",
      "tooltipIdentifier": "index.overdueInvoices"
    }
  })], 1)])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 910 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('v-popover', {
    staticStyle: {
      "display": "inline-block"
    },
    attrs: {
      "offset": "16",
      "options": _vm.options,
      "open": _vm.show,
      "placement": "left"
    }
  }, [_c('button', {
    staticClass: "tooltip-target b3",
    staticStyle: {
      "display": "inline-block"
    },
    on: {
      "mouseover": function($event) {
        _vm.show = true
      },
      "mouseleave": function($event) {
        _vm.show = false
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-calculator fa-fw"
  })]), _vm._v(" "), _c('template', {
    slot: "popover"
  }, [_c('div', {
    staticStyle: {
      "background": "#172b43",
      "color": "#fff",
      "padding": "5px 10px",
      "text-align": "center",
      "margin-bottom": "10px",
      "border-radius": "4px"
    }
  }, [_c('b', [_vm._v("BUDGET")])]), _vm._v(" "), _c('div', {
    staticClass: "line good"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. omsætning")]), _vm._v(" "), _c('div', {
    staticClass: "right good"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_price ? _vm.project.calculation_price : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "line bad"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. kostpris")]), _vm._v(" "), _c('div', {
    staticClass: "right bad"
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_cost ? _vm.project.calculation_cost : 0)))])]), _vm._v(" "), _c('div', {
    staticClass: "divider",
    staticStyle: {
      "margin": "10px 0"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "line total"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("Forv. dækningsbidrag")]), _vm._v(" "), _c('div', {
    staticClass: "right",
    class: {
      'good': _vm.project.calculation_coverage > 0, 'bad': _vm.project.calculation_coverage < 0
    }
  }, [_vm._v(_vm._s(_vm._f("realCurrency")(_vm.project.calculation_coverage ? _vm.project.calculation_coverage : 0)))])])])], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "offline-wrapper"
  }, [_c('div', {
    staticClass: "offline-inner"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-circle"
  })]), _vm._v(" "), _c('h1', [_vm._v("Whoops!")]), _vm._v(" "), _c('h3', [_vm._v("You've lost the connection to the internet.")]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v("We could not register a live connection to the internet. Since this application uses network functions, please make sure you have a valid network connection and try again.")]), _vm._v(" "), _c('p', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Refresh this page")])])])])])
}]}

/***/ }),
/* 912 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "expected-ebitda"
  }, [_c('div', {
    staticClass: "expected-ebitda-box"
  }, [_c('div', {
    staticClass: "period"
  }, [_vm._v("\n            Forventet EBITDA i indeværende regnskabsår\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "inside"
  }, [_c('div', [_c('div', {
    staticClass: "small-title"
  }, [_vm._v("Forventet EBITDA (driftsoverskud)")]), _vm._v(" "), (_vm.data && !_vm.data.forecast) ? _c('div', {
    staticClass: "no-budget"
  }, [_vm._v("\n                    Hvis du lægger et budget i proEBITDA, vil du her kunne se, hvad regnskabsårets EBITDA med stor sandsynlighed vil blive. Kontakt os, hvis du har spørgsmål.\n                ")]) : _c('div', {
    staticClass: "large-title color-good"
  }, [(_vm.data) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(_vm.data.expected_ebitda)))]) : (_vm.error) ? _c('span', [_vm._v("-")]) : _c('span', [_c('i', {
    staticClass: "fas fa-spinner fa-spin"
  })])])]), _vm._v(" "), (_vm.data && _vm.data.forecast) ? _c('div', {
    staticClass: "cta",
    on: {
      "click": function($event) {
        return _vm.$modal.show('expected-ebitda')
      }
    }
  }, [_vm._v("\n                Læs mere\n            ")]) : _vm._e()])]), _vm._v(" "), _c('modal', {
    attrs: {
      "name": "expected-ebitda",
      "height": "auto",
      "adaptive": true,
      "scrollable": true,
      "width": "900"
    }
  }, [(_vm.data && _vm.data.forecast) ? _c('div', {
    staticClass: "expected-ebitda-modal"
  }, [_c('div', {
    staticClass: "modal-close",
    on: {
      "click": function($event) {
        return _vm.$modal.hide('expected-ebitda')
      }
    }
  }, [_c('i', {
    staticClass: "fal fa-times"
  })]), _vm._v(" "), _c('h3', [_vm._v("Sådan er tallet beregnet")]), _vm._v(" "), _c('div', {
    staticClass: "sub"
  }, [_vm._v("\n                Regnskabsåret " + _vm._s(_vm._f("moment")(_vm.data.accounting_year.from, "D. MMM YYYY")) + " - " + _vm._s(_vm._f("moment")(_vm.data.accounting_year.to, "D. MMM YYYY")) + ". Hold musen over "), _c('i', {
    staticClass: "fas fa-info-circle"
  }), _vm._v(" for at se mellemregningerne.\n            ")]), _vm._v(" "), _c('table', {
    staticClass: "calc"
  }, [_c('tr', [_c('td', [_vm._v("\n                        Realiseret EBITDA\n                        "), _c('calc-tooltip', {
    attrs: {
      "title": "Bogført og kassekladder",
      "lines": _vm.realizedLines
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "formula"
  }, [_vm._v("Bogført og kassekladder, regnskabsårets start til i dag")]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.realized_ebitda)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                        Værdi af opgaver\n                        "), _c('calc-tooltip', {
    attrs: {
      "title": "Opgaver der ikke er faktureret færdig",
      "lines": _vm.wipLines
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "formula"
  }, [_vm._v(_vm._s(_vm.data.wip.ongoing_count + _vm.data.wip.unbilled_count) + " opgaver")]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.wip.total)))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("\n                        Forventet resten af regnskabsåret\n                        "), _c('calc-tooltip', {
    attrs: {
      "title": "Kundetimer × DB pr. time over nulpunktsomsætning",
      "lines": _vm.forecastLines
    }
  })], 1), _vm._v(" "), _c('td', {
    staticClass: "formula"
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.data.forecast.remaining_hours)) + " kundetimer × " + _vm._s(_vm._f("currency")(Math.abs(_vm.data.forecast.per_hour_above_break_even))) + " " + _vm._s(_vm.data.forecast.per_hour_above_break_even < 0 ? 'under' : 'over') + " nulpunktsomsætning")]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.forecast.amount)))])]), _vm._v(" "), _c('tr', {
    staticClass: "sum"
  }, [_c('td', [_vm._v("Forventet EBITDA")]), _vm._v(" "), _c('td', {
    staticClass: "formula"
  }, [_vm._v("Realiseret + opgaver + resten af regnskabsåret")]), _vm._v(" "), _c('td', {
    staticClass: "amount"
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.expected_ebitda)))])])]), _vm._v(" "), _c('div', {
    staticClass: "budget-note",
    class: _vm.aboveBudget ? 'is-good' : 'is-bad'
  }, [(_vm.cphDeviationPercent !== null) ? [_vm._v("\n                    Du ligger "), _c('b', [_vm._v(_vm._s(_vm.cphDeviationPercent) + " % " + _vm._s(_vm.cphDeviation < 0 ? 'under' : 'over'))]), _vm._v(" dit budget på DB pr. time.\n                ")] : _vm._e(), _vm._v("\n                Fortsætter du sådan, tjener du "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(Math.abs(_vm.data.forecast.budget_deviation))) + " " + _vm._s(_vm.aboveBudget ? 'mere' : 'mindre'))]), _vm._v(" end budgetteret resten af regnskabsåret.\n                "), _c('calc-tooltip', {
    attrs: {
      "title": "Sammenholdt med budgettet",
      "lines": _vm.comparisonLines
    }
  })], 2), _vm._v(" "), _c('ebitda-development', {
    staticClass: "development",
    attrs: {
      "months": _vm.data.months,
      "wip": _vm.data.wip
    }
  })], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 913 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.vareforbrug"
    }
  }), _vm._v("\n        Vareforbrug\n    ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                    " + _vm._s(props.row.name) + "\n                ")]) : (props.column.field == 'total_quantity') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("numberWithDecimals")(props.row.total_quantity)) + "\n                ")]) : (props.column.field == 'total_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.total_cost)) + "\n                ")]) : _c('div', [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 146854863)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 914 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cleanup"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Opgaver uden afdeling\n    ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1551988799)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('div', {
    staticClass: "placeholder"
  }, [_c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v("\n        Oversigten viser opgaver, der ikke er tildelt en afdeling. Det bør rettes op i dit program  til styring af opgaver, så du får den rigtige information at træffe beslutninger på i de forskellige faneblade i proEBITDA. Vær opmærksom på, at ændringen først slår igennem, når data er blevet synkroniseret igen (hver nat).\n        "), _c('br'), _c('br')])
}]}

/***/ }),
/* 915 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "oekonomi.unpaidInvoices",
      "placement": "left"
    }
  }), _vm._v("\n        Fakturaer, der ikke er betalt\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number ? props.row.invoice_number : '-') + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                    Betalt\n                ")]) : _c('span', [_vm._v("\n                    Ikke betalt\n                ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2812794680)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 916 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customers-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('time-usage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'timeUsage'),
      expression: "selectedItem === 'timeUsage'"
    }]
  }), _vm._v(" "), _c('time-usage-skills', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'timeUsageSkills'),
      expression: "selectedItem === 'timeUsageSkills'"
    }]
  }), _vm._v(" "), _c('employee-revenue', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'employeeRevenue'),
      expression: "selectedItem === 'employeeRevenue'"
    }]
  }), _vm._v(" "), _c('efficiency-graph', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'efficiencyGraph'),
      expression: "selectedItem === 'efficiencyGraph'"
    }]
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 917 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "-12px"
    }
  }, [_c('div', {
    class: {
      'col-lg-12': !_vm.selectedProjectType, 'col-lg-4': _vm.selectedProjectType
    }
  }, [_c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_vm._v("\n                Opgavetyper\n            ")]), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    key: _vm.tableKey,
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'proposal_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.proposal_cost)) + "\n                    ")]) : (props.column.field == 'expended_cost') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.expended_cost)) + "\n                    ")]) : (props.column.field == 'difference') ? _c('div', {
          class: {
            'good': (props.row.proposal_cost - props.row.expended_cost) > 0, 'bad': (props.row.proposal_cost - props.row.expended_cost) < 0
          },
          staticStyle: {
            "text-align": "left"
          }
        }, [((props.row.proposal_cost - props.row.expended_cost) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(props.row.proposal_cost - props.row.expended_cost)) + "\n                    ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                            Betalt\n                        ")]) : _c('span', [_vm._v("\n                            Ikke betalt\n                        ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1087789773)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)]), _vm._v(" "), (_vm.selectedProjectType) ? _c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.selectedProjectType) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedProjectType = null;
        _vm.tableKey = 0
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                ")])])]) : _vm._e(), _vm._v(" "), _c('minuba-budget-report-projecttypes-linetypes', {
    attrs: {
      "rows": _vm.selectedProjectType.budget_line_types,
      "type": _vm.selectedProjectType.name
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 918 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-projects"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "enterprise.mainProjectType"
    }
  }), _vm._v("\n                    Hvilke konkrete entrepriseopgaver tjenes der penge på?\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                                " + _vm._s(props.row.description) + "\n                            ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name) + "\n                            ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                                    content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                                }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                                " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "project": props.row
          }
        }), _vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")], 1) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'external_created_at') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("moment")(props.row.external_created_at, "DD. MMM YYYY")) + "\n                            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 782458130)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])])])
},staticRenderFns: []}

/***/ }),
/* 919 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "placeholder padding mb-4"
  }, [_c('b', [_vm._v("\n            Hvordan skal værdien af værdikæden beregnes?\n             \n            "), _c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": 'settings.budget_calc'
    }
  })], 1), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('label', {
    staticClass: "mr-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "calculation"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "calculation")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "calculation"
      }, function($event) {
        return _vm.selectBudgetCalc('calculation')
      }]
    }
  }), _vm._v("\n            Kalkulation\n        ")]), _vm._v(" "), _c('label', {
    staticClass: "mr-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "budget"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "budget")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "budget"
      }, function($event) {
        return _vm.selectBudgetCalc('budget')
      }]
    }
  }), _vm._v("\n            Budget\n        ")]), _vm._v(" "), _c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.budgetCalc),
      expression: "budgetCalc"
    }],
    attrs: {
      "type": "radio",
      "name": "budget-calculation",
      "value": "both"
    },
    domProps: {
      "checked": _vm._q(_vm.budgetCalc, "both")
    },
    on: {
      "change": [function($event) {
        _vm.budgetCalc = "both"
      }, function($event) {
        return _vm.selectBudgetCalc('both')
      }]
    }
  }), _vm._v("\n            Budget + kalkulation\n        ")])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 920 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employee-skills-single-projects"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.case_number) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 921 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy"
  }, [_c('box-helper', {
    attrs: {
      "headline": "Kunder",
      "identifier": "customers"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Kunder</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Ét samlet overblik over dine kunder\n            ")])]), _vm._v(" "), _c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 922 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n\n    Her kan du angive om du ønsker at skjule en eller flere igangværende opgaver.\n    "), _c('br'), _c('br'), _vm._v(" "), _c('i', [_vm._v("Bemærk, at ændringen udelukkende træder i kraft på igangværende opgaver, ikke på afsluttede, bogførte mv.")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            Igangværende opgaver (" + _vm._s(_vm.rows.length > 0 ? _vm.rows.length : '') + ")\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "searchOptions": _vm.searchOptions,
      "paginationOptions": _vm.paginationOptions,
      "sortOptions": _vm.sortOptions,
      "styleClass": "vgt-table"
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'show') ? _c('div', [(props.row.show) ? _c('div', {
          staticClass: "coverage-indicator"
        }, [_c('div', {
          staticClass: "coverage-indicator good"
        }), _vm._v("\n                            Synlig\n                        ")]) : _c('div', {
          staticClass: "coverage-indicator"
        }, [_c('div', {
          staticClass: "coverage-indicator bad"
        }), _vm._v("\n                            Ikke synlig\n                        ")])]) : (props.column.field == 'action') ? _c('div', [(props.row.show) ? _c('div', [_c('button', {
          on: {
            "click": function($event) {
              return _vm.updateProject(props.row, false)
            }
          }
        }, [_vm._v("\n                                Skjul\n                            ")])]) : _c('div', [_c('button', {
          on: {
            "click": function($event) {
              return _vm.updateProject(props.row, true)
            }
          }
        }, [_vm._v("\n                                Gør synlig\n                            ")])])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 880643397)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 923 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-helper-wrapper"
  }, [_c('div', {
    staticClass: "box-helper-button",
    on: {
      "click": function($event) {
        return _vm.showHelper()
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), (_vm.show) ? _c('div', {
    staticClass: "box-helper",
    on: {
      "click": function($event) {
        return _vm.hideHelper()
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "html",
    domProps: {
      "innerHTML": _vm._s(_vm.content)
    }
  })])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button"
  }, [_c('i', {
    staticClass: "fas fa-question fa-fw"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "close"
  }, [_c('i', {
    staticClass: "fas fa-times fa-fw"
  })])
}]}

/***/ }),
/* 924 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.full_name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.project_types,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_projects') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.total_projects) + "\n                    ")]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description"
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1817214742)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), (!_vm.selectedRow) ? _c('div', [_vm._v("\n        Vælg en opgavetype for at se de enkelte opgaver her\n    ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [(_vm.selectedRow) ? _c('employee-revenue-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 925 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-followup-cph"
  }, [(_vm.data) ? _c('div', [(_vm.graphModal) ? _c('div', {
    staticClass: "graph-modal"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "inner__title"
  }, [_vm._v("\n                    Udvikling i DB pr. time for \"" + _vm._s(_vm.graphModal.name) + "\"\n                ")]), _vm._v(" "), _c('div', [_c('vue-apex-charts', {
    attrs: {
      "height": 400,
      "series": _vm.graphModal.graph,
      "options": _vm.graphOptions
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "close-wrapper"
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.graphModal = null
      }
    }
  }, [_vm._v("\n                        Luk\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "budgetfollowup.cph",
      "placement": "left"
    }
  }), _vm._v("\n                Opgavetyper\n            ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [_c('div', {
    staticStyle: {
      "margin-bottom": "30px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.budget.ebitda_goal)))]), _vm._v("\n                            Ønsket EBITDA"), _c('br'), _vm._v("(driftsoverskud)\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "color-avg",
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.budget.cph_zero_revenue)))]), _vm._v("\n                            Krav til DB pr. time for at nå nulpunktsomsætning\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    staticClass: "color-good",
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.budget.cph_goal_ebitda)))]), _vm._v("\n                            Krav til DB pr. time for at nå ønsket EBITDA\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', {
    class: {
      'color-bad': _vm.data.total_coverage_per_hour < _vm.data.budget.cph_zero_revenue, 'color-avg': _vm.data.total_coverage_per_hour < _vm.data.budget.cph_goal_ebitda, 'color-good': _vm.data.total_coverage_per_hour > _vm.data.budget.cph_goal_ebitda
    },
    staticStyle: {
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.total_coverage_per_hour)))]), _vm._v("\n                            DB pr. time"), _c('br'), _vm._v("(realiseret)\n                        ")])])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.data.project_types), function(projectType, index) {
    return _c('tr', {
      key: 'cphProjectType_' + index
    }, [_c('td', {
      staticClass: "table-column__description",
      attrs: {
        "align": "left",
        "title": projectType.name
      }
    }, [_vm._v("\n                                " + _vm._s(projectType.name) + "\n                            ")]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.projects_count)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "font-weight": "bold"
      },
      attrs: {
        "align": "right"
      }
    }, [(projectType.coverage_per_hour !== 0) ? _c('span', [_c('span', {
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [(projectType.coverage_per_hour > _vm.data.budget.cph_goal_ebitda) ? _c('span', {
      staticClass: "color-good"
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")]) : (projectType.coverage_per_hour > _vm.data.budget.cph_zero_revenue) ? _c('span', {
      staticClass: "color-avg"
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")]) : _c('span', {
      staticClass: "color-bad"
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")])])]) : _c('span', [_vm._v("\n                                    -\n                                ")])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "left"
      }
    }, [(projectType.coverage_per_hour !== 0) ? _c('span', [_c('span', {
      staticStyle: {
        "font-size": "14px"
      }
    }, [(projectType.direction === 'up') ? _c('i', {
      staticClass: "fas fa-arrow-up fa-fw color-good"
    }) : _vm._e(), _vm._v(" "), (projectType.direction === 'down') ? _c('i', {
      staticClass: "fas fa-arrow-down fa-fw color-bad"
    }) : _vm._e(), _vm._v(" "), (projectType.direction === 'neutral') ? _c('i', {
      staticClass: "fas fa-arrow-right fa-fw color-avg"
    }) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "fas fa-chart-bar fa-fw",
      on: {
        "click": function($event) {
          _vm.graphModal = projectType
        }
      }
    })]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(projectType.budget)) + "\n                            ")]), _vm._v(" "), (projectType.coverage_per_hour !== 0) ? _c('td', {
      class: {
        'color-bad': (Math.round(projectType.coverage_per_hour) - Math.round(projectType.budget)) < 0, 'color-good': (Math.round(projectType.coverage_per_hour) - Math.round(projectType.budget)) > 0
      },
      attrs: {
        "align": "right"
      }
    }, [((Math.round(projectType.coverage_per_hour) - Math.round(projectType.budget)) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(Math.round(projectType.coverage_per_hour) - Math.round(projectType.budget))) + "\n                            ")]) : _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                -\n                            ")])])
  }), 0)])])])]) : _c('div', [_c('box-loading')], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Opgavetype")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Antal timer")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Antal opgaver")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Realiseret")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left",
      "width": "5%"
    }
  }, [_c('span', {
    staticStyle: {
      "opacity": "0.5"
    }
  }, [_vm._v(" Udv.")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Budget")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right",
      "width": "15%"
    }
  }, [_vm._v("Difference")])])])
}]}

/***/ }),
/* 926 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.claims"
    }
  }), _vm._v("\n        Igangværende reklamationer\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                " + _vm._s(props.row.status.name) + "\n                "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.case_number) + "\n            ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                " + _vm._s(props.row.description ? props.row.description : '-') + "\n            ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                    }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                    " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n            ")]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 801382959)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 927 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "customer-revenue-single"
  }, [(!_vm.loading) ? _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.customers,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'timelog_hours') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("number")(props.row.timelog_hours)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 1550499789)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])]) : _vm._e()], 1)]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 928 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rows.length) ? _c('div', {
    staticClass: "value-wrapper"
  }, [_c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                Værdi, salgspris i alt\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.totalValueWithCP)) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.snoozedProjects"
    }
  }), _vm._v("\n            Opgaver uden bevægelse de sidste " + _vm._s(_vm.$store.state.config.companyMeta.settings.snoozed_days) + " dage\n        ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(props.row.status.name) + "\n                    "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.case_number) + "\n                ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v(_vm._s(props.row.description))]), _vm._v("\n                    " + _vm._s(props.row.description ? props.row.description : '-') + "\n                ")], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                    }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                    " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                ")]) : (props.column.field == 'invoices_total') ? _c('div', [(props.row.invoices_total > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(props.row.invoices_total)))]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'total_expenses') ? _c('div', [(props.row.total_expenses > 0) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'value') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.value)) + "\n                ")], 1) : (props.column.field == 'value_with_avg_cp') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "valueBasedWithCP": true,
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.value_with_avg_cp)) + "\n                ")], 1) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 3865168805)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 929 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-loading",
    style: ('height:' + _vm.height + 'px;')
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 512 512"
    }
  }, [_c('path', {
    attrs: {
      "fill": "none",
      "stroke": "#000000",
      "stroke-width": "10",
      "d": "M507.42 114.49c-2.34-9.47-9.66-16.98-19.06-19.61-9.47-2.61-19.65 0-26.65 6.98l-63.87 63.87-44.25-7.36-7.38-44.24 63.87-63.87c6.94-6.92 9.62-17.09 7-26.54-2.62-9.47-10.19-16.83-19.75-19.2C345.6-8.31 291.95 6.54 254.14 44.3c-37.84 37.87-52.21 92.52-38.62 144.7L22.19 382.29c-29.59 29.63-29.59 77.83 0 107.45C36.54 504.09 55.63 512 75.94 512s39.37-7.91 53.71-22.26l193.14-193.11c52.03 13.73 106.8-.72 144.89-38.82 37.81-37.81 52.68-91.39 39.74-143.32zm-62.36 120.7c-31.87 31.81-78.43 42.63-121.77 28.23l-9.38-3.14-206.88 206.84c-16.62 16.62-45.59 16.62-62.21 0-17.12-17.14-17.12-45.06 0-62.21l207.01-206.98-3.09-9.34c-14.31-43.45-3.56-90.06 28.03-121.67C299.48 44.2 329.44 32 360.56 32c6.87 0 13.81.59 20.72 1.81l-69.31 69.35 13.81 83.02L408.84 200l69.3-69.35c6.72 38.25-5.34 76.79-33.08 104.54zM80 416c-8.84 0-16 7.16-16 16s7.16 16 16 16 16-7.16 16-16-7.16-16-16-16z"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n            Indlæser ...\n        ")])])])
},staticRenderFns: []}

/***/ }),
/* 930 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "title-block",
    class: _vm.position + ' ' + _vm.customClass
  }, [_c('div', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.headline)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), _vm._t("text")], 2)
},staticRenderFns: []}

/***/ }),
/* 931 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "budget-planning",
    class: {
      'loaded': _vm.data && !_vm.data.created_budget
    }
  }, [(_vm.data && !_vm.data.created_budget) ? _c('div', {
    staticClass: "floater"
  }, [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-bottom": "0px",
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "goal-ebitda col-lg-3"
  }, [_c('div', {
    staticClass: "floater__inner"
  }, [_c('div', {
    staticClass: "lg"
  }, [(_vm.stepsInitiated.ebitdagoal) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.ebitda.goal)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]), _vm._v(" "), _c('div', [_vm._v("\n                        Ønsket EBITDA (driftsoverskud)\n                        "), _c('br'), _vm._v(" "), (_vm.stepsInitiated.coverageperhour) ? _c('span', [_vm._v("\n                            Beregnet EBITDA: "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.resultList[_vm.resultList.length - 1].budget)))])]) : _c('span', [_vm._v("\n                            -\n                        ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "demand-for-zero-revenue col-lg-3"
  }, [_c('div', {
    staticClass: "floater__inner"
  }, [_c('div', {
    staticClass: "lg"
  }, [(_vm.stepsInitiated.expenses && _vm.stepsInitiated.hours) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.demandForZeroRevenue)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]), _vm._v("\n                    DB pr. time for at nå\n                    "), _c('br'), _vm._v("\n                    nulpunktsomsætning\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "demand-for-goal col-lg-3"
  }, [_c('div', {
    staticClass: "floater__inner"
  }, [_c('div', {
    staticClass: "lg"
  }, [(_vm.stepsInitiated.expenses && _vm.stepsInitiated.ebitdagoal && _vm.stepsInitiated.hours) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.demandForGoal)) + "\n                        ")]) : _c('span', [_vm._v("\n                            -\n                        ")])]), _vm._v("\n                    DB pr. time for at nå\n                    "), _c('br'), _vm._v("\n                    ønsket EBITDA\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "calculated-coverage-per-hour col-lg-3"
  }, [_c('div', {
    staticClass: "floater__inner"
  }, [(_vm.stepsInitiated.coverageperhour) ? _c('div', {
    staticClass: "lg",
    class: {
      'good': _vm.displayedCoveragePerHour >= Math.ceil(_vm.demandForGoal), 'neutral': _vm.displayedCoveragePerHour > Math.ceil(_vm.demandForZeroRevenue), 'bad': _vm.displayedCoveragePerHour < Math.ceil(_vm.demandForZeroRevenue)
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.displayedCoveragePerHour)) + "\n                    ")]) : _c('div', {
    staticClass: "lg"
  }, [_vm._v("\n                        -\n                    ")]), _vm._v("\n                    Beregnet DB pr. time\n                    "), _c('br'), _vm._v("\n                    (ud fra dine indtastninger)\n                ")])])])]) : _vm._e(), _vm._v(" "), (_vm.showExpensesModal) ? _c('div', {
    staticClass: "expenses-modal"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "inner__title"
  }, [_vm._v("\n                Underkonti for \"" + _vm._s(_vm.showExpensesModal.name) + "\"\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "inner__list"
  }, [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Navn")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.updatingBudget),
      expression: "!updatingBudget"
    }],
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Historisk")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.showExpensesModal.input_type === 'total') ? _c('d-tooltip', {
    attrs: {
      "identifier": "budgetplanning.pencil.modal",
      "placement": "inline",
      "icon": "pencil"
    },
    on: {
      "clicked": function($event) {
        _vm.showExpensesModal.input_type = 'accounts'
      }
    }
  }) : _vm._e(), _vm._v("\n                                Budget\n                            ")], 1)])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.showExpensesModal.accounts.filter(function (x) { return x.entries_total !== 0; })), function(account, index) {
    return _c('tr', {
      key: 'account_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(account.account_number))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(account.name))]), _vm._v(" "), _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.updatingBudget),
        expression: "!updatingBudget"
      }],
      staticStyle: {
        "white-space": "nowrap"
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("currency")(account.entries_total)))]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      attrs: {
        "align": "right"
      }
    }, [(_vm.showExpensesModal.input_type === 'accounts') ? _c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          currencySymbol: '\u00a0kr.',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (account.budget),
        callback: function($$v) {
          _vm.$set(account, "budget", $$v)
        },
        expression: "account.budget"
      }
    }) : _c('span', {
      staticStyle: {
        "display": "block",
        "padding": "4px"
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm._f("currency")(account.budget)) + "\n                                ")])], 1)])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.updatingBudget),
      expression: "!updatingBudget"
    }],
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.showExpensesModal.entries_total)))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.sum(_vm.showExpensesModal.accounts, 'budget'))))])])], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "close-wrapper"
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.closeExpensesModal(_vm.showExpensesModal.slug)
      }
    }
  }, [_vm._v("\n                    Luk\n                ")])])])]) : _vm._e(), _vm._v(" "), _c('box-helper', {
    attrs: {
      "headline": "Budgetlægning",
      "identifier": "budgetPlanning"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "container section"
  }, [_c('title-block', {
    staticClass: "mb-xl",
    attrs: {
      "headline": "<b>Budgetlægning</b>",
      "position": "center"
    }
  }, [_c('p', {
    attrs: {
      "slot": "text"
    },
    slot: "text"
  }, [_vm._v("\n                Læg dit budget\n            ")])]), _vm._v(" "), (_vm.updatingBudget) ? _c('div', {
    staticStyle: {
      "font-weight": "bold",
      "padding": "20px",
      "background": "#172b43",
      "color": "#fff",
      "border-radius": "4px",
      "font-size": "14px"
    }
  }, [_vm._v("\n            OBS! Du er ved at opdatere dit eksisterende budget. Ønsker du at lægge et nyt budget, skal du gå til fanebladet Overblik og herefter vælge fanebladet Læg budget igen.\n            "), _c('br'), _vm._v("\n            Hust at trykke Gem, når du er færdig med at ændre budgettet.\n        ")]) : _vm._e(), _vm._v(" "), (_vm.data && !_vm.data.created_budget) ? _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "margin-top": "30px"
    }
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [(_vm.updatingBudget) ? _c('div', [_vm._v("\n                        Du er nu ved at ændre budgettet for perioden:\n                    ")]) : _c('div', [_vm._v("\n                        Du er nu ved at lægge budget for perioden:"), _c('br')]), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.periods.budget.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.periods.budget.to, 'DD/MM/YYYY')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-6",
    staticStyle: {
      "text-align": "right"
    }
  }, [_vm._v("\n                    Du kigger på data fra perioden:"), _c('br'), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.periods.data.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.periods.data.to, 'DD/MM/YYYY')))])])]), _vm._v(" "), _c('div', {
    staticClass: "step-switcher",
    staticStyle: {
      "display": "none"
    }
  }, [_c('div', {
    staticClass: "steps"
  }, [_c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 1
    },
    on: {
      "click": function($event) {
        _vm.step = 1
      }
    }
  }, [_vm._v("\n                        1. Omkostninger\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 2
    },
    on: {
      "click": function($event) {
        _vm.step = 2
      }
    }
  }, [_vm._v("\n                        2. Ønsket EBITDA (driftsoverskud)\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 3
    },
    on: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("\n                        3. Solgte timer\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 4
    },
    on: {
      "click": function($event) {
        _vm.step = 4
      }
    }
  }, [_vm._v("\n                        4. DB pr. time\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "step",
    class: {
      'active': _vm.step === 5
    },
    on: {
      "click": function($event) {
        _vm.step = 5
      }
    }
  }, [_vm._v("\n                        5. Resultat\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-expenses"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading",
    class: {
      'completed': _vm.stepsCompleted.expenses
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.expenses",
      "type": "icon"
    }
  }), _vm._v(" "), (_vm.stepsCompleted.expenses) ? _c('i', {
    staticClass: "fas fa-check-circle"
  }) : _vm._e(), _vm._v("\n                    Omkostninger\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.stepsInitiated.expenses) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.expenses"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsInitiated.expenses = true
      }
    }
  }, [_vm._v("\n                            Kom i gang\n                        ")])], 1) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.expenses && _vm.stepsCompleted.expenses) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Du har sat dine forventede omkostninger til "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.totalExpenses)))])]), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "height": 300,
      "options": _vm.expensesGraphOptions,
      "series": _vm.totalExpensesPeriodisedSeries,
      "type": "bar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsCompleted.expenses = false
      }
    }
  }, [_vm._v("\n                                Vis / ret indtastning\n                            ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.expenses && !_vm.stepsCompleted.expenses) ? _c('div', [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Nuv. budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Historisk\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Rettet budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Budget\n                                        ")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.expensesAccountCategories), function(accountCategory, index) {
    return _c('tr', {
      key: 'accountCategory_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [(accountCategory.accounts.length > 0) ? _c('i', {
      staticClass: "fas fa-list fa-fw expense-icon",
      on: {
        "click": function($event) {
          return _vm.openExpensesModal(accountCategory)
        }
      }
    }) : _c('i', {
      staticClass: "fas fa-list fa-fw expense-icon",
      staticStyle: {
        "opacity": "0"
      }
    }), _vm._v("\n                                        " + _vm._s(accountCategory.name) + "\n                                        "), (accountCategory.slug === 'vareforbrug') ? _c('span', [_vm._v("\n                                             "), _c('d-tooltip', {
      attrs: {
        "identifier": "budgetplanning.materials.diff",
        "placement": "inline"
      }
    }), _vm._v(" \n                                            "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: ("\n                                                    Ifølge sagsstyringssystemet har du brugt <b>" + (_vm.data.differences.materials.ordersystem > 0 ? '-' : '') + (_vm.$options.filters.currency(_vm.data.differences.materials.ordersystem)) + "</b> på materialer til opgaver.\n                                                    <br><br>\n                                                    Ifølge dit regnskabssystem har du brugt <b>" + (_vm.$options.filters.currency(_vm.data.differences.materials.economic)) + "</b> på materialer til opgaver.\n                                                    <br><br>\n                                                    Det giver en difference på <b>" + (_vm.$options.filters.currency(_vm.data.differences.materials.diff)) + "</b>\n                                                ")
        }),
        expression: "{\n                                                content: `\n                                                    Ifølge sagsstyringssystemet har du brugt <b>${data.differences.materials.ordersystem > 0 ? '-' : ''}${$options.filters.currency(data.differences.materials.ordersystem)}</b> på materialer til opgaver.\n                                                    <br><br>\n                                                    Ifølge dit regnskabssystem har du brugt <b>${$options.filters.currency(data.differences.materials.economic)}</b> på materialer til opgaver.\n                                                    <br><br>\n                                                    Det giver en difference på <b>${$options.filters.currency(data.differences.materials.diff)}</b>\n                                                `\n                                            }"
      }],
      staticClass: "fas fa-calculator",
      staticStyle: {
        "opacity": "0.5"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (accountCategory.slug === 'lonninger-svende') ? _c('span', [_vm._v("\n                                             "), _c('d-tooltip', {
      attrs: {
        "identifier": "budgetplanning.employees.diff",
        "placement": "inline"
      }
    }), _vm._v(" \n                                            "), (_vm.$auth.user().roles[0].name === 'super-admin') ? _c('i', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip",
        value: ({
          content: ("\n                                                    Ifølge sagsstyringssystemet har du brugt <b>" + (_vm.data.differences.employees.ordersystem > 0 ? '-' : '') + (_vm.$options.filters.currency(_vm.data.differences.employees.ordersystem)) + "</b> på lønninger til svende.\n                                                    <br><br>\n                                                    Ifølge dit regnskabssystem har du brugt <b>" + (_vm.$options.filters.currency(_vm.data.differences.employees.economic)) + "</b> på lønninger til svende.\n                                                    <br><br>\n                                                    Det giver en difference på <b>" + (_vm.$options.filters.currency(_vm.data.differences.employees.diff)) + "</b>\n                                                ")
        }),
        expression: "{\n                                                content: `\n                                                    Ifølge sagsstyringssystemet har du brugt <b>${data.differences.employees.ordersystem > 0 ? '-' : ''}${$options.filters.currency(data.differences.employees.ordersystem)}</b> på lønninger til svende.\n                                                    <br><br>\n                                                    Ifølge dit regnskabssystem har du brugt <b>${$options.filters.currency(data.differences.employees.economic)}</b> på lønninger til svende.\n                                                    <br><br>\n                                                    Det giver en difference på <b>${$options.filters.currency(data.differences.employees.diff)}</b>\n                                                `\n                                            }"
      }],
      staticClass: "fas fa-calculator",
      staticStyle: {
        "opacity": "0.5"
      }
    }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (accountCategory.slug === 'underleverandorer') ? _c('span', [_vm._v("\n                                             "), _c('d-tooltip', {
      attrs: {
        "identifier": "budgetplanning.subcontractors",
        "placement": "inline"
      }
    }), _vm._v(" \n                                        ")], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(accountCategory.old_budget)) + "\n                                        ")]) : _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(accountCategory.entries_total)) + "\n                                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      class: {
        'edited-lower': _vm.updatingBudget && accountCategory.old_budget > accountCategory.budget, 'edited-higher': _vm.updatingBudget && accountCategory.old_budget < accountCategory.budget
      },
      attrs: {
        "align": "right"
      }
    }, [(accountCategory.input_type === 'total') ? _c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          currencySymbol: '\u00a0kr.',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (accountCategory.budget),
        callback: function($$v) {
          _vm.$set(accountCategory, "budget", $$v)
        },
        expression: "accountCategory.budget"
      }
    }) : _c('span', {
      staticStyle: {
        "display": "block",
        "padding": "4px"
      }
    }, [_c('d-tooltip', {
      attrs: {
        "identifier": "budgetplanning.pencil.expenses",
        "placement": "inline",
        "icon": "pencil"
      },
      on: {
        "clicked": function($event) {
          accountCategory.input_type = 'total'
        }
      }
    }), _vm._v("\n                                            " + _vm._s(_vm._f("currency")(accountCategory.budget)) + "\n                                        ")], 1)], 1)])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.totalHistoricExpenses > 0) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.totalHistoricExpenses)))]), _vm._v(" "), _c('td', {
    staticClass: "budget",
    class: {
      'edited-lower': _vm.updatingBudget && _vm.totalHistoricExpenses > (_vm.totalExpenses * -1), 'edited-higher': _vm.updatingBudget && _vm.totalHistoricExpenses < (_vm.totalExpenses * -1)
    },
    attrs: {
      "align": "right"
    }
  }, [(_vm.totalExpenses > 0) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")(_vm.totalExpenses)))])])], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til \"omkostninger\"\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentExpenses),
      expression: "commentExpenses"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentExpenses)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentExpenses = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.finishStep('expenses', 'step-expenses')
      }
    }
  }, [_vm._v("\n                                Gem og fortsæt\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-ebitdagoal"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading",
    class: {
      'completed': _vm.stepsCompleted.ebitdagoal
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.goal",
      "type": "icon"
    }
  }), _vm._v(" "), (_vm.stepsCompleted.ebitdagoal) ? _c('i', {
    staticClass: "fas fa-check-circle"
  }) : _vm._e(), _vm._v("\n                    Ønsket EBITDA (driftsoverskud)\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding",
    staticStyle: {
      "text-align": "center"
    }
  }, [(!_vm.stepsInitiated.ebitdagoal) ? _c('div', [(_vm.stepsCompleted.expenses) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.goal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsInitiated.ebitdagoal = true
      }
    }
  }, [_vm._v("\n                                Kom i gang\n                            ")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "opacity": "0.5",
      "font-style": "italic"
    }
  }, [_vm._v("\n                            Udfyld dine forventede omkostninger for at åbne dette punkt\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.ebitdagoal && _vm.stepsCompleted.ebitdagoal) ? _c('div', [_c('div', [_vm._v("Du har sat dit ønskede EBITDA til")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("currency")(_vm.data.ebitda.goal)))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsCompleted.ebitdagoal = false
      }
    }
  }, [_vm._v("\n                                Vis / ret indtastning\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.ebitdagoal && !_vm.stepsCompleted.ebitdagoal) ? _c('div', [(_vm.updatingBudget) ? _c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._m(0), _vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.data.ebitda.old_goal)) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.updatingBudget) ? _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('b', [_vm._v("Rettet budget:")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "autonumeric-wrap",
    class: {
      'edited-higher': _vm.updatingBudget && _vm.data.ebitda.goal > _vm.data.ebitda.old_goal, 'edited-lower': _vm.updatingBudget && _vm.data.ebitda.goal < _vm.data.ebitda.old_goal
    }
  }, [_c('vue-autonumeric', {
    attrs: {
      "options": {
        digitGroupSeparator: '.',
        decimalCharacter: ',',
        decimalCharacterAlternative: '.',
        currencySymbol: '\u00a0kr.',
        currencySymbolPlacement: 's',
        roundingMethod: 'U',
        decimalPlaces: 0
      }
    },
    model: {
      value: (_vm.data.ebitda.goal),
      callback: function($$v) {
        _vm.$set(_vm.data.ebitda, "goal", $$v)
      },
      expression: "data.ebitda.goal"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til \"ønsket EBITDA\"\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentEbitda),
      expression: "commentEbitda"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentEbitda)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentEbitda = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "30px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.finishStep('ebitdagoal', 'step-ebitdagoal')
      }
    }
  }, [_vm._v("\n                                Gem og fortsæt\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-hours"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading",
    class: {
      'completed': _vm.stepsCompleted.hours
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.hours",
      "type": "icon"
    }
  }), _vm._v(" "), (_vm.stepsCompleted.hours) ? _c('i', {
    staticClass: "fas fa-check-circle"
  }) : _vm._e(), _vm._v("\n                    Solgte timer\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.stepsInitiated.hours) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.stepsCompleted.ebitdagoal) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.hours"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsInitiated.hours = true
      }
    }
  }, [_vm._v("\n                                Kom i gang\n                            ")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "opacity": "0.5",
      "font-style": "italic"
    }
  }, [_vm._v("\n                            Udfyld dit ønskede EBITDA for at åbne dette punkt\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.hours && _vm.stepsCompleted.hours) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v("Du har sat forventede antal solgte timer til")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.totalHours)))]), _vm._v(" "), _c('vue-apex-charts', {
    attrs: {
      "height": 300,
      "options": _vm.hoursGraphOptions,
      "series": _vm.totalHoursPeriodisedSeries,
      "type": "bar"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsCompleted.hours = false
      }
    }
  }, [_vm._v("\n                                Vis / ret indtastning\n                            ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.hours && !_vm.stepsCompleted.hours) ? _c('div', [_c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center",
      "margin-bottom": "30px"
    }
  }, [_c('div', [_vm._v("\n                                Gennemsnitlig tid hos kunderne i perioden: "), _c('b', [_vm._v(_vm._s(_vm._f("number")((_vm.sum(_vm.employeesInPeriod, 'hours') / _vm.sum(_vm.employeesInPeriod, 'available_hours')) * 100)) + "%")]), _vm._v(" "), _c('br'), _vm._v("\n                                Beregnet gennemsnitlig tid hos kunderne ud fra din indtastning: "), _c('b', [_vm._v(_vm._s(_vm._f("number")(_vm.percentageHoursWithCustomers)) + "%")])]), _vm._v(" "), (!_vm.updatingBudget && _vm.hoursCalcType === 'projectTypes') ? _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.hoursCalcType = 'employees'
      }
    }
  }, [_vm._v("\n                                Tryk her for at budgettere solgte timer ud fra medarbejdere i stedet\n                            ")]) : _vm._e(), _vm._v(" "), (!_vm.updatingBudget && _vm.hoursCalcType === 'employees') ? _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.hoursCalcType = 'projectTypes'
      }
    }
  }, [_vm._v("\n                                Tryk her for at budgettere solgte timer ud fra opgavetyper i stedet\n                            ")]) : _vm._e()]), _vm._v(" "), (_vm.hoursCalcType === 'projectTypes') ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.hours.project_types), function(projectType, index) {
    return _c('tr', {
      key: 'projectTypeHour_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(projectType.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.projects_count)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours)))]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      attrs: {
        "align": "right"
      }
    }, [_c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (projectType.budget),
        callback: function($$v) {
          _vm.$set(projectType, "budget", $$v)
        },
        expression: "projectType.budget"
      }
    })], 1)])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.project_types, 'hours'))))]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v(_vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.project_types, 'budget'))))])])], 2)]) : _vm._e(), _vm._v(" "), (_vm.hoursCalcType === 'employees') ? _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Medarbejder")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Timer til rådighed")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Kundetid (nuv. budget)\n                                        ")]) : _c('span', [_vm._v("\n                                            Kundetid historisk\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Budget kundetid")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Nuv. budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Solgte timer historisk\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Rettet budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Budget solgte timer\n                                        ")])])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.data.hours.employees), function(employee, index) {
    return _c('tr', {
      key: 'employeeHour_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(employee.name === 'Planlagt ansættelse af nye svende' ? 'Planlagt ansættelse eller afskedigelse af svende/lærlinge' : employee.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(employee.available_hours)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.old_hours_with_project_percent)) + "%    \n                                        ")]) : _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.hours_with_project_percent_historic)) + "%\n                                        ")])]), _vm._v(" "), _c('td', {
      staticStyle: {
        "padding-left": "30px"
      },
      attrs: {
        "align": "right"
      }
    }, [(employee.name === 'Planlagt ansættelse af nye svende') ? _c('div', [_vm._v("\n                                            -\n                                        ")]) : _c('div', {
      staticClass: "slider",
      staticStyle: {
        "margin": "0",
        "display": "flex",
        "align-items": "center"
      }
    }, [(employee.budget_type === 'percent') ? _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employee.hours_with_project_percent),
        expression: "employee.hours_with_project_percent"
      }],
      attrs: {
        "type": "range",
        "min": 0,
        "max": 125
      },
      domProps: {
        "value": (employee.hours_with_project_percent)
      },
      on: {
        "input": function($event) {
          employee.budget = (employee.hours_with_project_percent / 100) * employee.available_hours
        },
        "__r": function($event) {
          return _vm.$set(employee, "hours_with_project_percent", $event.target.value)
        }
      }
    }) : _vm._e(), _vm._v(" "), (employee.budget_type === 'percent') ? _c('div', {
      staticStyle: {
        "padding-left": "5px",
        "width": "50px",
        "flex-shrink": "0"
      }
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("number")(employee.hours_with_project_percent)) + "%\n                                            ")]) : _vm._e(), _vm._v(" "), (employee.budget_type === 'input') ? _c('div', {
      staticStyle: {
        "padding": "11px 0"
      }
    }, [_c('i', {
      staticClass: "fas fa-pencil",
      staticStyle: {
        "opacity": "0.75"
      },
      on: {
        "click": function($event) {
          employee.budget_type = 'percent'
        }
      }
    }), _vm._v("\n                                                " + _vm._s(_vm._f("number")(employee.hours_with_project_percent)) + "%\n                                            ")]) : _vm._e()])]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.old_budget)) + "\n                                        ")]) : _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.hours)) + "\n                                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      class: {
        'edited-higher': _vm.updatingBudget && employee.budget > employee.old_budget, 'edited-lower': _vm.updatingBudget && employee.budget < employee.old_budget
      },
      attrs: {
        "align": "right"
      }
    }, [(employee.budget_type === 'input') ? _c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (employee.budget),
        callback: function($$v) {
          _vm.$set(employee, "budget", $$v)
        },
        expression: "employee.budget"
      }
    }) : _vm._e(), _vm._v(" "), (employee.budget_type === 'percent') ? _c('div', [_c('i', {
      staticClass: "fas fa-pencil",
      staticStyle: {
        "opacity": "0.75"
      },
      on: {
        "click": function($event) {
          employee.budget_type = 'input'
        }
      }
    }), _vm._v("\n                                            " + _vm._s(_vm._f("number")(employee.budget)) + "\n                                        ")]) : _vm._e()], 1)])
  }), _vm._v(" "), _c('tr', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_c('td', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Total")]), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.employees, 'old_budget'))) + "\n                                        ")]) : _c('span', [_vm._v("\n                                            " + _vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.employees, 'hours'))) + "\n                                        ")])]), _vm._v(" "), _c('td', {
    class: {
      'edited-higher': _vm.updatingBudget && _vm.sum(_vm.data.hours.employees, 'old_budget') < _vm.sum(_vm.data.hours.employees, 'budget'), 'edited-lower': _vm.updatingBudget && _vm.sum(_vm.data.hours.employees, 'old_budget') > _vm.sum(_vm.data.hours.employees, 'budget')
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm._f("number")(_vm.sum(_vm.data.hours.employees, 'budget'))) + "\n                                    ")])])], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til \"solgte timer\"\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentHours),
      expression: "commentHours"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentHours)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentHours = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.finishStep('hours', 'step-hours')
      }
    }
  }, [_vm._v("\n                                Gem og fortsæt\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-coverageperhour"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading",
    class: {
      'completed': _vm.stepsCompleted.coverageperhour
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.coverageperhour",
      "type": "icon"
    }
  }), _vm._v(" "), (_vm.stepsCompleted.coverageperhour) ? _c('i', {
    staticClass: "fas fa-check-circle"
  }) : _vm._e(), _vm._v("\n                    DB pr. time\n                ")], 1), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.stepsInitiated.coverageperhour) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.stepsCompleted.hours) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('contentful-guide', {
    attrs: {
      "identifier": "guide.coverageperhour"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsInitiated.coverageperhour = true
      }
    }
  }, [_vm._v("\n                                Kom i gang\n                            ")])], 1) : _c('div', {
    staticStyle: {
      "text-align": "center",
      "opacity": "0.5",
      "font-style": "italic"
    }
  }, [_vm._v("\n                            Udfyld forventet antal solgte timer for at åbne dette punkt\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.coverageperhour && _vm.stepsCompleted.coverageperhour) ? _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('div', [_vm._v("Dit beregnede DB pr. time er")]), _vm._v(" "), _c('div', {
    class: {
      'good': _vm.displayedCoveragePerHour >= Math.ceil(_vm.demandForGoal), 'neutral': _vm.displayedCoveragePerHour > Math.ceil(_vm.demandForZeroRevenue), 'bad': _vm.displayedCoveragePerHour < Math.ceil(_vm.demandForZeroRevenue)
    },
    staticStyle: {
      "margin-top": "15px",
      "font-size": "24px",
      "font-weight": "bold"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm._f("currency")(_vm.displayedCoveragePerHour)) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.stepsCompleted.coverageperhour = false
      }
    }
  }, [_vm._v("\n                                Vis / ret indtastning\n                            ")])])]) : _vm._e(), _vm._v(" "), (_vm.stepsInitiated.coverageperhour && !_vm.stepsCompleted.coverageperhour) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_vm._v("\n                            Gennemsnitligt DB pr. time historisk: "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(_vm.coveragePerHourHistoric)))])]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Opgavetype")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Antal opgaver")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Gns. antal timer pr. opgave")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Nuv. budget\n                                        ")]) : _c('span', [_vm._v("\n                                            DB pr. time historisk\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("\n                                            Rettet budget\n                                        ")]) : _c('span', [_vm._v("\n                                            Budget\n                                        ")])]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Gns. ekstra pris pr. opgave")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.data.coverage_per_hour.project_types), function(projectType, index) {
    return _c('tr', {
      key: 'cphProjectType_' + index
    }, [_c('td', {
      attrs: {
        "align": "left"
      }
    }, [_vm._v(_vm._s(projectType.name))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.projects_count)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours_with_ongoing)))]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [_vm._v(_vm._s(_vm._f("number")(projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)))]), _vm._v(" "), (!_vm.updatingBudget) ? _c('td', {
      staticStyle: {
        "font-weight": "bold"
      },
      attrs: {
        "align": "right"
      }
    }, [(projectType.coverage_per_hour > _vm.demandForGoal) ? _c('span', {
      staticClass: "good",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")]) : (projectType.coverage_per_hour > _vm.demandForZeroRevenue) ? _c('span', {
      staticClass: "neutral",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")]) : _c('span', {
      staticClass: "bad",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.coverage_per_hour)) + "\n                                        ")])]) : _c('td', {
      staticStyle: {
        "font-weight": "bold"
      },
      attrs: {
        "align": "right"
      }
    }, [(projectType.old_budget_coverage_per_hour > _vm.demandForGoal) ? _c('span', {
      staticClass: "good",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.old_budget_coverage_per_hour)) + "\n                                        ")]) : (projectType.old_budget_coverage_per_hour > _vm.demandForZeroRevenue) ? _c('span', {
      staticClass: "neutral",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.old_budget_coverage_per_hour)) + "\n                                        ")]) : _c('span', {
      staticClass: "bad",
      staticStyle: {
        "display": "flex",
        "align-items": "center",
        "justify-content": "flex-end"
      }
    }, [_vm._v("\n                                            " + _vm._s(_vm._f("currency")(projectType.old_budget_coverage_per_hour)) + "\n                                        ")])]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      attrs: {
        "align": "right"
      }
    }, [_c('div', {
      class: {
        'good': projectType.budget_coverage_per_hour > _vm.demandForGoal, 'neutral': projectType.budget_coverage_per_hour > _vm.demandForZeroRevenue, 'bad': projectType.budget_coverage_per_hour < _vm.demandForZeroRevenue
      },
      staticStyle: {
        "font-weight": "bold"
      }
    }, [_c('vue-autonumeric', {
      attrs: {
        "options": {
          digitGroupSeparator: '.',
          decimalCharacter: ',',
          decimalCharacterAlternative: '.',
          currencySymbol: '\u00a0kr.',
          currencySymbolPlacement: 's',
          roundingMethod: 'U',
          decimalPlaces: 0
        }
      },
      model: {
        value: (projectType.budget_coverage_per_hour),
        callback: function($$v) {
          _vm.$set(projectType, "budget_coverage_per_hour", $$v)
        },
        expression: "projectType.budget_coverage_per_hour"
      }
    })], 1)]), _vm._v(" "), _c('td', {
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [(((projectType.budget_coverage_per_hour - projectType.old_budget_coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")((projectType.budget_coverage_per_hour - projectType.old_budget_coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0))) + "\n                                        ")]) : _c('span', [(((projectType.budget_coverage_per_hour - projectType.coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0)) > 0) ? _c('span', [_vm._v("+")]) : _vm._e(), _vm._v(_vm._s(_vm._f("currency")((projectType.budget_coverage_per_hour - projectType.coverage_per_hour) * (projectType.hours > 0 ? (projectType.hours / projectType.projects_count) : 0))) + "\n                                        ")])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til \"DB pr. time\"\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentCPH),
      expression: "commentCPH"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.commentCPH)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.commentCPH = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.finishStep('coverageperhour', 'step-coverageperhour')
      }
    }
  }, [_vm._v("\n                                Gem og fortsæt\n                            ")])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "placeholder",
    staticStyle: {
      "margin-top": "30px"
    },
    attrs: {
      "id": "step-result"
    }
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Resultat\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.allStepsCompleted) ? _c('div', {
    staticStyle: {
      "opacity": "0.5",
      "font-style": "italic",
      "text-align": "center"
    }
  }, [_vm._v("\n                        Udfyld omkostninger, ønsket EBITDA, solgte timer samt DB pr. time for at se det endelige resultat her\n                    ")]) : _c('div', [_c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Konto")]), _vm._v(" "), (!_vm.updatingBudget) ? _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Historisk")]) : _vm._e(), _vm._v(" "), (_vm.updatingBudget) ? _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Nuv. budget")]) : _vm._e(), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [(_vm.updatingBudget) ? _c('span', [_vm._v("Nyt budget")]) : _c('span', [_vm._v("Budget")])]), _vm._v(" "), _c('th', {
    staticStyle: {
      "font-style": "italic"
    },
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                                        Forskel\n                                    ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.resultList), function(accountCategory, index) {
    return _c('tr', {
      key: 'resultAccountCategory_' + index
    }, [_c('td', {
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      attrs: {
        "align": "left"
      }
    }, [_vm._v("\n                                        " + _vm._s(accountCategory.name) + "\n                                    ")]), _vm._v(" "), (!_vm.updatingBudget) ? _c('td', {
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(accountCategory.total)) + "\n                                    ")]) : _vm._e(), _vm._v(" "), (_vm.updatingBudget) ? _c('td', {
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(accountCategory.oldBudget)) + "\n                                    ")]) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "budget",
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      attrs: {
        "align": "right"
      }
    }, [_vm._v("\n                                        " + _vm._s(_vm._f("currency")(accountCategory.budget)) + "\n                                    ")]), _vm._v(" "), _c('td', {
      staticClass: "budget",
      class: {
        'bold': ['Dækningsbidrag 1', 'Dækningsbidrag 2', 'EBITDA'].includes(accountCategory.name)
      },
      staticStyle: {
        "font-style": "italic"
      },
      attrs: {
        "align": "right"
      }
    }, [(_vm.updatingBudget) ? _c('span', [(Math.round(accountCategory.budget) > Math.round(accountCategory.oldBudget)) ? _c('span', {
      staticClass: "good"
    }, [_vm._v("\n                                                +" + _vm._s(_vm._f("currency")(accountCategory.budget - accountCategory.oldBudget)) + "\n                                            ")]) : (Math.round(accountCategory.budget) < Math.round(accountCategory.oldBudget)) ? _c('span', {
      staticClass: "bad"
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("currency")(accountCategory.budget - accountCategory.oldBudget)) + "\n                                            ")]) : _c('span', [_vm._v("\n                                                -\n                                            ")])]) : _c('span', [(Math.round(accountCategory.budget) > Math.round(accountCategory.total)) ? _c('span', {
      staticClass: "good"
    }, [_vm._v("\n                                                +" + _vm._s(_vm._f("currency")(accountCategory.budget - accountCategory.total)) + "\n                                            ")]) : (Math.round(accountCategory.budget) < Math.round(accountCategory.total)) ? _c('span', {
      staticClass: "bad"
    }, [_vm._v("\n                                                " + _vm._s(_vm._f("currency")(accountCategory.budget - accountCategory.total)) + "\n                                            ")]) : _c('span', [_vm._v("\n                                                -\n                                            ")])])])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_vm._v("\n                            Evt. kommentar til dette budget\n                            "), _c('div', [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.comment),
      expression: "comment"
    }],
    staticStyle: {
      "border": "1px solid #ccc",
      "border-radius": "4px",
      "padding": "10px",
      "text-align": "left",
      "width": "50%",
      "margin-top": "10px"
    },
    attrs: {
      "placeholder": "Kommentér eksempelvis på hvilke ting du har ændret, så du kan huske det til næste budgetlægning",
      "rows": "4"
    },
    domProps: {
      "value": (_vm.comment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.comment = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-top": "15px",
      "text-align": "center"
    }
  }, [_c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        return _vm.saveBudget()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-save fa-fw"
  }), _vm._v("\n                                Gem budget\n                            ")])])])])])]) : (_vm.data && _vm.data.created_budget) ? _c('div', {
    staticClass: "placeholder padding",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("\n            Der er lagt et budget for perioden:"), _c('br'), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.created_budget.from, 'DD/MM/YYYY')) + " - " + _vm._s(_vm._f("moment")(_vm.data.created_budget.to, 'DD/MM/YYYY')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n            Budgettet blev lagt:"), _c('br'), _c('b', [_vm._v(_vm._s(_vm._f("moment")(_vm.data.created_budget.created_at, 'DD/MM/YYYY [kl.] HH:mm')))]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.data.created_budget.comment) ? _c('div', [_c('div', [_vm._v("Din egen kommentar til budgettet:")]), _vm._v(" "), _c('pre', {
    staticStyle: {
      "display": "block",
      "border": "1px solid #ccc",
      "padding": "15px",
      "border-radius": "4px",
      "width": "50%",
      "margin": "10px auto 0 auto",
      "font-family": "inherit",
      "text-align": "left"
    }
  }, [_vm._v(_vm._s(_vm.data.created_budget.comment))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "budget-btn",
    on: {
      "click": function($event) {
        _vm.data.created_budget = null
      }
    }
  }, [_vm._v("\n                Læg et nyt budget\n            ")]), _vm._v(" "), (_vm.data.created_budget.data) ? _c('span', [_vm._v("\n                  \n                "), _c('a', {
    staticClass: "budget-btn",
    staticStyle: {
      "text-decoration": "none"
    },
    attrs: {
      "href": "/budget-laegning?update=1"
    }
  }, [_vm._v("\n                    Ret eksisterende budget\n                ")])]) : _vm._e()]) : _c('div', [_c('box-loading')], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('b', [_vm._v("Nuv. budget:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    attrs: {
      "align": "left"
    }
  }, [_vm._v("Opgavetype")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Antal opgaver")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Gns. antal timer pr. opgave")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Solgte timer historisk")]), _vm._v(" "), _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("Budget solgte timer")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                                        Antal timer\n                                        "), _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px",
      "opacity": "0.5"
    }
  }, [_vm._v("afsluttede opgaver")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', {
    attrs: {
      "align": "right"
    }
  }, [_vm._v("\n                                        Antal timer\n                                        "), _c('span', {
    staticStyle: {
      "display": "block",
      "font-size": "10px",
      "opacity": "0.5"
    }
  }, [_vm._v("inkl. igangv. opgaver")])])
}]}

/***/ }),
/* 932 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-learning"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('revenue-and-costs', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'revenueAndCosts'),
      expression: "selectedItem === 'revenueAndCosts'"
    }]
  }), _vm._v(" "), _c('ebitda', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'ebitda'),
      expression: "selectedItem === 'ebitda'"
    }]
  }), _vm._v(" "), _c('budget-followup', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'budgetFollowup'),
      expression: "selectedItem === 'budgetFollowup'"
    }]
  }), _vm._v(" "), (_vm.selectedItem === 'compare') ? _c('compare') : _vm._e(), _vm._v(" "), _c('potential', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'potential'),
      expression: "selectedItem === 'potential'"
    }]
  }), _vm._v(" "), _c('keyFigures', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'keyFigures'),
      expression: "selectedItem === 'keyFigures'"
    }]
  }), _vm._v(" "), _c('materials', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'materials'),
      expression: "selectedItem === 'materials'"
    }]
  }), _vm._v(" "), _c('all-invoices', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'allInvoices'),
      expression: "selectedItem === 'allInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('allInvoices', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 933 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "employees-sub-projects-single"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.first_name) + " " + _vm._s(_vm.data.last_name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.sub_projects,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.description) + "\n                    ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                    ")]) : (props.column.field == 'total_expenses') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name ? props.row.name : '-') + "\n                    ")]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                        -\n                    ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                        -\n                    ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 934 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('div', {
    staticClass: "inner"
  }, [_vm._m(0), _vm._v(" "), (!_vm.showResetPasswordForm) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                Login\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "input username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                    Brugernavn\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Indtast brugernavn"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "input password"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n                    Adgangskode\n                ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Indtast adgangskode"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.login()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "remember-me"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember",
      "id": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "remember"
    }
  }, [_vm._v("\n                        Husk mig\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "forgot-password"
  }, [_c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        return _vm.toggleResetPasswordForm()
      }
    }
  }, [_vm._v("\n                        Glemt adgangskode?\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.login()
      }
    }
  }, [_vm._v("\n                Log ind\n            ")])]) : _c('div', {
    staticClass: "box"
  }, [(!_vm.passwordResetted) ? _c('div', [_c('div', {
    staticClass: "header"
  }, [_vm._v("\n                    Glemt adgangskode\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "input username"
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                        E-mail\n                    ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "email",
      "placeholder": "Indtast e-mail"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doReset()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        return _vm.doReset()
      }
    }
  }, [_vm._v("\n                    Nulstil adgangskode\n                ")])]) : _c('div', [_vm._v("\n                Vi har nu nulstillet din adgangskode. Du bør have modtaget en e-mail med en midlertidig adgangskode. Når du logger ind næste gang, anbefaler vi, at du ændrer din kode til noget du selv kan huske.\n            ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/proebitda_logo.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "slogan"
  }, [_vm._v("\n                - Garanterede resultater\n            ")])])
}]}

/***/ }),
/* 935 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "register-card"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('h3', [_vm._v("Registrer bruger")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('form', {
    attrs: {
      "action": "/#",
      "method": "/post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.register()
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "username"
    }
  }, [_vm._v("\n                Brugernavn:\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.username),
      expression: "username"
    }],
    attrs: {
      "type": "text",
      "name": "username",
      "placeholder": "Brugernavn"
    },
    domProps: {
      "value": (_vm.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("\n                Password:\n            ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password",
      "placeholder": "Password"
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "remember"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rememberMe),
      expression: "rememberMe"
    }],
    attrs: {
      "type": "checkbox",
      "name": "remember"
    },
    domProps: {
      "checked": Array.isArray(_vm.rememberMe) ? _vm._i(_vm.rememberMe, null) > -1 : (_vm.rememberMe)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rememberMe,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.rememberMe = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.rememberMe = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.rememberMe = $$c
        }
      }
    }
  }), _vm._v(" Husk mig\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                Registrer\n            ")])])])])
},staticRenderFns: []}

/***/ }),
/* 936 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "change-company"
  }, [_c('div', {
    staticClass: "container section"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n                    Skift virksomhed\n                ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                    Som super admin kan du her ændre hvilken virksomhed du ønsker at se data for. Når du vælger en virksomhed, vil applikationen opdatere og du ser nu de samme data, som virksomhedens egne brugere ser det.\n                ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "24px"
    }
  }, [_vm._v("\n                    Tallet ud for hver virksomhed viser hvor mange svende der har registreret tid inden for de seneste 90 dage.\n                ")]), _vm._v(" "), (_vm.invalidApiKeyCount > 0) ? _c('div', {
    staticClass: "api-warning-banner"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-triangle"
  }), _vm._v("\n                    " + _vm._s(_vm.invalidApiKeyCount) + " virksomhed" + _vm._s(_vm.invalidApiKeyCount === 1 ? '' : 'er') + " med ugyldig API-nøgle\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "filters"
  }, [_c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("Sortering")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.sortBy === 'name'
    },
    on: {
      "click": function($event) {
        _vm.sortBy = 'name'
      }
    }
  }, [_vm._v("Alfabetisk")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.sortBy === 'svende_desc'
    },
    on: {
      "click": function($event) {
        _vm.sortBy = 'svende_desc'
      }
    }
  }, [_vm._v("Flest svende")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.sortBy === 'newest'
    },
    on: {
      "click": function($event) {
        _vm.sortBy = 'newest'
      }
    }
  }, [_vm._v("Senest oprettet")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("System")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.providerFilter === 'all'
    },
    on: {
      "click": function($event) {
        _vm.providerFilter = 'all'
      }
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.providerFilter === 'Ordrestyring'
    },
    on: {
      "click": function($event) {
        _vm.providerFilter = 'Ordrestyring'
      }
    }
  }, [_vm._v("Ordrestyring")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.providerFilter === 'Minuba'
    },
    on: {
      "click": function($event) {
        _vm.providerFilter = 'Minuba'
      }
    }
  }, [_vm._v("Minuba")])]), _vm._v(" "), _c('div', {
    staticClass: "filter-group"
  }, [_c('div', {
    staticClass: "filter-label"
  }, [_vm._v("Svende")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.svendeFilter === 'all'
    },
    on: {
      "click": function($event) {
        _vm.svendeFilter = 'all'
      }
    }
  }, [_vm._v("Alle")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.svendeFilter === 'with'
    },
    on: {
      "click": function($event) {
        _vm.svendeFilter = 'with'
      }
    }
  }, [_vm._v("Med svende")]), _vm._v(" "), _c('button', {
    class: {
      active: _vm.svendeFilter === 'without'
    },
    on: {
      "click": function($event) {
        _vm.svendeFilter = 'without'
      }
    }
  }, [_vm._v("Uden svende")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-8"
  }, [(_vm.loading) ? _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }) : [(_vm.filteredCompanies.length === 0) ? _c('div', {
    staticStyle: {
      "color": "#666",
      "padding": "20px"
    }
  }, [_vm._v("\n                        Ingen virksomheder matcher filtrene.\n                    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredCompanies), function(company) {
    return _c('div', {
      key: company.uuid,
      staticClass: "company"
    }, [_c('div', {
      staticClass: "name"
    }, [(company.api_key_status === 'invalid') ? _c('span', {
      staticClass: "api-warning",
      attrs: {
        "title": 'Ugyldig API-nøgle: ' + (company.api_key_check_error || '?')
      }
    }, [_c('i', {
      staticClass: "fas fa-exclamation-triangle"
    })]) : _vm._e(), _vm._v("\n                            " + _vm._s(company.name) + "\n                            "), _c('br'), _vm._v(" "), (company.api_provider.name === 'Ordrestyring') ? _c('span', {
      staticStyle: {
        "background": "#339861",
        "color": "#fff",
        "font-size": "12px",
        "padding": "2px 6px",
        "margin-top": "4px",
        "display": "inline-block",
        "border-radius": "3px"
      }
    }, [_vm._v("\n                                " + _vm._s(company.api_provider.name) + "\n                            ")]) : _c('span', {
      staticStyle: {
        "background": "#852240",
        "color": "#fff",
        "font-size": "12px",
        "padding": "2px 6px",
        "margin-top": "4px",
        "display": "inline-block",
        "border-radius": "3px"
      }
    }, [_vm._v("\n                                " + _vm._s(company.api_provider.name) + "\n                            ")]), _vm._v(" "), (company.active_field_employees_90d > 0) ? _c('span', {
      staticClass: "svende-badge",
      attrs: {
        "title": 'Aktive svende (working_field=1) der har registreret tid de seneste 90 dage'
      }
    }, [_c('i', {
      staticClass: "fas fa-user-hard-hat"
    }), _vm._v(" " + _vm._s(company.active_field_employees_90d) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "action",
      on: {
        "click": function($event) {
          return _vm.changeCompany(company)
        }
      }
    }, [_vm._v("\n                            Skift til denne virksomhed\n                            "), _c('i', {
      staticClass: "fas fa-arrow-right"
    })])])
  })]], 2)])])])
},staticRenderFns: []}

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rows.length) ? _c('div', {
    staticClass: "value-wrapper"
  }, [_c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                Værdi, salgspris i alt\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.totalValueWithCP)) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "projects.ongoingProjects"
    }
  }), _vm._v("\n            Igangværende opgaver (" + _vm._s(_vm.employeeName) + ")\n        ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                    "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                    " + _vm._s(props.row.status.name) + "\n                    "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.case_number) + "\n                ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description ? props.row.description : '-'
          }
        }, [_vm._v(_vm._s(props.row.description ? props.row.description : '-'))])], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                        content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                    }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                    " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                    " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                    " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                ")]) : (props.column.field == 'invoices_total') ? _c('div', [(props.row.invoices_total > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(props.row.invoices_total)))]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'total_expenses') ? _c('div', [(props.row.total_expenses > 0) ? _c('span', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                    ")]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'value') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.value)) + "\n                ")], 1) : (props.column.field == 'value_with_avg_cp') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "valueBasedWithCP": true,
            "project": props.row
          }
        }), _vm._v("\n                    " + _vm._s(_vm._f("currency")(props.row.value_with_avg_cp)) + "\n                ")], 1) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                    " + _vm._s(props.formattedRow[props.column.field]) + "\n                ")])]
      }
    }], null, false, 2096538820)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.kostprisPrTime"
    }
  }), _vm._v("\n        Kostpris pr. time\n    ")], 1), _vm._v(" "), (_vm.data && !_vm.loading && _vm.data.accounts_total && _vm.data.total_hours) ? _c('div', {
    staticClass: "placeholder padding box"
  }, [_c('div', {
    staticClass: "large"
  }, [_vm._v("\n            " + _vm._s(_vm._f("currency")(_vm.data.costprice_per_hour)) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "meta"
  }, [_vm._v("\n            Udregningen er baseret på de totale udgifter til svende divideret med antal timer brugt hos kunderne i perioden\n            "), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }), _vm._v(" "), (_vm.showCalculations) ? _c('div', {
    staticClass: "accounts"
  }, [_vm._l((_vm.data.calculations), function(account) {
    return _c('div', {
      key: account.uuid,
      staticClass: "account"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v("\n                        " + _vm._s(account.name) + "\n                    ")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(Math.abs(account.total))) + "\n                    ")])])
  }), _vm._v(" "), _c('div', {
    staticClass: "account total"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        Total\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.data.accounts_total)) + "\n                    ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "account total"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v("\n                        Antal timer hos kunderne\n                    ")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("\n                        " + _vm._s(_vm._f("number")(_vm.data.total_hours)) + "\n                    ")])])], 2) : _vm._e()])]) : (!_vm.data && _vm.loading) ? _c('box-loading', {
    attrs: {
      "height": "350"
    }
  }) : _c('div', {
    staticClass: "placeholder padding"
  }, [_vm._v("\n        Vi kunne ikke udregne kostprisen. Tjek, at du har angivet hvilke medarbejdere og konti, der skal regnes med i denne udregning. Dette kan du ændre i indstillingerne\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "economy-operations"
  }, [_c('content-switch', {
    attrs: {
      "items": _vm.switchItems,
      "selectedItem": _vm.selectedItem,
      "counts": _vm.counts
    },
    on: {
      "selectItem": function($event) {
        return _vm.handleSelectItem($event)
      }
    }
  }), _vm._v(" "), _c('noInvoiceProjects-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'noInvoiceProjects'),
      expression: "selectedItem === 'noInvoiceProjects'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('noInvoiceProjects', $event)
      }
    }
  }), _vm._v(" "), _c('unpaidInvoices-table', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'unpaidInvoices'),
      expression: "selectedItem === 'unpaidInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('unpaidInvoices', $event)
      }
    }
  }), _vm._v(" "), _c('exceeded-payments', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'exceededPayments'),
      expression: "selectedItem === 'exceededPayments'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('exceededPayments', $event)
      }
    }
  }), _vm._v(" "), _c('all-invoices', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.selectedItem === 'allInvoices'),
      expression: "selectedItem === 'allInvoices'"
    }],
    on: {
      "finishedLoading": function($event) {
        return _vm.updateCount('allInvoices', $event)
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 940 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "compare-coverage-per-hour"
  }, [_c('div', {
    staticClass: "placeholder"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            DB pr. time\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder padding"
  }, [(!_vm.loading && _vm.series.length > 0) ? _c('vue-apex-charts', {
    ref: "tester",
    attrs: {
      "height": _vm.height,
      "options": _vm.options,
      "series": _vm.series,
      "type": "line"
    }
  }) : _c('box-loading', {
    attrs: {
      "height": "400"
    }
  })], 1)])])
},staticRenderFns: []}

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account-plan"
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("\n        Kontoplan\n    ")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "cursor": "pointer",
      "margin-bottom": "15px"
    },
    attrs: {
      "align": "right"
    },
    on: {
      "click": function($event) {
        _vm.showEmptyAccounts = !_vm.showEmptyAccounts
      }
    }
  }, [(!_vm.showEmptyAccounts) ? _c('span', [_vm._v("Vis konti uden bevægelse")]) : _c('span', [_vm._v("Skjul konti uden bevægelse")])]), _vm._v(" "), (!_vm.loading && _vm.accounts && _vm.accountCategories) ? _c('div', {
    staticClass: "accounts"
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.filteredAccounts), function(account) {
    return _c('div', {
      key: account.uuid,
      staticClass: "account"
    }, [_c('div', {
      staticClass: "number"
    }, [_vm._v("\n                " + _vm._s(account.account_number) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "name"
    }, [_vm._v("\n                " + _vm._s(account.name) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "value"
    }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(account.entries_total)) + "\n            ")]), _vm._v(" "), _c('div', {
      staticClass: "category"
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (account.category.uuid),
        expression: "account.category.uuid"
      }],
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(account.category, "uuid", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          return _vm.updateAccount(account, $event)
        }]
      }
    }, _vm._l((_vm.accountCategories), function(accountCategory) {
      return _c('option', {
        key: accountCategory.uuid,
        domProps: {
          "value": accountCategory.uuid
        }
      }, [_vm._v("\n                        " + _vm._s(accountCategory.name) + "\n                    ")])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "show"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (account.show),
        expression: "account.show"
      }],
      attrs: {
        "type": "checkbox"
      },
      domProps: {
        "checked": Array.isArray(account.show) ? _vm._i(account.show, null) > -1 : (account.show)
      },
      on: {
        "change": [function($event) {
          var $$a = account.show,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(account, "show", $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(account, "show", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(account, "show", $$c)
          }
        }, function($event) {
          return _vm.toggleAccount(account)
        }]
      }
    }), _vm._v("\n                 \n                "), (account.show) ? _c('span', [_vm._v("\n                    Synlig\n                ")]) : _c('span', [_vm._v("\n                    Skjult\n                ")])])])
  })], 2) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "account bold"
  }, [_c('div', {
    staticClass: "number"
  }, [_vm._v("Konto")]), _vm._v(" "), _c('div', {
    staticClass: "name"
  }, [_vm._v("Navn")]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v("Bogført i perioden")]), _vm._v(" "), _c('div', {
    staticClass: "category"
  }, [_vm._v("Hovedkonto")]), _vm._v(" "), _c('div', {
    staticClass: "show"
  }, [_vm._v("Vis/skjul")])])
}]}

/***/ }),
/* 942 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ("number-card " + _vm.state + " " + (_vm.selected ? 'selected' : '')),
    on: {
      "click": function($event) {
        return _vm.goTo()
      }
    }
  }, [(_vm.tooltipIdentifier) ? _c('div', {
    staticClass: "tooltip-bottom-right"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "inline",
      "identifier": _vm.tooltipIdentifier
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    class: 'fad fa-' + _vm.icon + ' fa-fw'
  })]), _vm._v(" "), _c('div', {
    staticClass: "number",
    class: 'colo__' + _vm.state
  }, [(_vm.number !== false) ? _c('count-to', {
    ref: "counter",
    attrs: {
      "startVal": 0,
      "endVal": Number(_vm.number),
      "duration": 5000,
      "autoplay": true,
      "separator": "."
    }
  }) : _c('span', {
    staticClass: "soon"
  }, [_vm._v("\n            Kommer snart\n        ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "heading"
  }, [_vm._v("\n        " + _vm._s(_vm.heading) + "\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "description"
  }, [_vm._v("\n        " + _vm._s(_vm.description) + "\n    ")])])
},staticRenderFns: []}

/***/ }),
/* 943 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.allInvoices"
    }
  }), _vm._v("\n        Alle fakturaer og kreditnotaer\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number ? props.row.invoice_number : '-') + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'paid') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [(props.row.paid) ? _c('span', [_vm._v("\n                    Betalt\n                ")]) : _c('span', [_vm._v("\n                    Ikke betalt\n                ")])]) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 2812794680)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "placement": "left",
      "identifier": "oekonomi.overdueInvoices"
    }
  }), _vm._v("\n        Fakturaer hvor betalingsfristen er overskredet med " + _vm._s(_vm.$store.state.config.companyMeta.settings.overdue_days) + " dage (" + _vm._s(_vm.employeeName) + ")\n    ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description--long",
          attrs: {
            "title": props.row.description
          }
        }, [_vm._v("\n                " + _vm._s(props.row.description) + "\n            ")]) : (props.column.field == 'invoice_number') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(props.row.invoice_number) + "\n            ")]) : (props.column.field == 'external_id') ? _c('div', {
          staticClass: "table-column__external-id"
        }, [_vm._v("\n                " + _vm._s(props.row.external_id) + "\n            ")]) : (props.column.field == 'due_at') ? _c('div', [_vm._v("\n                " + _vm._s(_vm._f("moment")(props.row.due_at, "DD. MMM YYYY")) + "\n            ")]) : (props.column.field == 'amount') ? _c('div', {
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(props.row.amount)) + "\n            ")]) : (props.column.field == 'project.minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                " + _vm._s(props.formattedRow[props.column.field]) + "\n            ")])]
      }
    }], null, false, 1272204435)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n            Ingen data ...\n        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.rows.length) ? _c('div', {
    staticClass: "value-wrapper"
  }, [_c('div', {
    staticClass: "value-line"
  }, [_c('div', {
    staticClass: "left"
  }, [_vm._v("\n                Værdi, salgspris i alt\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_vm._v("\n                " + _vm._s(_vm._f("currency")(_vm.totalValueWithCP)) + "\n            ")])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "g-table-wrapper"
  }, [_c('div', {
    staticClass: "table-title"
  }, [_c('d-tooltip', {
    attrs: {
      "identifier": "oekonomi.unbilledProjects",
      "placement": "left"
    }
  }), _vm._v("\n            Afsluttede opgaver, der ikke er fakturerede (" + _vm._s(_vm.employeeName) + ")\n        ")], 1), _vm._v(" "), (!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'status.name') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(props.row.status.name) + "\n                        "), _c('div', {
          staticClass: "coverage-indicator status",
          style: ('background:#' + props.row.status.color + ';')
        })]) : (props.column.field == 'case_number') ? _c('div', {
          staticClass: "table-column__ordernumber",
          staticStyle: {
            "text-align": "left"
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.case_number) + "\n                    ")]) : (props.column.field == 'description') ? _c('div', {
          staticClass: "table-column__description"
        }, [(props.row.calculation_price > 499 || props.row.calculation_cost > 499) ? _c('budget-tooltip', {
          attrs: {
            "project": props.row
          }
        }) : _vm._e(), _vm._v(" "), _c('span', {
          attrs: {
            "title": props.row.description ? props.row.description : '-'
          }
        }, [_vm._v(_vm._s(props.row.description ? props.row.description : '-'))])], 1) : (props.column.field == 'customer.name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer ? props.row.customer.name : '-'
          }
        }, [(props.row.installation_address) ? _c('i', {
          directives: [{
            name: "tooltip",
            rawName: "v-tooltip",
            value: ({
              content: '<b>Installationsadresse</b><br>' + (_vm.$auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)
            }),
            expression: "{\n                            content: '<b>Installationsadresse</b><br>' + ($auth.user().company.demo_company ? 'Vejnavn nr, postnummer by' : props.row.installation_address.full_text)\n                        }"
          }],
          staticClass: "fal fa-map-marker-alt",
          staticStyle: {
            "margin-left": "2px"
          }
        }) : _vm._e(), _vm._v("\n                        " + _vm._s(props.row.customer ? props.row.customer.name : '-') + "\n                    ")]) : (props.column.field == 'action') ? _c('div', {
          staticClass: "g-table__action",
          on: {
            "click": function($event) {
              return _vm.openExternalLink(props.row.external_id)
            }
          }
        }, [_c('i', {
          staticClass: "fad fa-eye"
        })]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : (props.column.field == 'type.name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.type ? props.row.type.name : '-'
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.type ? props.row.type.name : '-') + "\n                    ")]) : (props.column.field == 'invoices_total') ? _c('div', [(props.row.invoices_total > 0) ? _c('span', [_vm._v(_vm._s(_vm._f("currency")(props.row.invoices_total)))]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'total_expenses') ? _c('div', [(props.row.total_expenses > 0) ? _c('span', [_vm._v("\n                            " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                        ")]) : _c('span', [_vm._v("-")])]) : (props.column.field == 'value') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.value)) + "\n                    ")], 1) : (props.column.field == 'value_with_avg_cp') ? _c('div', [_c('project-tooltip', {
          attrs: {
            "valueBased": true,
            "valueBasedWithCP": true,
            "project": props.row
          }
        }), _vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.value_with_avg_cp)) + "\n                    ")], 1) : (props.column.field == 'minuba_external_id') ? _c('div', [_c('a', {
          staticClass: "minuba-link",
          attrs: {
            "href": 'https://app.minuba.dk/?op=casedetails&glist=' + props.row.minuba_external_id,
            "target": "_blank"
          }
        }, [_c('i', {
          staticClass: "fas fa-eye"
        })])]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }], null, false, 517486020)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                Ingen data ...\n            ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "value-chain"
  }, [_c('div', {
    staticClass: "chain"
  }, [_c('div', {
    staticClass: "chain__title"
  }, [_vm._v("\n            " + _vm._s(_vm.data.first_name) + "\n            "), _c('div', {
    staticStyle: {
      "font-size": "16px",
      "display": "inline-block"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "links"
  }, [_c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-file-alt fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.offer.count) + "\n                    ")]), _vm._v("\n                    tilbud, der afventer afgørelse\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentielt DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Potentiel omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.offer.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.offer.count > 0 ? ((_vm.data.offer.has_budget / _vm.data.offer.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.offer.has_budget) + " / " + _vm._s(_vm.data.offer.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-inbox-in fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.open.count) + "\n                    ")]), _vm._v("\n                    opgaver, der ikke er påbegyndt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.open.expected_revenue)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.open.count > 0 ? ((_vm.data.open.has_budget / _vm.data.open.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.open.has_budget) + " / " + _vm._s(_vm.data.open.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-clock fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.ongoing.count) + "\n                    ")]), _vm._v("\n                    igangværende opgaver,\n                    "), _c('br'), _vm._v("\n                    der arbejdes på\n                ")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', [_c('span', {
    staticClass: "small"
  }, [_vm._v("Værdi, salgspris")]), _vm._v("\n                        " + _vm._s(_vm._f("currency")(_vm.data.ongoing.value_with_avg_cp)) + "\n                    ")])]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.ongoing.count > 0 ? ((_vm.data.ongoing.has_budget / _vm.data.ongoing.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.ongoing.has_budget) + " / " + _vm._s(_vm.data.ongoing.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-check-circle fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unbilled.count) + "\n                    ")]), _vm._v("\n                    afsluttede opgaver,\n                    "), _c('br'), _vm._v("\n                    der ikke er fakturerede\n                ")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Værdi, salgspris")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unbilled.value_with_avg_cp)) + "\n                ")]), _vm._v(" "), (_vm.$auth.user().company.api_provider.slug === 'minuba') ? _c('div', {
    staticClass: "budget"
  }, [_c('span', {
    staticClass: "budget-bar-wrapper"
  }, [_c('span', {
    staticClass: "budget-bar-inner",
    style: ('width:' + (_vm.data.unbilled.count > 0 ? ((_vm.data.unbilled.has_budget / _vm.data.unbilled.count) * 100) : 0) + '%;')
  })]), _vm._v(" "), _c('span', {
    staticClass: "small mt-1"
  }, [_vm._v(_vm._s(_vm.data.unbilled.has_budget) + " / " + _vm._s(_vm.data.unbilled.count) + " opgaver har budget")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-envelope-open-dollar fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.unpaid_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer, der endnu ikke er betalt\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.unpaid_invoices.expected_revenue)) + "\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "link"
  }, [_c('div', {
    staticClass: "name"
  }, [_c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "fad fa-calendar-exclamation fa-fw"
  }), _vm._v("\n                        " + _vm._s(_vm.data.overdue_invoices.count) + "\n                    ")]), _vm._v("\n                    fakturaer med overskredet betaling\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "coverage"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet DB")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_coverage)) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "revenue"
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Forventet omsætning")]), _vm._v("\n                    " + _vm._s(_vm._f("currency")(_vm.data.overdue_invoices.expected_revenue)) + "\n                ")])])])]), _vm._v("\n\n    Vælg en af nedenstående bokse og scroll ned på siden for at se de enkelte opgaver/fakturaer\n    "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "number-overview"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Tilbud",
      "description": "der afventer afgørelse",
      "number": _vm.data.offer.count,
      "icon": "file-alt",
      "state": "avg",
      "doEmit": true,
      "selected": _vm.selectedTable === 'offer',
      "tooltipIdentifier": "index.offerProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('offer')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Opgaver",
      "description": "der endnu ikke er påbegyndt",
      "number": _vm.data.open.count,
      "icon": "inbox-in",
      "state": "avg",
      "doEmit": true,
      "selected": _vm.selectedTable === 'open',
      "tooltipIdentifier": "index.openProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('open')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": "der arbejdes på lige nu",
      "number": _vm.data.ongoing.count,
      "icon": "clock",
      "state": "bad",
      "doEmit": true,
      "selected": _vm.selectedTable === 'ongoing',
      "tooltipIdentifier": "index.ongoingProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('ongoing')
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Igangværende opgaver",
      "description": 'uden registreringer i ' + _vm.$store.state.config.companyMeta.settings.snoozed_days + ' dage ',
      "number": _vm.data.snoozed.count,
      "icon": "snooze",
      "state": "bad",
      "doEmit": true,
      "selected": _vm.selectedTable === 'snoozed',
      "tooltipIdentifier": "index.snoozedProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('snoozed')
      }
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('number-card', {
    attrs: {
      "heading": "Reklamationer",
      "description": "der ikke er afsluttet",
      "number": _vm.data.claims.count,
      "icon": "comment-exclamation",
      "state": "good",
      "doEmit": true,
      "selected": _vm.selectedTable === 'claims',
      "tooltipIdentifier": "index.openClaims"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('claims')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Afsluttede opgaver",
      "description": "der ikke er fakturerede",
      "number": _vm.data.unbilled.count,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "doEmit": true,
      "selected": _vm.selectedTable === 'noInvoice',
      "tooltipIdentifier": "index.unbilledProjects"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('noInvoice')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": "der endnu ikke er betalt",
      "number": _vm.data.unpaid_invoices.count,
      "icon": "envelope-open-dollar",
      "state": "avg",
      "doEmit": true,
      "selected": _vm.selectedTable === 'unpaid',
      "tooltipIdentifier": "index.unpaidInvoices"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('unpaid')
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('number-card', {
    attrs: {
      "heading": "Fakturaer",
      "description": 'hvor betaling er overskredet med ' + _vm.$store.state.config.companyMeta.settings.overdue_days + ' dage',
      "number": _vm.data.overdue_invoices.count,
      "icon": "calendar-exclamation",
      "state": "bad",
      "doEmit": true,
      "selected": _vm.selectedTable === 'exceededPayments',
      "tooltipIdentifier": "index.overdueInvoices"
    },
    on: {
      "clicked": function($event) {
        return _vm.showTable('exceededPayments')
      }
    }
  })], 1)])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "tables"
    }
  }, [(_vm.selectedTable === 'offer') ? _c('table-offer', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'open') ? _c('table-open', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'ongoing') ? _c('table-ongoing', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'snoozed') ? _c('table-snoozed', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'claims') ? _c('table-claims', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'noInvoice') ? _c('table-noinvoice', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'unpaid') ? _c('table-unpaid', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.selectedTable === 'exceededPayments') ? _c('table-overdue', {
    attrs: {
      "employeeId": _vm.data.relation_id,
      "employeeName": _vm.data.first_name
    },
    on: {
      "finishedLoading": function($event) {
        return _vm.scrollNow()
      }
    }
  }) : _vm._e()], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revenue",
    staticStyle: {
      "opacity": "0"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Placeholder")]), _vm._v("\n                    Placeholder\n                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "revenue",
    staticStyle: {
      "opacity": "0"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("Placeholder")]), _vm._v("\n                    Placeholder\n                ")])
}]}

/***/ }),
/* 947 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sub-project-types"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-3': _vm.selectedRow
    }
  }, [_c('div', {
    staticClass: "placeholder fit-content"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n                    Underentrepriser\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [(!_vm.loading) ? _c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.rows,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectSubProjectType
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                                "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name ? props.row.name : '-'
          }
        }, [_vm._v("\n                                " + _vm._s(props.row.name ? props.row.name : '-') + "\n                            ")]) : (props.column.field == 'coverage') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage)) + "\n                            ")]) : (props.column.field == 'invoices_total') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.invoices_total)) + "\n                            ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                                "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'budget') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'efficiency') ? _c('div', [_vm._v("\n                                -\n                            ")]) : (props.column.field == 'total_expenses') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.total_expenses)) + "\n                            ")]) : (props.column.field == 'sub_projects_total_expenses') ? _c('div', [_vm._v("\n                                " + _vm._s(_vm._f("currency")(props.row.sub_projects_total_expenses)) + "\n                            ")]) : _c('div', {
          attrs: {
            "title": props.formattedRow[props.column.field]
          }
        }, [_vm._v("\n                                " + _vm._s(props.formattedRow[props.column.field]) + "\n                            ")])]
      }
    }], null, false, 1893579095)
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                            Ingen data ...\n                        ")])]) : _c('box-loading', {
    attrs: {
      "height": "350"
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'col-lg-6': !_vm.selectedRow, 'col-lg-9': _vm.selectedRow
    }
  }, [(!_vm.selectedRow) ? _c('div', [_vm._v("\n                Vælg en underentreprise for at se en liste over alle opgaver inden for denne type\n            ")]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('a', {
    staticStyle: {
      "text-decoration": "none",
      "color": "#172b43",
      "font-weight": "600"
    },
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.selectedRow = null
      }
    }
  }, [_c('i', {
    staticClass: "far fa-times"
  }), _vm._v(" Luk\n                    ")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedRow) ? _c('sub-project-types-single', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _vm._e()], 1)])])
},staticRenderFns: []}

/***/ }),
/* 948 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "responsible-project-types"
  }, [_c('div', {
    staticClass: "placeholder mb-4"
  }, [_c('div', {
    staticClass: "placeholder__heading"
  }, [_vm._v("\n            " + _vm._s(_vm.data.name) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "placeholder"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.data.responsibles,
      "search-options": _vm.searchOptions,
      "pagination-options": _vm.paginationOptions,
      "sort-options": _vm.sortOptions,
      "styleClass": _vm.styleClass,
      "row-style-class": _vm.selectedRowClass
    },
    on: {
      "on-row-click": _vm.selectResponsible
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'coverage_percent') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("coveragePercent")(props.row.coverage_percent)) + " \n                        "), (props.row.coverage_percent !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_percent < _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_percent) >= _vm.$store.state.config.companyMeta.settings.coverage_percent.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'total_revenue') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_revenue)) + "\n                    ")]) : (props.column.field == 'total_coverage') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.total_coverage)) + "\n                    ")]) : (props.column.field == 'coverage_per_hour') ? _c('div', {
          staticClass: "coverage-cell"
        }, [_vm._v("\n                        " + _vm._s(_vm._f("currency")(props.row.coverage_per_hour)) + " \n                        "), (props.row.coverage_per_hour !== null) ? _c('div', {
          staticClass: "coverage-indicator",
          class: {
            'bad': props.row.coverage_per_hour < _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'avg': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.medium.value, 'good': _vm.$options.filters.rounded(props.row.coverage_per_hour) >= _vm.$store.state.config.companyMeta.settings.coverage_per_hour.high.value
          }
        }) : _vm._e()]) : (props.column.field == 'customer_name') ? _c('div', {
          staticClass: "table-column__customer",
          attrs: {
            "title": props.row.customer_name
          }
        }, [(props.row.customer_name) ? _c('span', [_vm._v("\n                            " + _vm._s(props.row.customer_name) + "\n                        ")]) : _c('span', [_vm._v(" - ")])]) : (props.column.field == 'name') ? _c('div', {
          staticClass: "table-column__description",
          attrs: {
            "title": props.row.name
          }
        }, [_vm._v("\n                        " + _vm._s(props.row.name) + "\n                    ")]) : (props.column.field == 'start_date') ? _c('div', [_vm._v("\n                        " + _vm._s(_vm._f("moment")(props.row.start_date, "DD. MMM YYYY")) + "\n                    ")]) : _c('div', [_vm._v("\n                        " + _vm._s(props.formattedRow[props.column.field]) + "\n                    ")])]
      }
    }])
  }, [_c('div', {
    attrs: {
      "slot": "emptystate"
    },
    slot: "emptystate"
  }, [_vm._v("\n                    Ingen data ...\n                ")])])], 1)]), _vm._v(" "), (_vm.selectedRow) ? _c('project-types-projects', {
    attrs: {
      "data": _vm.selectedRow
    }
  }) : _c('div', [_vm._v("\n        Vælg en ansvarlig for at se dennes opgaver her\n    ")])], 1)
},staticRenderFns: []}

/***/ }),
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ })
],[479]);


// WEBPACK FOOTER //
// static/js/app.b92041092003c1117985.js